class EventEmitter{
	constructor(){
		this.eventMap = new Map();
	}
	on(evt, listener, once = false){
		if(!this.eventMap.has(evt)){
			this.eventMap.set(evt, new Map());
		}

		this.eventMap.get(evt).set(listener, once);
	}
	once(evt, listener){
		this.on(evt, listener, true);
	}
	emit(evt){
		const listeners = this.eventMap.get(evt);

		if(listeners === undefined){ return; }

		const args = [].slice.call(arguments, 1);

		for(let [listener, once] of listeners){
			listener.apply(this, args);

			if(once){ this.off(evt, listener); }
		}
	}
	off(evt, listener){
		const listeners = this.eventMap.get(evt);

		if(listeners === undefined){ return; }

		listeners.delete(listener);

		if(listeners.size === 0){ this.eventMap.delete(evt); }
	}
	removeAllListeners(evt){
		this.eventMap.delete(evt);
	}
}

const ignore = new Set(['tag','settings','el','items']);
const excludeEvents = new Set(['value','text','constructor','events','visible','enabled']);
const numToPixel = new Set(['gap']);
const events$2 = new Set();
const alias$1 = new Map([
	['h', 'height'],
	['w', 'width'],
	['minh', 'minHeight'],
	['minw', 'minWidth'],
	['maxh', 'maxHeight'],
	['maxw', 'maxWidth'],
	['bgcolor', 'backgroundColor'],
	['upper', 'uppercase'],
	['lower', 'lowercase'],
	['shrink', 'flexShrink'],
	['dir', 'direction'],
	['textField', 'date-text-field'],
	['bind', 'data-bind'],
	['dataroll', 'data-role'],
	['datatype', 'data-type'],
	['databind', 'data-bind'],
	['dataRoll', 'data-role'],
	['dataType', 'data-type'],
	['dataBind', 'data-bind'],
	['start', 'flex-start'],
	['end', 'flex-end'],
	['around', 'space-around'],
	['between', 'space-between'],
	['zindex', 'z-index']
]);

function initialize$1(){
	for(let arr of Object.entries(kendo.ui)){
		const fn = arr[1].fn || {events: []};

		for(let evt of fn.events || []){
			if(!evt || evt.startsWith('_') || excludeEvents.has(evt)){ continue; }
	
			events$2.add(evt);
		}
	}
	
	for(let item of Object.getOwnPropertyNames(globalThis)){
			const obj = globalThis[item];
	
			if(!obj){ continue; }
	
			for(let prop in obj.prototype || {}){
				if(prop.startsWith('on')){ events$2.add(prop.substring(2)); }
			}
	}
}

if(typeof kendo !== 'undefined'){ initialize$1(); }

function dom(opts, container){
	const {tag, css, attr, style, html, text} = parseOptions(opts);
	const el = $(`<${tag}>`).appendTo(container || $('body'));

	el.css(css);
	el.attr(attr);
	el.html(html);
	el.text(text);
	el.addClass(style);

	if(attr.title){ el.kendoTooltip({}); }

	return el;
}
function parseOptions(opts){
	opts = Object.assign({tag: 'div', css: {}, attr: {}, style: [], html: null, text: null}, opts);
	opts.style =  Array.isArray(opts.style) ? opts.style : opts.style.split(' ');

	setBinds(opts);

	for(let[key, val] of Object.entries(opts)){
		if(ignore.has(key)){ continue; }

		const lower = key.toLowerCase();
		const key1 = alias$1.get(lower) || key;
		const key2 = key1.replace(/([A-Z])/g, '-$1').toLowerCase();

		if(ignore.has(key1)){ continue; }

		if(numToPixel.has(key) && typeof val === 'number' && Number.isFinite(val)){
			val = `${val}px`;
		}

		switch(key1){
			case 'lowercase':
			case 'uppercase':
			case 'capitalize':
				opts.css.textTransform = key1;
			break;
			case 'bold':
				opts.css.fontWeight = 'bold';
			break;
			case 'alignitems':
				opts.css.alignItems = alias$1.get(val) || val;
			break;
			case 'aligncontent':
				opts.css.alignContent = alias$1.get(val) || val;
			break;
			case 'alignself':
				opts.css.alignSelf = alias$1.get(val) || val;
			break;
			case 'stretch':
				opts.css.flex = 'auto';
				opts.css.overflow = 'auto';
			break;
			default:
				if(checkCSS(key2, val)){
					opts.css[key1] = val;
				} else if(!(val instanceof Object)){
					opts.attr[key1] = val;
				}
			break;
		}
	}

	return opts;
}
function setBinds(opts){
	if(!opts.bind){ return; }

	const out = {};

	for(let [key, value] of Object.entries(opts.bind)){
		if(events$2.has(key)){
			out.events = out.events || {};
			out.events[key] = value;
		} else if(checkCSS(key, value)){
			console.log({key, val});
			out.css = out.css || {};
			out.css[key] = value;
		} else {
			out[key] = value;
		}
	}

	delete opts.bind;

	opts.bind = JSON.stringify(out).match(/{(.*)}/)[1].replace(/"/g, '');
}
function checkCSS(key, val){
	key = key.startsWith('-') ? key.substr(1) : key;

	return CSS.supports(key, val) || CSS.supports(key, 'inherit');
}

class Model extends EventEmitter{
	constructor(data = {}){
		super();
		
		for(let key of Reflect.ownKeys(Reflect.getPrototypeOf(this))){
			data[key] = this[key].bind(this);
		}

		this.model = kendo.observable(data);
	}
	set(key, value){
		if(key instanceof Object){
			for(let [key2, val] of Object.entries(key)){
				this.model.set(key2, val);
			}
		} else {
			this.model.set(key, value);
		}
	}
	get(key){
		if(Array.isArray(key)){
			const obj = {};

			for(let key2 of key){ obj[key2] = this.model.get(key2); }

			return obj;
		} else {
			return this.model.get(key);
		}
	}
	async fetch(url, opts){
		opts = Object.assign({method: 'get'}, opts);
		
		if(opts.data || opts.formData){
			opts.headers = {'Accept': 'application/json', 'Content-Type': 'application/json'};
			opts.method = 'post';
			opts.body = opts.formData || JSON.stringify(opts.data);
			delete opts.data;
			delete opts.formData;
		}

		const res = await fetch(url, opts);
		const type = res.headers.get('content-type') || 'text';
		const disp = res.headers.get('content-disposition') || 'text';

		if(res.redirected){
			location.reload();
		} else if(disp.startsWith('attachment')){
			const file = disp.match(/^.+filename="(.+)"$/)[1];
			const blob = await res.blob();
			const href = URL.createObjectURL(blob);
			const link = dom({tag: 'a', href: href, download: file, container: 'body'});

			link[0].click();
			link.remove();
			setTimeout(() => URL.revokeObjectURL(href), 0);
		} else if(type.startsWith('application/json')){
			return await res.json();
		} else {
			return {
				status: res.status,
				headers: [...res.headers],
				body: await res.text()
			};
		}
	}
}

const monthMap = new Map();
const dayMap = new Map();
const durrMap = new Map();
const unitMap = new Map();
const unitAlias = new Map();
const tokens = new Map();
const msDay = 24 * 60 * 60 * 1000;
const msYear = msDay * 365;
const regex$2 = {
	parse: /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,
	format: /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
	tokens: /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,
	duration: /^([-+])?P(?:([-+]?[\d,.]*)Y)?(?:([-+]?[\d,.]*)M)?(?:([-+]?[\d,.]*)W)?(?:([-+]?[\d,.]*)D)?(?:T(?:([-+]?[\d,.]*)H)?(?:([-+]?[\d,.]*)M)?(?:([-+]?[\d,.]*)S)?)?$/,
	num1: /\d/,
	num2: /\d{2}/,
	num3: /\d{3}/,
	num4: /\d{4}/,
	num12: /\d{1,2}/,
	signed: /[+-]?\d+/,
	offset: /[+-]\d{2}:?(\d{2})?|Z/,
	word: /\d*[^-_:/,()\s\d]+/
};
const constants = [
	[0, 'Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
	[1, 'January','February','March','April','May','June','July','August','September','October','November','December'],
	[2, 'ms', 'millisecond', null, 'Milliseconds', false, 1],
	[2, 's', 'second', null, 'Seconds', false, 1000],
	[2, 'm', 'minute', null, 'Minutes', false, 60 * 1000],
	[2, 'h', 'hour', null, 'Hours', false, 60 * 60 * 1000],
	[2, 'd', 'date', 'days', 'Date', false, msDay],
	[2, 'w', 'day', 'weeks', 'Day', false, 7 * msDay],
	[2, 'M', 'month', null, 'Month', true, msYear / 12],
	[2, 'q', 'quarter', null, null, false, 0],
	[2, 'y', 'year', null, 'FullYear', true, msYear],
	[3, 'A', 'word', 'afternoon', isAfternoon, (a) => a.hour() < 12 ? 'AM' : 'PM'],
	[3, 'a', 'word', 'afternoon', isAfternoon, (a) => a.hour() < 12 ? 'am' : 'pm'],
	[3, 'Do', 'word', 'date', (a) => +(a.match(/\d+/)[0])],
	[3, 'Q', 'num1', 'month', (a) => (+a - 1) * 3 + 1],
	[3, 'S', 'num1', 'milliseconds', (a) => +a * 100],
	[3, 'SS', 'num2', 'milliseconds', (a) => +a * 10],
	[3, 'SSS', 'num3', 'milliseconds', (a) => +a, (a) => pad(a.millisecond(), 3, '0')],
	[3, 's', 'num12', 'seconds', null, (a) => a.second()],
	[3, 'ss', 'num12', 'seconds', null, (a) => pad(a.second(), 2, '0')],
	[3, 'm', 'num12', 'minutes', null, (a) => a.minute()],
	[3, 'mm', 'num12', 'minutes', null, (a) => pad(a.minute(), 2, '0')],
	[3, 'h', 'num12', 'hours', null, (a) => pad(a.hour() % 12 || 12, 1, '0')],
	[3, 'hh', 'num12', 'hours', null, (a) => pad(a.hour() % 12 || 12, 2, '0')],
	[3, 'H', 'num12', 'hours', null, (a) => a.hour()],
	[3, 'HH', 'num12', 'hours', null, (a) => pad(a.hour(), 2, '0')],
	[3, 'D', 'num12', 'date', null, (a) => a.date()],
	[3, 'DD', 'num2', 'date', null, (a) => pad(a.date(), 2, '0')],
	[3, 'w', 'num12', 'week'],
	[3, 'ww', 'num2', 'week'],
	[3, 'M', 'num12', 'month', minusOne, (a, b) => a.month() + b],
	[3, 'MM', 'num2', 'month', minusOne, (a, b) => pad(a.month() + b, 2, '0')],
	[3, 'Y', 'signed', 'year', null, (a) => a.year()],
	[3, 'YY', 'num2', 'year', parseYear, getYear2],
	[3, 'YYYY', 'num4', 'year', null, (a) => pad(a.year(), 4, '0')],
	[3, 'MMM', 'word', 'month', parseMonth, (a) => getMonth(a, false)],
	[3, 'MMMM', 'word', 'month', parseMonth, (a) => getMonth(a, true)],
	[3, 'Z', 'offset', 'offset', parseOffset],
	[3, 'ZZ', 'offset', 'offset', parseOffset],
	[3, 'd', null, null, null, (a) => getDay(a, 0)],
	[3, 'dd', null, null, null, (a) => getDay(a, 1)],
	[3, 'ddd', null, null, null, (a) => getDay(a, 2)],
	[3, 'dddd', null, null, null, (a) => getDay(a, 3)]
];

function init(){
	for(let arr of constants){
		const type = arr.shift();

		if(type === 0){
			for(let [idx, day] of arr.entries()){
				dayMap.set(idx, {idx: idx, full: day, short2: day.substring(0, 2), short3: day.substring(0, 3)});
			}
		} else if(type === 1){
			for(let [idx, month] of arr.entries()){
				const obj = {idx: idx, full: month, short: month.substring(0, 3)};
				monthMap.set(idx, obj);
				monthMap.set(obj.short.toLowerCase(), obj);
				monthMap.set(obj.full.toLowerCase(), obj);
			}
		} else if(type === 2){
			const obj = {key: arr[0], type: arr[1], cmd: arr[3], useSet: arr[4], ms: arr[5]};

			if(obj.ms){
				obj.durr = arr[2] || `${arr[1]}s`;
				durrMap.set(obj.durr, obj);
			}

			unitMap.set(obj.type, obj);
			unitAlias.set(obj.key, obj);
			unitAlias.set(`${obj.type}s`, obj);
		} else if(type === 3){
			tokens.set(arr[0], {regex: regex$2[arr[1]], key: arr[2], parser: arr[3] || Number, toString: arr[4]});
		}
	}

	constants.length = 0;
}
function minusOne(val){
	return Number(val) - 1;
}
function parseYear(val){
	return +val + (+val > 68 ? 1900 : 2000);
}
function parseMonth(val){
	const obj = monthMap.get(val.toLowerCase());

	return obj ? obj.idx : 0;
}
function parseOffset(str) {
	if(!str || str === 'Z'){ return 0; }
	
	const parts = str.match(/([+-]|\d\d)/g);
	const mins = +(parts[1] * 60) + (+parts[2] || 0);

	return mins === 0 ? 0 : parts[0] === '+' ? -mins : mins;
}
function isAfternoon(val){
	return val.toUpperCase() === 'PM';
}
function getYear2(obj, offset){
	const val = obj.year();

	return offset ? val.toString().slice(-2) : pad(val, 2, '0');
}
function getMonth(obj, full){
	const hit = monthMap.get(obj.month());

	return full ? hit.full : hit.short;
}
function getDay(obj, idx){
	const val = obj.day();
	const {short2, short3, full} = dayMap.get(val);
	
	return [val, short2, short3, full][idx];
}
function pad(val, len, pad){
	return (val || '').toString().padStart(len, pad);
}

init();

for(let {type, cmd, durr} of Array.from(unitMap.values()).reverse()){
	if(durr){
		`as${durr.replace(/^[a-z]/, (val) => val.toUpperCase())}`;
	}
}

class FileSave extends Model{
	constructor(title, data, name){
		super({name});

		const arr = Array.isArray(data)? data : [data];
		const dataSource = arr.map((a) => { return {text: a.ext.toUpperCase(), value: a}; });
		const view = [
			{el: 'dialog', id: 'fileSave', bind: {close: 'close'}, options: {
				title: title,
				visible: false,
				actions: [
					{text: 'Save', primary: true, action: this.save.bind(this)},
					{text: 'Cancel'}
				]
			}, items: [
				{el: 'panel', direction: 'row', alignItems: 'center', gap: 10, items: [
					{el: 'textBox', id: 'fileSaveName', width: 250, bind: {value: 'name'}, options: {label: 'File Name'}},
					{el: 'dropDownList', width: '8em', bind: {value: 'data'}, options: {
						dataTextField: 'text',
						dataValueField: 'value',
						dataSource: dataSource,
						valuePrimitive: true,
						visible: dataSource.length > 1,
						label: 'Format'
					}}
				]}
			]}
		];

		this.set('data', arr[0]);
	
		viewManager.load(this, view);
		viewManager.get('fileSave').open().center();
		viewManager.get('fileSaveName').focus();
	}
	save(){
		const {name, data} = this.model.toJSON();
		const fn = this.getFilename(name, data.ext);
		const blob =  this.getBlob(data.blob);
		const href = URL.createObjectURL(blob);
		const link = dom({tag: 'a', href: href, download: fn, container: 'body'});

		link[0].click();
		link.remove();
		globalThis.URL.revokeObjectURL(href);
	}
	close(){
		viewManager.get('fileSave').destroy();
		viewManager.unset(['fileSave', 'fileSaveName']);
	}
	getFilename(name, ext){
		name = name || 'untitled';

		return name.endsWith(`.${ext}`) ? name : `${name}.${ext}`;
	}
	getBlob(data){
		if(typeof data === 'string'){
			return new Blob([data], {type: 'text/plain'});
		} else {
			return data;
		}
	}
}

function fileSave(title, data, name){
	return new FileSave(title, data, name);
}

function round$2(val, precision){
	if(!precision || precision <= 0){ return Math.round(val); }

	const factor = Math.pow(10, precision || 0);

	return Math.round(val * factor) / factor;
}
function floorNearest(val, factor){
	 return Math.floor(val / factor) * factor;
}
function ceilNearest(val, factor){
	return Math.ceil(val / factor) * factor;
}
function roundNearest(val, factor){
	const a = floorNearest(val, factor);
	const b = ceilNearest(val, factor);

	return val - a < b - val ? a : b;
}
function uuid(){
	let date = Date.now();

	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (chr) => {
		const random = Math.trunc((date + Math.random() * 16) % 16);

		date = Math.floor(date / 16);
		
		return (chr === 'x' ? random : (random & 0x7 | 0x8)).toString(16);
	});
}
function fromCamelCase(str, delim = '-'){
	const regex = /[A-Z]/g;

	return str.replace(regex, (a) => {
		return delim + a.toLowerCase();
	});
}

const epsilon$2 = 0.0000001;
const {abs: abs$4, max: max$2, min: min$2, PI: PI$3} = Math;

function roundCoord$1(coord, precision){
	return [round$2(coord[0], precision), round$2(coord[1], precision)];
}
function dmsToDeg(deg, min, sec, dir){
	const out = deg + (min / 60) + (sec / 3600);

	return (dir === 'S' || dir === 'W') ? out * -1 : out;
}
function degToDms(deg, lat){
	const neg = deg < 0;
	let dir = null;

	deg = unwrapDegree(deg, lat);

	if(lat){
		dir = neg ? 'S' : 'N';
	} else {
		dir = neg ? 'W' : 'E';
	}

	deg = Math.abs(deg);

	let a = Math.floor(deg);
	let b = (deg - a) * 60;
	let c = (b - Math.floor(b)) * 60;

	b = Math.floor(b);

	if(c >= 60){
		c = c - 60;
		b += 1;
	}

	if(b >= 60){
		b = b - 60;
		a += 1;
	}

	return {
		dir: dir,
		deg: a,
		min: b,
		sec: c
	};
}
function setPrecision(coords, precision = 6){
	return coordEach$1(coords, (coord) => {
		return roundCoord$1(coord, precision);
	})
}
function endpoints(a){
	return {a: a[0], b: a[a.length - 1]};
}
function exteriorRings(coords){
	return getRings(coords, true);
}
function interiorRings(coords){
	return getRings(coords, false);
}
function equal(a, b, eps = epsilon$2){
	const dx = abs$4(a[0] - b[0]);
	const dy = abs$4(a[1] - b[1]);
	const mx = max$2(1, abs$4(a[0]), abs$4(b[0]));
	const my = max$2(1, abs$4(a[1]), abs$4(b[1]));

	return ((dx <= eps * mx) && dy <= eps * my);
}
function minMax(a, b){
	return {
		lon: {min: min$2(a[0], b[0]), max: max$2(a[0], b[0])},
		lat: {min: min$2(a[1], b[1]), max: max$2(a[1], b[1])}
	};
}
function deltaAngle(ang1, ang2, cw = true){
	const a = cw ? ang1 : ang2;
	const b = cw ? ang2 : ang1;
	const delta = (b < a ? b + 360 : b) - a;

	return delta % 360;
}
function angleDiff$1(ang1, ang2){
	let delta = ang1 - ang2;

	while(delta < -180){ delta += 360; }
	while(delta >= 180){ delta -= 360; }

	return delta;
}
function pointCount(coords){
	return coordAll(coords).length;
}
function pointDelta(a, b){
	return [b[0] - a[0], b[1] - a[1]];
}
function toRad$2(deg){
	return Number(deg) * (PI$3 / 180);
}
function toDeg(rad){
	return Number(rad) * (180 / PI$3);
}
function coordEach$1(arr, func){
	return iterate$1(arr, func, isCoord);
}
function lineEach$1(arr, func){
	return iterate$1(arr, func, isLine);
}
function ringEach(arr, func){
	return iterate$1(arr, func, isRing);
}
function segmentEach(arr, func){
	return iterate$1(arr, func, isSegment);
}
function segmentsEach(arr, func){
	return iterate$1(arr, func, isSegments);
}
function objectEach(arr, func){
	return iterate$1(arr, func, isObject);
}
function objectsEach(arr, func){
	return iterate$1(arr, func, isObjects);
}
function coordAll(arr){
	return getAll(arr, isCoord);
}
function lineAll(arr){
	return getAll(arr, isLine);
}
function ringAll(arr){
	return getAll(arr, isRing);
}
function segmentAll(arr){
	return getAll(arr, isSegment);
}
function objectAll(arr){
	return getAll(arr, isObject);
}
function isCoord(a){
	return Array.isArray(a) && typeof a[0] === 'number';
}
function isLine(a){
	return Array.isArray(a) && a.length > 1 && isCoord(a[0]);
}
function isRing(a){
	return isLine(a) && isClosed(a);
}
function isSegment(a){
	return Array.isArray(a) && a.length === 2 && isCoord(a[0]);
}
function isSegments(a){
	return Array.isArray(a) && isSegment(a[0]);
}
function isObject(a){
	return !(Array.isArray(a)) && a instanceof Object;
}
function isObjects(a){
	return Array.isArray(a) && isObject(a[0]);
}
function isClosed(a){
	const ep = endpoints(a);

	return equal(ep.a, ep.b, 0);
}
function closePolygon(coords){
	if(!isClosed(coords)){ coords.push(coords[0]); }

	return coords;
}
function toSegments$2(coords){
	return lineEach$1(coords, (line) => {
		const arr = line.slice(0);
		const out = [];
		let prev = arr.shift();

		for(let curr of arr){
			out.push([prev, curr]);
			prev = curr;
		}

		return out;
	});
}
function fromSegments(segments){
	return segmentsEach(segments, (arr) => {
		const out = [arr[0][0]];

		segmentEach(arr, (seg) => {
			out.push(seg[1]);
		});

		return out;
	});
}
function uniqueCoords(arr){
	const set = new Set();
	const out = [];

	coordEach$1(arr, (coord) => {
		const key = coord.join(',');

		if(set.has(key)){ return; }

		out.push(coord);
		set.add(key);
	});

	return out;
}
function getType(arr){
	if(isCoord(arr)){
		return 'Point';
	} else if(isLine(arr)){
		return 'LineString';
	} else if(isRing(arr[0])){
		return 'Polygon';
	} else if(isLine(arr[0])){
		return 'MultiLineString';
	} else if(isRing(arr[0][0])){
		return 'MultiPolygon';
	}
}
function unwrapCoord(coord){
	return [
		unwrapDegree(coord[0], false),
		unwrapDegree(coord[1], true)
	];
}
function unwrapDegree(val, lat){
	const max = lat ? 90 : 180;
	const min = -max;
	const offset = max * 2;

	val = val % offset;

	if(val < min){ val += offset; }
	if(val > max){ val -= offset; }

	return val;
}
function getAll(arr, validator){
	const out = [];
	const func = (a) => { out.push(a); };

	iterate$1(arr, func, validator);

	return out;
}
function getRings(coords, exterior){
	const out = [];

	ringEach(coords, (ring, idx) => {
		if(idx === 0 && !exterior){ return -1; }
		if(idx !== 0 && exterior){ return -1; }

		out.push(ring);
	});

	return out;
}
function iterate$1(arr, method, validator){
	if(validator(arr)){return method(arr, 0); }

	const bool = validator(arr[0]);
	const len = arr.length;
	const out = new Array(len);

	for(let i = 0; i < len; i++){
		const obj = arr[i];

		if(bool){
			const res = method(obj, i);
			if(res === -1){ break; }
			out[i] = res;
		} else {
			out[i] = (iterate$1(obj, method, validator));
		}
	}

	return out;
}

var utils$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	angleDiff: angleDiff$1,
	closePolygon: closePolygon,
	coordAll: coordAll,
	coordEach: coordEach$1,
	degToDms: degToDms,
	deltaAngle: deltaAngle,
	dmsToDeg: dmsToDeg,
	endpoints: endpoints,
	equal: equal,
	exteriorRings: exteriorRings,
	fromSegments: fromSegments,
	getType: getType,
	interiorRings: interiorRings,
	isClosed: isClosed,
	isCoord: isCoord,
	isLine: isLine,
	isObject: isObject,
	isObjects: isObjects,
	isRing: isRing,
	isSegment: isSegment,
	isSegments: isSegments,
	lineAll: lineAll,
	lineEach: lineEach$1,
	minMax: minMax,
	objectAll: objectAll,
	objectEach: objectEach,
	objectsEach: objectsEach,
	pointCount: pointCount,
	pointDelta: pointDelta,
	ringAll: ringAll,
	ringEach: ringEach,
	round: round$2,
	roundCoord: roundCoord$1,
	segmentAll: segmentAll,
	segmentEach: segmentEach,
	segmentsEach: segmentsEach,
	setPrecision: setPrecision,
	toDeg: toDeg,
	toRad: toRad$2,
	toSegments: toSegments$2,
	uniqueCoords: uniqueCoords,
	unwrapCoord: unwrapCoord,
	uuid: uuid
});

const wgs84 = {
	radius: 6378137};

const alias = new Map([
	['celsius','c'],
	['fahrenheit','f'],
	['kelvin','k'],
	['acre','a'],
	['acres','a'],
	['meter','m'],
	['meters','m'],
	['kilometer','km'],
	['kilometers','km'],
	['millimeter','mm'],
	['millimeters','mm'],
	['centimeter','cm'],
	['centimeters','cm'],
	['inch','in'],
	['inches','in'],
	['foot','ft'],
	['feet','ft'],
	['yard','yd'],
	['yards','yd'],
	['mile','mi'],
	['miles','mi'],
	['nauticalmile','nm'],
	['nauticalmiles','nm'],
	['hectare','h'],
	['hectares','h'],
	['radian','r'],
	['radians','r'],
	['degree','d'],
	['degrees','d'],
	['nmi','nm'],
	['bytes','b'],
	['kilobytes','kb'],
	['megabytes','mb'],
	['gigabytes','gb'],
	['terabytes','tb']
]);

const unitMaps = {
	distance: new Map([
		['r', 1],
		['m', wgs84.radius],
		['d', wgs84.radius / 111325],
		['km', wgs84.radius / 1000],
		['mm', wgs84.radius * 1000],
		['cm', wgs84.radius * 100],
		['in', wgs84.radius * 39.37007874],
		['ft', wgs84.radius * 3.280839895],
		['yd', wgs84.radius / 1.0936],
		['mi', wgs84.radius / 1609.344],
		['nm', wgs84.radius / 1852]
	]),
	area: new Map([
		['m', 1],
		['h', 0.0001],
		['km', 0.000001],
		['mm', 1000000],
		['cm', 10000],
		['in', 1550.0031000062],
		['ft', 10.7639104167097],
		['yd', 1.19599004630108],
		['a', 0.000247105381467165],
		['mi', 3.86102158542446e-7],
		['nm', 2.9155334959812285e-7]
	]),
	temp: new Map([
		['c', 1],
		['f', 33.80],
		['k', 274.15]
	]),
	memoryBinary: new Map([
		['b', 1048576],
		['kb', 1024],
		['mb', 1],
		['gb', 0.0009765625],
		['tb', 0.00000095367432]
	]),
	memoryDecimal: new Map([
		['b', 1000000],
		['kb', 1000],
		['mb', 1],
		['gb', 0.001],
		['tb', 0.000001]
	])
};

function length$2(val, from, to){
	return radToLen(lenToRad(val, from), to);
}
function distance$1(val, from, to){
	return radToLen(lenToRad(val, from), to);
}
function area$1(val, from, to){
	return convert(val, from, to, 'area');
}
function toRad$1(deg){
	return (deg % 360) * Math.PI / 180;
}
function convert(val, from, to, key){
	from = getAlias(from);
	to = getAlias(to);

	if(from === to){ return val; }

	const a = unitMaps[key].get(from);
	const b = unitMaps[key].get(to);

	return ((val / a) * b);
}
function toCartesian(coord, ref = [0, 0]) {
	const lon = toRad$1(coord[0]);
	const lat = toRad$1(coord[1]);
	const rlon = toRad$1(ref[0]);
	const rlat = toRad$1(ref[1]);

	return {
		x: wgs84.radius * (lon - rlon) * Math.cos(rlat),
		y: wgs84.radius * (lat - rlat)
	}
}
function radToLen(val, units){
	units = getAlias(units);
	return val * unitMaps.distance.get(units);
}
function lenToRad(val, units){
	units = getAlias(units);
	return val / unitMaps.distance.get(units);
}
function getAlias(unit){
	unit = unit.toLowerCase();
	return alias.has(unit) ? alias.get(unit) : unit;
}

var convert$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	area: area$1,
	convert: convert,
	distance: distance$1,
	length: length$2,
	toCartesian: toCartesian,
	toRad: toRad$1
});

const {sqrt: sqrt$3, atan, atan2: atan2$3, abs: abs$3, cbrt, max: max$1, min: min$1, pow: pow$1, sin: sin$2, cos: cos$2, round: round$1, floor: floor$1, PI: PI$2} = Math;
const tiny = sqrt$3(Number.MIN_VALUE);
const degree = PI$2/180;
const digits = 53;
const epsilon$1 = pow$1(0.5, digits - 1);
const maxIterate1 = 20;
const maxIterate2 = maxIterate1 + digits + 10;
const cap0 = 1 << 0;
const cap1 = 1 << 1;
const cap2 = 1 << 2;
const cap3 = 1 << 3;
const cap4 = 1 << 4;
const tol0 = epsilon$1;
const tol1 = 200 * tol0;
const tol2 = sqrt$3(tol0);
const tol3 = tol0 * tol1;
const xthresh = 1000 * tol2;
const geod = {
	a: 6378137,
	b: 6356752.314245179,
	c: 40589732499314.76,
	f: 0.0033528106647474805,
	f1: 0.9966471893352525,
	e2: 0.0066943799901413165,
	ep2: 0.006739496742276434,
	n: 0.0016792203863837047,
	tol: 3.6424611488788524e-8,
	coeff1: [
		-0.0234375, -0.046927475637074494, -0.06281503005876607, -0.2502088451303832, -0.49916038980680816, 1
	],
	coeff2: [
		0.0234375, 0.03908873781853724, 0.04695366939653196, 0.12499964752736174, 0.24958019490340408, 0.01953125,
		0.02345061890926862, 0.046822392185686165, 0.062342661206936094, 0.013671875, 0.023393770302437927,
		0.025963026642854565, 0.013671875, 0.01362595881755982, 0.008203125
	],
	coeff3: [
		0.00646020646020646, 0.0035037627212872787, 0.034742279454780166, -0.01921732223244865, -0.19923321555984239,
		0.6662190894642603, 0.000111000111000111, 0.003426620602971002, -0.009510765372597735, -0.01893413691235592,
		0.0221370239510936, 0.0007459207459207459, -0.004142006291321442, -0.00504225176309005, 0.007584982177746079,
		-0.0021565735851450138, -0.001962613370670692, 0.0036104265913438913, -9472009472009472e-19, 0.0020416649913317735,
		0.0012916376552740189
	]
};
const coeff1 = [-1, 6, -16, 32, -9, 64, -128, 2048, 9, -16, 768, 3, -5, 512, -7, 1280, -7, 2048];
const coeff2 = [205, -432, 768, 1536, 4005, -4736, 3840, 12288, -225, 116, 384, -7173, 2695, 7680, 3467, 7680, 38081, 61440];
const coeff3 = [1, 2, 16, 32, 35, 64, 384, 2048, 15, 80, 768, 7, 35, 512, 63, 1280, 77, 2048];
const coeff4 = [1, 4, 64, 0, 256];
const coeff5 = [-11, -28, -192, 0, 256];
const options = {
	none: 0,
	arc: 64,
	latitude: 128,
	longitude: 264,
	azimuth: 512,
	distance: 1025,
	standard: 1929,
	distanceIn: 2051,
	reducedLen: 4101,
	scale: 8197,
	area: 16400,
	all: 32671,
	unroll: 32768,
	mask: 65408,
	latLon: 128 | 264 | 512,
	forward: 512 | 4101 | 8197,
	reverse1: 128 | 264 | 512 | 2051 | 4101 | 8197,
	reverse2: 128 | 264 | 512 | 4101 | 8197,
	bearingDistance: 512 | 1025
};
function direct(point, bearing, distance, units = 'm', opts = options.standard){
	const dist = length$2(distance, units, 'm');
	const res = genDirect(point[0], point[1], bearing, false, dist, opts);

	return result(res, units);
}
function direct2(lon, lat, bearing, distance, opts){
	return genDirect(lon, lat, bearing, false, distance, opts);
}
function inverse(a, b, units = 'm', opts = options.standard){
	const {standard, unroll, mask, azimuth} = options;

	if(opts === unroll){ opts |= standard; }
	
	opts &= mask;

	const inv = new Inverse(a[0], a[1], b[0], b[1], opts);
	const res = inv.res;

	if(opts & azimuth){
		res.vals.bearing1 = atan2d(res.salp1, res.calp1);
		res.vals.bearing2 = atan2d(res.salp2, res.calp2);
	}

	return result(res.vals, units);
}
function inverse2(lon1, lat1, lon2, lat2, opts = options.standard){
	const {azimuth, standard, unroll, mask} = options;

	if(opts === unroll){ opts |= standard; }
	
	opts &= mask;

	const inv = new Inverse(lon1, lat1, lon2, lat2, opts);
	const res = inv.res;

	if(opts & azimuth){
		res.vals.bearing1 = atan2d(res.salp1, res.calp1);
		res.vals.bearing2 = atan2d(res.salp2, res.calp2);
	}

	return res.vals;
}
function arcDirect(point, bearing, distance, opts){
	return genDirect(point[0], point[1], bearing, true, distance, opts);
}
function line(point, bearing, opts){
	return new Line(point[0], point[1], bearing, opts);
}
function directLine(point, bearing, distance, opts){
	return genDirectLine(point[0], point[1], bearing, false, distance, opts);
}
function inverseLine(a, b, opts){
	const {standard, distanceIn, bearingDistance, arc, mask, distance} = options;
	const lon1 = a[0];
	const lat1 = a[1];
	const lon2 = b[0];
	const lat2 = b[1];

	opts = opts || standard | distanceIn | bearingDistance;

	const inv = new Inverse(lon1, lat1, lon2, lat2, arc);
	const res = inv.res;

	const bearing1 = atan2d(res.salp1, res.calp1);

	if(opts & (mask & distanceIn)){ opts |= distance; }

	const line = new Line(lon1, lat1, bearing1, opts, res.salp1, res.calp1);
	line.setArc(res.vals.arcLength);

	return line;
}
function forward(a, b){
	const out = inverse(a, b, 'm', options.forward);

	if(out.scale1 <= 0){ return null; }

	out.bearing1 *= degree;

	const factor = out.reducedLength / out.scale1;

	return [factor * sin$2(out.bearing1), factor * cos$2(out.bearing1)];
}
function reverse(a, b){
	const eps = 0.01 * sqrt$3(epsilon$1);
	const deg = atan2$3(b[1], b[0]) / degree;
	let rho = hypot(b[1], b[0]);
	let bool = rho <= 6378137;
	let dist = 6378137 * atan(rho / 6378137);
	let decr = 10;
	let incr = 0;
	let out = null;

	if(!bool){ rho = 1 / rho; }

	const ln = line(a, deg, options.reverse1);

	while(decr--){
		out = ln.calculate(false, dist, options.reverse2);

		if(incr){ break; }

		const {reducedLength, scale1} = out;
		const i = bool ? (reducedLength / scale1 - rho) * scale1 * scale1 : (rho - scale1 / reducedLength) * reducedLength * reducedLength;

		dist -= i;

		if(abs$3(i) < eps * 6378137){ incr++; }
	}

	return incr ? [out.lon2, out.lat2] : null;
}
function azimForward(a, b){
	const out = inverse(a, b, 'm', options.bearingDistance);
	const bearing = out.bearing1 * degree;
	const x = out.distance * sin$2(bearing);
	const y = out.distance * cos$2(bearing);

	return [x, y];
}
function azimReverse(a, b){
	const x = b[0];
	const y = b[1];
	const bearing = atan2$3(x, y) / degree;
	const dist = hypot(x, y);
	const dir = direct(a, bearing, dist, 'm', options.latLon);

	return [dir.lon2, dir.lat2];
}
function mid(a, b){
	const inv = inverse(a, b, 'm', options.bearingDistance);

	return direct(a, inv.bearing1, inv.distance / 2, 'm', options.latLon);
}
function calcAreaPerimeter(coords, clockwise, units = 'm'){
	const poly = polygon$2();
	const len = coords.length;

	for(let i = 0; i < len; i++){
		poly.addPoint(coords[i]);
	}

	const res = poly.compute(clockwise);

	return {
		area: area$1(res.area, 'm', units),
		perimeter: distance$1(res.perimeter, 'm', units)
	};
}
function polygon$2(){
	return new Polygon(false);
}
function result(res, units){
	const b1 = res.bearing1;
	const b2 = res.bearing2;
	
	res.origin = [res.lon1, res.lat1];
	
	if('lon2' in res){
		res.point = [res.lon2, res.lat2];
		res.destination = res.point;
	}

	res.distance = res.distance || 0;
	res.distance = distance$1(res.distance, 'm', units);
	res.dist = res.distance;

	if(b1 && b1 < 0){ res.bearing1 = abs$3((b1 + 360) % 360); }
	if(b2 && b2 < 0){ res.bearing2 = abs$3((b2 + 360) % 360); }
	
	return res;
}
function genDirect(lon, lat, bearing, arcmode, distance, opts = options.standard){
	const {standard, unroll, distanceIn} = options;

	if(opts === unroll){ opts |= standard; }
	if(!arcmode){ opts |= distanceIn; }

	const line = new Line(lon, lat, bearing, opts);
	
	return line.calculate(arcmode, distance, opts);
}
function genDirectLine(lon, lat, bearing, arcmode, distance, opts){
	const {standard, distanceIn} = options;

	if(!opts){ opts = standard | distanceIn; }
	{ opts |= distanceIn; }
	
	const line = new Line(lon, lat, bearing, opts);

	line.genSetDistance(arcmode, distance);
	
	return line;
}
class Inverse{
	constructor(lon1, lat1, lon2, lat2, opts){
		const {distance, reducedLen, scale, area} = options;
		const vals = {};
		const a = {
			a4: null,
			alp12: null,
			b41: null,
			b42: null,
			c1a: [],
			c2a: [],
			c3a: [],
			c4a: null,
			calp0: null,
			calp1: null,
			calp12: null,
			calp1a: null,
			calp1b: null,
			calp2: null,
			cbet1: null,
			cbet2: null,
			cdalp1: null,
			cdomg12: null,
			clam12: null,
			comg12: null,
			csig1: null,
			csig2: null,
			dalp1: null,
			dbet1: null,
			dbet2: null,
			diff: null,
			dn1: null,
			dn2: null,
			dnm: null,
			domg12: null,
			dv: null,
			eps: null,
			k: null,
			lam12: null,
			latSign: null,
			lenMask: null,
			lon12: null,
			lon12s: null,
			lonSign: null,
			m12x: null,
			meridian: null,
			nsalp1: null,
			nvals: null,
			omg12: null,
			res: null,
			s12x: null,
			salp0: null,
			salp1: null,
			salp12: null,
			salp1a: null,
			salp1b: null,
			salp2: null,
			sbet1: null,
			sbet2: null,
			sdalp1: null,
			sdomg12: null,
			sig12: null,
			slam12: null,
			somg12: null,
			ssig1: null,
			ssig2: null,
			swap: null,
			v: null
		};

		vals.lat1 = lat1 = fixLat(lat1);
		vals.lat2 = lat2 = fixLat(lat2);
		lat1 = angleRound(lat1);
		lat2 = angleRound(lat2);
		a.diff = angleDiff(lon1, lon2);
		a.lon12 = a.diff.s;
		a.lon12s = a.diff.t;

		this.setLongitude(a, vals, opts, lon1, lon2);
		this.setLatitude(a, lat1, lat2);
	
		a.dn1 = sqrt$3(1 + geod.ep2 * sq(a.sbet1));
		a.dn2 = sqrt$3(1 + geod.ep2 * sq(a.sbet2));
		a.meridian = lat1 === -90 || a.slam12 === 0;
	
		if(a.meridian){ this.setMeridian(a, vals, opts); }
		if(!a.meridian){ this.setNonMeridian1(a, vals, opts); }
		if(opts & distance){ vals.distance = 0 + a.s12x; }
		if(opts & reducedLen){ vals.reducedLength = 0 + a.m12x; }
		if(opts & area){ this.setArea(a, vals); }
	
		if(a.swap < 0){
			a.res = a.salp1;
			a.salp1 = a.salp2;
			a.salp2 = a.res;
			a.res = a.calp1;
			a.calp1 = a.calp2;
			a.calp2 = a.res;
	
			if(opts & scale){
				a.res = vals.scale1;
				vals.scale1 = vals.scale2;
				vals.scale2 = a.res;
			}
		}
	
		a.salp1 *= a.swap * a.lonSign;
		a.calp1 *= a.swap * a.latSign;
		a.salp2 *= a.swap * a.lonSign;
		a.calp2 *= a.swap * a.latSign;
	
		this.res = {vals: vals, salp1: a.salp1, calp1: a.calp1, salp2: a.salp2, calp2: a.calp2};
	}
	setLongitude(a, vals, opts, lon1, lon2){
		if(opts & options.unroll){
			vals.lon1 = lon1;
			vals.lon2 = (lon1 + a.lon12) + a.lon12s;
		} else {
			vals.lon1 = angleNormalize(lon1);
			vals.lon2 = angleNormalize(lon2);
		}

		a.lonSign = a.lon12 >= 0 ? 1 : -1;
		a.lon12 = a.lonSign * angleRound(a.lon12);
		a.lon12s = angleRound((180 - a.lon12) - a.lonSign * a.lon12s);
		a.lam12 = a.lon12 * degree;
		a.res = sinCos(a.lon12 > 90 ? a.lon12s : a.lon12);
		a.slam12 = a.res.sin;
		a.clam12 = (a.lon12 > 90 ? -1 : 1) * a.res.cos;
	}
	setLatitude(a, lat1, lat2){
		a.swap = abs$3(lat1) < abs$3(lat2) ? -1 : 1;
		
		if(a.swap < 0){
			a.lonSign *= -1;
			a.res = lat1;
			lat1 = lat2;
			lat2 = a.res;
		}
	
		a.latSign = lat1 < 0 ? 1 : -1;
		lat1 *= a.latSign;
		lat2 *= a.latSign;
		a.res = sinCos(lat1);
		a.sbet1 = geod.f1 * a.res.sin;
		a.cbet1 = a.res.cos;
		a.res = hypot(a.sbet1, a.cbet1);
		a.sbet1 /= a.res;
		a.cbet1 /= a.res;
		a.cbet1 = max$1(tiny, a.cbet1);
		a.res = sinCos(lat2);
		a.sbet2 = geod.f1 * a.res.sin;
		a.cbet2 = a.res.cos;
		a.res = hypot(a.sbet2, a.cbet2);
		a.sbet2 /= a.res;
		a.cbet2 /= a.res;
		a.cbet2 = max$1(tiny, a.cbet2);
	
		if(a.cbet1 < -a.sbet1){
			if(a.cbet2 === a.cbet1){ a.sbet2 = a.sbet2 < 0 ? a.sbet1 : -a.sbet1; }
		} else if(abs$3(a.sbet2) === -a.sbet1){
			a.cbet2 = a.cbet1;
		}
	}
	setArea(a, vals){
		a.salp0 = a.salp1 * a.cbet1;
		a.calp0 = hypot(a.calp1, a.salp1 * a.sbet1);
		
		if(a.calp0 !== 0 && a.salp0 !== 0){
			a.ssig1 = a.sbet1;
			a.csig1 = a.calp1 * a.cbet1;
			a.ssig2 = a.sbet2;
			a.csig2 = a.calp2 * a.cbet2;
			a.k2 = sq(a.calp0) * geod.ep2;
			a.eps = a.k2 / (2 * (1 + sqrt$3(1 + a.k2)) + a.k2);
			a.a4 = sq(geod.a) * a.calp0 * a.salp0 * geod.e2;
			a.res = hypot(a.ssig1, a.csig1);
			a.ssig1 /= a.res;
			a.csig1 /= a.res;
			a.res = hypot(a.ssig2, a.csig2);
			a.ssig2 /= a.res;
			a.csig2 /= a.res;
			a.c4a = getCoeff3(a.eps, false);
			a.b41 = sinCosSeries(false, a.ssig1, a.csig1, a.c4a);
			a.b42 = sinCosSeries(false, a.ssig2, a.csig2, a.c4a);
			vals.area = a.a4 * (a.b42 - a.b41);
		} else {
			vals.area = 0;
		}

		if(!a.meridian && a.somg12 > 1){
			a.somg12 = sin$2(a.omg12);
			a.comg12 = cos$2(a.omg12);
		}

		if(!a.meridian && a.comg12 > -0.7071 && a.sbet2 - a.sbet1 < 1.75){
			a.domg12 = 1 + a.comg12;
			a.dbet1 = 1 + a.cbet1;
			a.dbet2 = 1 + a.cbet2;
			a.alp12 = 2 * atan2$3( a.somg12 * (a.sbet1 * a.dbet2 + a.sbet2 * a.dbet1), a.domg12 * (a.sbet1 * a.sbet2 + a.dbet1 * a.dbet2));
		} else {
			a.salp12 = a.salp2 * a.calp1 - a.calp2 * a.salp1;
			a.calp12 = a.calp2 * a.calp1 + a.salp2 * a.salp1;

			if(a.salp12 === 0 && a.calp12 < 0){
				a.salp12 = tiny * a.calp1;
				a.calp12 = -1;
			}
			
			a.alp12 = atan2$3(a.salp12, a.calp12);
		}

		vals.area += geod.c * a.alp12;
		vals.area *= a.swap * a.lonSign * a.latSign;
		vals.area += 0;
	}
	setMeridian(a, vals, opts){
		const {distance, reducedLen, scale} = options;

		a.calp1 = a.clam12;
		a.salp1 = a.slam12;
		a.calp2 = 1;
		a.salp2 = 0;
		a.ssig1 = a.sbet1;
		a.csig1 = a.calp1 * a.cbet1;
		a.ssig2 = a.sbet2;
		a.csig2 = a.calp2 * a.cbet2;
		a.sig12 = atan2$3(max$1(0, a.csig1 * a.ssig2 - a.ssig1 * a.csig2), a.csig1 * a.csig2 + a.ssig1 * a.ssig2);
		a.nvals = this.lengths({
			eps: geod.n,
			sig12: a.sig12,
			ssig1: a.ssig1,
			csig1: a.csig1,
			dn1: a.dn1,
			ssig2: a.ssig2,
			csig2: a.csig2,
			dn2: a.dn2,
			cbet1: a.cbet1,
			cbet2: a.cbet2,
			c1a: a.c1a,
			c2a: a.c2a,
			opts: opts | distance | reducedLen
		});
		a.s12x = a.nvals.s12b;
		a.m12x = a.nvals.m12b;

		if(opts & scale){
			vals.scale1 = a.nvals.scale1;
			vals.scale2 = a.nvals.scale2;
		}

		if(a.sig12 < 1 || a.m12x >= 0){
			if(a.sig12 < 3 * tiny || (a.sig12 < tol0 && (a.s12x < 0 || a.m12x < 0))){
				a.sig12 = a.m12x = a.s12x = 0;
			}
				
			a.m12x *= geod.b;
			a.s12x *= geod.b;
			vals.arcLength = a.sig12 / degree;
		} else {
			a.meridian = false;
		}

		a.somg12 = 2;
	}
	setNonMeridian1(a, vals, opts){
		if(a.sbet1 === 0 &&	(a.lon12s >= geod.f * 180)){
			a.calp1 = a.calp2 = 0;
			a.salp1 = a.salp2 = 1;
			a.s12x = geod.a * a.lam12;
			a.sig12 = a.omg12 = a.lam12 / geod.f1;
			a.m12x = geod.b * sin$2(a.sig12);
			
			if(opts & options.scale){ vals.scale1 = vals.scale2 = cos$2(a.sig12); }
	
			vals.arcLength = a.lon12 / geod.f1;
		} else {
			this.setNonMeridian2(a, vals, opts);
		}

	}
	setNonMeridian2(a, vals, opts){
		const {scale, reducedLen, distance, none, area} = options;

		a.nvals = this.start(a);
		a.sig12 = a.nvals.sig12;
		a.salp1 = a.nvals.salp1;
		a.calp1 = a.nvals.calp1;

		if(a.sig12 >= 0){
			a.salp2 = a.nvals.salp2;
			a.calp2 = a.nvals.calp2;
			a.dnm = a.nvals.dnm;
			a.s12x = a.sig12 * geod.b * a.dnm;
			a.m12x = sq(a.dnm) * geod.b * sin$2(a.sig12 / a.dnm);

			if(opts & scale){ vals.scale1 = vals.scale2 = cos$2(a.sig12 / a.dnm); }

			vals.arcLength = a.sig12 / degree;
			a.omg12 = a.lam12 / (geod.f1 * a.dnm);
		} else {
			a.salp1a = tiny;
			a.calp1a = 1;
			a.salp1b = tiny;
			a.calp1b = -1;

			this.iterate(a);
			
			a.lenMask = opts | (opts & (reducedLen | scale) ? distance : none);
			a.nvals = this.lengths({
				eps: a.eps,
				sig12: a.sig12,
				ssig1: a.ssig1,
				csig1: a.csig1,
				dn1: a.dn1,
				ssig2: a.ssig2,
				csig2: a.csig2,
				dn2: a.dn2,
				cbet1: a.cbet1,
				cbet2: a.cbet2,
				c1a: a.c1a,
				c2a: a.c2a,
				opts: a.lenMask
			});
			a.s12x = a.nvals.s12b;
			a.m12x = a.nvals.m12b;

			if(opts & scale){
				vals.scale1 = a.nvals.scale1;
				vals.scale2 = a.nvals.scale2;
			}

			a.m12x *= geod.b;
			a.s12x *= geod.b;
			
			vals.arcLength = a.sig12 / degree;

			if(opts & area){
				a.sdomg12 = sin$2(a.domg12);
				a.cdomg12 = cos$2(a.domg12);
				a.somg12 = a.slam12 * a.cdomg12 - a.clam12 * a.sdomg12;
				a.comg12 = a.clam12 * a.cdomg12 + a.slam12 * a.sdomg12;
			}
		}
	}
	iterate(a){
		let numit = 0;

		for(let tripn = false, tripb = false; numit < maxIterate2; ++numit){
			a.nvals = this.lambda(a, numit < maxIterate1);
			a.v = a.nvals.lam12;
			a.salp2 = a.nvals.salp2;
			a.calp2 = a.nvals.calp2;
			a.sig12 = a.nvals.sig12;
			a.ssig1 = a.nvals.ssig1;
			a.csig1 = a.nvals.csig1;
			a.ssig2 = a.nvals.ssig2;
			a.csig2 = a.nvals.csig2;
			a.eps = a.nvals.eps;
			a.domg12 = a.nvals.domg12;
			a.dv = a.nvals.dlam12;

			if(tripb || (abs$3(a.v || 0) < (tripn ? 8 : 1) * tol0)){ break; }

			if(a.v > 0 && (numit < maxIterate1 || a.calp1/a.salp1 > a.calp1b/a.salp1b)){
				a.salp1b = a.salp1;
				a.calp1b = a.calp1;
			} else if(a.v < 0 && (numit < maxIterate1 || a.calp1/a.salp1 < a.calp1a/a.salp1a)){
				a.salp1a = a.salp1;
				a.calp1a = a.calp1;
			}

			if(numit < maxIterate1 && a.dv > 0){
				a.dalp1 = -a.v/a.dv;
				a.sdalp1 = sin$2(a.dalp1);
				a.cdalp1 = cos$2(a.dalp1);
				a.nsalp1 = a.salp1 * a.cdalp1 + a.calp1 * a.sdalp1;
				
				if(a.nsalp1 > 0 && abs$3(a.dalp1) < PI$2){
					a.calp1 = a.calp1 * a.cdalp1 - a.salp1 * a.sdalp1;
					a.salp1 = a.nsalp1;
					a.res = hypot(a.salp1, a.calp1);
					a.salp1 /= a.res;
					a.calp1 /= a.res;

					tripn = abs$3(a.v) <= 16 * tol0;
					continue;
				}
			}

			a.salp1 = (a.salp1a + a.salp1b)/2;
			a.calp1 = (a.calp1a + a.calp1b)/2;
			a.res = hypot(a.salp1, a.calp1);
			a.salp1 /= a.res;
			a.calp1 /= a.res;
			tripn = false;
			tripb = (abs$3(a.salp1a - a.salp1) + (a.calp1a - a.calp1) < tol3 || abs$3(a.salp1 - a.salp1b) + (a.calp1 - a.calp1b) < tol3);
		}
	}
	start(a){
		const {reducedLen} = options;
		const vals = {};
		let sbet12 = a.sbet2 * a.cbet1 - a.cbet2 * a.sbet1;
		let cbet12 = a.cbet2 * a.cbet1 + a.sbet2 * a.sbet1;
		let sbet12a, shortline, omg12, sbetm2, somg12, comg12, res, ssig12, csig12, x, y, lamscale, betscale, k2, eps, k, omg12a, lam12x;
		
		vals.sig12 = -1;
	
		sbet12a = a.sbet2 * a.cbet1;
		sbet12a += a.cbet2 * a.sbet1;
	
		shortline = cbet12 >= 0 && sbet12 < 0.5 && a.cbet2 * a.lam12 < 0.5;
		
		if(shortline){
			sbetm2 = sq(a.sbet1 + a.sbet2);
			sbetm2 /= sbetm2 + sq(a.cbet1 + a.cbet2);
			vals.dnm = sqrt$3(1 + geod.ep2 * sbetm2);
			omg12 = a.lam12 / (geod.f1 * vals.dnm);
			somg12 = sin$2(omg12);
			comg12 = cos$2(omg12);
		} else {
			somg12 = a.slam12;
			comg12 = a.clam12;
		}
	
		vals.salp1 = a.cbet2 * somg12;
		vals.calp1 = comg12 >= 0 ? sbet12 + a.cbet2 * a.sbet1 * sq(somg12) / (1 + comg12) : sbet12a - a.cbet2 * a.sbet1 * sq(somg12) / (1 - comg12);
	
		ssig12 = hypot(vals.salp1, vals.calp1);
		csig12 = a.sbet1 * a.sbet2 + a.cbet1 * a.cbet2 * comg12;
	
		if(shortline && ssig12 < geod.tol){
			vals.salp2 = a.cbet1 * somg12;
			vals.calp2 = sbet12 - a.cbet1 * a.sbet2 * (comg12 >= 0 ? sq(somg12) / (1 + comg12) : 1 - comg12);
			res = hypot(vals.salp2, vals.calp2);
			vals.salp2 /= res;
			vals.calp2 /= res;
			vals.sig12 = atan2$3(ssig12, csig12);
		} else if(abs$3(geod.n) <= 0.1 && csig12 < 0 && ssig12 < 6 * abs$3(geod.n) * PI$2 * sq(a.cbet1)){
			lam12x = atan2$3(-a.slam12, -a.clam12);
			
			{			
				k2 = sq(a.sbet1) * geod.ep2;
				eps = k2 / (2 * (1 + sqrt$3(1 + k2)) + k2);
				lamscale = geod.f * a.cbet1 * calcPoly(eps) * PI$2;
				betscale = lamscale * a.cbet1;
				x = lam12x / lamscale;
				y = sbet12a / betscale;
			}
	
			if(y > -tol1 && x > -1 - xthresh){
				{
					vals.salp1 = min$1(1, -x);
					vals.calp1 = -sqrt$3(1 - sq(vals.salp1));
				}
			} else {
				k = astroid(x, y);
				omg12a = lamscale * (-x * k/(1 + k)  );
				somg12 = sin$2(omg12a);
				comg12 = -cos$2(omg12a);
	
				vals.salp1 = a.cbet2 * somg12;
				vals.calp1 = sbet12a - a.cbet2 * a.sbet1 * sq(somg12) / (1 - comg12);
			}
		}
	
		if(isNaN(vals.salp1) || vals.salp1 > 0){
			res = hypot(vals.salp1, vals.calp1);
			vals.salp1 /= res;
			vals.calp1 /= res;
		} else {
			vals.salp1 = 1;
			vals.calp1 = 0;
		}
	
		return vals;
	}
	lengths(a){
		const {mask, reducedLen, scale, distance} = options;
		const vals = {};
		let a1 = null;
		let a2 = null;
		let b1 = null;
		let b2 = null;
		let c = null;
		let m = null;
		
		a.opts &= mask;
			
		if(a.opts & (distance | reducedLen | scale)){
			a1 = getCoeff1(a.eps, coeff4, true);
			getCoeff2(a.eps, coeff1, a.c1a);
			
			if(a.opts & (reducedLen | scale)){
				a2 = getCoeff1(a.eps, coeff5, false);
				getCoeff2(a.eps, coeff3, a.c2a);
				m = a1 - a2;
				a2 = 1 + a2;
			}
			
			a1 = 1 + a1;
		}
	
		if(a.opts & distance){
			b1 = sinCosSeries(true, a.ssig2, a.csig2, a.c1a) - sinCosSeries(true, a.ssig1, a.csig1, a.c1a);
	
			vals.s12b = a1 * (a.sig12 + b1);
	
			if(a.opts & (reducedLen | scale)){
				b2 = sinCosSeries(true, a.ssig2, a.csig2, a.c2a) - sinCosSeries(true, a.ssig1, a.csig1, a.c2a);
				c = m * a.sig12 + (a1 * b1 - a2 * b2);
			}
		} else if(a.opts & (reducedLen | scale)){
			for(let i = 1; i <= 6; ++i){
				a.c2a[i] = a1 * a.c1a[i] - a2 * a.c2a[i];
			}
	
			c = m * a.sig12 + (sinCosSeries(true, a.ssig2, a.csig2, a.c2a) - sinCosSeries(true, a.ssig1, a.csig1, a.c2a));
		}
		
		if(a.opts & reducedLen){
			vals.m0 = m;
			vals.m12b = a.dn2 * (a.csig1 * a.ssig2) - a.dn1 * (a.ssig1 * a.csig2) - a.csig1 *a.csig2 * c;
		}
		if(a.opts & scale){
			let csig12 = a.csig1 * a.csig2 + a.ssig1 * a.ssig2;
			let res = geod.ep2 * (a.cbet1 - a.cbet2) * (a.cbet1 + a.cbet2) / (a.dn1 + a.dn2);
			vals.scale1 = csig12 + (res * a.ssig2 - a.csig2 * c) * a.ssig1 / a.dn1;
			vals.scale2 = csig12 - (res * a.ssig1 - a.csig1 * c) * a.ssig2 / a.dn2;
		}
	
		return vals;
	}
	lambda(a, diff){
		const {reducedLen} = options;
		const vals = {};
		let res, salp0, calp0, somg1, comg1, somg2, comg2, somg12, comg12, b312, eta, k2, nvals;
		
		if(a.sbet1 === 0 && a.calp1 === 0){ a.calp1 = -tiny; }
	
		salp0 = a.salp1 * a.cbet1;
		calp0 = hypot(a.calp1, a.salp1 * a.sbet1);
	
		vals.ssig1 = a.sbet1;
		somg1 = salp0 * a.sbet1;
		vals.csig1 = comg1 = a.calp1 * a.cbet1;
	
		res = hypot(vals.ssig1, vals.csig1);
		vals.ssig1 /= res;
		vals.csig1 /= res;
		vals.salp2 = a.cbet2 !== a.cbet1 ? salp0 / a.cbet2 : a.salp1;
	
		if(a.cbet1 || abs$3(a.sbet2) !== -a.sbet1){
			let num = a.cbet1 < -a.sbet1 ? (a.cbet2 - a.cbet1) * (a.cbet1 + a.cbet2) : (a.sbet1 - a.sbet2) * (a.sbet1 + a.sbet2);
			vals.calp2 = sqrt$3(sq(a.calp1 * a.cbet1) + num) / a.cbet2;
		} else {
			vals.calp2 = abs$3(a.calp1);	
		}
	
		vals.ssig2 = a.sbet2;
		somg2 = salp0 * a.sbet2;
		vals.csig2 = comg2 = vals.calp2 * a.cbet2;
		res = hypot(vals.ssig2, vals.csig2);
		vals.ssig2 /= res;
		vals.csig2 /= res;
		vals.sig12 = atan2$3(max$1(0, vals.csig1 * vals.ssig2 - vals.ssig1 * vals.csig2), vals.csig1 * vals.csig2 + vals.ssig1 * vals.ssig2);
		somg12 = max$1(0, comg1 * somg2 - somg1 * comg2);
		comg12 = comg1 * comg2 + somg1 * somg2;
		eta = atan2$3(somg12 * a.clam12 - comg12 * a.slam12, comg12 * a.clam12 + somg12 * a.slam12);
		k2 = sq(calp0) * geod.ep2;
		vals.eps = k2 / (2 * (1 + sqrt$3(1 + k2)) + k2);
		getCoeff3(vals.eps, true, a.c3a);
		b312 = (sinCosSeries(true, vals.ssig2, vals.csig2, a.c3a) - sinCosSeries(true, vals.ssig1, vals.csig1, a.c3a));
		vals.domg12 = -0.0033528106647474805 * calcPoly(vals.eps) * salp0 * (vals.sig12 + b312);
		vals.lam12 = eta + vals.domg12;
		
		if(diff){
			if(vals.calp2 === 0){
				vals.dlam12 = -2 * geod.f1 * a.dn1 / a.sbet1;
			} else {
				nvals = this.lengths({
					eps: vals.eps,
					sig12: vals.sig12,
					ssig1: vals.ssig1,
					csig1: vals.csig1,
					dn1: a.dn1,
					ssig2: vals.ssig2,
					csig2: vals.csig2,
					dn2: a.dn2,
					cbet1: a.cbet1,
					cbet2: a.cbet2,
					c1a: a.c1a,
					c2a: a.c2a,
					opts: reducedLen
				});
				vals.dlam12 = nvals.m12b;
				vals.dlam12 *= geod.f1 / (vals.calp2 * a.cbet2);
			}
		}
		return vals;
	}
}
class Line{
	constructor(lon, lat, bearing1, opts, salp1, calp1){
		const {latitude, azimuth, standard, unroll, distanceIn} = options;
		const a = {res: null, eps: null, sbet1: null, cbet1: null};

		opts = opts || standard | distanceIn;
			
		this.opts = opts | latitude | azimuth | unroll;
		this.lon1 = lon;
		this.lat1 = fixLat(lat);
	
		if(salp1 === undefined || calp1 === undefined){
			this.bearing1 = angleNormalize(bearing1);
			a.res = sinCos(angleRound(this.bearing1));
			this.salp1 = a.res.sin;
			this.calp1 = a.res.cos;
		} else {
			this.bearing1 = bearing1;
			this.salp1 = salp1;
			this.calp1 = calp1;
		}
	
		a.res = sinCos(angleRound(this.lat1));
		a.sbet1 = geod.f1 * a.res.sin;
		a.cbet1 = a.res.cos;
		a.res = hypot(a.sbet1, a.cbet1);
		a.sbet1 /= a.res;
		a.cbet1 /= a.res;
		a.cbet1 = max$1(tiny, a.cbet1);
		
		this.dn1 = sqrt$3(1 + geod.ep2 * sq(a.sbet1));
		this.salp0 = this.salp1 * a.cbet1;
		this.calp0 = hypot(this.calp1, this.salp1 * a.sbet1);
		this.ssig1 = a.sbet1;
		this.somg1 = this.salp0 * a.sbet1;
		this.csig1 = this.comg1 = a.sbet1 !== 0 || this.calp1 !== 0 ? a.cbet1 * this.calp1 : 1;
	
		a.res = hypot(this.ssig1, this.csig1);
		
		this.ssig1 /= a.res;
		this.csig1 /= a.res;
		this.k2 = sq(this.calp0) * geod.ep2;
	
		a.eps = this.k2 / (2 * (1 + sqrt$3(1 + this.k2)) + this.k2);
	
		if(this.opts & cap0){
			this.a1m1 = getCoeff1(a.eps, coeff4, true);
			this.c1a = getCoeff2(a.eps, coeff1);
			this.b11 = sinCosSeries(true, this.ssig1, this.csig1, this.c1a);
			
			const s = sin$2(this.b11);
			const c = cos$2(this.b11);
	
			this.stau1 = this.ssig1 * c + this.csig1 * s;
			this.ctau1 = this.csig1 * c - this.ssig1 * s;
		}
	
		if(this.opts & cap1){
			this.c1pa = getCoeff2(a.eps, coeff2);
		}
	
		if(this.opts & cap2){
			this.c2a = getCoeff2(a.eps, coeff3);
			this.a2m1 = getCoeff1(a.eps, coeff5, false);
			this.b21 = sinCosSeries(true, this.ssig1, this.csig1, this.c2a);
		}
	
		if(this.opts & cap3){	
			this.c3a = getCoeff3(a.eps, true);
			this.a3c = -0.0033528106647474805 * this.salp0 * calcPoly(a.eps);
			this.b31 = sinCosSeries(true, this.ssig1, this.csig1, this.c3a);
		}
	
		if(this.opts & cap4){
			this.c4a = getCoeff3(a.eps, false);
			this.a4 = sq(geod.a) * this.calp0 * this.salp0 * geod.e2;
			this.b41 = sinCosSeries(false, this.ssig1, this.csig1, this.c4a);
		}
	
		this.a13 = this.s13 = Number.NaN;
	}
	calculate(arcmode, dist, opts = options.standard){
		const {latitude, azimuth, standard, unroll, mask, distance, distanceIn, reducedLen, longitude, scale, area} = options;
		const a = {
			ab1: 0,
			b12: 0,
			c: null,
			calp2: null,
			cbet2: null,
			csig12: null,
			csig2: null,
			dn2: null,
			res: null,
			s: null,
			salp2: null,
			sbet2: null,
			sig12: null,
			ssig12: null,
			ssig2: null,
			tau12: null
		};
		const b = this;
		const out = {};
	
		if(opts === unroll){ opts |= standard; }
		opts &= b.opts & mask;

		out.lat1 = b.lat1;
		out.bearing1 = b.bearing1;
		out.lon1 = opts & unroll ? b.lon1 : angleNormalize(b.lon1);

		if(this.calcLenDist(a, b, out, dist, arcmode, distanceIn, mask)){ return out; }

		a.ssig2 = b.ssig1 * a.csig12 + b.csig1 * a.ssig12;
		a.csig2 = b.csig1 * a.csig12 - b.ssig1 * a.ssig12;
		a.dn2 = sqrt$3(1 + b.k2 * sq(a.ssig2));

		if(opts & (distance | reducedLen | scale)){
			a.b12 = sinCosSeries(true, a.ssig2, a.csig2, b.c1a);
			a.ab1 = (1 + b.a1m1) * (a.b12 - b.b11);
		}

		a.sbet2 = b.calp0 * a.ssig2;
		a.cbet2 = hypot(b.salp0, b.calp0 * a.csig2);

		if(a.cbet2 === 0){ a.cbet2 = a.csig2 = tiny; }

		a.salp2 = b.salp0;
		a.calp2 = b.calp0 * a.csig2;

		if(arcmode && (opts & distance)){ out.distance = geod.b * ((1 + b.a1m1) * a.sig12 + a.ab1); }
		if(opts & longitude){ this.setLatitude(out, a, b, opts, unroll); }
		if(opts & latitude){ out.lat2 = atan2d(a.sbet2, geod.f1 * a.cbet2); }
		if(opts & azimuth){ out.bearing2 = atan2d(a.salp2, a.calp2); }
		if(opts & (reducedLen | scale)){ this.setScale(out, a, b, opts, reducedLen, scale); }
		if(opts & area){ this.setArea(out, a, b); }
		if(!arcmode){ out.arcLength = a.sig12 / degree; }
		
		return out;
	}
	calcLenDist(a, b, out, dist, arcmode, distanceIn, mask){
		if(arcmode){
			out.arcLength = dist;
			a.sig12 = dist * degree;
			a.res = sinCos(dist);
			a.ssig12 = a.res.sin;
			a.csig12 = a.res.cos;
		} else {
			out.distance = dist;

			if(!(b.opts & distanceIn & mask)){
				out.arcLength = Number.NaN;
				return true;
			}

			a.tau12 = dist / (geod.b * (1 + b.a1m1));
			a.s = sin$2(a.tau12);
			a.c = cos$2(a.tau12);
			a.b12 = -sinCosSeries(true, b.stau1 * a.c + b.ctau1 * a.s, b.ctau1 * a.c - b.stau1 * a.s, b.c1pa);
			a.sig12 = a.tau12 - (a.b12 - b.b11);
			a.ssig12 = sin$2(a.sig12);
			a.csig12 = cos$2(a.sig12);
		}

		return false;
	}
	setLatitude(out, a, b, opts, unroll){
		let somg2 = b.salp0 * a.ssig2;
		let comg2 = a.csig2;
		let e = copysign(1, b.salp0);
		let omg12 = null;

		if(opts & unroll){
			omg12 = e * (a.sig12 - (atan2$3(a.ssig2, a.csig2) - atan2$3(b.ssig1, b.csig1)) + (atan2$3(e * somg2, comg2) - atan2$3(e * b.somg1, b.comg1)));
		} else {
			omg12 = atan2$3(somg2 * b.comg1 - comg2 * b.somg1, comg2 * b.comg1 + somg2 * b.somg1);
		}
	
		let lam12 = omg12 + b.a3c * (a.sig12 + (sinCosSeries(true, a.ssig2, a.csig2, b.c3a) - b.b31));
		let lon12 = lam12 / degree;
	
		out.lon2 = opts & unroll ? b.lon1 + lon12 : angleNormalize(angleNormalize(b.lon1) + angleNormalize(lon12));
	}
	setScale(out, a, b, opts, reducedLen, scale){
		let b22 = sinCosSeries(true, a.ssig2, a.csig2, b.c2a);
		let ab2 = (1 + b.a2m1) * (b22 - b.b21);
		let j12 = (b.a1m1 - b.a2m1) * a.sig12 + (a.ab1 - ab2);
	
		if(opts & reducedLen){
			out.reducedLength = geod.b * ((a.dn2 * (b.csig1 * a.ssig2) - b.dn1 * (b.ssig1 * a.csig2)) - b.csig1 * a.csig2 * j12);
		}

		if(opts & scale){
			a.res = b.k2 * (a.ssig2 - b.ssig1) * (a.ssig2 + b.ssig1) / (b.dn1 + a.dn2);
			out.scale1 = a.csig12 + (a.res * a.ssig2 - a.csig2 * j12) * b.ssig1 / b.dn1;
			out.scale2 = a.csig12 - (a.res * b.ssig1 - b.csig1 * j12) * a.ssig2 / a.dn2;
		}
	}
	setArea(out, a, b){
		let b42 = sinCosSeries(false, a.ssig2, a.csig2, b.c4a);
		let salp12 = null;
		let calp12 = null;
	
		if(b.calp0 === 0 || b.salp0 === 0){
			salp12 = a.salp2 * b.calp1 - a.calp2 * b.salp1;
			calp12 = a.calp2 * b.calp1 + a.salp2 * b.salp1;
		} else {
			salp12 = b.calp0 * b.salp0 * (a.csig12 <= 0 ? b.csig1 * (1 - a.csig12) + a.ssig12 * b.ssig1 : a.ssig12 * (b.csig1 * a.ssig12 / (1 + a.csig12) + b.ssig1));
			calp12 = sq(b.salp0) + sq(b.calp0) * b.csig1 * a.csig2;
		}

		out.area = geod.c * atan2$3(salp12, calp12) + b.a4 * (b42 - b.b41);
	}
	position(distance, units = 'm', opts = options.standard){
		const res = this.calculate(false, distance, opts);

		return result(res, units);
	}
	arcPosition(distance, units = 'm', opts = options.standard){
		const res = this.calculate(true, distance, opts);

		return result(res, units);
	}
	genSetDistance(arcmode, distance){
		if(arcmode){
			this.setArc(distance);
		} else {
			this.setDistance(distance);
		}
	}
	setDistance(distance){
		this.s13 = distance;

		const res = this.calculate(false, distance, options.arc);

		this.a13 = 0 + res.arcLength;
	}
	setArc(distance){
		this.a13 = distance;

		const res = this.calculate(true, distance, options.distance);

		this.s13 = 0 + res.distance;
	}
}
class Polygon{
	constructor(polyline = false){
		const {latitude, longitude, distance, none, area, unroll} = options;
		this.area = 4 * PI$2 * geod.c;
		this.polyline = polyline;
		this.mask = latitude | longitude | distance | (polyline ? none : area | unroll);
		this.perimetersum = new Accumulator(0);

		if(!polyline){ this.areasum = new Accumulator(0); }
		
		this.clear();
	}
	addPoint(point){
		const lon = point[0];
		const lat = point[1];
			
		if(this.num === 0){
			this.lat0 = this.lat = lat;
			this.lon0 = this.lon = lon;
		} else {
			const res = inverse2(this.lon, this.lat, lon, lat, this.mask);
			this.perimetersum.add(res.distance);
			
			if(!this.polyline){
				this.areasum.add(res.area);
				this.crossings += transit(this.lon, lon);
			}
			
			this.lat = lat;
			this.lon = lon;
		}

		++this.num;
	}
	addEdge(azimuth, distance){
		if(this.num){
			const res = direct2(this.lon, this.lat, azimuth, distance, this.mask);
			
			this.perimetersum.add(distance);
		
			if(!this.polyline){
				this.areasum.add(res.area);
				this.crossings += transitDirect(this.lon, res.lon2);
			}
		
			this.lat = res.lat2;
			this.lon = res.lon2;
		}

		++this.num;
	}
	compute(reverse, sign){
		const vals = {number: this.num};

		if(this.num < 2){
			vals.perimeter = 0;
		
			if(!this.polyline){ vals.area = 0; }
		
			return vals;
		}

		if(this.polyline){
			vals.perimeter = this.perimetersum.sum();
			return vals;
		}

		const res = inverse2(this.lon, this.lat, this.lon0, this.lat0, this.mask);
		vals.perimeter = this.perimetersum.sum(res.distance);
		
		const temp = new Accumulator(this.areasum);
		
		temp.add(res.area);
		vals.area = areaReduceA(temp, this.area, this.crossings + transit(this.lon, this.lon0), reverse, sign);
		
		return vals;
	}
	testPoint(point, reverse, sign){
		const lon = point[0];
		const lat = point[1];
		const vals = {number: this.num + 1};
	
		if(this.num === 0){
			vals.perimeter = 0;
			
			if(!this.polyline){ vals.area = 0; }

			return vals;
		}

		vals.perimeter = this.perimetersum.sum();
		
		let tempsum = this.polyline ? 0 : this.areasum.sum();
		let crossings = this.crossings;
		
		for(let i = 0; i < (this.polyline ? 1 : 2); ++i){
			const x1 = i === 0 ? this.lon : lon;
			const y1 = i === 0 ? this.lat : lat;
			const x2 = i !== 0 ? this.lon0 : lon;
			const y2 = i !== 0 ? this.lat0 : lat;
			const res = inverse2(x1, y1, x2, y2, this.mask);
		
			vals.perimeter += res.distance;
		
			if(!this.polyline){
				tempsum += res.area;
				crossings += transit(i === 0 ? this.lon : lon, i !== 0 ? this.lon0 : lon);
			}
		}

		if(this.polyline){ return vals; }

		vals.area = areaReduceB(tempsum, this.area, crossings, reverse, sign);
		
		return vals;
	}
	testEdge(azi, distance, reverse, sign){
		const vals = {number: this.num ? this.num + 1 : 0};
		
		if(this.num === 0){ return vals; }
		
		vals.perimeter = this.perimetersum.sum() + distance;
		
		if(this.polyline){ return vals; }
	
		let tempsum = this.areasum.sum();
		let crossings = this.crossings;
		let res = direct2(this.lon, this.lat, azi, distance, this.mask);
		
		tempsum += res.area;
		crossings += transitDirect(this.lon, res.lon2);
		crossings += transit(res.lon2, this.lon0);
		res = inverse2(res.lon2, res.lat2, this.lon0, this.lat0, this.mask);
		vals.perimeter += res.distance;
		tempsum += res.area;
	
		vals.area = areaReduceB(tempsum, this.area, crossings, reverse, sign);
		
		return vals;
	}
	clear(){
		this.num = 0;
		this.crossings = 0;
		this.perimetersum.set(0);
		this.lat0 = this.lon0 = this.lat = this.lon = NaN;

		if(!this.polyline){ this.areasum.set(0); }
	}
}
class Accumulator{
	constructor(y){
		this.set(y);
	}
	set(y = 0){
		if(y.constructor === Accumulator) {
			this.s = y.s;
			this.t = y.t;
		} else {
			this.s = y;
			this.t = 0;
		}
	}
	add(y){
		let u = sum$1(y, this.t);
		let v = sum$1(u.s, this.s);

		this.s = v.s;
		this.t = v.t;

		if(this.s === 0){
			this.s = u.t;
		} else {
			this.t += u.t;
		}
	}
	sum(y){
		if(!y){ return this.s; }

		const b = new Accumulator(this);
		b.add(y);

		return b.s;
	}
	negate(){
		this.s *= -1;
		this.t *= -1;
	}
	remainder(y){
		this.s = remainder(this.s, y);
		this.add(0);
	}
}
function getCoeff1(eps, coeff, flip){
	const a = polyval(3, coeff, 0, sq(eps)) / coeff[4];
	
	return flip ? (a + eps) / (1 - eps) : (a - eps) / (1 + eps);
}
function getCoeff2(eps, coeff, out = []){
	const eps2 = sq(eps);
	let b = 0;
	let c = null;
	let e = eps;

	for(let a = 1; a <= 6; ++a){
		c = floor$1((6 - a) / 2);
		out[a] = e * polyval(c, coeff, b, eps2) / coeff[b + c + 1];
		b += c + 2;
		e *= eps;
	}

	return out;
}
function getCoeff3(eps, bool, out = []){
	const coeff = bool ? geod.coeff2 : geod.coeff3;
	const idx = bool ? 1 : 0;
	let factor = 1;
	let b = 0;
	let c = null;
	let x = bool ? eps : 1;
	let y = bool ? 1: eps;

	for(let a = idx; a < 6; ++a){
		c = 6 - a - 1;
		factor *= x;
		out[a] = factor * polyval(c, coeff, b, eps);
		b += c + 1;
		factor *= y;
	}

	return out;
}
function calcPoly(eps){
	return polyval(6 - 1, geod.coeff1, 0, eps);
}
function astroid(x, y){
	let k = 0;
	let p = sq(x);
	let q = sq(y);
	let r1 = (p + q - 1) / 6;
	
	if(!(q === 0 && r1 <= 0)){
		let s = p * q / 4;
		let r2 = sq(r1);
		let r3 = r1 * r2;
		let disc = s * (s + 2 * r3);
		let u = r1;
		
		if(disc >= 0){
			let t3 = s + r3;
			t3 += t3 < 0 ? -sqrt$3(disc) : sqrt$3(disc);
			let t = cbrt(t3);
			u += t + (t !== 0 ? r2 / t : 0);
		} else {
			let ang = atan2$3(sqrt$3(-disc), -(s + r3));
			u += 2 * r1 * cos$2(ang / 3);
		}

		let v = sqrt$3(sq(u) + q);
		let uv = u < 0 ? q / (v - u) : u + v;
		let w = (uv - q) / (2 * v);
		k = uv / (sqrt$3(uv + sq(w)) + w);
	}

	return k;
}
function sinCosSeries(sinp, sinx, cosx, arr){
	let len = arr.length;
	let cnt = len - (sinp ? 1 : 0);
	let a = 2 * (cosx - sinx) * (cosx + sinx);
	let y0 = cnt & 1 ? arr[--len] : 0;
	let y1 = 0;

	cnt = floor$1(cnt/2);
	
	while(cnt--){
		y1 = a * y0 - y1 + arr[--len];
		y0 = a * y1 - y0 + arr[--len];
	}

	return (sinp ? 2 * sinx * cosx * y0 : cosx * (y0 - y1));
}
function sq(x){
	return x * x;
}
function fixLat(lat){
	return abs$3(lat) > 90 ? Number.NaN : lat;
}
function angleNormalize(x){
	x = remainder(x, 360);
	
	return x === -180 ? 180 : x;
}
function angleRound(x){
	if(x === 0){ return x; }

	const z = 1/16;
	let y = abs$3(x);

	y = y < z ? z - (z - y) : y;
	
	return x < 0 ? -y : y;
}
function angleDiff(x, y){
	const r = sum$1(angleNormalize(-x), angleNormalize(y));
	const d = angleNormalize(r.s);
	const t = r.t;
	
	return sum$1(d === 180 && t > 0 ? -180 : d, t);
}
function sum$1(a, b){
	const s = a + b;
	let diff1 = s - b;
	let diff2 = s - diff1;

	diff1 -= a;
	diff2 -= b;
	
	const t = -(diff1 + diff2);

	return {s, t};
}
function remainder(a, b){
	a = a % b;

	if(a < -b / 2){
		return a + b;
	} else {
		return a < b / 2 ? a : a - b;
	}
}
function hypot(x, y){
	return sqrt$3(x * x + y * y);
}
function polyval(cnt, arr, i, x){
	let y = cnt < 0 ? 0 : arr[i++];
	
	while(--cnt >= 0){ y = y * x + arr[i++]; }

	return y;
}
function copysign(x, y){
	return abs$3(x) * (y < 0 || (y === 0 && 1/y < 0) ? -1 : 1);
}
function atan2d(y, x){
	let a = 0;
	let b = null;

	if(abs$3(y) > abs$3(x)){
		b = x;
		x = y;
		y = b;
		a = 2;
	}
	
	if(x < 0){
		x = -x;
		++a;
	}

	let ang = atan2$3(y, x) / degree;

	switch(a){
		case 1:
			ang = (y >= 0 ? 180 : -180) - ang;
		break;
		case 2:
			ang = 90 - ang;
		break;
		case 3:
			ang = -90 + ang;
		break;
	}

	return ang;
}
function sinCos(x){
	let r = x % 360;
	let q = 0 + round$1(r / 90);
	let sinx = null;
	let cosx = null;
	
	r -= 90 * q;
	r *= degree;

	let s = sin$2(r);
	let c = cos$2(r);

	switch(q & 3){
		case 0:
			sinx = s;
			cosx = c;
		break;
		case 1:
			sinx = c;
			cosx = -s;
		break;
		case 2:
			sinx = -s;
			cosx = -c;
		break;
		default:
			sinx = -c;
			cosx = s;
		break;
	}

	if(x !== 0){
		sinx += 0;
		cosx += 0;
	}
	
	return {sin: sinx, cos: cosx};
}
function transit(lon1, lon2){
	lon1 = angleNormalize(lon1);
	lon2 = angleNormalize(lon2);

	const diff = angleDiff(lon1, lon2).s;

	if(lon1 <= 0 && lon2 > 0 && diff > 0){
		return 1;
	} else if(lon2 <= 0 && lon1 > 0 && diff < 0){
		return -1;
	} else {
		return 0;
	}
}
function transitDirect(lon1, lon2){

	lon1 = lon1 % 720;
	lon2 = lon2 % 720;

	const a = ((lon2 <= 0 && lon2 > -360) || lon2 > 360 ? 1 : 0);
	const b = ((lon1 <= 0 && lon1 > -360) || lon1 > 360 ? 1 : 0);

	return a - b;
}
function areaReduceA(a, b, crossings, reverse, sign){
	a.remainder(b);
	if(crossings & 1){ a.add( (a.sum() < 0 ? 1 : -1) * b/2 ); }
	if(!reverse){ a.negate(); }
	if(sign){
		if(a.sum() > b/2){
			a.add(-b);
		} else if(a.sum() <= -b/2){
			a.add( +b );
		}
	} else if(a.sum() >= b){
		a.add( -b );
	} else if(a.sum() < 0){
		a.add( +b );
	}
	return 0 + a.sum();
}
function areaReduceB(a, b, crossings, reverse, sign){
	a = remainder(a, b);
	
	if(crossings & 1){ a += (a < 0 ? 1 : -1) * b/2; }
	if(!reverse){ a *= -1; }
	if(sign){
		if(a > b/2){
			a -= b;
		} else if(a <= -b/2){
			a += b;
		}
	} else if(a >= b){
		a -= b;
	} else if(a < 0){
		a += b;
	}

	return 0 + a;
}

function toBBOX(arg){
	return arg instanceof BBOX$1 ? arg : new BBOX$1(arg);
}

let BBOX$1 = class BBOX{
	constructor(coords){
		this.clear();

		if(!coords){ return; }

		if(Object.hasOwn(coords, 'minX')){
			this.merge(coords);
			return;
		}

		coordEach$1(coords, this.add.bind(this));
	}
	clear(){
		const a = this;

		a.minX = Infinity;
		a.minY = Infinity;
		a.maxX = -Infinity;
		a.maxY = -Infinity;

		return a;
	}
	add(coord){
		const a = this;
		const x = Object.hasOwn(coord, 'x') ? coord.x : coord[0];
		const y = Object.hasOwn(coord, 'y') ? coord.y : coord[1];

		a.minX = Math.min(x, a.minX);
		a.minY = Math.min(y, a.minY);
		a.maxX = Math.max(x, a.maxX);
		a.maxY = Math.max(y, a.maxY);

		return a;
	}
	addGeojson(geojson){
		switch(geojson.type){
			case 'Point':
			case 'LineString':
			case 'MultiPoint':
			case 'Polygon':
			case 'MultiLineString':
			case 'MultiPolygon':
				for(let coord of coordAll(geojson.coordinates)){
					this.add(coord);
				}
			break;
			case 'Feature':
				this.addGeojson(geojson.geometry);
			break;
			case 'FeatureCollection':
				for(let a of geojson.features){ this.addGeojson(a.geometry); }
			break;
			case 'GeometryCollection':
				for(let a of geojson.geometries){ this.addGeojson(a); }
			break;
		}

		return this;
	}
	polygon(){
		const a = this;

		return [[
			[a.minX, a.minY],
			[a.maxX, a.minY],
			[a.maxX, a.maxY],
			[a.minX, a.maxY],
			[a.minX, a.minY]
		]];
	}
	intersect(arg){
		const a = this;
		const b = toBBOX(arg);
		
		return b.minX <= a.maxX && b.minY <= a.maxY && b.maxX >= a.minX && b.maxY >= a.minY;
	}
	contains(arg){
		const a = this;
		const b = toBBOX(arg);

		return a.minX <= b.minX && a.minY <= b.minY && b.maxX <= a.maxX && b.maxY <= a.maxY;
	}
	overlap(arg){
		const a = this;
		const b = toBBOX(arg);

		if(!this.intersect(b)){ return null; }

		return {
			minX: Math.max(a.minX, b.minX),
			minY: Math.max(a.minY, b.minY),
			maxX: Math.min(a.maxX, b.maxX),
			maxY: Math.min(a.maxY, b.maxY)
		};
	}
	touch(arg){
		const b = toBBOX(arg);

		return this.overlap(b) || this.contains(b) ? true : false;
	}
	intersectArea(arg){
		const a = this;
		const b = toBBOX(arg);
		const minX = Math.max(a.minX, b.minX);
		const minY = Math.max(a.minY, b.minY);
		const maxX = Math.min(a.maxX, b.maxX);
		const maxY = Math.min(a.maxY, b.maxY);

		return Math.max(0, maxX - minX) *  Math.max(0, maxY - minY);
	}
	equal(arg){
		const a = this;
		const b = toBBOX(arg);

		return a.minX === b.minX && a.minY === b.minY && a.maxX === b.maxX && a.maxY === b.maxY;
	}
	center(){
		const a = this;

		return [
			a.minX + (a.maxX - a.minX),
			a.minY + (a.maxY - a.minY)
		];
	}
	pointInside(point){
		const a = this;
		const x = point.x || point[0];
		const y = point.y || point[1];

		return a.minX <= x && x <= a.maxX && a.minY <= y && y <= a.maxY;
	}
	size(){
		const a = this;
		
		return {x: a.maxX - a.minX, y: a.maxY - a.minY};
	}
	area(){
		const a = this;

		return (a.maxX - a.minX) * (a.maxY - a.minY);
	}
	margin(){
		const a = this;

		return (a.maxX - a.minX) + (a.maxY - a.minY);
	}
	buffer(dist, units = 'm'){
		if(!dist){ return; }

		const a = this;
		const min = direct([a.minX, a.minY], 225, dist, units).point;
		const max = direct([a.maxX, a.maxY], 45, dist, units).point;

		a.add(min);
		a.add(max);

		return a;
	}
	merge(bbox){
		const a = this;

		a.minX = Math.min(bbox.minX, a.minX);
		a.minY = Math.min(bbox.minY, a.minY);
		a.maxX = Math.max(bbox.maxX, a.maxX);
		a.maxY = Math.max(bbox.maxY, a.maxY);

		return a;
	}
	shift(axis, deg){
		const a = this;
		const xy = axis.toUpperCase();

		a[`min${xy}`] += deg;
		a[`max${xy}`] += deg;

		return a;
	}
	clone(){
		const a = this;

		return new BBOX([[a.minX, a.minY], [a.maxX, a.maxY]]);
	}
};

function bbox(coords){
	return new BBOX$1(coords);
}

function rtree(maxEntries = 9){
	return new RTree(maxEntries);
}

class RTree{
	constructor(maxEntries = 9){
		this.maxEntries = Math.max(4, maxEntries);
		this.minEntries = Math.max(2, Math.ceil(this.maxEntries * 0.4));
		this.clear();
	}
	insert(item, level = this.data.height - 1){
		const bbox = getSetBBOX(item);
		const path = [];
		const node = this.getSubTree(bbox, this.data, level, path);

		node.children.push(item);
		node.bbox.merge(bbox);

		while(level >= 0){
			if(path[level].children.length > this.maxEntries){
				this.split(path, level);
				level--;
			} else {
				break;
			}
		}

		updatePath(bbox, path, level);
	}
	remove(item, equalsFn){
		if(!item){ return; }

		const bbox = getSetBBOX(item);
		const path = [];
		const indexes = [];
		let node = this.data;
		let idx = null;
		let up = null;
		let parent = null;

		while(node || path.length){
			if(!node){
				node = path.pop();
				parent = path[path.at(-1)];
				idx = indexes.pop();
				up = true;
			}

			if(node.leaf){
				const index = findItem(item, node.children, equalsFn);

				if(index !== -1){
					node.children.splice(index, 1);
					path.push(node);
					this.condense(path);
					
					return;
				}
			}

			if(!up && !node.leaf && node.bbox.contains(bbox)){
				path.push(node);
				indexes.push(idx);
				idx = 0;
				parent = node;
				node = node.children[0];
			} else if(parent){
				idx++;
				node = parent.children[idx];
				up = false;
			} else {
				node = null;
			}
		}
	}
	search(obj){
		const bbox = getSetBBOX(obj);
		const out = [];
		let node = this.data;

		if(!bbox.intersect(node.bbox)){ return out; }

		const arr = [];

		while(node){
			const {children} = node;

			for(let i = 0, len = children.length; i < len; i++){
				const child = children[i];

				if(bbox.intersect(child.bbox)){
					if(node.leaf){
						out.push(child);
					} else if(bbox.contains(child.bbox)){
						this.all(child, out);
					} else {
						arr.push(child);
					}
				}
			}
			
			node = arr.pop();
		}

		return out;
	}
	split(path, level){
		const node = path[level];
		const len = node.children.length;
		const entries = this.minEntries;

		this.splitAxis(node, entries, len);

		const idx = this.splitIndex(node, entries, len);
		const {children} = node;

		const newNode = createNode(children.splice(idx, children.length - idx));
		newNode.height = node.height;
		newNode.leaf = node.leaf;

		calcBBOX(node);
		calcBBOX(newNode);

		if(level){
			path[level - 1].children.push(newNode);
		} else {
			this.splitRoot(node, newNode);
		}
	}
	splitRoot(node, newNode){
		this.data = createNode([node, newNode]);
		this.data.height = node.height + 1;
		this.data.leaf = false;

		calcBBOX(this.data);
	}
	splitAxis(node, entries, len){
		const xMargin = this.getMargin(node, entries, len, 'x');
		const yMargin = this.getMargin(node, entries, len, 'y');

		if(xMargin < yMargin){ node.children.sort(compareX); }
	}
	splitIndex(node, entries, len){
		let idx = null;
		let minOverlap = Infinity;
		let minArea = Infinity;

		for(let i = entries; i <= len - entries; i++){
			const bbox1 = distBBOX(node, 0, i).bbox;
			const bbox2 = distBBOX(node, i, len).bbox;
			const overlap = bbox1.intersectArea(bbox2);
			const area = bbox1.area() + bbox2.area();

			if(overlap < minOverlap){
				minOverlap = overlap;
				idx = i;
				minArea = Math.min(area, minArea);
			} else if(overlap === minOverlap){
				if(area < minArea){
					minArea = area;
					idx = i;
				}
			}
		}

		return idx || len - entries;
	}
	getMargin(node, entries, len, xy){
		const compare = xy === 'x' ? compareX : compareY;
		node.children.sort(compare);

		const left = distBBOX(node, 0, entries).bbox;
		const right = distBBOX(node, len - entries, len).bbox;
		
		let margin = left.margin() + right.margin();

		for(let i = entries; i < len - entries; i++){
			left.merge(node.children[i].bbox);
			margin += left.margin();
		}

		for(let i = len - entries - 1; i >= entries; i--){
			right.merge(node.children[i].bbox);
			margin += right.margin();
		}

		return margin;
	}
	getSubTree(bbox, node, level, path){
		while(true){
			const {leaf, children} = node;
			path.push(node);

			if(leaf || path.length - 1 === level){ break; }

			let minArea = Infinity;
			let minEnlarge = Infinity;
			let targetNode = null;

			for(let i = 0, len = children.length; i < len; i++){
				const child = children[i];
				const area = child.bbox.area();
				const enlarge = enlargedArea(bbox, child.bbox) - area;

				if(enlarge < minEnlarge){
					minEnlarge = enlarge;
					minArea = Math.min(area, minArea);
					targetNode = child;
				} else if(enlarge === minEnlarge){
					if(area < minArea){
						minArea = area;
						targetNode = child;
					}
				}
			}

			node = targetNode || node.children[0];
		}

		return node;
	}
	condense(path){
		for(let i = path.length - 1; i >= 0; i--){
			if(path[i].children.length === 0){
				if(i > 0){
					const siblings = path[i - 1].children;
					siblings.splice(siblings.indexOf(path[i]), 1);
				} else {
					this.clear();
				}
			} else {
				calcBBOX(path[i]);
			}
		}
	}
	all(node = this.data, out = []){
		const arr = [];

		while(node){
			if(node.leaf){
				out.push(...node.children);
			} else {
				arr.push(...node.children);
			}

			node = arr.pop();
		}

		return out;
	}
	load(arr = []){
		for(let i = 0, len = arr.length; i < len; i++){
			this.insert(arr[i]);
		}

		return this;
	}
	clear(){
		this.data = createNode([]);
	}
}
function getSetBBOX(item){
	if(item.bbox){ return item.bbox; }

	item.bbox = bbox();

	if(Object.hasOwn(item, 'x')){
		item.bbox.add(item);
	} else {
		item.bbox.merge(item);
	}

	return item.bbox;
}
function compareX(a, b){
	a.bbox = a.bbox || getSetBBOX(a);
	b.bbox = b.bbox || getSetBBOX(b);

	return a.bbox.minX - b.bbox.minX;
}
function compareY(a, b){
	a.bbox = a.bbox || getSetBBOX(a);
	b.bbox = b.bbox || getSetBBOX(b);

	return a.bbox.minY - b.bbox.minY;
}
function updatePath(bbox, path, level){
	for(let i = level; i >= 0; i--){
		path[i].bbox.merge(bbox);
	}
}
function enlargedArea(a, b){
	const x = Math.max(b.maxX, a.maxX) - Math.min(b.minX, a.minX);
	const y = Math.max(b.maxY, a.maxY) - Math.min(b.minY, a.minY);
	
	return x * y;
}
function calcBBOX(node){
	distBBOX(node, 0, node.children.length, node);
}
function distBBOX(node, idx, len, target){
	target = target || createNode();
	target.bbox.clear();

	for(let i = idx; i < len; i++){
		target.bbox.merge(node.children[i].bbox);
	}

	return target;
}
function findItem(item, items, equalsFn){
	if(!equalsFn){ return items.indexOf(item); }

	for(let i = 0; i < items.length; i++){
		if(equalsFn(item, items[i])){ return i; }
	}
	
	return -1;
}
function createNode(children = []){
	return {
		children: children,
		height: 1,
		leaf: true,
		bbox: bbox()
	};
}

/*
 *      bignumber.js v9.3.1
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2025 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */


var
  isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i,
  mathceil = Math.ceil,
  mathfloor = Math.floor,

  bignumberError = '[BigNumber Error] ',
  tooManyDigits = bignumberError + 'Number primitive has more than 15 significant digits: ',

  BASE = 1e14,
  LOG_BASE = 14,
  MAX_SAFE_INTEGER = 0x1fffffffffffff,         // 2^53 - 1
  // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
  POWS_TEN = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13],
  SQRT_BASE = 1e7,

  // EDITABLE
  // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
  // the arguments to toExponential, toFixed, toFormat, and toPrecision.
  MAX = 1E9;                                   // 0 to MAX_INT32


/*
 * Create and return a BigNumber constructor.
 */
function clone$1(configObject) {
  var div, convertBase, parseNumeric,
    P = BigNumber.prototype = { constructor: BigNumber, toString: null, valueOf: null },
    ONE = new BigNumber(1),


    //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------


    // The default values below must be integers within the inclusive ranges stated.
    // The values can also be changed at run-time using BigNumber.set.

    // The maximum number of decimal places for operations involving division.
    DECIMAL_PLACES = 20,                     // 0 to MAX

    // The rounding mode used when rounding to the above decimal places, and when using
    // toExponential, toFixed, toFormat and toPrecision, and round (default value).
    // UP         0 Away from zero.
    // DOWN       1 Towards zero.
    // CEIL       2 Towards +Infinity.
    // FLOOR      3 Towards -Infinity.
    // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
    // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
    // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
    // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
    // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
    ROUNDING_MODE = 4,                       // 0 to 8

    // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]

    // The exponent value at and beneath which toString returns exponential notation.
    // Number type: -7
    TO_EXP_NEG = -7,                         // 0 to -MAX

    // The exponent value at and above which toString returns exponential notation.
    // Number type: 21
    TO_EXP_POS = 21,                         // 0 to MAX

    // RANGE : [MIN_EXP, MAX_EXP]

    // The minimum exponent value, beneath which underflow to zero occurs.
    // Number type: -324  (5e-324)
    MIN_EXP = -1e7,                          // -1 to -MAX

    // The maximum exponent value, above which overflow to Infinity occurs.
    // Number type:  308  (1.7976931348623157e+308)
    // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
    MAX_EXP = 1e7,                           // 1 to MAX

    // Whether to use cryptographically-secure random number generation, if available.
    CRYPTO = false,                          // true or false

    // The modulo mode used when calculating the modulus: a mod n.
    // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
    // The remainder (r) is calculated as: r = a - n * q.
    //
    // UP        0 The remainder is positive if the dividend is negative, else is negative.
    // DOWN      1 The remainder has the same sign as the dividend.
    //             This modulo mode is commonly known as 'truncated division' and is
    //             equivalent to (a % n) in JavaScript.
    // FLOOR     3 The remainder has the same sign as the divisor (Python %).
    // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
    // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
    //             The remainder is always positive.
    //
    // The truncated division, floored division, Euclidian division and IEEE 754 remainder
    // modes are commonly used for the modulus operation.
    // Although the other rounding modes can also be used, they may not give useful results.
    MODULO_MODE = 1,                         // 0 to 9

    // The maximum number of significant digits of the result of the exponentiatedBy operation.
    // If POW_PRECISION is 0, there will be unlimited significant digits.
    POW_PRECISION = 0,                       // 0 to MAX

    // The format specification used by the BigNumber.prototype.toFormat method.
    FORMAT = {
      prefix: '',
      groupSize: 3,
      secondaryGroupSize: 0,
      groupSeparator: ',',
      decimalSeparator: '.',
      fractionGroupSize: 0,
      fractionGroupSeparator: '\xA0',        // non-breaking space
      suffix: ''
    },

    // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
    // '-', '.', whitespace, or repeated character.
    // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
    ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz',
    alphabetHasNormalDecimalDigits = true;


  //------------------------------------------------------------------------------------------


  // CONSTRUCTOR


  /*
   * The BigNumber constructor and exported function.
   * Create and return a new instance of a BigNumber object.
   *
   * v {number|string|BigNumber} A numeric value.
   * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
   */
  function BigNumber(v, b) {
    var alphabet, c, caseChanged, e, i, isNum, len, str,
      x = this;

    // Enable constructor call without `new`.
    if (!(x instanceof BigNumber)) return new BigNumber(v, b);

    if (b == null) {

      if (v && v._isBigNumber === true) {
        x.s = v.s;

        if (!v.c || v.e > MAX_EXP) {
          x.c = x.e = null;
        } else if (v.e < MIN_EXP) {
          x.c = [x.e = 0];
        } else {
          x.e = v.e;
          x.c = v.c.slice();
        }

        return;
      }

      if ((isNum = typeof v == 'number') && v * 0 == 0) {

        // Use `1 / n` to handle minus zero also.
        x.s = 1 / v < 0 ? (v = -v, -1) : 1;

        // Fast path for integers, where n < 2147483648 (2**31).
        if (v === ~~v) {
          for (e = 0, i = v; i >= 10; i /= 10, e++);

          if (e > MAX_EXP) {
            x.c = x.e = null;
          } else {
            x.e = e;
            x.c = [v];
          }

          return;
        }

        str = String(v);
      } else {

        if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);

        x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
      }

      // Decimal point?
      if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');

      // Exponential form?
      if ((i = str.search(/e/i)) > 0) {

        // Determine exponent.
        if (e < 0) e = i;
        e += +str.slice(i + 1);
        str = str.substring(0, i);
      } else if (e < 0) {

        // Integer.
        e = str.length;
      }

    } else {

      // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
      intCheck(b, 2, ALPHABET.length, 'Base');

      // Allow exponential notation to be used with base 10 argument, while
      // also rounding to DECIMAL_PLACES as with other bases.
      if (b == 10 && alphabetHasNormalDecimalDigits) {
        x = new BigNumber(v);
        return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
      }

      str = String(v);

      if (isNum = typeof v == 'number') {

        // Avoid potential interpretation of Infinity and NaN as base 44+ values.
        if (v * 0 != 0) return parseNumeric(x, str, isNum, b);

        x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;

        // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
        if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, '').length > 15) {
          throw Error
           (tooManyDigits + v);
        }
      } else {
        x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
      }

      alphabet = ALPHABET.slice(0, b);
      e = i = 0;

      // Check that str is a valid base b number.
      // Don't use RegExp, so alphabet can contain special characters.
      for (len = str.length; i < len; i++) {
        if (alphabet.indexOf(c = str.charAt(i)) < 0) {
          if (c == '.') {

            // If '.' is not the first character and it has not be found before.
            if (i > e) {
              e = len;
              continue;
            }
          } else if (!caseChanged) {

            // Allow e.g. hexadecimal 'FF' as well as 'ff'.
            if (str == str.toUpperCase() && (str = str.toLowerCase()) ||
                str == str.toLowerCase() && (str = str.toUpperCase())) {
              caseChanged = true;
              i = -1;
              e = 0;
              continue;
            }
          }

          return parseNumeric(x, String(v), isNum, b);
        }
      }

      // Prevent later check for length on converted number.
      isNum = false;
      str = convertBase(str, b, 10, x.s);

      // Decimal point?
      if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
      else e = str.length;
    }

    // Determine leading zeros.
    for (i = 0; str.charCodeAt(i) === 48; i++);

    // Determine trailing zeros.
    for (len = str.length; str.charCodeAt(--len) === 48;);

    if (str = str.slice(i, ++len)) {
      len -= i;

      // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
      if (isNum && BigNumber.DEBUG &&
        len > 15 && (v > MAX_SAFE_INTEGER || v !== mathfloor(v))) {
          throw Error
           (tooManyDigits + (x.s * v));
      }

       // Overflow?
      if ((e = e - i - 1) > MAX_EXP) {

        // Infinity.
        x.c = x.e = null;

      // Underflow?
      } else if (e < MIN_EXP) {

        // Zero.
        x.c = [x.e = 0];
      } else {
        x.e = e;
        x.c = [];

        // Transform base

        // e is the base 10 exponent.
        // i is where to slice str to get the first element of the coefficient array.
        i = (e + 1) % LOG_BASE;
        if (e < 0) i += LOG_BASE;  // i < 1

        if (i < len) {
          if (i) x.c.push(+str.slice(0, i));

          for (len -= LOG_BASE; i < len;) {
            x.c.push(+str.slice(i, i += LOG_BASE));
          }

          i = LOG_BASE - (str = str.slice(i)).length;
        } else {
          i -= len;
        }

        for (; i--; str += '0');
        x.c.push(+str);
      }
    } else {

      // Zero.
      x.c = [x.e = 0];
    }
  }


  // CONSTRUCTOR PROPERTIES


  BigNumber.clone = clone$1;

  BigNumber.ROUND_UP = 0;
  BigNumber.ROUND_DOWN = 1;
  BigNumber.ROUND_CEIL = 2;
  BigNumber.ROUND_FLOOR = 3;
  BigNumber.ROUND_HALF_UP = 4;
  BigNumber.ROUND_HALF_DOWN = 5;
  BigNumber.ROUND_HALF_EVEN = 6;
  BigNumber.ROUND_HALF_CEIL = 7;
  BigNumber.ROUND_HALF_FLOOR = 8;
  BigNumber.EUCLID = 9;


  /*
   * Configure infrequently-changing library-wide settings.
   *
   * Accept an object with the following optional properties (if the value of a property is
   * a number, it must be an integer within the inclusive range stated):
   *
   *   DECIMAL_PLACES   {number}           0 to MAX
   *   ROUNDING_MODE    {number}           0 to 8
   *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
   *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
   *   CRYPTO           {boolean}          true or false
   *   MODULO_MODE      {number}           0 to 9
   *   POW_PRECISION       {number}           0 to MAX
   *   ALPHABET         {string}           A string of two or more unique characters which does
   *                                       not contain '.'.
   *   FORMAT           {object}           An object with some of the following properties:
   *     prefix                 {string}
   *     groupSize              {number}
   *     secondaryGroupSize     {number}
   *     groupSeparator         {string}
   *     decimalSeparator       {string}
   *     fractionGroupSize      {number}
   *     fractionGroupSeparator {string}
   *     suffix                 {string}
   *
   * (The values assigned to the above FORMAT object properties are not checked for validity.)
   *
   * E.g.
   * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
   *
   * Ignore properties/parameters set to null or undefined, except for ALPHABET.
   *
   * Return an object with the properties current values.
   */
  BigNumber.config = BigNumber.set = function (obj) {
    var p, v;

    if (obj != null) {

      if (typeof obj == 'object') {

        // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
        // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
        if (obj.hasOwnProperty(p = 'DECIMAL_PLACES')) {
          v = obj[p];
          intCheck(v, 0, MAX, p);
          DECIMAL_PLACES = v;
        }

        // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
        // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
        if (obj.hasOwnProperty(p = 'ROUNDING_MODE')) {
          v = obj[p];
          intCheck(v, 0, 8, p);
          ROUNDING_MODE = v;
        }

        // EXPONENTIAL_AT {number|number[]}
        // Integer, -MAX to MAX inclusive or
        // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
        // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
        if (obj.hasOwnProperty(p = 'EXPONENTIAL_AT')) {
          v = obj[p];
          if (v && v.pop) {
            intCheck(v[0], -MAX, 0, p);
            intCheck(v[1], 0, MAX, p);
            TO_EXP_NEG = v[0];
            TO_EXP_POS = v[1];
          } else {
            intCheck(v, -MAX, MAX, p);
            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
          }
        }

        // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
        // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
        // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
        if (obj.hasOwnProperty(p = 'RANGE')) {
          v = obj[p];
          if (v && v.pop) {
            intCheck(v[0], -MAX, -1, p);
            intCheck(v[1], 1, MAX, p);
            MIN_EXP = v[0];
            MAX_EXP = v[1];
          } else {
            intCheck(v, -MAX, MAX, p);
            if (v) {
              MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
            } else {
              throw Error
               (bignumberError + p + ' cannot be zero: ' + v);
            }
          }
        }

        // CRYPTO {boolean} true or false.
        // '[BigNumber Error] CRYPTO not true or false: {v}'
        // '[BigNumber Error] crypto unavailable'
        if (obj.hasOwnProperty(p = 'CRYPTO')) {
          v = obj[p];
          if (v === !!v) {
            if (v) {
              if (typeof crypto != 'undefined' && crypto &&
               (crypto.getRandomValues || crypto.randomBytes)) {
                CRYPTO = v;
              } else {
                CRYPTO = !v;
                throw Error
                 (bignumberError + 'crypto unavailable');
              }
            } else {
              CRYPTO = v;
            }
          } else {
            throw Error
             (bignumberError + p + ' not true or false: ' + v);
          }
        }

        // MODULO_MODE {number} Integer, 0 to 9 inclusive.
        // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
        if (obj.hasOwnProperty(p = 'MODULO_MODE')) {
          v = obj[p];
          intCheck(v, 0, 9, p);
          MODULO_MODE = v;
        }

        // POW_PRECISION {number} Integer, 0 to MAX inclusive.
        // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
        if (obj.hasOwnProperty(p = 'POW_PRECISION')) {
          v = obj[p];
          intCheck(v, 0, MAX, p);
          POW_PRECISION = v;
        }

        // FORMAT {object}
        // '[BigNumber Error] FORMAT not an object: {v}'
        if (obj.hasOwnProperty(p = 'FORMAT')) {
          v = obj[p];
          if (typeof v == 'object') FORMAT = v;
          else throw Error
           (bignumberError + p + ' not an object: ' + v);
        }

        // ALPHABET {string}
        // '[BigNumber Error] ALPHABET invalid: {v}'
        if (obj.hasOwnProperty(p = 'ALPHABET')) {
          v = obj[p];

          // Disallow if less than two characters,
          // or if it contains '+', '-', '.', whitespace, or a repeated character.
          if (typeof v == 'string' && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
            alphabetHasNormalDecimalDigits = v.slice(0, 10) == '0123456789';
            ALPHABET = v;
          } else {
            throw Error
             (bignumberError + p + ' invalid: ' + v);
          }
        }

      } else {

        // '[BigNumber Error] Object expected: {v}'
        throw Error
         (bignumberError + 'Object expected: ' + obj);
      }
    }

    return {
      DECIMAL_PLACES: DECIMAL_PLACES,
      ROUNDING_MODE: ROUNDING_MODE,
      EXPONENTIAL_AT: [TO_EXP_NEG, TO_EXP_POS],
      RANGE: [MIN_EXP, MAX_EXP],
      CRYPTO: CRYPTO,
      MODULO_MODE: MODULO_MODE,
      POW_PRECISION: POW_PRECISION,
      FORMAT: FORMAT,
      ALPHABET: ALPHABET
    };
  };


  /*
   * Return true if v is a BigNumber instance, otherwise return false.
   *
   * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
   *
   * v {any}
   *
   * '[BigNumber Error] Invalid BigNumber: {v}'
   */
  BigNumber.isBigNumber = function (v) {
    if (!v || v._isBigNumber !== true) return false;
    if (!BigNumber.DEBUG) return true;

    var i, n,
      c = v.c,
      e = v.e,
      s = v.s;

    out: if ({}.toString.call(c) == '[object Array]') {

      if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {

        // If the first element is zero, the BigNumber value must be zero.
        if (c[0] === 0) {
          if (e === 0 && c.length === 1) return true;
          break out;
        }

        // Calculate number of digits that c[0] should have, based on the exponent.
        i = (e + 1) % LOG_BASE;
        if (i < 1) i += LOG_BASE;

        // Calculate number of digits of c[0].
        //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
        if (String(c[0]).length == i) {

          for (i = 0; i < c.length; i++) {
            n = c[i];
            if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
          }

          // Last element cannot be zero, unless it is the only element.
          if (n !== 0) return true;
        }
      }

    // Infinity/NaN
    } else if (c === null && e === null && (s === null || s === 1 || s === -1)) {
      return true;
    }

    throw Error
      (bignumberError + 'Invalid BigNumber: ' + v);
  };


  /*
   * Return a new BigNumber whose value is the maximum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */
  BigNumber.maximum = BigNumber.max = function () {
    return maxOrMin(arguments, -1);
  };


  /*
   * Return a new BigNumber whose value is the minimum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */
  BigNumber.minimum = BigNumber.min = function () {
    return maxOrMin(arguments, 1);
  };


  /*
   * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
   * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
   * zeros are produced).
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
   * '[BigNumber Error] crypto unavailable'
   */
  BigNumber.random = (function () {
    var pow2_53 = 0x20000000000000;

    // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
    // Check if Math.random() produces more than 32 bits of randomness.
    // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
    // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
    var random53bitInt = (Math.random() * pow2_53) & 0x1fffff
     ? function () { return mathfloor(Math.random() * pow2_53); }
     : function () { return ((Math.random() * 0x40000000 | 0) * 0x800000) +
       (Math.random() * 0x800000 | 0); };

    return function (dp) {
      var a, b, e, k, v,
        i = 0,
        c = [],
        rand = new BigNumber(ONE);

      if (dp == null) dp = DECIMAL_PLACES;
      else intCheck(dp, 0, MAX);

      k = mathceil(dp / LOG_BASE);

      if (CRYPTO) {

        // Browsers supporting crypto.getRandomValues.
        if (crypto.getRandomValues) {

          a = crypto.getRandomValues(new Uint32Array(k *= 2));

          for (; i < k;) {

            // 53 bits:
            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
            //                                     11111 11111111 11111111
            // 0x20000 is 2^21.
            v = a[i] * 0x20000 + (a[i + 1] >>> 11);

            // Rejection sampling:
            // 0 <= v < 9007199254740992
            // Probability that v >= 9e15, is
            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
            if (v >= 9e15) {
              b = crypto.getRandomValues(new Uint32Array(2));
              a[i] = b[0];
              a[i + 1] = b[1];
            } else {

              // 0 <= v <= 8999999999999999
              // 0 <= (v % 1e14) <= 99999999999999
              c.push(v % 1e14);
              i += 2;
            }
          }
          i = k / 2;

        // Node.js supporting crypto.randomBytes.
        } else if (crypto.randomBytes) {

          // buffer
          a = crypto.randomBytes(k *= 7);

          for (; i < k;) {

            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
            // 0x100000000 is 2^32, 0x1000000 is 2^24
            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
            // 0 <= v < 9007199254740992
            v = ((a[i] & 31) * 0x1000000000000) + (a[i + 1] * 0x10000000000) +
               (a[i + 2] * 0x100000000) + (a[i + 3] * 0x1000000) +
               (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];

            if (v >= 9e15) {
              crypto.randomBytes(7).copy(a, i);
            } else {

              // 0 <= (v % 1e14) <= 99999999999999
              c.push(v % 1e14);
              i += 7;
            }
          }
          i = k / 7;
        } else {
          CRYPTO = false;
          throw Error
           (bignumberError + 'crypto unavailable');
        }
      }

      // Use Math.random.
      if (!CRYPTO) {

        for (; i < k;) {
          v = random53bitInt();
          if (v < 9e15) c[i++] = v % 1e14;
        }
      }

      k = c[--i];
      dp %= LOG_BASE;

      // Convert trailing digits to zeros according to dp.
      if (k && dp) {
        v = POWS_TEN[LOG_BASE - dp];
        c[i] = mathfloor(k / v) * v;
      }

      // Remove trailing elements which are zero.
      for (; c[i] === 0; c.pop(), i--);

      // Zero?
      if (i < 0) {
        c = [e = 0];
      } else {

        // Remove leading elements which are zero and adjust exponent accordingly.
        for (e = -1 ; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);

        // Count the digits of the first element of c to determine leading zeros, and...
        for (i = 1, v = c[0]; v >= 10; v /= 10, i++);

        // adjust the exponent accordingly.
        if (i < LOG_BASE) e -= LOG_BASE - i;
      }

      rand.e = e;
      rand.c = c;
      return rand;
    };
  })();


   /*
   * Return a BigNumber whose value is the sum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */
  BigNumber.sum = function () {
    var i = 1,
      args = arguments,
      sum = new BigNumber(args[0]);
    for (; i < args.length;) sum = sum.plus(args[i++]);
    return sum;
  };


  // PRIVATE FUNCTIONS


  // Called by BigNumber and BigNumber.prototype.toString.
  convertBase = (function () {
    var decimal = '0123456789';

    /*
     * Convert string of baseIn to an array of numbers of baseOut.
     * Eg. toBaseOut('255', 10, 16) returns [15, 15].
     * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
     */
    function toBaseOut(str, baseIn, baseOut, alphabet) {
      var j,
        arr = [0],
        arrL,
        i = 0,
        len = str.length;

      for (; i < len;) {
        for (arrL = arr.length; arrL--; arr[arrL] *= baseIn);

        arr[0] += alphabet.indexOf(str.charAt(i++));

        for (j = 0; j < arr.length; j++) {

          if (arr[j] > baseOut - 1) {
            if (arr[j + 1] == null) arr[j + 1] = 0;
            arr[j + 1] += arr[j] / baseOut | 0;
            arr[j] %= baseOut;
          }
        }
      }

      return arr.reverse();
    }

    // Convert a numeric string of baseIn to a numeric string of baseOut.
    // If the caller is toString, we are converting from base 10 to baseOut.
    // If the caller is BigNumber, we are converting from baseIn to base 10.
    return function (str, baseIn, baseOut, sign, callerIsToString) {
      var alphabet, d, e, k, r, x, xc, y,
        i = str.indexOf('.'),
        dp = DECIMAL_PLACES,
        rm = ROUNDING_MODE;

      // Non-integer.
      if (i >= 0) {
        k = POW_PRECISION;

        // Unlimited precision.
        POW_PRECISION = 0;
        str = str.replace('.', '');
        y = new BigNumber(baseIn);
        x = y.pow(str.length - i);
        POW_PRECISION = k;

        // Convert str as if an integer, then restore the fraction part by dividing the
        // result by its base raised to a power.

        y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, '0'),
         10, baseOut, decimal);
        y.e = y.c.length;
      }

      // Convert the number as integer.

      xc = toBaseOut(str, baseIn, baseOut, callerIsToString
       ? (alphabet = ALPHABET, decimal)
       : (alphabet = decimal, ALPHABET));

      // xc now represents str as an integer and converted to baseOut. e is the exponent.
      e = k = xc.length;

      // Remove trailing zeros.
      for (; xc[--k] == 0; xc.pop());

      // Zero?
      if (!xc[0]) return alphabet.charAt(0);

      // Does str represent an integer? If so, no need for the division.
      if (i < 0) {
        --e;
      } else {
        x.c = xc;
        x.e = e;

        // The sign is needed for correct rounding.
        x.s = sign;
        x = div(x, y, dp, rm, baseOut);
        xc = x.c;
        r = x.r;
        e = x.e;
      }

      // xc now represents str converted to baseOut.

      // The index of the rounding digit.
      d = e + dp + 1;

      // The rounding digit: the digit to the right of the digit that may be rounded up.
      i = xc[d];

      // Look at the rounding digits and mode to determine whether to round up.

      k = baseOut / 2;
      r = r || d < 0 || xc[d + 1] != null;

      r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
            : i > k || i == k &&(rm == 4 || r || rm == 6 && xc[d - 1] & 1 ||
             rm == (x.s < 0 ? 8 : 7));

      // If the index of the rounding digit is not greater than zero, or xc represents
      // zero, then the result of the base conversion is zero or, if rounding up, a value
      // such as 0.00001.
      if (d < 1 || !xc[0]) {

        // 1^-dp or 0
        str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
      } else {

        // Truncate xc to the required number of decimal places.
        xc.length = d;

        // Round up?
        if (r) {

          // Rounding up may mean the previous digit has to be rounded up and so on.
          for (--baseOut; ++xc[--d] > baseOut;) {
            xc[d] = 0;

            if (!d) {
              ++e;
              xc = [1].concat(xc);
            }
          }
        }

        // Determine trailing zeros.
        for (k = xc.length; !xc[--k];);

        // E.g. [4, 11, 15] becomes 4bf.
        for (i = 0, str = ''; i <= k; str += alphabet.charAt(xc[i++]));

        // Add leading zeros, decimal point and trailing zeros as required.
        str = toFixedPoint(str, e, alphabet.charAt(0));
      }

      // The caller will add the sign.
      return str;
    };
  })();


  // Perform division in the specified base. Called by div and convertBase.
  div = (function () {

    // Assume non-zero x and k.
    function multiply(x, k, base) {
      var m, temp, xlo, xhi,
        carry = 0,
        i = x.length,
        klo = k % SQRT_BASE,
        khi = k / SQRT_BASE | 0;

      for (x = x.slice(); i--;) {
        xlo = x[i] % SQRT_BASE;
        xhi = x[i] / SQRT_BASE | 0;
        m = khi * xlo + xhi * klo;
        temp = klo * xlo + ((m % SQRT_BASE) * SQRT_BASE) + carry;
        carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
        x[i] = temp % base;
      }

      if (carry) x = [carry].concat(x);

      return x;
    }

    function compare(a, b, aL, bL) {
      var i, cmp;

      if (aL != bL) {
        cmp = aL > bL ? 1 : -1;
      } else {

        for (i = cmp = 0; i < aL; i++) {

          if (a[i] != b[i]) {
            cmp = a[i] > b[i] ? 1 : -1;
            break;
          }
        }
      }

      return cmp;
    }

    function subtract(a, b, aL, base) {
      var i = 0;

      // Subtract b from a.
      for (; aL--;) {
        a[aL] -= i;
        i = a[aL] < b[aL] ? 1 : 0;
        a[aL] = i * base + a[aL] - b[aL];
      }

      // Remove leading zeros.
      for (; !a[0] && a.length > 1; a.splice(0, 1));
    }

    // x: dividend, y: divisor.
    return function (x, y, dp, rm, base) {
      var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0,
        yL, yz,
        s = x.s == y.s ? 1 : -1,
        xc = x.c,
        yc = y.c;

      // Either NaN, Infinity or 0?
      if (!xc || !xc[0] || !yc || !yc[0]) {

        return new BigNumber(

         // Return NaN if either NaN, or both Infinity or 0.
         !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN :

          // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
          xc && xc[0] == 0 || !yc ? s * 0 : s / 0
       );
      }

      q = new BigNumber(s);
      qc = q.c = [];
      e = x.e - y.e;
      s = dp + e + 1;

      if (!base) {
        base = BASE;
        e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
        s = s / LOG_BASE | 0;
      }

      // Result exponent may be one less then the current value of e.
      // The coefficients of the BigNumbers from convertBase may have trailing zeros.
      for (i = 0; yc[i] == (xc[i] || 0); i++);

      if (yc[i] > (xc[i] || 0)) e--;

      if (s < 0) {
        qc.push(1);
        more = true;
      } else {
        xL = xc.length;
        yL = yc.length;
        i = 0;
        s += 2;

        // Normalise xc and yc so highest order digit of yc is >= base / 2.

        n = mathfloor(base / (yc[0] + 1));

        // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
        // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
        if (n > 1) {
          yc = multiply(yc, n, base);
          xc = multiply(xc, n, base);
          yL = yc.length;
          xL = xc.length;
        }

        xi = yL;
        rem = xc.slice(0, yL);
        remL = rem.length;

        // Add zeros to make remainder as long as divisor.
        for (; remL < yL; rem[remL++] = 0);
        yz = yc.slice();
        yz = [0].concat(yz);
        yc0 = yc[0];
        if (yc[1] >= base / 2) yc0++;
        // Not necessary, but to prevent trial digit n > base, when using base 3.
        // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;

        do {
          n = 0;

          // Compare divisor and remainder.
          cmp = compare(yc, rem, yL, remL);

          // If divisor < remainder.
          if (cmp < 0) {

            // Calculate trial digit, n.

            rem0 = rem[0];
            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);

            // n is how many times the divisor goes into the current remainder.
            n = mathfloor(rem0 / yc0);

            //  Algorithm:
            //  product = divisor multiplied by trial digit (n).
            //  Compare product and remainder.
            //  If product is greater than remainder:
            //    Subtract divisor from product, decrement trial digit.
            //  Subtract product from remainder.
            //  If product was less than remainder at the last compare:
            //    Compare new remainder and divisor.
            //    If remainder is greater than divisor:
            //      Subtract divisor from remainder, increment trial digit.

            if (n > 1) {

              // n may be > base only when base is 3.
              if (n >= base) n = base - 1;

              // product = divisor * trial digit.
              prod = multiply(yc, n, base);
              prodL = prod.length;
              remL = rem.length;

              // Compare product and remainder.
              // If product > remainder then trial digit n too high.
              // n is 1 too high about 5% of the time, and is not known to have
              // ever been more than 1 too high.
              while (compare(prod, rem, prodL, remL) == 1) {
                n--;

                // Subtract divisor from product.
                subtract(prod, yL < prodL ? yz : yc, prodL, base);
                prodL = prod.length;
                cmp = 1;
              }
            } else {

              // n is 0 or 1, cmp is -1.
              // If n is 0, there is no need to compare yc and rem again below,
              // so change cmp to 1 to avoid it.
              // If n is 1, leave cmp as -1, so yc and rem are compared again.
              if (n == 0) {

                // divisor < remainder, so n must be at least 1.
                cmp = n = 1;
              }

              // product = divisor
              prod = yc.slice();
              prodL = prod.length;
            }

            if (prodL < remL) prod = [0].concat(prod);

            // Subtract product from remainder.
            subtract(rem, prod, remL, base);
            remL = rem.length;

             // If product was < remainder.
            if (cmp == -1) {

              // Compare divisor and new remainder.
              // If divisor < new remainder, subtract divisor from remainder.
              // Trial digit n too low.
              // n is 1 too low about 5% of the time, and very rarely 2 too low.
              while (compare(yc, rem, yL, remL) < 1) {
                n++;

                // Subtract divisor from remainder.
                subtract(rem, yL < remL ? yz : yc, remL, base);
                remL = rem.length;
              }
            }
          } else if (cmp === 0) {
            n++;
            rem = [0];
          } // else cmp === 1 and n will be 0

          // Add the next digit, n, to the result array.
          qc[i++] = n;

          // Update the remainder.
          if (rem[0]) {
            rem[remL++] = xc[xi] || 0;
          } else {
            rem = [xc[xi]];
            remL = 1;
          }
        } while ((xi++ < xL || rem[0] != null) && s--);

        more = rem[0] != null;

        // Leading zero?
        if (!qc[0]) qc.splice(0, 1);
      }

      if (base == BASE) {

        // To calculate q.e, first get the number of digits of qc[0].
        for (i = 1, s = qc[0]; s >= 10; s /= 10, i++);

        round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);

      // Caller is convertBase.
      } else {
        q.e = e;
        q.r = +more;
      }

      return q;
    };
  })();


  /*
   * Return a string representing the value of BigNumber n in fixed-point or exponential
   * notation rounded to the specified decimal places or significant digits.
   *
   * n: a BigNumber.
   * i: the index of the last digit required (i.e. the digit that may be rounded up).
   * rm: the rounding mode.
   * id: 1 (toExponential) or 2 (toPrecision).
   */
  function format(n, i, rm, id) {
    var c0, e, ne, len, str;

    if (rm == null) rm = ROUNDING_MODE;
    else intCheck(rm, 0, 8);

    if (!n.c) return n.toString();

    c0 = n.c[0];
    ne = n.e;

    if (i == null) {
      str = coeffToString(n.c);
      str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS)
       ? toExponential(str, ne)
       : toFixedPoint(str, ne, '0');
    } else {
      n = round(new BigNumber(n), i, rm);

      // n.e may have changed if the value was rounded up.
      e = n.e;

      str = coeffToString(n.c);
      len = str.length;

      // toPrecision returns exponential notation if the number of significant digits
      // specified is less than the number of digits necessary to represent the integer
      // part of the value in fixed-point notation.

      // Exponential notation.
      if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {

        // Append zeros?
        for (; len < i; str += '0', len++);
        str = toExponential(str, e);

      // Fixed-point notation.
      } else {
        i -= ne + (id === 2 && e > ne);
        str = toFixedPoint(str, e, '0');

        // Append zeros?
        if (e + 1 > len) {
          if (--i > 0) for (str += '.'; i--; str += '0');
        } else {
          i += e - len;
          if (i > 0) {
            if (e + 1 == len) str += '.';
            for (; i--; str += '0');
          }
        }
      }
    }

    return n.s < 0 && c0 ? '-' + str : str;
  }


  // Handle BigNumber.max and BigNumber.min.
  // If any number is NaN, return NaN.
  function maxOrMin(args, n) {
    var k, y,
      i = 1,
      x = new BigNumber(args[0]);

    for (; i < args.length; i++) {
      y = new BigNumber(args[i]);
      if (!y.s || (k = compare(x, y)) === n || k === 0 && x.s === n) {
        x = y;
      }
    }

    return x;
  }


  /*
   * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
   * Called by minus, plus and times.
   */
  function normalise(n, c, e) {
    var i = 1,
      j = c.length;

     // Remove trailing zeros.
    for (; !c[--j]; c.pop());

    // Calculate the base 10 exponent. First get the number of digits of c[0].
    for (j = c[0]; j >= 10; j /= 10, i++);

    // Overflow?
    if ((e = i + e * LOG_BASE - 1) > MAX_EXP) {

      // Infinity.
      n.c = n.e = null;

    // Underflow?
    } else if (e < MIN_EXP) {

      // Zero.
      n.c = [n.e = 0];
    } else {
      n.e = e;
      n.c = c;
    }

    return n;
  }


  // Handle values that fail the validity test in BigNumber.
  parseNumeric = (function () {
    var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i,
      dotAfter = /^([^.]+)\.$/,
      dotBefore = /^\.([^.]+)$/,
      isInfinityOrNaN = /^-?(Infinity|NaN)$/,
      whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;

    return function (x, str, isNum, b) {
      var base,
        s = isNum ? str : str.replace(whitespaceOrPlus, '');

      // No exception on ±Infinity or NaN.
      if (isInfinityOrNaN.test(s)) {
        x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
      } else {
        if (!isNum) {

          // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
          s = s.replace(basePrefix, function (m, p1, p2) {
            base = (p2 = p2.toLowerCase()) == 'x' ? 16 : p2 == 'b' ? 2 : 8;
            return !b || b == base ? p1 : m;
          });

          if (b) {
            base = b;

            // E.g. '1.' to '1', '.1' to '0.1'
            s = s.replace(dotAfter, '$1').replace(dotBefore, '0.$1');
          }

          if (str != s) return new BigNumber(s, base);
        }

        // '[BigNumber Error] Not a number: {n}'
        // '[BigNumber Error] Not a base {b} number: {n}'
        if (BigNumber.DEBUG) {
          throw Error
            (bignumberError + 'Not a' + (b ? ' base ' + b : '') + ' number: ' + str);
        }

        // NaN
        x.s = null;
      }

      x.c = x.e = null;
    }
  })();


  /*
   * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
   * If r is truthy, it is known that there are more digits after the rounding digit.
   */
  function round(x, sd, rm, r) {
    var d, i, j, k, n, ni, rd,
      xc = x.c,
      pows10 = POWS_TEN;

    // if x is not Infinity or NaN...
    if (xc) {

      // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
      // n is a base 1e14 number, the value of the element of array x.c containing rd.
      // ni is the index of n within x.c.
      // d is the number of digits of n.
      // i is the index of rd within n including leading zeros.
      // j is the actual index of rd within n (if < 0, rd is a leading zero).
      out: {

        // Get the number of digits of the first element of xc.
        for (d = 1, k = xc[0]; k >= 10; k /= 10, d++);
        i = sd - d;

        // If the rounding digit is in the first element of xc...
        if (i < 0) {
          i += LOG_BASE;
          j = sd;
          n = xc[ni = 0];

          // Get the rounding digit at index j of n.
          rd = mathfloor(n / pows10[d - j - 1] % 10);
        } else {
          ni = mathceil((i + 1) / LOG_BASE);

          if (ni >= xc.length) {

            if (r) {

              // Needed by sqrt.
              for (; xc.length <= ni; xc.push(0));
              n = rd = 0;
              d = 1;
              i %= LOG_BASE;
              j = i - LOG_BASE + 1;
            } else {
              break out;
            }
          } else {
            n = k = xc[ni];

            // Get the number of digits of n.
            for (d = 1; k >= 10; k /= 10, d++);

            // Get the index of rd within n.
            i %= LOG_BASE;

            // Get the index of rd within n, adjusted for leading zeros.
            // The number of leading zeros of n is given by LOG_BASE - d.
            j = i - LOG_BASE + d;

            // Get the rounding digit at index j of n.
            rd = j < 0 ? 0 : mathfloor(n / pows10[d - j - 1] % 10);
          }
        }

        r = r || sd < 0 ||

        // Are there any non-zero digits after the rounding digit?
        // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
        // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
         xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);

        r = rm < 4
         ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
         : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 &&

          // Check whether the digit to the left of the rounding digit is odd.
          ((i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10) & 1 ||
           rm == (x.s < 0 ? 8 : 7));

        if (sd < 1 || !xc[0]) {
          xc.length = 0;

          if (r) {

            // Convert sd to decimal places.
            sd -= x.e + 1;

            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
            x.e = -sd || 0;
          } else {

            // Zero.
            xc[0] = x.e = 0;
          }

          return x;
        }

        // Remove excess digits.
        if (i == 0) {
          xc.length = ni;
          k = 1;
          ni--;
        } else {
          xc.length = ni + 1;
          k = pows10[LOG_BASE - i];

          // E.g. 56700 becomes 56000 if 7 is the rounding digit.
          // j > 0 means i > number of leading zeros of n.
          xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
        }

        // Round up?
        if (r) {

          for (; ;) {

            // If the digit to be rounded up is in the first element of xc...
            if (ni == 0) {

              // i will be the length of xc[0] before k is added.
              for (i = 1, j = xc[0]; j >= 10; j /= 10, i++);
              j = xc[0] += k;
              for (k = 1; j >= 10; j /= 10, k++);

              // if i != k the length has increased.
              if (i != k) {
                x.e++;
                if (xc[0] == BASE) xc[0] = 1;
              }

              break;
            } else {
              xc[ni] += k;
              if (xc[ni] != BASE) break;
              xc[ni--] = 0;
              k = 1;
            }
          }
        }

        // Remove trailing zeros.
        for (i = xc.length; xc[--i] === 0; xc.pop());
      }

      // Overflow? Infinity.
      if (x.e > MAX_EXP) {
        x.c = x.e = null;

      // Underflow? Zero.
      } else if (x.e < MIN_EXP) {
        x.c = [x.e = 0];
      }
    }

    return x;
  }


  function valueOf(n) {
    var str,
      e = n.e;

    if (e === null) return n.toString();

    str = coeffToString(n.c);

    str = e <= TO_EXP_NEG || e >= TO_EXP_POS
      ? toExponential(str, e)
      : toFixedPoint(str, e, '0');

    return n.s < 0 ? '-' + str : str;
  }


  // PROTOTYPE/INSTANCE METHODS


  /*
   * Return a new BigNumber whose value is the absolute value of this BigNumber.
   */
  P.absoluteValue = P.abs = function () {
    var x = new BigNumber(this);
    if (x.s < 0) x.s = 1;
    return x;
  };


  /*
   * Return
   *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
   *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
   *   0 if they have the same value,
   *   or null if the value of either is NaN.
   */
  P.comparedTo = function (y, b) {
    return compare(this, new BigNumber(y, b));
  };


  /*
   * If dp is undefined or null or true or false, return the number of decimal places of the
   * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
   *
   * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
   * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
   * ROUNDING_MODE if rm is omitted.
   *
   * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */
  P.decimalPlaces = P.dp = function (dp, rm) {
    var c, n, v,
      x = this;

    if (dp != null) {
      intCheck(dp, 0, MAX);
      if (rm == null) rm = ROUNDING_MODE;
      else intCheck(rm, 0, 8);

      return round(new BigNumber(x), dp + x.e + 1, rm);
    }

    if (!(c = x.c)) return null;
    n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;

    // Subtract the number of trailing zeros of the last number.
    if (v = c[v]) for (; v % 10 == 0; v /= 10, n--);
    if (n < 0) n = 0;

    return n;
  };


  /*
   *  n / 0 = I
   *  n / N = N
   *  n / I = 0
   *  0 / n = 0
   *  0 / 0 = N
   *  0 / N = N
   *  0 / I = 0
   *  N / n = N
   *  N / 0 = N
   *  N / N = N
   *  N / I = N
   *  I / n = I
   *  I / 0 = I
   *  I / N = N
   *  I / I = N
   *
   * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
   * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
   */
  P.dividedBy = P.div = function (y, b) {
    return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
  };


  /*
   * Return a new BigNumber whose value is the integer part of dividing the value of this
   * BigNumber by the value of BigNumber(y, b).
   */
  P.dividedToIntegerBy = P.idiv = function (y, b) {
    return div(this, new BigNumber(y, b), 0, 1);
  };


  /*
   * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
   *
   * If m is present, return the result modulo m.
   * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
   * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
   *
   * The modular power operation works efficiently when x, n, and m are integers, otherwise it
   * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
   *
   * n {number|string|BigNumber} The exponent. An integer.
   * [m] {number|string|BigNumber} The modulus.
   *
   * '[BigNumber Error] Exponent not an integer: {n}'
   */
  P.exponentiatedBy = P.pow = function (n, m) {
    var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y,
      x = this;

    n = new BigNumber(n);

    // Allow NaN and ±Infinity, but not other non-integers.
    if (n.c && !n.isInteger()) {
      throw Error
        (bignumberError + 'Exponent not an integer: ' + valueOf(n));
    }

    if (m != null) m = new BigNumber(m);

    // Exponent of MAX_SAFE_INTEGER is 15.
    nIsBig = n.e > 14;

    // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
    if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {

      // The sign of the result of pow when x is negative depends on the evenness of n.
      // If +n overflows to ±Infinity, the evenness of n would be not be known.
      y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - isOdd(n)) : +valueOf(n)));
      return m ? y.mod(m) : y;
    }

    nIsNeg = n.s < 0;

    if (m) {

      // x % m returns NaN if abs(m) is zero, or m is NaN.
      if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);

      isModExp = !nIsNeg && x.isInteger() && m.isInteger();

      if (isModExp) x = x.mod(m);

    // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
    // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
    } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0
      // [1, 240000000]
      ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7
      // [80000000000000]  [99999750000000]
      : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {

      // If x is negative and n is odd, k = -0, else k = 0.
      k = x.s < 0 && isOdd(n) ? -0 : 0;

      // If x >= 1, k = ±Infinity.
      if (x.e > -1) k = 1 / k;

      // If n is negative return ±0, else return ±Infinity.
      return new BigNumber(nIsNeg ? 1 / k : k);

    } else if (POW_PRECISION) {

      // Truncating each coefficient array to a length of k after each multiplication
      // equates to truncating significant digits to POW_PRECISION + [28, 41],
      // i.e. there will be a minimum of 28 guard digits retained.
      k = mathceil(POW_PRECISION / LOG_BASE + 2);
    }

    if (nIsBig) {
      half = new BigNumber(0.5);
      if (nIsNeg) n.s = 1;
      nIsOdd = isOdd(n);
    } else {
      i = Math.abs(+valueOf(n));
      nIsOdd = i % 2;
    }

    y = new BigNumber(ONE);

    // Performs 54 loop iterations for n of 9007199254740991.
    for (; ;) {

      if (nIsOdd) {
        y = y.times(x);
        if (!y.c) break;

        if (k) {
          if (y.c.length > k) y.c.length = k;
        } else if (isModExp) {
          y = y.mod(m);    //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
        }
      }

      if (i) {
        i = mathfloor(i / 2);
        if (i === 0) break;
        nIsOdd = i % 2;
      } else {
        n = n.times(half);
        round(n, n.e + 1, 1);

        if (n.e > 14) {
          nIsOdd = isOdd(n);
        } else {
          i = +valueOf(n);
          if (i === 0) break;
          nIsOdd = i % 2;
        }
      }

      x = x.times(x);

      if (k) {
        if (x.c && x.c.length > k) x.c.length = k;
      } else if (isModExp) {
        x = x.mod(m);    //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
      }
    }

    if (isModExp) return y;
    if (nIsNeg) y = ONE.div(y);

    return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
  };


  /*
   * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
   * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
   *
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
   */
  P.integerValue = function (rm) {
    var n = new BigNumber(this);
    if (rm == null) rm = ROUNDING_MODE;
    else intCheck(rm, 0, 8);
    return round(n, n.e + 1, rm);
  };


  /*
   * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
   * otherwise return false.
   */
  P.isEqualTo = P.eq = function (y, b) {
    return compare(this, new BigNumber(y, b)) === 0;
  };


  /*
   * Return true if the value of this BigNumber is a finite number, otherwise return false.
   */
  P.isFinite = function () {
    return !!this.c;
  };


  /*
   * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
   * otherwise return false.
   */
  P.isGreaterThan = P.gt = function (y, b) {
    return compare(this, new BigNumber(y, b)) > 0;
  };


  /*
   * Return true if the value of this BigNumber is greater than or equal to the value of
   * BigNumber(y, b), otherwise return false.
   */
  P.isGreaterThanOrEqualTo = P.gte = function (y, b) {
    return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;

  };


  /*
   * Return true if the value of this BigNumber is an integer, otherwise return false.
   */
  P.isInteger = function () {
    return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
  };


  /*
   * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
   * otherwise return false.
   */
  P.isLessThan = P.lt = function (y, b) {
    return compare(this, new BigNumber(y, b)) < 0;
  };


  /*
   * Return true if the value of this BigNumber is less than or equal to the value of
   * BigNumber(y, b), otherwise return false.
   */
  P.isLessThanOrEqualTo = P.lte = function (y, b) {
    return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
  };


  /*
   * Return true if the value of this BigNumber is NaN, otherwise return false.
   */
  P.isNaN = function () {
    return !this.s;
  };


  /*
   * Return true if the value of this BigNumber is negative, otherwise return false.
   */
  P.isNegative = function () {
    return this.s < 0;
  };


  /*
   * Return true if the value of this BigNumber is positive, otherwise return false.
   */
  P.isPositive = function () {
    return this.s > 0;
  };


  /*
   * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
   */
  P.isZero = function () {
    return !!this.c && this.c[0] == 0;
  };


  /*
   *  n - 0 = n
   *  n - N = N
   *  n - I = -I
   *  0 - n = -n
   *  0 - 0 = 0
   *  0 - N = N
   *  0 - I = -I
   *  N - n = N
   *  N - 0 = N
   *  N - N = N
   *  N - I = N
   *  I - n = I
   *  I - 0 = I
   *  I - N = N
   *  I - I = N
   *
   * Return a new BigNumber whose value is the value of this BigNumber minus the value of
   * BigNumber(y, b).
   */
  P.minus = function (y, b) {
    var i, j, t, xLTy,
      x = this,
      a = x.s;

    y = new BigNumber(y, b);
    b = y.s;

    // Either NaN?
    if (!a || !b) return new BigNumber(NaN);

    // Signs differ?
    if (a != b) {
      y.s = -b;
      return x.plus(y);
    }

    var xe = x.e / LOG_BASE,
      ye = y.e / LOG_BASE,
      xc = x.c,
      yc = y.c;

    if (!xe || !ye) {

      // Either Infinity?
      if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);

      // Either zero?
      if (!xc[0] || !yc[0]) {

        // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
        return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x :

         // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
         ROUNDING_MODE == 3 ? -0 : 0);
      }
    }

    xe = bitFloor(xe);
    ye = bitFloor(ye);
    xc = xc.slice();

    // Determine which is the bigger number.
    if (a = xe - ye) {

      if (xLTy = a < 0) {
        a = -a;
        t = xc;
      } else {
        ye = xe;
        t = yc;
      }

      t.reverse();

      // Prepend zeros to equalise exponents.
      for (b = a; b--; t.push(0));
      t.reverse();
    } else {

      // Exponents equal. Check digit by digit.
      j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;

      for (a = b = 0; b < j; b++) {

        if (xc[b] != yc[b]) {
          xLTy = xc[b] < yc[b];
          break;
        }
      }
    }

    // x < y? Point xc to the array of the bigger number.
    if (xLTy) {
      t = xc;
      xc = yc;
      yc = t;
      y.s = -y.s;
    }

    b = (j = yc.length) - (i = xc.length);

    // Append zeros to xc if shorter.
    // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
    if (b > 0) for (; b--; xc[i++] = 0);
    b = BASE - 1;

    // Subtract yc from xc.
    for (; j > a;) {

      if (xc[--j] < yc[j]) {
        for (i = j; i && !xc[--i]; xc[i] = b);
        --xc[i];
        xc[j] += BASE;
      }

      xc[j] -= yc[j];
    }

    // Remove leading zeros and adjust exponent accordingly.
    for (; xc[0] == 0; xc.splice(0, 1), --ye);

    // Zero?
    if (!xc[0]) {

      // Following IEEE 754 (2008) 6.3,
      // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
      y.s = ROUNDING_MODE == 3 ? -1 : 1;
      y.c = [y.e = 0];
      return y;
    }

    // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
    // for finite x and y.
    return normalise(y, xc, ye);
  };


  /*
   *   n % 0 =  N
   *   n % N =  N
   *   n % I =  n
   *   0 % n =  0
   *  -0 % n = -0
   *   0 % 0 =  N
   *   0 % N =  N
   *   0 % I =  0
   *   N % n =  N
   *   N % 0 =  N
   *   N % N =  N
   *   N % I =  N
   *   I % n =  N
   *   I % 0 =  N
   *   I % N =  N
   *   I % I =  N
   *
   * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
   * BigNumber(y, b). The result depends on the value of MODULO_MODE.
   */
  P.modulo = P.mod = function (y, b) {
    var q, s,
      x = this;

    y = new BigNumber(y, b);

    // Return NaN if x is Infinity or NaN, or y is NaN or zero.
    if (!x.c || !y.s || y.c && !y.c[0]) {
      return new BigNumber(NaN);

    // Return x if y is Infinity or x is zero.
    } else if (!y.c || x.c && !x.c[0]) {
      return new BigNumber(x);
    }

    if (MODULO_MODE == 9) {

      // Euclidian division: q = sign(y) * floor(x / abs(y))
      // r = x - qy    where  0 <= r < abs(y)
      s = y.s;
      y.s = 1;
      q = div(x, y, 0, 3);
      y.s = s;
      q.s *= s;
    } else {
      q = div(x, y, 0, MODULO_MODE);
    }

    y = x.minus(q.times(y));

    // To match JavaScript %, ensure sign of zero is sign of dividend.
    if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;

    return y;
  };


  /*
   *  n * 0 = 0
   *  n * N = N
   *  n * I = I
   *  0 * n = 0
   *  0 * 0 = 0
   *  0 * N = N
   *  0 * I = N
   *  N * n = N
   *  N * 0 = N
   *  N * N = N
   *  N * I = N
   *  I * n = I
   *  I * 0 = N
   *  I * N = N
   *  I * I = I
   *
   * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
   * of BigNumber(y, b).
   */
  P.multipliedBy = P.times = function (y, b) {
    var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc,
      base, sqrtBase,
      x = this,
      xc = x.c,
      yc = (y = new BigNumber(y, b)).c;

    // Either NaN, ±Infinity or ±0?
    if (!xc || !yc || !xc[0] || !yc[0]) {

      // Return NaN if either is NaN, or one is 0 and the other is Infinity.
      if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) {
        y.c = y.e = y.s = null;
      } else {
        y.s *= x.s;

        // Return ±Infinity if either is ±Infinity.
        if (!xc || !yc) {
          y.c = y.e = null;

        // Return ±0 if either is ±0.
        } else {
          y.c = [0];
          y.e = 0;
        }
      }

      return y;
    }

    e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
    y.s *= x.s;
    xcL = xc.length;
    ycL = yc.length;

    // Ensure xc points to longer array and xcL to its length.
    if (xcL < ycL) {
      zc = xc;
      xc = yc;
      yc = zc;
      i = xcL;
      xcL = ycL;
      ycL = i;
    }

    // Initialise the result array with zeros.
    for (i = xcL + ycL, zc = []; i--; zc.push(0));

    base = BASE;
    sqrtBase = SQRT_BASE;

    for (i = ycL; --i >= 0;) {
      c = 0;
      ylo = yc[i] % sqrtBase;
      yhi = yc[i] / sqrtBase | 0;

      for (k = xcL, j = i + k; j > i;) {
        xlo = xc[--k] % sqrtBase;
        xhi = xc[k] / sqrtBase | 0;
        m = yhi * xlo + xhi * ylo;
        xlo = ylo * xlo + ((m % sqrtBase) * sqrtBase) + zc[j] + c;
        c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
        zc[j--] = xlo % base;
      }

      zc[j] = c;
    }

    if (c) {
      ++e;
    } else {
      zc.splice(0, 1);
    }

    return normalise(y, zc, e);
  };


  /*
   * Return a new BigNumber whose value is the value of this BigNumber negated,
   * i.e. multiplied by -1.
   */
  P.negated = function () {
    var x = new BigNumber(this);
    x.s = -x.s || null;
    return x;
  };


  /*
   *  n + 0 = n
   *  n + N = N
   *  n + I = I
   *  0 + n = n
   *  0 + 0 = 0
   *  0 + N = N
   *  0 + I = I
   *  N + n = N
   *  N + 0 = N
   *  N + N = N
   *  N + I = N
   *  I + n = I
   *  I + 0 = I
   *  I + N = N
   *  I + I = I
   *
   * Return a new BigNumber whose value is the value of this BigNumber plus the value of
   * BigNumber(y, b).
   */
  P.plus = function (y, b) {
    var t,
      x = this,
      a = x.s;

    y = new BigNumber(y, b);
    b = y.s;

    // Either NaN?
    if (!a || !b) return new BigNumber(NaN);

    // Signs differ?
     if (a != b) {
      y.s = -b;
      return x.minus(y);
    }

    var xe = x.e / LOG_BASE,
      ye = y.e / LOG_BASE,
      xc = x.c,
      yc = y.c;

    if (!xe || !ye) {

      // Return ±Infinity if either ±Infinity.
      if (!xc || !yc) return new BigNumber(a / 0);

      // Either zero?
      // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
      if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
    }

    xe = bitFloor(xe);
    ye = bitFloor(ye);
    xc = xc.slice();

    // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
    if (a = xe - ye) {
      if (a > 0) {
        ye = xe;
        t = yc;
      } else {
        a = -a;
        t = xc;
      }

      t.reverse();
      for (; a--; t.push(0));
      t.reverse();
    }

    a = xc.length;
    b = yc.length;

    // Point xc to the longer array, and b to the shorter length.
    if (a - b < 0) {
      t = yc;
      yc = xc;
      xc = t;
      b = a;
    }

    // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
    for (a = 0; b;) {
      a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
      xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
    }

    if (a) {
      xc = [a].concat(xc);
      ++ye;
    }

    // No need to check for zero, as +x + +y != 0 && -x + -y != 0
    // ye = MAX_EXP + 1 possible
    return normalise(y, xc, ye);
  };


  /*
   * If sd is undefined or null or true or false, return the number of significant digits of
   * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
   * If sd is true include integer-part trailing zeros in the count.
   *
   * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
   * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
   * ROUNDING_MODE if rm is omitted.
   *
   * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
   *                     boolean: whether to count integer-part trailing zeros: true or false.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
   */
  P.precision = P.sd = function (sd, rm) {
    var c, n, v,
      x = this;

    if (sd != null && sd !== !!sd) {
      intCheck(sd, 1, MAX);
      if (rm == null) rm = ROUNDING_MODE;
      else intCheck(rm, 0, 8);

      return round(new BigNumber(x), sd, rm);
    }

    if (!(c = x.c)) return null;
    v = c.length - 1;
    n = v * LOG_BASE + 1;

    if (v = c[v]) {

      // Subtract the number of trailing zeros of the last element.
      for (; v % 10 == 0; v /= 10, n--);

      // Add the number of digits of the first element.
      for (v = c[0]; v >= 10; v /= 10, n++);
    }

    if (sd && x.e + 1 > n) n = x.e + 1;

    return n;
  };


  /*
   * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
   * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
   *
   * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
   */
  P.shiftedBy = function (k) {
    intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
    return this.times('1e' + k);
  };


  /*
   *  sqrt(-n) =  N
   *  sqrt(N) =  N
   *  sqrt(-I) =  N
   *  sqrt(I) =  I
   *  sqrt(0) =  0
   *  sqrt(-0) = -0
   *
   * Return a new BigNumber whose value is the square root of the value of this BigNumber,
   * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
   */
  P.squareRoot = P.sqrt = function () {
    var m, n, r, rep, t,
      x = this,
      c = x.c,
      s = x.s,
      e = x.e,
      dp = DECIMAL_PLACES + 4,
      half = new BigNumber('0.5');

    // Negative/NaN/Infinity/zero?
    if (s !== 1 || !c || !c[0]) {
      return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
    }

    // Initial estimate.
    s = Math.sqrt(+valueOf(x));

    // Math.sqrt underflow/overflow?
    // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
    if (s == 0 || s == 1 / 0) {
      n = coeffToString(c);
      if ((n.length + e) % 2 == 0) n += '0';
      s = Math.sqrt(+n);
      e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);

      if (s == 1 / 0) {
        n = '5e' + e;
      } else {
        n = s.toExponential();
        n = n.slice(0, n.indexOf('e') + 1) + e;
      }

      r = new BigNumber(n);
    } else {
      r = new BigNumber(s + '');
    }

    // Check for zero.
    // r could be zero if MIN_EXP is changed after the this value was created.
    // This would cause a division by zero (x/t) and hence Infinity below, which would cause
    // coeffToString to throw.
    if (r.c[0]) {
      e = r.e;
      s = e + dp;
      if (s < 3) s = 0;

      // Newton-Raphson iteration.
      for (; ;) {
        t = r;
        r = half.times(t.plus(div(x, t, dp, 1)));

        if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {

          // The exponent of r may here be one less than the final result exponent,
          // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
          // are indexed correctly.
          if (r.e < e) --s;
          n = n.slice(s - 3, s + 1);

          // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
          // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
          // iteration.
          if (n == '9999' || !rep && n == '4999') {

            // On the first iteration only, check to see if rounding up gives the
            // exact result as the nines may infinitely repeat.
            if (!rep) {
              round(t, t.e + DECIMAL_PLACES + 2, 0);

              if (t.times(t).eq(x)) {
                r = t;
                break;
              }
            }

            dp += 4;
            s += 4;
            rep = 1;
          } else {

            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
            // result. If not, then there are further digits and m will be truthy.
            if (!+n || !+n.slice(1) && n.charAt(0) == '5') {

              // Truncate to the first rounding digit.
              round(r, r.e + DECIMAL_PLACES + 2, 1);
              m = !r.times(r).eq(x);
            }

            break;
          }
        }
      }
    }

    return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
  };


  /*
   * Return a string representing the value of this BigNumber in exponential notation and
   * rounded using ROUNDING_MODE to dp fixed decimal places.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */
  P.toExponential = function (dp, rm) {
    if (dp != null) {
      intCheck(dp, 0, MAX);
      dp++;
    }
    return format(this, dp, rm, 1);
  };


  /*
   * Return a string representing the value of this BigNumber in fixed-point notation rounding
   * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
   *
   * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
   * but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */
  P.toFixed = function (dp, rm) {
    if (dp != null) {
      intCheck(dp, 0, MAX);
      dp = dp + this.e + 1;
    }
    return format(this, dp, rm);
  };


  /*
   * Return a string representing the value of this BigNumber in fixed-point notation rounded
   * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
   * of the format or FORMAT object (see BigNumber.set).
   *
   * The formatting object may contain some or all of the properties shown below.
   *
   * FORMAT = {
   *   prefix: '',
   *   groupSize: 3,
   *   secondaryGroupSize: 0,
   *   groupSeparator: ',',
   *   decimalSeparator: '.',
   *   fractionGroupSize: 0,
   *   fractionGroupSeparator: '\xA0',      // non-breaking space
   *   suffix: ''
   * };
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   * [format] {object} Formatting options. See FORMAT pbject above.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   * '[BigNumber Error] Argument not an object: {format}'
   */
  P.toFormat = function (dp, rm, format) {
    var str,
      x = this;

    if (format == null) {
      if (dp != null && rm && typeof rm == 'object') {
        format = rm;
        rm = null;
      } else if (dp && typeof dp == 'object') {
        format = dp;
        dp = rm = null;
      } else {
        format = FORMAT;
      }
    } else if (typeof format != 'object') {
      throw Error
        (bignumberError + 'Argument not an object: ' + format);
    }

    str = x.toFixed(dp, rm);

    if (x.c) {
      var i,
        arr = str.split('.'),
        g1 = +format.groupSize,
        g2 = +format.secondaryGroupSize,
        groupSeparator = format.groupSeparator || '',
        intPart = arr[0],
        fractionPart = arr[1],
        isNeg = x.s < 0,
        intDigits = isNeg ? intPart.slice(1) : intPart,
        len = intDigits.length;

      if (g2) {
        i = g1;
        g1 = g2;
        g2 = i;
        len -= i;
      }

      if (g1 > 0 && len > 0) {
        i = len % g1 || g1;
        intPart = intDigits.substr(0, i);
        for (; i < len; i += g1) intPart += groupSeparator + intDigits.substr(i, g1);
        if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
        if (isNeg) intPart = '-' + intPart;
      }

      str = fractionPart
       ? intPart + (format.decimalSeparator || '') + ((g2 = +format.fractionGroupSize)
        ? fractionPart.replace(new RegExp('\\d{' + g2 + '}\\B', 'g'),
         '$&' + (format.fractionGroupSeparator || ''))
        : fractionPart)
       : intPart;
    }

    return (format.prefix || '') + str + (format.suffix || '');
  };


  /*
   * Return an array of two BigNumbers representing the value of this BigNumber as a simple
   * fraction with an integer numerator and an integer denominator.
   * The denominator will be a positive non-zero value less than or equal to the specified
   * maximum denominator. If a maximum denominator is not specified, the denominator will be
   * the lowest value necessary to represent the number exactly.
   *
   * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
   *
   * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
   */
  P.toFraction = function (md) {
    var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s,
      x = this,
      xc = x.c;

    if (md != null) {
      n = new BigNumber(md);

      // Throw if md is less than one or is not an integer, unless it is Infinity.
      if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) {
        throw Error
          (bignumberError + 'Argument ' +
            (n.isInteger() ? 'out of range: ' : 'not an integer: ') + valueOf(n));
      }
    }

    if (!xc) return new BigNumber(x);

    d = new BigNumber(ONE);
    n1 = d0 = new BigNumber(ONE);
    d1 = n0 = new BigNumber(ONE);
    s = coeffToString(xc);

    // Determine initial denominator.
    // d is a power of 10 and the minimum max denominator that specifies the value exactly.
    e = d.e = s.length - x.e - 1;
    d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
    md = !md || n.comparedTo(d) > 0 ? (e > 0 ? d : n1) : n;

    exp = MAX_EXP;
    MAX_EXP = 1 / 0;
    n = new BigNumber(s);

    // n0 = d1 = 0
    n0.c[0] = 0;

    for (; ;)  {
      q = div(n, d, 0, 1);
      d2 = d0.plus(q.times(d1));
      if (d2.comparedTo(md) == 1) break;
      d0 = d1;
      d1 = d2;
      n1 = n0.plus(q.times(d2 = n1));
      n0 = d2;
      d = n.minus(q.times(d2 = d));
      n = d2;
    }

    d2 = div(md.minus(d0), d1, 0, 1);
    n0 = n0.plus(d2.times(n1));
    d0 = d0.plus(d2.times(d1));
    n0.s = n1.s = x.s;
    e = e * 2;

    // Determine which fraction is closer to x, n0/d0 or n1/d1
    r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(
        div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [n1, d1] : [n0, d0];

    MAX_EXP = exp;

    return r;
  };


  /*
   * Return the value of this BigNumber converted to a number primitive.
   */
  P.toNumber = function () {
    return +valueOf(this);
  };


  /*
   * Return a string representing the value of this BigNumber rounded to sd significant digits
   * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
   * necessary to represent the integer part of the value in fixed-point notation, then use
   * exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
   */
  P.toPrecision = function (sd, rm) {
    if (sd != null) intCheck(sd, 1, MAX);
    return format(this, sd, rm, 2);
  };


  /*
   * Return a string representing the value of this BigNumber in base b, or base 10 if b is
   * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
   * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
   * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
   * TO_EXP_NEG, return exponential notation.
   *
   * [b] {number} Integer, 2 to ALPHABET.length inclusive.
   *
   * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
   */
  P.toString = function (b) {
    var str,
      n = this,
      s = n.s,
      e = n.e;

    // Infinity or NaN?
    if (e === null) {
      if (s) {
        str = 'Infinity';
        if (s < 0) str = '-' + str;
      } else {
        str = 'NaN';
      }
    } else {
      if (b == null) {
        str = e <= TO_EXP_NEG || e >= TO_EXP_POS
         ? toExponential(coeffToString(n.c), e)
         : toFixedPoint(coeffToString(n.c), e, '0');
      } else if (b === 10 && alphabetHasNormalDecimalDigits) {
        n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
        str = toFixedPoint(coeffToString(n.c), n.e, '0');
      } else {
        intCheck(b, 2, ALPHABET.length, 'Base');
        str = convertBase(toFixedPoint(coeffToString(n.c), e, '0'), 10, b, s, true);
      }

      if (s < 0 && n.c[0]) str = '-' + str;
    }

    return str;
  };


  /*
   * Return as toString, but do not accept a base argument, and include the minus sign for
   * negative zero.
   */
  P.valueOf = P.toJSON = function () {
    return valueOf(this);
  };


  P._isBigNumber = true;

  P[Symbol.toStringTag] = 'BigNumber';

  // Node.js v10.12.0+
  P[Symbol.for('nodejs.util.inspect.custom')] = P.valueOf;

  if (configObject != null) BigNumber.set(configObject);

  return BigNumber;
}


// PRIVATE HELPER FUNCTIONS

// These functions don't need access to variables,
// e.g. DECIMAL_PLACES, in the scope of the `clone` function above.


function bitFloor(n) {
  var i = n | 0;
  return n > 0 || n === i ? i : i - 1;
}


// Return a coefficient array as a string of base 10 digits.
function coeffToString(a) {
  var s, z,
    i = 1,
    j = a.length,
    r = a[0] + '';

  for (; i < j;) {
    s = a[i++] + '';
    z = LOG_BASE - s.length;
    for (; z--; s = '0' + s);
    r += s;
  }

  // Determine trailing zeros.
  for (j = r.length; r.charCodeAt(--j) === 48;);

  return r.slice(0, j + 1 || 1);
}


// Compare the value of BigNumbers x and y.
function compare(x, y) {
  var a, b,
    xc = x.c,
    yc = y.c,
    i = x.s,
    j = y.s,
    k = x.e,
    l = y.e;

  // Either NaN?
  if (!i || !j) return null;

  a = xc && !xc[0];
  b = yc && !yc[0];

  // Either zero?
  if (a || b) return a ? b ? 0 : -j : i;

  // Signs differ?
  if (i != j) return i;

  a = i < 0;
  b = k == l;

  // Either Infinity?
  if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;

  // Compare exponents.
  if (!b) return k > l ^ a ? 1 : -1;

  j = (k = xc.length) < (l = yc.length) ? k : l;

  // Compare digit by digit.
  for (i = 0; i < j; i++) if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;

  // Compare lengths.
  return k == l ? 0 : k > l ^ a ? 1 : -1;
}


/*
 * Check that n is a primitive number, an integer, and in range, otherwise throw.
 */
function intCheck(n, min, max, name) {
  if (n < min || n > max || n !== mathfloor(n)) {
    throw Error
     (bignumberError + (name || 'Argument') + (typeof n == 'number'
       ? n < min || n > max ? ' out of range: ' : ' not an integer: '
       : ' not a primitive number: ') + String(n));
  }
}


// Assumes finite n.
function isOdd(n) {
  var k = n.c.length - 1;
  return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
}


function toExponential(str, e) {
  return (str.length > 1 ? str.charAt(0) + '.' + str.slice(1) : str) +
   (e < 0 ? 'e' : 'e+') + e;
}


function toFixedPoint(str, e, z) {
  var len, zs;

  // Negative exponent?
  if (e < 0) {

    // Prepend zeros.
    for (zs = z + '.'; ++e; zs += z);
    str = zs + str;

  // Positive exponent
  } else {
    len = str.length;

    // Append zeros.
    if (++e > len) {
      for (zs = z, e -= len; --e; zs += z);
      str += zs;
    } else if (e < len) {
      str = str.slice(0, e) + '.' + str.slice(e);
    }
  }

  return str;
}


// EXPORT


var BigNumber = clone$1();

// src/index.ts
var SplayTreeNode = class {
  key;
  left = null;
  right = null;
  constructor(key) {
    this.key = key;
  }
};
var SplayTreeSetNode = class extends SplayTreeNode {
  constructor(key) {
    super(key);
  }
};
var SplayTree = class {
  size = 0;
  modificationCount = 0;
  splayCount = 0;
  splay(key) {
    const root = this.root;
    if (root == null) {
      this.compare(key, key);
      return -1;
    }
    let right = null;
    let newTreeRight = null;
    let left = null;
    let newTreeLeft = null;
    let current = root;
    const compare = this.compare;
    let comp;
    while (true) {
      comp = compare(current.key, key);
      if (comp > 0) {
        let currentLeft = current.left;
        if (currentLeft == null) break;
        comp = compare(currentLeft.key, key);
        if (comp > 0) {
          current.left = currentLeft.right;
          currentLeft.right = current;
          current = currentLeft;
          currentLeft = current.left;
          if (currentLeft == null) break;
        }
        if (right == null) {
          newTreeRight = current;
        } else {
          right.left = current;
        }
        right = current;
        current = currentLeft;
      } else if (comp < 0) {
        let currentRight = current.right;
        if (currentRight == null) break;
        comp = compare(currentRight.key, key);
        if (comp < 0) {
          current.right = currentRight.left;
          currentRight.left = current;
          current = currentRight;
          currentRight = current.right;
          if (currentRight == null) break;
        }
        if (left == null) {
          newTreeLeft = current;
        } else {
          left.right = current;
        }
        left = current;
        current = currentRight;
      } else {
        break;
      }
    }
    if (left != null) {
      left.right = current.left;
      current.left = newTreeLeft;
    }
    if (right != null) {
      right.left = current.right;
      current.right = newTreeRight;
    }
    if (this.root !== current) {
      this.root = current;
      this.splayCount++;
    }
    return comp;
  }
  splayMin(node) {
    let current = node;
    let nextLeft = current.left;
    while (nextLeft != null) {
      const left = nextLeft;
      current.left = left.right;
      left.right = current;
      current = left;
      nextLeft = current.left;
    }
    return current;
  }
  splayMax(node) {
    let current = node;
    let nextRight = current.right;
    while (nextRight != null) {
      const right = nextRight;
      current.right = right.left;
      right.left = current;
      current = right;
      nextRight = current.right;
    }
    return current;
  }
  _delete(key) {
    if (this.root == null) return null;
    const comp = this.splay(key);
    if (comp != 0) return null;
    let root = this.root;
    const result = root;
    const left = root.left;
    this.size--;
    if (left == null) {
      this.root = root.right;
    } else {
      const right = root.right;
      root = this.splayMax(left);
      root.right = right;
      this.root = root;
    }
    this.modificationCount++;
    return result;
  }
  addNewRoot(node, comp) {
    this.size++;
    this.modificationCount++;
    const root = this.root;
    if (root == null) {
      this.root = node;
      return;
    }
    if (comp < 0) {
      node.left = root;
      node.right = root.right;
      root.right = null;
    } else {
      node.right = root;
      node.left = root.left;
      root.left = null;
    }
    this.root = node;
  }
  _first() {
    const root = this.root;
    if (root == null) return null;
    this.root = this.splayMin(root);
    return this.root;
  }
  _last() {
    const root = this.root;
    if (root == null) return null;
    this.root = this.splayMax(root);
    return this.root;
  }
  clear() {
    this.root = null;
    this.size = 0;
    this.modificationCount++;
  }
  has(key) {
    return this.validKey(key) && this.splay(key) == 0;
  }
  defaultCompare() {
    return (a, b) => a < b ? -1 : a > b ? 1 : 0;
  }
  wrap() {
    return {
      getRoot: () => {
        return this.root;
      },
      setRoot: (root) => {
        this.root = root;
      },
      getSize: () => {
        return this.size;
      },
      getModificationCount: () => {
        return this.modificationCount;
      },
      getSplayCount: () => {
        return this.splayCount;
      },
      setSplayCount: (count) => {
        this.splayCount = count;
      },
      splay: (key) => {
        return this.splay(key);
      },
      has: (key) => {
        return this.has(key);
      }
    };
  }
};
var SplayTreeSet = class _SplayTreeSet extends SplayTree {
  root = null;
  compare;
  validKey;
  constructor(compare, isValidKey) {
    super();
    this.compare = compare ?? this.defaultCompare();
    this.validKey = isValidKey ?? ((v) => v != null && v != void 0);
  }
  delete(element) {
    if (!this.validKey(element)) return false;
    return this._delete(element) != null;
  }
  deleteAll(elements) {
    for (const element of elements) {
      this.delete(element);
    }
  }
  forEach(f) {
    const nodes = this[Symbol.iterator]();
    let result;
    while (result = nodes.next(), !result.done) {
      f(result.value, result.value, this);
    }
  }
  add(element) {
    const compare = this.splay(element);
    if (compare != 0) this.addNewRoot(new SplayTreeSetNode(element), compare);
    return this;
  }
  addAndReturn(element) {
    const compare = this.splay(element);
    if (compare != 0) this.addNewRoot(new SplayTreeSetNode(element), compare);
    return this.root.key;
  }
  addAll(elements) {
    for (const element of elements) {
      this.add(element);
    }
  }
  isEmpty() {
    return this.root == null;
  }
  isNotEmpty() {
    return this.root != null;
  }
  single() {
    if (this.size == 0) throw "Bad state: No element";
    if (this.size > 1) throw "Bad state: Too many element";
    return this.root.key;
  }
  first() {
    if (this.size == 0) throw "Bad state: No element";
    return this._first().key;
  }
  last() {
    if (this.size == 0) throw "Bad state: No element";
    return this._last().key;
  }
  lastBefore(element) {
    if (element == null) throw "Invalid arguments(s)";
    if (this.root == null) return null;
    const comp = this.splay(element);
    if (comp < 0) return this.root.key;
    let node = this.root.left;
    if (node == null) return null;
    let nodeRight = node.right;
    while (nodeRight != null) {
      node = nodeRight;
      nodeRight = node.right;
    }
    return node.key;
  }
  firstAfter(element) {
    if (element == null) throw "Invalid arguments(s)";
    if (this.root == null) return null;
    const comp = this.splay(element);
    if (comp > 0) return this.root.key;
    let node = this.root.right;
    if (node == null) return null;
    let nodeLeft = node.left;
    while (nodeLeft != null) {
      node = nodeLeft;
      nodeLeft = node.left;
    }
    return node.key;
  }
  retainAll(elements) {
    const retainSet = new _SplayTreeSet(this.compare, this.validKey);
    const modificationCount = this.modificationCount;
    for (const object of elements) {
      if (modificationCount != this.modificationCount) {
        throw "Concurrent modification during iteration.";
      }
      if (this.validKey(object) && this.splay(object) == 0) {
        retainSet.add(this.root.key);
      }
    }
    if (retainSet.size != this.size) {
      this.root = retainSet.root;
      this.size = retainSet.size;
      this.modificationCount++;
    }
  }
  lookup(object) {
    if (!this.validKey(object)) return null;
    const comp = this.splay(object);
    if (comp != 0) return null;
    return this.root.key;
  }
  intersection(other) {
    const result = new _SplayTreeSet(this.compare, this.validKey);
    for (const element of this) {
      if (other.has(element)) result.add(element);
    }
    return result;
  }
  difference(other) {
    const result = new _SplayTreeSet(this.compare, this.validKey);
    for (const element of this) {
      if (!other.has(element)) result.add(element);
    }
    return result;
  }
  union(other) {
    const u = this.clone();
    u.addAll(other);
    return u;
  }
  clone() {
    const set = new _SplayTreeSet(this.compare, this.validKey);
    set.size = this.size;
    set.root = this.copyNode(this.root);
    return set;
  }
  copyNode(node) {
    if (node == null) return null;
    function copyChildren(node2, dest) {
      let left;
      let right;
      do {
        left = node2.left;
        right = node2.right;
        if (left != null) {
          const newLeft = new SplayTreeSetNode(left.key);
          dest.left = newLeft;
          copyChildren(left, newLeft);
        }
        if (right != null) {
          const newRight = new SplayTreeSetNode(right.key);
          dest.right = newRight;
          node2 = right;
          dest = newRight;
        }
      } while (right != null);
    }
    const result = new SplayTreeSetNode(node.key);
    copyChildren(node, result);
    return result;
  }
  toSet() {
    return this.clone();
  }
  entries() {
    return new SplayTreeSetEntryIterableIterator(this.wrap());
  }
  keys() {
    return this[Symbol.iterator]();
  }
  values() {
    return this[Symbol.iterator]();
  }
  [Symbol.iterator]() {
    return new SplayTreeKeyIterableIterator(this.wrap());
  }
  [Symbol.toStringTag] = "[object Set]";
};
var SplayTreeIterableIterator = class {
  tree;
  path = new Array();
  modificationCount = null;
  splayCount;
  constructor(tree) {
    this.tree = tree;
    this.splayCount = tree.getSplayCount();
  }
  [Symbol.iterator]() {
    return this;
  }
  next() {
    if (this.moveNext()) return { done: false, value: this.current() };
    return { done: true, value: null };
  }
  current() {
    if (!this.path.length) return null;
    const node = this.path[this.path.length - 1];
    return this.getValue(node);
  }
  rebuildPath(key) {
    this.path.splice(0, this.path.length);
    this.tree.splay(key);
    this.path.push(this.tree.getRoot());
    this.splayCount = this.tree.getSplayCount();
  }
  findLeftMostDescendent(node) {
    while (node != null) {
      this.path.push(node);
      node = node.left;
    }
  }
  moveNext() {
    if (this.modificationCount != this.tree.getModificationCount()) {
      if (this.modificationCount == null) {
        this.modificationCount = this.tree.getModificationCount();
        let node2 = this.tree.getRoot();
        while (node2 != null) {
          this.path.push(node2);
          node2 = node2.left;
        }
        return this.path.length > 0;
      }
      throw "Concurrent modification during iteration.";
    }
    if (!this.path.length) return false;
    if (this.splayCount != this.tree.getSplayCount()) {
      this.rebuildPath(this.path[this.path.length - 1].key);
    }
    let node = this.path[this.path.length - 1];
    let next = node.right;
    if (next != null) {
      while (next != null) {
        this.path.push(next);
        next = next.left;
      }
      return true;
    }
    this.path.pop();
    while (this.path.length && this.path[this.path.length - 1].right === node) {
      node = this.path.pop();
    }
    return this.path.length > 0;
  }
};
var SplayTreeKeyIterableIterator = class extends SplayTreeIterableIterator {
  getValue(node) {
    return node.key;
  }
};
var SplayTreeSetEntryIterableIterator = class extends SplayTreeIterableIterator {
  getValue(node) {
    return [node.key, node.key];
  }
};

// src/geom-in.ts

// src/constant.ts
var constant_default = (x) => {
  return () => {
    return x;
  };
};

// src/compare.ts
var compare_default = (eps) => {
  const almostEqual = eps ? (a, b) => b.minus(a).abs().isLessThanOrEqualTo(eps) : constant_default(false);
  return (a, b) => {
    if (almostEqual(a, b)) return 0;
    return a.comparedTo(b);
  };
};

// src/orient.ts
function orient_default(eps) {
  const almostCollinear = eps ? (area2, ax, ay, cx, cy) => area2.exponentiatedBy(2).isLessThanOrEqualTo(
    cx.minus(ax).exponentiatedBy(2).plus(cy.minus(ay).exponentiatedBy(2)).times(eps)
  ) : constant_default(false);
  return (a, b, c) => {
    const ax = a.x, ay = a.y, cx = c.x, cy = c.y;
    const area2 = ay.minus(cy).times(b.x.minus(cx)).minus(ax.minus(cx).times(b.y.minus(cy)));
    if (almostCollinear(area2, ax, ay, cx, cy)) return 0;
    return area2.comparedTo(0);
  };
}

// src/identity.ts
var identity_default = (x) => {
  return x;
};

// src/snap.ts
var snap_default = (eps) => {
  if (eps) {
    const xTree = new SplayTreeSet(compare_default(eps));
    const yTree = new SplayTreeSet(compare_default(eps));
    const snapCoord = (coord, tree) => {
      return tree.addAndReturn(coord);
    };
    const snap = (v) => {
      return {
        x: snapCoord(v.x, xTree),
        y: snapCoord(v.y, yTree)
      };
    };
    snap({ x: new BigNumber(0), y: new BigNumber(0) });
    return snap;
  }
  return identity_default;
};

// src/precision.ts
var set = (eps) => {
  return {
    set: (eps2) => {
      precision = set(eps2);
    },
    reset: () => set(eps),
    compare: compare_default(eps),
    snap: snap_default(eps),
    orient: orient_default(eps)
  };
};
var precision = set();

// src/bbox.ts
var isInBbox = (bbox, point) => {
  return bbox.ll.x.isLessThanOrEqualTo(point.x) && point.x.isLessThanOrEqualTo(bbox.ur.x) && bbox.ll.y.isLessThanOrEqualTo(point.y) && point.y.isLessThanOrEqualTo(bbox.ur.y);
};
var getBboxOverlap = (b1, b2) => {
  if (b2.ur.x.isLessThan(b1.ll.x) || b1.ur.x.isLessThan(b2.ll.x) || b2.ur.y.isLessThan(b1.ll.y) || b1.ur.y.isLessThan(b2.ll.y))
    return null;
  const lowerX = b1.ll.x.isLessThan(b2.ll.x) ? b2.ll.x : b1.ll.x;
  const upperX = b1.ur.x.isLessThan(b2.ur.x) ? b1.ur.x : b2.ur.x;
  const lowerY = b1.ll.y.isLessThan(b2.ll.y) ? b2.ll.y : b1.ll.y;
  const upperY = b1.ur.y.isLessThan(b2.ur.y) ? b1.ur.y : b2.ur.y;
  return { ll: { x: lowerX, y: lowerY }, ur: { x: upperX, y: upperY } };
};

// src/vector.ts
var crossProduct = (a, b) => a.x.times(b.y).minus(a.y.times(b.x));
var dotProduct = (a, b) => a.x.times(b.x).plus(a.y.times(b.y));
var length$1 = (v) => dotProduct(v, v).sqrt();
var sineOfAngle = (pShared, pBase, pAngle) => {
  const vBase = { x: pBase.x.minus(pShared.x), y: pBase.y.minus(pShared.y) };
  const vAngle = { x: pAngle.x.minus(pShared.x), y: pAngle.y.minus(pShared.y) };
  return crossProduct(vAngle, vBase).div(length$1(vAngle)).div(length$1(vBase));
};
var cosineOfAngle = (pShared, pBase, pAngle) => {
  const vBase = { x: pBase.x.minus(pShared.x), y: pBase.y.minus(pShared.y) };
  const vAngle = { x: pAngle.x.minus(pShared.x), y: pAngle.y.minus(pShared.y) };
  return dotProduct(vAngle, vBase).div(length$1(vAngle)).div(length$1(vBase));
};
var horizontalIntersection = (pt, v, y) => {
  if (v.y.isZero()) return null;
  return { x: pt.x.plus(v.x.div(v.y).times(y.minus(pt.y))), y };
};
var verticalIntersection = (pt, v, x) => {
  if (v.x.isZero()) return null;
  return { x, y: pt.y.plus(v.y.div(v.x).times(x.minus(pt.x))) };
};
var intersection$1 = (pt1, v1, pt2, v2) => {
  if (v1.x.isZero()) return verticalIntersection(pt2, v2, pt1.x);
  if (v2.x.isZero()) return verticalIntersection(pt1, v1, pt2.x);
  if (v1.y.isZero()) return horizontalIntersection(pt2, v2, pt1.y);
  if (v2.y.isZero()) return horizontalIntersection(pt1, v1, pt2.y);
  const kross = crossProduct(v1, v2);
  if (kross.isZero()) return null;
  const ve = { x: pt2.x.minus(pt1.x), y: pt2.y.minus(pt1.y) };
  const d1 = crossProduct(ve, v1).div(kross);
  const d2 = crossProduct(ve, v2).div(kross);
  const x1 = pt1.x.plus(d2.times(v1.x)), x2 = pt2.x.plus(d1.times(v2.x));
  const y1 = pt1.y.plus(d2.times(v1.y)), y2 = pt2.y.plus(d1.times(v2.y));
  const x = x1.plus(x2).div(2);
  const y = y1.plus(y2).div(2);
  return { x, y };
};

// src/sweep-event.ts
var SweepEvent = class _SweepEvent {
  point;
  isLeft;
  segment;
  otherSE;
  consumedBy;
  // for ordering sweep events in the sweep event queue
  static compare(a, b) {
    const ptCmp = _SweepEvent.comparePoints(a.point, b.point);
    if (ptCmp !== 0) return ptCmp;
    if (a.point !== b.point) a.link(b);
    if (a.isLeft !== b.isLeft) return a.isLeft ? 1 : -1;
    return Segment.compare(a.segment, b.segment);
  }
  // for ordering points in sweep line order
  static comparePoints(aPt, bPt) {
    if (aPt.x.isLessThan(bPt.x)) return -1;
    if (aPt.x.isGreaterThan(bPt.x)) return 1;
    if (aPt.y.isLessThan(bPt.y)) return -1;
    if (aPt.y.isGreaterThan(bPt.y)) return 1;
    return 0;
  }
  // Warning: 'point' input will be modified and re-used (for performance)
  constructor(point, isLeft) {
    if (point.events === void 0) point.events = [this];
    else point.events.push(this);
    this.point = point;
    this.isLeft = isLeft;
  }
  link(other) {
    if (other.point === this.point) {
      throw new Error("Tried to link already linked events");
    }
    const otherEvents = other.point.events;
    for (let i = 0, iMax = otherEvents.length; i < iMax; i++) {
      const evt = otherEvents[i];
      this.point.events.push(evt);
      evt.point = this.point;
    }
    this.checkForConsuming();
  }
  /* Do a pass over our linked events and check to see if any pair
   * of segments match, and should be consumed. */
  checkForConsuming() {
    const numEvents = this.point.events.length;
    for (let i = 0; i < numEvents; i++) {
      const evt1 = this.point.events[i];
      if (evt1.segment.consumedBy !== void 0) continue;
      for (let j = i + 1; j < numEvents; j++) {
        const evt2 = this.point.events[j];
        if (evt2.consumedBy !== void 0) continue;
        if (evt1.otherSE.point.events !== evt2.otherSE.point.events) continue;
        evt1.segment.consume(evt2.segment);
      }
    }
  }
  getAvailableLinkedEvents() {
    const events = [];
    for (let i = 0, iMax = this.point.events.length; i < iMax; i++) {
      const evt = this.point.events[i];
      if (evt !== this && !evt.segment.ringOut && evt.segment.isInResult()) {
        events.push(evt);
      }
    }
    return events;
  }
  /**
   * Returns a comparator function for sorting linked events that will
   * favor the event that will give us the smallest left-side angle.
   * All ring construction starts as low as possible heading to the right,
   * so by always turning left as sharp as possible we'll get polygons
   * without uncessary loops & holes.
   *
   * The comparator function has a compute cache such that it avoids
   * re-computing already-computed values.
   */
  getLeftmostComparator(baseEvent) {
    const cache = /* @__PURE__ */ new Map();
    const fillCache = (linkedEvent) => {
      const nextEvent = linkedEvent.otherSE;
      cache.set(linkedEvent, {
        sine: sineOfAngle(this.point, baseEvent.point, nextEvent.point),
        cosine: cosineOfAngle(this.point, baseEvent.point, nextEvent.point)
      });
    };
    return (a, b) => {
      if (!cache.has(a)) fillCache(a);
      if (!cache.has(b)) fillCache(b);
      const { sine: asine, cosine: acosine } = cache.get(a);
      const { sine: bsine, cosine: bcosine } = cache.get(b);
      if (asine.isGreaterThanOrEqualTo(0) && bsine.isGreaterThanOrEqualTo(0)) {
        if (acosine.isLessThan(bcosine)) return 1;
        if (acosine.isGreaterThan(bcosine)) return -1;
        return 0;
      }
      if (asine.isLessThan(0) && bsine.isLessThan(0)) {
        if (acosine.isLessThan(bcosine)) return -1;
        if (acosine.isGreaterThan(bcosine)) return 1;
        return 0;
      }
      if (bsine.isLessThan(asine)) return -1;
      if (bsine.isGreaterThan(asine)) return 1;
      return 0;
    };
  }
};

// src/geom-out.ts
var RingOut = class _RingOut {
  events;
  poly;
  _isExteriorRing;
  _enclosingRing;
  /* Given the segments from the sweep line pass, compute & return a series
   * of closed rings from all the segments marked to be part of the result */
  static factory(allSegments) {
    const ringsOut = [];
    for (let i = 0, iMax = allSegments.length; i < iMax; i++) {
      const segment = allSegments[i];
      if (!segment.isInResult() || segment.ringOut) continue;
      let prevEvent = null;
      let event = segment.leftSE;
      let nextEvent = segment.rightSE;
      const events = [event];
      const startingPoint = event.point;
      const intersectionLEs = [];
      while (true) {
        prevEvent = event;
        event = nextEvent;
        events.push(event);
        if (event.point === startingPoint) break;
        while (true) {
          const availableLEs = event.getAvailableLinkedEvents();
          if (availableLEs.length === 0) {
            const firstPt = events[0].point;
            const lastPt = events[events.length - 1].point;
            throw new Error(
              `Unable to complete output ring starting at [${firstPt.x}, ${firstPt.y}]. Last matching segment found ends at [${lastPt.x}, ${lastPt.y}].`
            );
          }
          if (availableLEs.length === 1) {
            nextEvent = availableLEs[0].otherSE;
            break;
          }
          let indexLE = null;
          for (let j = 0, jMax = intersectionLEs.length; j < jMax; j++) {
            if (intersectionLEs[j].point === event.point) {
              indexLE = j;
              break;
            }
          }
          if (indexLE !== null) {
            const intersectionLE = intersectionLEs.splice(indexLE)[0];
            const ringEvents = events.splice(intersectionLE.index);
            ringEvents.unshift(ringEvents[0].otherSE);
            ringsOut.push(new _RingOut(ringEvents.reverse()));
            continue;
          }
          intersectionLEs.push({
            index: events.length,
            point: event.point
          });
          const comparator = event.getLeftmostComparator(prevEvent);
          nextEvent = availableLEs.sort(comparator)[0].otherSE;
          break;
        }
      }
      ringsOut.push(new _RingOut(events));
    }
    return ringsOut;
  }
  constructor(events) {
    this.events = events;
    for (let i = 0, iMax = events.length; i < iMax; i++) {
      events[i].segment.ringOut = this;
    }
    this.poly = null;
  }
  getGeom() {
    let prevPt = this.events[0].point;
    const points = [prevPt];
    for (let i = 1, iMax = this.events.length - 1; i < iMax; i++) {
      const pt2 = this.events[i].point;
      const nextPt2 = this.events[i + 1].point;
      if (precision.orient(pt2, prevPt, nextPt2) === 0) continue;
      points.push(pt2);
      prevPt = pt2;
    }
    if (points.length === 1) return null;
    const pt = points[0];
    const nextPt = points[1];
    if (precision.orient(pt, prevPt, nextPt) === 0) points.shift();
    points.push(points[0]);
    const step = this.isExteriorRing() ? 1 : -1;
    const iStart = this.isExteriorRing() ? 0 : points.length - 1;
    const iEnd = this.isExteriorRing() ? points.length : -1;
    const orderedPoints = [];
    for (let i = iStart; i != iEnd; i += step)
      orderedPoints.push([points[i].x.toNumber(), points[i].y.toNumber()]);
    return orderedPoints;
  }
  isExteriorRing() {
    if (this._isExteriorRing === void 0) {
      const enclosing = this.enclosingRing();
      this._isExteriorRing = enclosing ? !enclosing.isExteriorRing() : true;
    }
    return this._isExteriorRing;
  }
  enclosingRing() {
    if (this._enclosingRing === void 0) {
      this._enclosingRing = this._calcEnclosingRing();
    }
    return this._enclosingRing;
  }
  /* Returns the ring that encloses this one, if any */
  _calcEnclosingRing() {
    let leftMostEvt = this.events[0];
    for (let i = 1, iMax = this.events.length; i < iMax; i++) {
      const evt = this.events[i];
      if (SweepEvent.compare(leftMostEvt, evt) > 0) leftMostEvt = evt;
    }
    let prevSeg = leftMostEvt.segment.prevInResult();
    let prevPrevSeg = prevSeg ? prevSeg.prevInResult() : null;
    while (true) {
      if (!prevSeg) return null;
      if (!prevPrevSeg) return prevSeg.ringOut;
      if (prevPrevSeg.ringOut !== prevSeg.ringOut) {
        if (prevPrevSeg.ringOut?.enclosingRing() !== prevSeg.ringOut) {
          return prevSeg.ringOut;
        } else return prevSeg.ringOut?.enclosingRing();
      }
      prevSeg = prevPrevSeg.prevInResult();
      prevPrevSeg = prevSeg ? prevSeg.prevInResult() : null;
    }
  }
};
var PolyOut = class {
  exteriorRing;
  interiorRings;
  constructor(exteriorRing) {
    this.exteriorRing = exteriorRing;
    exteriorRing.poly = this;
    this.interiorRings = [];
  }
  addInterior(ring) {
    this.interiorRings.push(ring);
    ring.poly = this;
  }
  getGeom() {
    const geom0 = this.exteriorRing.getGeom();
    if (geom0 === null) return null;
    const geom = [geom0];
    for (let i = 0, iMax = this.interiorRings.length; i < iMax; i++) {
      const ringGeom = this.interiorRings[i].getGeom();
      if (ringGeom === null) continue;
      geom.push(ringGeom);
    }
    return geom;
  }
};
var MultiPolyOut = class {
  rings;
  polys;
  constructor(rings) {
    this.rings = rings;
    this.polys = this._composePolys(rings);
  }
  getGeom() {
    const geom = [];
    for (let i = 0, iMax = this.polys.length; i < iMax; i++) {
      const polyGeom = this.polys[i].getGeom();
      if (polyGeom === null) continue;
      geom.push(polyGeom);
    }
    return geom;
  }
  _composePolys(rings) {
    const polys = [];
    for (let i = 0, iMax = rings.length; i < iMax; i++) {
      const ring = rings[i];
      if (ring.poly) continue;
      if (ring.isExteriorRing()) polys.push(new PolyOut(ring));
      else {
        const enclosingRing = ring.enclosingRing();
        if (!enclosingRing?.poly) polys.push(new PolyOut(enclosingRing));
        enclosingRing?.poly?.addInterior(ring);
      }
    }
    return polys;
  }
};
var SweepLine = class {
  queue;
  tree;
  segments;
  constructor(queue, comparator = Segment.compare) {
    this.queue = queue;
    this.tree = new SplayTreeSet(comparator);
    this.segments = [];
  }
  process(event) {
    const segment = event.segment;
    const newEvents = [];
    if (event.consumedBy) {
      if (event.isLeft) this.queue.delete(event.otherSE);
      else this.tree.delete(segment);
      return newEvents;
    }
    if (event.isLeft) this.tree.add(segment);
    let prevSeg = segment;
    let nextSeg = segment;
    do {
      prevSeg = this.tree.lastBefore(prevSeg);
    } while (prevSeg != null && prevSeg.consumedBy != void 0);
    do {
      nextSeg = this.tree.firstAfter(nextSeg);
    } while (nextSeg != null && nextSeg.consumedBy != void 0);
    if (event.isLeft) {
      let prevMySplitter = null;
      if (prevSeg) {
        const prevInter = prevSeg.getIntersection(segment);
        if (prevInter !== null) {
          if (!segment.isAnEndpoint(prevInter)) prevMySplitter = prevInter;
          if (!prevSeg.isAnEndpoint(prevInter)) {
            const newEventsFromSplit = this._splitSafely(prevSeg, prevInter);
            for (let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++) {
              newEvents.push(newEventsFromSplit[i]);
            }
          }
        }
      }
      let nextMySplitter = null;
      if (nextSeg) {
        const nextInter = nextSeg.getIntersection(segment);
        if (nextInter !== null) {
          if (!segment.isAnEndpoint(nextInter)) nextMySplitter = nextInter;
          if (!nextSeg.isAnEndpoint(nextInter)) {
            const newEventsFromSplit = this._splitSafely(nextSeg, nextInter);
            for (let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++) {
              newEvents.push(newEventsFromSplit[i]);
            }
          }
        }
      }
      if (prevMySplitter !== null || nextMySplitter !== null) {
        let mySplitter = null;
        if (prevMySplitter === null) mySplitter = nextMySplitter;
        else if (nextMySplitter === null) mySplitter = prevMySplitter;
        else {
          const cmpSplitters = SweepEvent.comparePoints(
            prevMySplitter,
            nextMySplitter
          );
          mySplitter = cmpSplitters <= 0 ? prevMySplitter : nextMySplitter;
        }
        this.queue.delete(segment.rightSE);
        newEvents.push(segment.rightSE);
        const newEventsFromSplit = segment.split(mySplitter);
        for (let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++) {
          newEvents.push(newEventsFromSplit[i]);
        }
      }
      if (newEvents.length > 0) {
        this.tree.delete(segment);
        newEvents.push(event);
      } else {
        this.segments.push(segment);
        segment.prev = prevSeg;
      }
    } else {
      if (prevSeg && nextSeg) {
        const inter = prevSeg.getIntersection(nextSeg);
        if (inter !== null) {
          if (!prevSeg.isAnEndpoint(inter)) {
            const newEventsFromSplit = this._splitSafely(prevSeg, inter);
            for (let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++) {
              newEvents.push(newEventsFromSplit[i]);
            }
          }
          if (!nextSeg.isAnEndpoint(inter)) {
            const newEventsFromSplit = this._splitSafely(nextSeg, inter);
            for (let i = 0, iMax = newEventsFromSplit.length; i < iMax; i++) {
              newEvents.push(newEventsFromSplit[i]);
            }
          }
        }
      }
      this.tree.delete(segment);
    }
    return newEvents;
  }
  /* Safely split a segment that is currently in the datastructures
   * IE - a segment other than the one that is currently being processed. */
  _splitSafely(seg, pt) {
    this.tree.delete(seg);
    const rightSE = seg.rightSE;
    this.queue.delete(rightSE);
    const newEvents = seg.split(pt);
    newEvents.push(rightSE);
    if (seg.consumedBy === void 0) this.tree.add(seg);
    return newEvents;
  }
};

// src/operation.ts
var Operation = class {
  type;
  numMultiPolys;
  run(type, geom, moreGeoms) {
    operation.type = type;
    const multipolys = [new MultiPolyIn(geom, true)];
    for (let i = 0, iMax = moreGeoms.length; i < iMax; i++) {
      multipolys.push(new MultiPolyIn(moreGeoms[i], false));
    }
    operation.numMultiPolys = multipolys.length;
    if (operation.type === "difference") {
      const subject = multipolys[0];
      let i = 1;
      while (i < multipolys.length) {
        if (getBboxOverlap(multipolys[i].bbox, subject.bbox) !== null) i++;
        else multipolys.splice(i, 1);
      }
    }
    if (operation.type === "intersection") {
      for (let i = 0, iMax = multipolys.length; i < iMax; i++) {
        const mpA = multipolys[i];
        for (let j = i + 1, jMax = multipolys.length; j < jMax; j++) {
          if (getBboxOverlap(mpA.bbox, multipolys[j].bbox) === null) return [];
        }
      }
    }
    const queue = new SplayTreeSet(SweepEvent.compare);
    for (let i = 0, iMax = multipolys.length; i < iMax; i++) {
      const sweepEvents = multipolys[i].getSweepEvents();
      for (let j = 0, jMax = sweepEvents.length; j < jMax; j++) {
        queue.add(sweepEvents[j]);
      }
    }
    const sweepLine = new SweepLine(queue);
    let evt = null;
    if (queue.size != 0) {
      evt = queue.first();
      queue.delete(evt);
    }
    while (evt) {
      const newEvents = sweepLine.process(evt);
      for (let i = 0, iMax = newEvents.length; i < iMax; i++) {
        const evt2 = newEvents[i];
        if (evt2.consumedBy === void 0) queue.add(evt2);
      }
      if (queue.size != 0) {
        evt = queue.first();
        queue.delete(evt);
      } else {
        evt = null;
      }
    }
    precision.reset();
    const ringsOut = RingOut.factory(sweepLine.segments);
    const result = new MultiPolyOut(ringsOut);
    return result.getGeom();
  }
};
var operation = new Operation();
var operation_default = operation;

// src/segment.ts
var segmentId = 0;
var Segment = class _Segment {
  id;
  leftSE;
  rightSE;
  rings;
  windings;
  ringOut;
  consumedBy;
  prev;
  _prevInResult;
  _beforeState;
  _afterState;
  _isInResult;
  /* This compare() function is for ordering segments in the sweep
   * line tree, and does so according to the following criteria:
   *
   * Consider the vertical line that lies an infinestimal step to the
   * right of the right-more of the two left endpoints of the input
   * segments. Imagine slowly moving a point up from negative infinity
   * in the increasing y direction. Which of the two segments will that
   * point intersect first? That segment comes 'before' the other one.
   *
   * If neither segment would be intersected by such a line, (if one
   * or more of the segments are vertical) then the line to be considered
   * is directly on the right-more of the two left inputs.
   */
  static compare(a, b) {
    const alx = a.leftSE.point.x;
    const blx = b.leftSE.point.x;
    const arx = a.rightSE.point.x;
    const brx = b.rightSE.point.x;
    if (brx.isLessThan(alx)) return 1;
    if (arx.isLessThan(blx)) return -1;
    const aly = a.leftSE.point.y;
    const bly = b.leftSE.point.y;
    const ary = a.rightSE.point.y;
    const bry = b.rightSE.point.y;
    if (alx.isLessThan(blx)) {
      if (bly.isLessThan(aly) && bly.isLessThan(ary)) return 1;
      if (bly.isGreaterThan(aly) && bly.isGreaterThan(ary)) return -1;
      const aCmpBLeft = a.comparePoint(b.leftSE.point);
      if (aCmpBLeft < 0) return 1;
      if (aCmpBLeft > 0) return -1;
      const bCmpARight = b.comparePoint(a.rightSE.point);
      if (bCmpARight !== 0) return bCmpARight;
      return -1;
    }
    if (alx.isGreaterThan(blx)) {
      if (aly.isLessThan(bly) && aly.isLessThan(bry)) return -1;
      if (aly.isGreaterThan(bly) && aly.isGreaterThan(bry)) return 1;
      const bCmpALeft = b.comparePoint(a.leftSE.point);
      if (bCmpALeft !== 0) return bCmpALeft;
      const aCmpBRight = a.comparePoint(b.rightSE.point);
      if (aCmpBRight < 0) return 1;
      if (aCmpBRight > 0) return -1;
      return 1;
    }
    if (aly.isLessThan(bly)) return -1;
    if (aly.isGreaterThan(bly)) return 1;
    if (arx.isLessThan(brx)) {
      const bCmpARight = b.comparePoint(a.rightSE.point);
      if (bCmpARight !== 0) return bCmpARight;
    }
    if (arx.isGreaterThan(brx)) {
      const aCmpBRight = a.comparePoint(b.rightSE.point);
      if (aCmpBRight < 0) return 1;
      if (aCmpBRight > 0) return -1;
    }
    if (!arx.eq(brx)) {
      const ay = ary.minus(aly);
      const ax = arx.minus(alx);
      const by = bry.minus(bly);
      const bx = brx.minus(blx);
      if (ay.isGreaterThan(ax) && by.isLessThan(bx)) return 1;
      if (ay.isLessThan(ax) && by.isGreaterThan(bx)) return -1;
    }
    if (arx.isGreaterThan(brx)) return 1;
    if (arx.isLessThan(brx)) return -1;
    if (ary.isLessThan(bry)) return -1;
    if (ary.isGreaterThan(bry)) return 1;
    if (a.id < b.id) return -1;
    if (a.id > b.id) return 1;
    return 0;
  }
  /* Warning: a reference to ringWindings input will be stored,
   *  and possibly will be later modified */
  constructor(leftSE, rightSE, rings, windings) {
    this.id = ++segmentId;
    this.leftSE = leftSE;
    leftSE.segment = this;
    leftSE.otherSE = rightSE;
    this.rightSE = rightSE;
    rightSE.segment = this;
    rightSE.otherSE = leftSE;
    this.rings = rings;
    this.windings = windings;
  }
  static fromRing(pt1, pt2, ring) {
    let leftPt, rightPt, winding;
    const cmpPts = SweepEvent.comparePoints(pt1, pt2);
    if (cmpPts < 0) {
      leftPt = pt1;
      rightPt = pt2;
      winding = 1;
    } else if (cmpPts > 0) {
      leftPt = pt2;
      rightPt = pt1;
      winding = -1;
    } else
      throw new Error(
        `Tried to create degenerate segment at [${pt1.x}, ${pt1.y}]`
      );
    const leftSE = new SweepEvent(leftPt, true);
    const rightSE = new SweepEvent(rightPt, false);
    return new _Segment(leftSE, rightSE, [ring], [winding]);
  }
  /* When a segment is split, the rightSE is replaced with a new sweep event */
  replaceRightSE(newRightSE) {
    this.rightSE = newRightSE;
    this.rightSE.segment = this;
    this.rightSE.otherSE = this.leftSE;
    this.leftSE.otherSE = this.rightSE;
  }
  bbox() {
    const y1 = this.leftSE.point.y;
    const y2 = this.rightSE.point.y;
    return {
      ll: { x: this.leftSE.point.x, y: y1.isLessThan(y2) ? y1 : y2 },
      ur: { x: this.rightSE.point.x, y: y1.isGreaterThan(y2) ? y1 : y2 }
    };
  }
  /* A vector from the left point to the right */
  vector() {
    return {
      x: this.rightSE.point.x.minus(this.leftSE.point.x),
      y: this.rightSE.point.y.minus(this.leftSE.point.y)
    };
  }
  isAnEndpoint(pt) {
    return pt.x.eq(this.leftSE.point.x) && pt.y.eq(this.leftSE.point.y) || pt.x.eq(this.rightSE.point.x) && pt.y.eq(this.rightSE.point.y);
  }
  /* Compare this segment with a point.
   *
   * A point P is considered to be colinear to a segment if there
   * exists a distance D such that if we travel along the segment
   * from one * endpoint towards the other a distance D, we find
   * ourselves at point P.
   *
   * Return value indicates:
   *
   *   1: point lies above the segment (to the left of vertical)
   *   0: point is colinear to segment
   *  -1: point lies below the segment (to the right of vertical)
   */
  comparePoint(point) {
    return precision.orient(this.leftSE.point, point, this.rightSE.point);
  }
  /**
   * Given another segment, returns the first non-trivial intersection
   * between the two segments (in terms of sweep line ordering), if it exists.
   *
   * A 'non-trivial' intersection is one that will cause one or both of the
   * segments to be split(). As such, 'trivial' vs. 'non-trivial' intersection:
   *
   *   * endpoint of segA with endpoint of segB --> trivial
   *   * endpoint of segA with point along segB --> non-trivial
   *   * endpoint of segB with point along segA --> non-trivial
   *   * point along segA with point along segB --> non-trivial
   *
   * If no non-trivial intersection exists, return null
   * Else, return null.
   */
  getIntersection(other) {
    const tBbox = this.bbox();
    const oBbox = other.bbox();
    const bboxOverlap = getBboxOverlap(tBbox, oBbox);
    if (bboxOverlap === null) return null;
    const tlp = this.leftSE.point;
    const trp = this.rightSE.point;
    const olp = other.leftSE.point;
    const orp = other.rightSE.point;
    const touchesOtherLSE = isInBbox(tBbox, olp) && this.comparePoint(olp) === 0;
    const touchesThisLSE = isInBbox(oBbox, tlp) && other.comparePoint(tlp) === 0;
    const touchesOtherRSE = isInBbox(tBbox, orp) && this.comparePoint(orp) === 0;
    const touchesThisRSE = isInBbox(oBbox, trp) && other.comparePoint(trp) === 0;
    if (touchesThisLSE && touchesOtherLSE) {
      if (touchesThisRSE && !touchesOtherRSE) return trp;
      if (!touchesThisRSE && touchesOtherRSE) return orp;
      return null;
    }
    if (touchesThisLSE) {
      if (touchesOtherRSE) {
        if (tlp.x.eq(orp.x) && tlp.y.eq(orp.y)) return null;
      }
      return tlp;
    }
    if (touchesOtherLSE) {
      if (touchesThisRSE) {
        if (trp.x.eq(olp.x) && trp.y.eq(olp.y)) return null;
      }
      return olp;
    }
    if (touchesThisRSE && touchesOtherRSE) return null;
    if (touchesThisRSE) return trp;
    if (touchesOtherRSE) return orp;
    const pt = intersection$1(tlp, this.vector(), olp, other.vector());
    if (pt === null) return null;
    if (!isInBbox(bboxOverlap, pt)) return null;
    return precision.snap(pt);
  }
  /**
   * Split the given segment into multiple segments on the given points.
   *  * Each existing segment will retain its leftSE and a new rightSE will be
   *    generated for it.
   *  * A new segment will be generated which will adopt the original segment's
   *    rightSE, and a new leftSE will be generated for it.
   *  * If there are more than two points given to split on, new segments
   *    in the middle will be generated with new leftSE and rightSE's.
   *  * An array of the newly generated SweepEvents will be returned.
   *
   * Warning: input array of points is modified
   */
  split(point) {
    const newEvents = [];
    const alreadyLinked = point.events !== void 0;
    const newLeftSE = new SweepEvent(point, true);
    const newRightSE = new SweepEvent(point, false);
    const oldRightSE = this.rightSE;
    this.replaceRightSE(newRightSE);
    newEvents.push(newRightSE);
    newEvents.push(newLeftSE);
    const newSeg = new _Segment(
      newLeftSE,
      oldRightSE,
      this.rings.slice(),
      this.windings.slice()
    );
    if (SweepEvent.comparePoints(newSeg.leftSE.point, newSeg.rightSE.point) > 0) {
      newSeg.swapEvents();
    }
    if (SweepEvent.comparePoints(this.leftSE.point, this.rightSE.point) > 0) {
      this.swapEvents();
    }
    if (alreadyLinked) {
      newLeftSE.checkForConsuming();
      newRightSE.checkForConsuming();
    }
    return newEvents;
  }
  /* Swap which event is left and right */
  swapEvents() {
    const tmpEvt = this.rightSE;
    this.rightSE = this.leftSE;
    this.leftSE = tmpEvt;
    this.leftSE.isLeft = true;
    this.rightSE.isLeft = false;
    for (let i = 0, iMax = this.windings.length; i < iMax; i++) {
      this.windings[i] *= -1;
    }
  }
  /* Consume another segment. We take their rings under our wing
   * and mark them as consumed. Use for perfectly overlapping segments */
  consume(other) {
    let consumer = this;
    let consumee = other;
    while (consumer.consumedBy) consumer = consumer.consumedBy;
    while (consumee.consumedBy) consumee = consumee.consumedBy;
    const cmp = _Segment.compare(consumer, consumee);
    if (cmp === 0) return;
    if (cmp > 0) {
      const tmp = consumer;
      consumer = consumee;
      consumee = tmp;
    }
    if (consumer.prev === consumee) {
      const tmp = consumer;
      consumer = consumee;
      consumee = tmp;
    }
    for (let i = 0, iMax = consumee.rings.length; i < iMax; i++) {
      const ring = consumee.rings[i];
      const winding = consumee.windings[i];
      const index = consumer.rings.indexOf(ring);
      if (index === -1) {
        consumer.rings.push(ring);
        consumer.windings.push(winding);
      } else consumer.windings[index] += winding;
    }
    consumee.rings = null;
    consumee.windings = null;
    consumee.consumedBy = consumer;
    consumee.leftSE.consumedBy = consumer.leftSE;
    consumee.rightSE.consumedBy = consumer.rightSE;
  }
  /* The first segment previous segment chain that is in the result */
  prevInResult() {
    if (this._prevInResult !== void 0) return this._prevInResult;
    if (!this.prev) this._prevInResult = null;
    else if (this.prev.isInResult()) this._prevInResult = this.prev;
    else this._prevInResult = this.prev.prevInResult();
    return this._prevInResult;
  }
  beforeState() {
    if (this._beforeState !== void 0) return this._beforeState;
    if (!this.prev)
      this._beforeState = {
        rings: [],
        windings: [],
        multiPolys: []
      };
    else {
      const seg = this.prev.consumedBy || this.prev;
      this._beforeState = seg.afterState();
    }
    return this._beforeState;
  }
  afterState() {
    if (this._afterState !== void 0) return this._afterState;
    const beforeState = this.beforeState();
    this._afterState = {
      rings: beforeState.rings.slice(0),
      windings: beforeState.windings.slice(0),
      multiPolys: []
    };
    const ringsAfter = this._afterState.rings;
    const windingsAfter = this._afterState.windings;
    const mpsAfter = this._afterState.multiPolys;
    for (let i = 0, iMax = this.rings.length; i < iMax; i++) {
      const ring = this.rings[i];
      const winding = this.windings[i];
      const index = ringsAfter.indexOf(ring);
      if (index === -1) {
        ringsAfter.push(ring);
        windingsAfter.push(winding);
      } else windingsAfter[index] += winding;
    }
    const polysAfter = [];
    const polysExclude = [];
    for (let i = 0, iMax = ringsAfter.length; i < iMax; i++) {
      if (windingsAfter[i] === 0) continue;
      const ring = ringsAfter[i];
      const poly = ring.poly;
      if (polysExclude.indexOf(poly) !== -1) continue;
      if (ring.isExterior) polysAfter.push(poly);
      else {
        if (polysExclude.indexOf(poly) === -1) polysExclude.push(poly);
        const index = polysAfter.indexOf(ring.poly);
        if (index !== -1) polysAfter.splice(index, 1);
      }
    }
    for (let i = 0, iMax = polysAfter.length; i < iMax; i++) {
      const mp = polysAfter[i].multiPoly;
      if (mpsAfter.indexOf(mp) === -1) mpsAfter.push(mp);
    }
    return this._afterState;
  }
  /* Is this segment part of the final result? */
  isInResult() {
    if (this.consumedBy) return false;
    if (this._isInResult !== void 0) return this._isInResult;
    const mpsBefore = this.beforeState().multiPolys;
    const mpsAfter = this.afterState().multiPolys;
    switch (operation_default.type) {
      case "union": {
        const noBefores = mpsBefore.length === 0;
        const noAfters = mpsAfter.length === 0;
        this._isInResult = noBefores !== noAfters;
        break;
      }
      case "intersection": {
        let least;
        let most;
        if (mpsBefore.length < mpsAfter.length) {
          least = mpsBefore.length;
          most = mpsAfter.length;
        } else {
          least = mpsAfter.length;
          most = mpsBefore.length;
        }
        this._isInResult = most === operation_default.numMultiPolys && least < most;
        break;
      }
      case "xor": {
        const diff = Math.abs(mpsBefore.length - mpsAfter.length);
        this._isInResult = diff % 2 === 1;
        break;
      }
      case "difference": {
        const isJustSubject = (mps) => mps.length === 1 && mps[0].isSubject;
        this._isInResult = isJustSubject(mpsBefore) !== isJustSubject(mpsAfter);
        break;
      }
    }
    return this._isInResult;
  }
};

// src/geom-in.ts
var RingIn = class {
  poly;
  isExterior;
  segments;
  bbox;
  constructor(geomRing, poly, isExterior) {
    if (!Array.isArray(geomRing) || geomRing.length === 0) {
      throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
    }
    this.poly = poly;
    this.isExterior = isExterior;
    this.segments = [];
    if (typeof geomRing[0][0] !== "number" || typeof geomRing[0][1] !== "number") {
      throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
    }
    const firstPoint = precision.snap({ x: new BigNumber(geomRing[0][0]), y: new BigNumber(geomRing[0][1]) });
    this.bbox = {
      ll: { x: firstPoint.x, y: firstPoint.y },
      ur: { x: firstPoint.x, y: firstPoint.y }
    };
    let prevPoint = firstPoint;
    for (let i = 1, iMax = geomRing.length; i < iMax; i++) {
      if (typeof geomRing[i][0] !== "number" || typeof geomRing[i][1] !== "number") {
        throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
      }
      const point = precision.snap({ x: new BigNumber(geomRing[i][0]), y: new BigNumber(geomRing[i][1]) });
      if (point.x.eq(prevPoint.x) && point.y.eq(prevPoint.y)) continue;
      this.segments.push(Segment.fromRing(prevPoint, point, this));
      if (point.x.isLessThan(this.bbox.ll.x)) this.bbox.ll.x = point.x;
      if (point.y.isLessThan(this.bbox.ll.y)) this.bbox.ll.y = point.y;
      if (point.x.isGreaterThan(this.bbox.ur.x)) this.bbox.ur.x = point.x;
      if (point.y.isGreaterThan(this.bbox.ur.y)) this.bbox.ur.y = point.y;
      prevPoint = point;
    }
    if (!firstPoint.x.eq(prevPoint.x) || !firstPoint.y.eq(prevPoint.y)) {
      this.segments.push(Segment.fromRing(prevPoint, firstPoint, this));
    }
  }
  getSweepEvents() {
    const sweepEvents = [];
    for (let i = 0, iMax = this.segments.length; i < iMax; i++) {
      const segment = this.segments[i];
      sweepEvents.push(segment.leftSE);
      sweepEvents.push(segment.rightSE);
    }
    return sweepEvents;
  }
};
var PolyIn = class {
  multiPoly;
  exteriorRing;
  interiorRings;
  bbox;
  constructor(geomPoly, multiPoly) {
    if (!Array.isArray(geomPoly)) {
      throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
    }
    this.exteriorRing = new RingIn(geomPoly[0], this, true);
    this.bbox = {
      ll: { x: this.exteriorRing.bbox.ll.x, y: this.exteriorRing.bbox.ll.y },
      ur: { x: this.exteriorRing.bbox.ur.x, y: this.exteriorRing.bbox.ur.y }
    };
    this.interiorRings = [];
    for (let i = 1, iMax = geomPoly.length; i < iMax; i++) {
      const ring = new RingIn(geomPoly[i], this, false);
      if (ring.bbox.ll.x.isLessThan(this.bbox.ll.x)) this.bbox.ll.x = ring.bbox.ll.x;
      if (ring.bbox.ll.y.isLessThan(this.bbox.ll.y)) this.bbox.ll.y = ring.bbox.ll.y;
      if (ring.bbox.ur.x.isGreaterThan(this.bbox.ur.x)) this.bbox.ur.x = ring.bbox.ur.x;
      if (ring.bbox.ur.y.isGreaterThan(this.bbox.ur.y)) this.bbox.ur.y = ring.bbox.ur.y;
      this.interiorRings.push(ring);
    }
    this.multiPoly = multiPoly;
  }
  getSweepEvents() {
    const sweepEvents = this.exteriorRing.getSweepEvents();
    for (let i = 0, iMax = this.interiorRings.length; i < iMax; i++) {
      const ringSweepEvents = this.interiorRings[i].getSweepEvents();
      for (let j = 0, jMax = ringSweepEvents.length; j < jMax; j++) {
        sweepEvents.push(ringSweepEvents[j]);
      }
    }
    return sweepEvents;
  }
};
var MultiPolyIn = class {
  isSubject;
  polys;
  bbox;
  constructor(geom, isSubject) {
    if (!Array.isArray(geom)) {
      throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
    }
    try {
      if (typeof geom[0][0][0] === "number") geom = [geom];
    } catch (ex) {
    }
    this.polys = [];
    this.bbox = {
      ll: { x: new BigNumber(Number.POSITIVE_INFINITY), y: new BigNumber(Number.POSITIVE_INFINITY) },
      ur: { x: new BigNumber(Number.NEGATIVE_INFINITY), y: new BigNumber(Number.NEGATIVE_INFINITY) }
    };
    for (let i = 0, iMax = geom.length; i < iMax; i++) {
      const poly = new PolyIn(geom[i], this);
      if (poly.bbox.ll.x.isLessThan(this.bbox.ll.x)) this.bbox.ll.x = poly.bbox.ll.x;
      if (poly.bbox.ll.y.isLessThan(this.bbox.ll.y)) this.bbox.ll.y = poly.bbox.ll.y;
      if (poly.bbox.ur.x.isGreaterThan(this.bbox.ur.x)) this.bbox.ur.x = poly.bbox.ur.x;
      if (poly.bbox.ur.y.isGreaterThan(this.bbox.ur.y)) this.bbox.ur.y = poly.bbox.ur.y;
      this.polys.push(poly);
    }
    this.isSubject = isSubject;
  }
  getSweepEvents() {
    const sweepEvents = [];
    for (let i = 0, iMax = this.polys.length; i < iMax; i++) {
      const polySweepEvents = this.polys[i].getSweepEvents();
      for (let j = 0, jMax = polySweepEvents.length; j < jMax; j++) {
        sweepEvents.push(polySweepEvents[j]);
      }
    }
    return sweepEvents;
  }
};

// src/index.ts
var union$1 = (geom, ...moreGeoms) => operation_default.run("union", geom, moreGeoms);
var intersection2 = (geom, ...moreGeoms) => operation_default.run("intersection", geom, moreGeoms);
var xor$1 = (geom, ...moreGeoms) => operation_default.run("xor", geom, moreGeoms);
var difference$1 = (geom, ...moreGeoms) => operation_default.run("difference", geom, moreGeoms);
precision.set;

const eps = 1.1102230246251565e-16;
const splitter = 134217729;
const resulterrbound = (3 + 8 * eps) * eps;
const ccwErrA = (3 + 16 * eps) * eps;
const ccwErrB = (2 + 12 * eps) * eps;
const ccwErrC = (9 + 64 * eps) * eps * eps;
const B = vec(4);
const C1 = vec(8);
const C2 = vec(12);
const D = vec(16);
const u = vec(4);

function orient(ax, ay, bx, by, cx, cy) {
	const left = (ay - cy) * (bx - cx);
	const right = (ax - cx) * (by - cy);
	const det = left - right;
	const detsum = Math.abs(left + right);

	return (Math.abs(det) >= ccwErrA * detsum) ? det : -adapt(ax, ay, bx, by, cx, cy, detsum);
}
function adapt(ax, ay, bx, by, cx, cy, detsum) {
	let acxtail, acytail, bcxtail, bcytail;
	let bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;

	const acx = ax - cx;
	const bcx = bx - cx;
	const acy = ay - cy;
	const bcy = by - cy;

	s1 = acx * bcy;
	c = splitter * acx;
	ahi = c - (c - acx);
	alo = acx - ahi;
	c = splitter * bcy;
	bhi = c - (c - bcy);
	blo = bcy - bhi;
	s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
	t1 = acy * bcx;
	c = splitter * acy;
	ahi = c - (c - acy);
	alo = acy - ahi;
	c = splitter * bcx;
	bhi = c - (c - bcx);
	blo = bcx - bhi;
	t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
	_i = s0 - t0;
	bvirt = s0 - _i;
	B[0] = s0 - (_i + bvirt) + (bvirt - t0);
	_j = s1 + _i;
	bvirt = _j - s1;
	_0 = s1 - (_j - bvirt) + (_i - bvirt);
	_i = _0 - t1;
	bvirt = _0 - _i;
	B[1] = _0 - (_i + bvirt) + (bvirt - t1);
	u3 = _j + _i;
	bvirt = u3 - _j;
	B[2] = _j - (u3 - bvirt) + (_i - bvirt);
	B[3] = u3;

	let det = estimate(4, B);
	let errbound = ccwErrB * detsum;
	
	if(det >= errbound || -det >= errbound){ return det; }

	bvirt = ax - acx;
	acxtail = ax - (acx + bvirt) + (bvirt - cx);
	bvirt = bx - bcx;
	bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
	bvirt = ay - acy;
	acytail = ay - (acy + bvirt) + (bvirt - cy);
	bvirt = by - bcy;
	bcytail = by - (bcy + bvirt) + (bvirt - cy);

	if(acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0){ return det; }

	errbound = ccwErrC * detsum + resulterrbound * Math.abs(det);
	det += (acx * bcytail + bcy * acxtail) - (acy * bcxtail + bcx * acytail);

	if(det >= errbound || -det >= errbound){ return det; }

	s1 = acxtail * bcy;
	c = splitter * acxtail;
	ahi = c - (c - acxtail);
	alo = acxtail - ahi;
	c = splitter * bcy;
	bhi = c - (c - bcy);
	blo = bcy - bhi;
	s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
	t1 = acytail * bcx;
	c = splitter * acytail;
	ahi = c - (c - acytail);
	alo = acytail - ahi;
	c = splitter * bcx;
	bhi = c - (c - bcx);
	blo = bcx - bhi;
	t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
	_i = s0 - t0;
	bvirt = s0 - _i;
	u[0] = s0 - (_i + bvirt) + (bvirt - t0);
	_j = s1 + _i;
	bvirt = _j - s1;
	_0 = s1 - (_j - bvirt) + (_i - bvirt);
	_i = _0 - t1;
	bvirt = _0 - _i;
	u[1] = _0 - (_i + bvirt) + (bvirt - t1);
	u3 = _j + _i;
	bvirt = u3 - _j;
	u[2] = _j - (u3 - bvirt) + (_i - bvirt);
	u[3] = u3;
	
	const C1len = sum(4, B, 4, u, C1);

	s1 = acx * bcytail;
	c = splitter * acx;
	ahi = c - (c - acx);
	alo = acx - ahi;
	c = splitter * bcytail;
	bhi = c - (c - bcytail);
	blo = bcytail - bhi;
	s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
	t1 = acy * bcxtail;
	c = splitter * acy;
	ahi = c - (c - acy);
	alo = acy - ahi;
	c = splitter * bcxtail;
	bhi = c - (c - bcxtail);
	blo = bcxtail - bhi;
	t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
	_i = s0 - t0;
	bvirt = s0 - _i;
	u[0] = s0 - (_i + bvirt) + (bvirt - t0);
	_j = s1 + _i;
	bvirt = _j - s1;
	_0 = s1 - (_j - bvirt) + (_i - bvirt);
	_i = _0 - t1;
	bvirt = _0 - _i;
	u[1] = _0 - (_i + bvirt) + (bvirt - t1);
	u3 = _j + _i;
	bvirt = u3 - _j;
	u[2] = _j - (u3 - bvirt) + (_i - bvirt);
	u[3] = u3;
	
	const C2len = sum(C1len, C1, 4, u, C2);

	s1 = acxtail * bcytail;
	c = splitter * acxtail;
	ahi = c - (c - acxtail);
	alo = acxtail - ahi;
	c = splitter * bcytail;
	bhi = c - (c - bcytail);
	blo = bcytail - bhi;
	s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
	t1 = acytail * bcxtail;
	c = splitter * acytail;
	ahi = c - (c - acytail);
	alo = acytail - ahi;
	c = splitter * bcxtail;
	bhi = c - (c - bcxtail);
	blo = bcxtail - bhi;
	t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
	_i = s0 - t0;
	bvirt = s0 - _i;
	u[0] = s0 - (_i + bvirt) + (bvirt - t0);
	_j = s1 + _i;
	bvirt = _j - s1;
	_0 = s1 - (_j - bvirt) + (_i - bvirt);
	_i = _0 - t1;
	bvirt = _0 - _i;
	u[1] = _0 - (_i + bvirt) + (bvirt - t1);
	u3 = _j + _i;
	bvirt = u3 - _j;
	u[2] = _j - (u3 - bvirt) + (_i - bvirt);
	u[3] = u3;

	const Dlen = sum(C2len, C2, 4, u, D);

	return D[Dlen - 1];
}
function sum(elen, e, flen, f, h){
	let q1, q2, hh, bvirt;
	let enow = e[0];
	let fnow = f[0];
	let eindex = 0;
	let findex = 0;
	let hindex = 0;

	if((fnow > enow) === (fnow > -enow)){
		q1 = enow;
		enow = e[++eindex];
	} else {
		q1 = fnow;
		fnow = f[++findex];
	}

	if(eindex < elen && findex < flen){
		if ((fnow > enow) === (fnow > -enow)){
			q2 = enow + q1;
			hh = q1 - (q2 - enow);
			enow = e[++eindex];
		} else {
			q2 = fnow + q1;
			hh = q1 - (q2 - fnow);
			fnow = f[++findex];
		}

		q1 = q2;
		
		if(hh !== 0){ h[hindex++] = hh; }
		
		while(eindex < elen && findex < flen){
			if((fnow > enow) === (fnow > -enow)){
				q2 = q1 + enow;
				bvirt = q2 - q1;
				hh = q1 - (q2 - bvirt) + (enow - bvirt);
				enow = e[++eindex];
			} else {
				q2 = q1 + fnow;
				bvirt = q2 - q1;
				hh = q1 - (q2 - bvirt) + (fnow - bvirt);
				fnow = f[++findex];
			}
			
			q1 = q2;

			if(hh !== 0){ h[hindex++] = hh; }
		}
	}

	while(eindex < elen){
		q2 = q1 + enow;
		bvirt = q2 - q1;
		hh = q1 - (q2 - bvirt) + (enow - bvirt);
		enow = e[++eindex];
		q1 = q2;

		if(hh !== 0){ h[hindex++] = hh; }
	}

	while(findex < flen){
		q2 = q1 + fnow;
		bvirt = q2 - q1;
		hh = q1 - (q2 - bvirt) + (fnow - bvirt);
		fnow = f[++findex];
		q1 = q2;

		if(hh !== 0){ h[hindex++] = hh; }
	}

	if(q1 !== 0 || hindex === 0){ h[hindex++] = q1; }

	return hindex;
}
function estimate(elen, e){
	let q1 = e[0];
	
	for(let i = 1; i < elen; i++){
		q1 += e[i];
	}
	
	return q1;
}
function vec(n){
	return new Float64Array(n);
}

const {abs: abs$2, min, max, ceil, floor, round, sign, atan2: atan2$2, sqrt: sqrt$2} = Math;
const epsilon = 0.0000001;

class Vec3{
	constructor(x, y, z){
		this.x = Number(x);
		this.y = Number(y);
		this.z = Number(z);
	}
	clone(){
		return new Vec3(this);
	}
	plus(b){
		const a = this;
		return new Vec3(a.x + b.x, a.y + b.y, a.z + b.z);
	}
	minus(b){
		const a = this;
		return new Vec3(a.x - b.x, a.y - b.y, a.z - b.z);
	}
	multiply(b){
		const a = this;
		return new Vec3(a.x * b.x, a.y * b.y, a.z * b.z);
	}
	divide(b){
		const a = this;
		return new Vec3(a.x / b.x, a.y / b.y, a.z / b.z);
	}
	dot(b = this){
		const a = this;
		return (a.x * b.x) + (a.y * b.y) + (a.z * b.z);
	}
	times(n){
		const a = this;
		return new Vec3(a.x * n, a.y * n, a.z * n);
	}
	divideBy(n){
		const a = this;
		return new Vec3(a.x / n, a.y / n, a.z / n);
	}
	lerp(b, t){
		return this.plus(b.minus(this).times(t));
	}
	length(b = this){
		return sqrt$2(this.dot(b));
	}
	unit(){
		const norm = this.length();

		return (norm === 1 || norm === 0) ? this.clone() : this.divideBy(norm);
	}
	min(b){
		const a = this;
		return new Vec3(min(a.x, b.x), min(a.y, b.y), min(a.z, b.z));
	}
	max(b){
		const a = this;
		return new Vec3(max(a.x, b.x), max(a.y, b.y), max(a.z, b.z));
	}
	ceil(b){
		const a = this;
		return new Vec3(ceil(a.x, b.x), ceil(a.y, b.y), ceil(a.z, b.z));
	}
	abs(){
		const a = this;
		return new Vec3(abs$2(a.x), abs$2(a.y), abs$2(a.z));
	}
	floor(){
		const a = this;
		return new Vec3(floor(a.x), floor(a.y), floor(a.z));
	}
	round(){
		const a = this;
		return new Vec3(round(a.x), round(a.y), round(a.z));
	}
	inverse(){
		const a = this;
		return new Vec3(1 / a.x, 1 / a.y, 1 / a.z);
	}
	negate(){
		const a = this;
		return new Vec3(-a.x, -a.y, -a.z);
	}
	normal(){
		const dot = this.dot();
		return dot <= 0 ? this : this.times(dot);
	}
	cross(b){
		const a = this;
		return new Vec3(a.y * b.z - a.z * b.y, a.z * b.x - a.x * b.z, a.x * b.y - a.y * b.x);
	}
	crossSum(b){
		const cross = this.cross(b);
		return cross.x + cross.y + cross.z;
	}
	distance(b){
		return this.minus(b).length();
	}
	distanceSquared(b){
		return this.minus(b).dot();
	}
	equalsEpsilon(b){
		const a = this;
		const bool1 = abs$2(a.x - b.x) <= epsilon * max(1.0, abs$2(a.x), abs$2(b.x));
		const bool2 = abs$2(a.y - b.y) <= epsilon * max(1.0, abs$2(a.y), abs$2(b.y));
		const bool3 = abs$2(a.z - b.z) <= epsilon * max(1.0, abs$2(a.z), abs$2(b.z));

		return (bool1 && bool2 && bool3);
	}
	equals(b){
		const a = this;
		return (a.x === b.x) && (a.y === b.y) && (a.z === b.z);
	}
	angle(b, plane){
		if(plane){ plane = sign(this.cross(b).dot(plane)); }

		const factor = plane || 1;
		const sin = this.cross(b).length() * factor;
		const cos = this.dot(b);

		return atan2$2(sin, cos);
	}
}
function toVec(coord){
	const {cos, sin, PI} = Math;
	const rad = 6371009;
	const lon = coord[0] * PI / 180;
	const lat = coord[1] * PI / 180;
	const x = rad * cos(lon) * cos(lat);
	const y = rad * sin(lon) * cos(lat);
	const z = rad * sin(lat);

	return new Vec3(x, y, z);
}
function fromVec(obj){
	return [
		Math.atan2(obj.y, obj.x) * 180 / Math.PI,
		Math.asin(obj.z / 6371009) * 180 / Math.PI
	];
}

const {abs: abs$1, cos: cos$1, sin: sin$1, atan2: atan2$1, asin, sqrt: sqrt$1, PI: PI$1} = Math;
const maxIterations = 2;

function circleNSEW(center, radius, units){
	return [
		direct(center, 0, radius, units).point,
		direct(center, 90, radius, units).point,
		direct(center, 180, radius, units).point,
		direct(center, 270, radius, units).point
	];
}
function pointLine(p, a, b, detailed = false, units = 'm'){
	let pt = [midLon(a[0], b[0]), (a[1] + b[1]) / 2];

	for(let i = 0; i < maxIterations; i++){
		const f1 = forward(pt, a);
		const f2 = forward(pt, b);
		const f3 = forward(pt, p);

		if(!f1 || !f2 || !f3){ return null; }

		const v1 = {x: f1[0], y: f1[1], z: 1};
		const v2 = {x: f2[0], y: f2[1], z: 1};
		const c1 = vectorCross(v1, v2, false);
		const v3 = {x: c1.y, y: -c1.x, z: c1.x * f3[1] - c1.y * f3[0]};
		const c2 = vectorCross(c1, v3, true);
		const res = azimReverse(pt, [c2.x, c2.y]);

		if(!res){ return null; }
		if(eq(pt, res)){ break; }

		pt = res;
	}

	const p1 = inverse(a, pt);
	const p2 = inverse(b, pt);
	const p3 = inverse(a, b);

	if(p1.dist > p3.dist || p2.dist > p3.dist){
		if(p1.dist < p2.dist){
			pt = [a[0], a[1]];
		} else {
			pt = [b[0], b[1]];
		}
	}

	return detailed ? {point: pt, distance: inverse(p, pt, units).dist} : pt;
}
function pointPolygon(a, b, detailed = false, units = 'm'){
	const out = {distance: Infinity, point: null};
	const ring = b[0];

	for(let i = 1; i < ring.length; i++){
		const obj = pointLine(a, ring[i - 1], ring[i], true, units);

		if(obj.distance < out.distance){
			out.distance = obj.distance;
			out.point = obj.point;
		}
	}

	return detailed ? out : out.point;
}
function lineLineIntersect(a1, a2, b1, b2){
	const segs1 = toSegments$2(geodesicLine$1(a1, a2));
	const segs2 = toSegments$2(geodesicLine$1(b1, b2));

	for(let seg1 of segs1){
		for(let seg2 of segs2){
			const x = lineLine(seg1[0], seg1[1], seg2[0], seg2[1]);

			if(x){ return x; }
		}
	}
}
function geodesicLine$1(a, b, tolerance = 25, units = 'km'){
	if(a[0] === b[0]){ return [a, b]; }

	const {bearing1, distance} = inverse(a, b, units);
	const steps = Math.floor(distance / tolerance);
	const length = distance / steps;
	const out = [a];
	let x1 = a[0];

	for(let step = 1; step < steps; step++){
		const {point} = direct(a, bearing1, (length * step), units);
		
		if(!point){ break; }
		
		const x2 = point[0];
		const dx = x1 - x2;

		if(dx < -180){
			point[0] += -360;
		} else if(dx > 180){
			point[0] += 360;
		}

		out.push(point);
		x1 = x2;
	}

	out.push(b);

	return out;
}
function lineLine(a1, a2, b1, b2, virtual = false, fast = false, skipBBOX = false){
	let bool = true;

	if(!skipBBOX){
		const bbox1 = bbox([a1, a2]);
		const bbox2 = bbox([b1, b2]);
		bool = bbox1.intersect(bbox2);
	}

	if(!virtual && !bool){ return null; }
	if(fast){ return lineLineFast(a1, a2, b1, b2); }

	const res = intersect([a1, a2, b1, b2]);

	if(!res){
		return null;
	} else if(virtual){
		return res;
	} else {
		return res.virtual === false ? res.intersection : null;
	}
}
function lineLineFast(p0, p1, p2, p3){
	let denom = (p3[1] - p2[1]) * (p1[0] - p0[0]) - (p3[0] - p2[0]) * (p1[1] - p0[1]);
	let ua = (p3[0] - p2[0]) * (p0[1] - p2[1]) - (p3[1] - p2[1]) * (p0[0] - p2[0]);
	let ub = (p1[0] - p0[0]) * (p0[1] - p2[1]) - (p1[1] - p0[1]) * (p0[0] - p2[0]);
	
	if(denom < 0){
		ua = -ua;
		ub = -ub;
		denom = -denom;
	}

	if(ua >= 0 && ua <= denom && ub >= 0 && ub <= denom && denom != 0){
		return [
			p0[0] + ua / denom * (p1[0] - p0[0]),
			p0[1] + ua / denom * (p1[1] - p0[1])
		];
	}

	return null;
}
function lineCircle(a, b, c, radius, units = 'm'){
	//if(!geoBool.bboxIntersect([a, b], circleNSEW(c, radius, units))){ return null; }

	let out = null;
	const r = distance$1(radius, units, 'm');
	const ab = inverse(a, b);
	const ac = inverse(a, c);
	const bc = inverse(b, c);

	if(ab.dist < 0.1 || !Number.isFinite(r) || r === 0){ return []; }
	if(ac.dist < 1){ return [direct(c, ab.bearing1, r)]; }
	if(bc.dist < 1){ return [direct(c, ab.bearing2 + 180, r)]; }

	const c2 = direct(a, (2 * ab.bearing1 - ac.bearing1), ac.dist).point;

	if(inverse(c, c2).dist < 1){
		out = [direct(c, ab.bearing1, r).point, direct(c, ab.bearing2 + 180, r).point];
	} else {
		out = calcCircles(c, r, c2, r);
	}

	if(!out.length){ return out; }

	if(out.length === 2){
		if((inverse(a, out[1]).dist > ab.dist) || (inverse(b, out[1]).dist > ab.dist)){
			out.pop();
		}
	}

	if((inverse(a, out[0]).dist > ab.dist) || (inverse(b, out[0]).dist > ab.dist)){
		out.shift();
	}

	return out;
}
function circleFromPoints(p1, p2, p3){
	const arr = antiClockwiseOrder([p1, p2, p3]);
	const a = mid(arr[0], arr[1]);
	const b = mid(arr[1], arr[2]);
	const center = intersect([a.origin, b.origin], [a.bearing2 - 90, b.bearing2 - 90]);

	if(!center){ return null; }

	const radius = inverse(center, p1).dist;

	return {center: center, radius: radius, units: 'meters'};
}
function circleCircle(c1, r1, c2, r2, units = 'm'){
	const {distance} = convert$1;
	const dist = inverse(c1, c2, units).dist / 2;

	if(dist > r1 || dist > r2){ return []; }

	r1 = distance(r1, units, 'm');
	r2 = distance(r2, units, 'm');

	return calcCircles(c1, r1, c2, r2);
}
function threeCircles(c1, r1, c2, r2, c3, r3, units = 'm'){
	const {distance} = convert$1;
	r1 = distance(r1, units, 'm');
	r2 = distance(r2, units, 'm');
	r3 = distance(r3, units, 'm');

	const ab = calcCircles(c1, r1, c2, r2);
	const ac = calcCircles(c1, r1, c3, r3);
	const bc = calcCircles(c2, r2, c3, r3);

	if(!ab.length || !ac.length || !bc.length){ return null; }

	const arr = [];

	if(inverse(ab[0], c3).dist <= r3){ arr.push(ab[0]); }
	if(ab.length === 2 && inverse(ab[1], c3).dist <= r3){ arr.push(ab[1]); }
	if(inverse(ac[0], c2).dist <= r2){ arr.push(ac[0]); }
	if(ac.length === 2 && inverse(ac[1], c2).dist <= r2){ arr.push(ac[1]); }
	if(inverse(bc[0], c1).dist <= r1){ arr.push(bc[0]); }
	if(bc.length === 2 && inverse(bc[1], c1).dist <= r1){ arr.push(bc[1]); }
	const len = arr.length;

	if(len === 1){
		return arr[0];
	} else if(len === 2){
		return mid(arr[0], arr[1]);
	} else if(len === 3){
		return calcTriangle(arr[0], arr[1], arr[2]);
	} else {
		if(ab.length !== 2 || ac.length !== 2 || bc.length !== 2){ return null; }

		const x = intersect([ab[0], ab[1], ac[0], ac[1]]);

		if(!x){ return null; }

		const p = x.intersection;

		return calcTriangle(
			inverse(p, ab[0]).dist < inverse(p, ab[1]).dist ? ab[0] : ab[1],
			inverse(p, ac[0]).dist < inverse(p, ac[1]).dist ? ac[0] : ac[1],
			inverse(p, bc[0]).dist < inverse(p, bc[1]).dist ? bc[0] : bc[1]
		);
	}
}
function triangulate$1(a, b, c){
	return calcTriangle(a, b, c);
}
function intersect(points, bearings, solve){
	const l2 = points.length === 2;
	let p1 = points[0];
	let p2 = l2 ? points[1] : points[2];
	let p3 = l2 ? direct(p1, bearings[0], 500000, 'm', options.latLon).point : points[1];
	let p4 = l2 ? direct(p2, bearings[1], 500000, 'm', options.latLon).point : points[3];
	let out = null;

	out = solveIntersect(p1, p3, p2, p4);

	if(!out || !Number.isFinite(out[0]) || !Number.isFinite(out[1])){ return null; }

	const inv1 = inverse(p1, out, 'm', options.distance);
	const inv2 = inverse(p2, out, 'm', options.distance);

	if(bearings){

		return out;
	} else {
		const a = inverse(p3, out, 'm', options.distance);
		const b = inverse(p1, p3, 'm', options.distance);
		const c = inverse(p4, out, 'm', options.distance);
		const d = inverse(p2, p4, 'm', options.distance);
		let virtual = false;
		let extA = null;
		let extB = null;

		if(inv1.dist > b.dist || a.dist > b.dist){
			virtual = true;
			extA = inv1.dist < a.dist ? p1 : p3;
		}

		if(inv2.dist > d.dist || c.dist > d.dist){
			virtual = true;
			extB = inv2.dist < c.dist ? p2 : p4;
		}

		return {intersection: out, virtual: virtual, extA: extA, extB: extB};
	}
}
function intersept(a, b, c){
	let out = [
		midLon(a[0], b[0]),
		(a[1] + b[1]) / 2
	];

	for (let i = 0; i < maxIterations; i++){
		const f1 = forward(out, a);
		const f2 = forward(out, b);
		const f3 = forward(out, c);

		if(!f1 || !f2 || !f3){ return null; }

		const v1 = {x: f1[0], y: f1[1], z: 1};
		const v2 = {x: f2[0], y: f2[1], z: 1};
		const vc1 = vectorCross(v1, v2, false);
		const v3 = {x: vc1.y, y: -vc1.x, z: vc1.x * f3[1] - vc1.y * f3[0]};
		const vc2 = vectorCross(vc1, v3, true);
		const res = reverse(out, [vc2.y, vc2.x]);

		if(!res){ return null; }
		if(eq(out, res)){ break; }

		out = res;
	}

	const inv1 = inverse(a, out);
	const inv2 = inverse(b, out);
	const inv3 = inverse(a, b);
	let dist = null;
	let nearest = null;
	let intersepts = false;

	if(inv1.dist > inv3.dist || inv2.dist > inv3.dist){
		if(inv1.dist < inv2.dist){
			dist = inverse(c, a).dist;
			nearest = a;
		} else {
			dist = inverse(c, b).dist;
			nearest = b;
		}
	} else {
		intersepts = true;
		nearest = out;
		dist = inverse(c, out).dist;
	}

	return {projected: out, nearest: nearest, intersepts: intersepts, dist: dist};
}
function solveIntersect(p1, p2, p3, p4){
	let out = [
		midLon(midLon(p1[0], p2[0]), midLon(p3[0], p4[0])),
		(p1[1] + p2[1] + p3[1] + p4[1]) / 4
	];

	for(let i = 0; i < maxIterations; i++){
		const f1 = forward(out, p1);
		const f2 = forward(out, p2);
		const f3 = forward(out, p3);
		const f4 = forward(out, p4);

		if(!f1 || !f2 || !f3 || !f4){ return null; }

		const v1 = {x: f1[0], y: f1[1], z: 1};
		const v2 = {x: f2[0], y: f2[1], z: 1};
		const v3 = {x: f3[0], y: f3[1], z: 1};
		const v4 = {x: f4[0], y: f4[1], z: 1};
		const vc1 = vectorCross(v1, v2, false);
		const vc2 = vectorCross(v3, v4, false);
		const vc3 = vectorCross(vc1, vc2, true);
		const res = reverse(out, [vc3.y, vc3.x]);

		if(!res){
			return null;
		} else if(eq(out, res)){
			break;
		}

		out = res;
	}

	return out;
}
function calcCircles(c1, r1, c2, r2){
	const info = inverse(c1, c2);

	if(abs$1(r1 + r2 - info.dist) < 1 || abs$1(abs$1(r1 - r2) - info.dist) < 1){
		return [direct(c1, info.bearing1, r1).point];
	}

	if(info.dist < abs$1(r1 - r2) || info.dist > r1 + r2){
		return [];
	}

	const vc1 = toVec(c1);
	const vc2 = toVec(c2);
	const vr1 = toVec(direct(c1, 0, r1).point);
	const vr2 = toVec(direct(c2, 0, r2).point);
	const l1 = vc1.minus(vr1).length();
	const l2 = vc2.minus(vr2).length();
	const v1 = vc1.cross(vc2);
	const a = v1.dot();

	if(a === 0){ return null; }

	const v2 = vc1.times(81179511356162 - l2 * l2).minus(vc2.times(81179511356162 - l1 * l1));
	const b = 162359022712324 * a - v2.dot();

	if(b < 0){ return null; }

	const v3 = v1.cross(v2).plus(v1.times(sqrt$1(b))).divideBy(2 * a);
	const l3 = v3.length();
	const v4 = v1.cross(v2).minus(v1.times(sqrt$1(b))).divideBy(2 * a);
	const l4 = v4.length();

	let p1 = [
		atan2$1(v3.y, v3.x) * 180 / PI$1,
		asin(v3.z / l3) * 180 / PI$1
	];
	let p2 = [
		atan2$1(v4.y, v4.x) * 180 / PI$1,
		asin(v4.z / l4) * 180 / PI$1
	];

	const setPoint = (point) => {
		const f1 = azimForward(point, c1);
		const f2 = azimForward(point, c2);
		const eap = circlesEAP(f1, r1, f2, r2);

		return azimReverse(point, eap);
	};

	for(let i = 0; i < maxIterations; i++){
		p1 = setPoint(p1);
		p2 = setPoint(p2);
	}

	return [p1, p2];
}
function calcTriangle(p1, p2, p3, units = 'm'){
	const arr = antiClockwiseOrder([p1, p2, p3]);
	const a = arr[0];
	const b = arr[1];
	const c = arr[2];
	const ab = mid(a, b);
	const bc = mid(b, c);
	const ca = mid(c, a);
	const inter = intersect([a, bc.point, b, ca.point]);
	const center = inter ? inter.intersection : null;

	//return only center here

	const circumCenter = intersect([ab.point, bc.point], [ab.bearing2 - 90, bc.bearing2 - 90]);
	const circumRadius = circumCenter ? inverse(a, circumCenter).dist : null;
	const b1 = (inverse(a, c).bearing1 + ab.bearing1) / 2;
	const b2 = (inverse(c, b).bearing1 + ca.bearing1) / 2;
	const inscrCenter = intersect([a, c], [b1, b2]);
	let inscrRadius = null;
	let orthoCenter = null;

	if(inscrCenter){
		const is1 = intersept(a, b, inscrCenter);
		inscrRadius = is1 ? inverse(inscrCenter, is1.projected).dist : null;
	}

	const abc = intersept(a, b, c);
	const acb = intersept(a, c, b);
	const bca = intersept(b, c, a);

	if(abc && acb && bca){
		const is2 = intersect([a, bca.projected, b, acb.projected]);
		orthoCenter = is2 ? is2.intersection : null;
	}

	const {area, perimeter} = calcAreaPerimeter([a, b, c], units);

	return {
		center, orthoCenter, inscrCenter, inscrRadius, circumCenter, circumRadius,
		area, perimeter, a, b, c, ab: ab.point, bc: bc.point, ca: ca.point
	};
}
function circlesEAP(c1, r1, c2, r2){
	const dx = c2[0] - c1[0];
	const dy = c2[1] - c1[1];
	const l = sqrt$1(dx * dx + dy * dy);
	const a = (l * l + r1 * r1 - r2 * r2) / (2 * l);
	const b = sqrt$1(r1 * r1 - a * a);
	const x1 = c1[0] + dx * a / l + (dy / l) * b;
	const y1 = c1[1] + dy * a / l - (dx / l) * b;
	const x2 = c1[0] + dx * a / l - (dy / l) * b;
	const y2 = c1[1] + dy * a / l + (dx / l) * b;

	if(sqrt$1(x1 * x1 + y1 * y1) < sqrt$1(x2 * x2 + y2 * y2)){
		return [x1, y1];
	} else {
		return [x2, y2];
	}
}
function antiClockwiseOrder(a){
	const len = a.length;
	let out = [];
	let point = null;

	if(len === 3){
		point = [
			midLon(midLon(a[0][0], a[1][0]), a[2][0]),
			(a[0][1] + a[1][1] + a[2][1]) / 3
		];
	} else if(len === 4){
		let p1 = intersect([a[0], a[1], a[2], a[3]]);

		if(!p1 || p1.virtual){ p1 = intersect([a[0], a[2], a[1], a[3]]); }
		if(!p1 || p1.virtual){ p1 = intersect([a[0], a[3], a[1], a[2]]); }
		if(!p1 || p1.virtual){
			point = [
				midLon(midLon(a[0][0], a[1][0]), midLon(a[2][0], a[3][0])),
				(a[0][1] + a[1][1] + a[2][1] + a[3][1]) / 4
			];
		} else {
			point = p1.intersection;
		}
	}

	for(let i = 0; i < len; i++){
		out.push(forward(point, a[i]));

		if(!out.at(-1)){ return null; }
	}

	out.sort((p1, p2) => {
		if(p1[0] >= 0 && p2[0] < 0){ return 1; }
		if(p1[0] < 0 && p2[0] >= 0){ return -1; }
		if(p1[0] === 0 && p2[0] === 0){
			if(p1[1] >= 0 || p2[1] >= 0){ return p1[1] > p2[1] ? 1 : -1; }
			return p2[1] > p1[1] ? 1 : -1;
		}

		const c = p1[0] * p2[1] - p2[0] * p1[1];

		if(c < 0){ return 1; }
		if(c > 0){ return -1; }

		const d = p1[0] * p1[0] + p1[1] * p1[1];
		const e = p2[0] * p2[0] + p2[1] * p2[1];

		return d > e ? 1 : -1;
	});

	return out.map((p) => {
		return reverse(point, [p[1], p[0]]);
	});
}
function vectorCross(a, b, bool){
	const x = a.y * b.z - a.z * b.y;
	const y = a.z * b.x - a.x * b.z;
	const z = a.x * b.y - a.y * b.x;

	return bool ? {x: x / z, y: y / z, z: 1} : {x, y, z};
}
function midLon(x1, x2){
	const a = x1 * PI$1 / 180;
	const b = x2 * PI$1 / 180;
	const c = a + atan2$1(sin$1(b - a), 1 + cos$1(b - a));
	const d = (c + 3 * PI$1) % (2 * PI$1) - PI$1;

	return d * 180 / PI$1;
}
function eq(a, b){
	return a[0] === b[0] && a[1] === b[1];
}

function contains(a, b, skipBBOX = false){
	const type = getType(a);

	if(type !== 'Polygon' && type !== 'MultiPolygon'){ return false; }

	if(type === 'MultiPolygon'){
		const len = a.length;

		for(let i = 0; i < len; i++){
			if(contains(a[i], b)){ return true; }
		}

		return false;
	}

	if(!checkBBOX(a, b, true, false, skipBBOX)){ return false; }

	let bool = true;

	coordEach$1(b, (point) => {
		bool = pointInPolygon(point, a, true) === false ? false : bool;

		if(bool){ return -1; }
	});

	return bool;
}
function pointOnLine(point, line, endPoints = true, rhumb = false, eps = 0){
	if(!checkBBOX(point, line)){ return false; }

	const segments = toSegments$2(line);
	const len = segments.length;
	const x = point[0];
	const y = point[1];

	for(let i = 0; i < len; i++){
		const a = segments[i][0];
		const b = segments[i][1];
		const x1 = a[0];
		const y1 = a[1];
		const x2 = b[0];
		const y2 = b[1];

		if(endPoints && ((x === x1 && y === y1) || (x === x2 && y === y2))){ return true; }
	
		if(rhumb){
			const dx1 = x - x1;
			const dy1 = y - y1;
			const dx2 = x2 - x1;
			const dy2 = y2 - y1;
			const cross = dx1 * dy2 - dy1 * dx2;

			if(Math.abs(cross) > eps){ return false; }

			if(Math.abs(dx2) >= Math.abs(dy2)){
				return dx2 > 0 ? x1 < x && x < x2 : x2 < x && x < x1;
			} else {
				return dy2 > 0 ? y1 < y && y < y2 : y2 < y && y < y1;
			}
		} else if(between(point, a, b)){
			return true;
		}
	}

	return false;
}
function pointInPolygon(point, polygon, skipBBOX = false, on = false){
	if(!checkBBOX(point, polygon, false, false, skipBBOX)){ return false; }

	const res = pointPolygonRelate(point, polygon, true);

	return res >= (on ? 0 : 1);
}
function pointPolygonRelate(point, polygon, skipBBOX = false){
	if(!checkBBOX(point, polygon, false, false, skipBBOX)){ return false; }

	const x = point[0];
	const y = point[1];
	const rings = ringAll(polygon);
	let cnt = 0;

	for(let ring of rings){
		for(let i = 1; i < ring.length; i++){
			const a = ring[i - 1];
			const b = ring[i];
			const x1 = a[0] - x;
			const y1 = a[1] - y;
			const x2 = b[0] - x;
			const y2 = b[1] - y;

			if(y1 === 0 && y2 === 0){
				if((x2 <= 0 && x1 >= 0) || (x1 <= 0 && x2 >= 0)){
					return 0;
				}
			} else if((y2 >= 0 && y1 <= 0) || (y2 <= 0 && y1 >= 0)) {
				const pos = orient(x1, x2, y1, y2, 0, 0);
					
				if(pos === 0){ return 0; }
				if((pos > 0 && y2 > 0 && y1 <= 0) || (pos < 0 && y2 <= 0 && y1 > 0)){ cnt++; }
			}
		}
	}
	
	// 1 inside, 0 on, -1 outside

	return cnt % 2 === 0 ? -1 : 1;
}
function clockwise(coords){
	const type = getType(coords);
	const arr = type === 'Polygon' ? coords[0] : coords;
	let sum = 0;

	for(let i = 1, len = arr.length; i < len; i++){
		const a = arr[i - 1];
		const b = arr[i];

		sum += (b[0] - a[0]) * (b[1] + a[1]);
	}

	return sum > 0;
}
function closed(coords){
	const a = coords[0];
	const b = coords[coords.length - 1];

	return a[0] === b[0] && a[1] === b[1];
}
function concave(coords){
	const len = coords.length;

	if(len <= 4){ return false; }

	const b = len - 1;
	let sign = false;

	for(let a = 0; a < b; a++){
		const x1 = coords[(a + 2) % b][0] - coords[(a + 1) % b][0];
		const y1 = coords[(a + 2) % b][1] - coords[(a + 1) % b][1];
		const x2 = coords[a][0] - coords[(a + 1) % b][0];
		const y2 = coords[a][1] - coords[(a + 1) % b][1];
		const cross = x1 * y2 - y1 * x2;

		if(a === 0){
			sign = cross > 0;
		} else if(sign !== cross > 0){
			return true;
		}
	}

	return false;
}
function same(a, b){
	const type1 = getType(a);
	const type2 = getType(b);

	if(type1 !== type2){ return false; }
	if(!checkBBOX(a, b, false, true)){ return false; }
	if(type1 === 'Point'){ return equal(a, b, 0); }

	const set = new Set();
	const segs1 = toSegments$2(a);
	const segs2 = toSegments$2(b);

	if(segs1.length !== segs2.length){ return false; }

	segmentEach(segs1, (s) => {
		const key = `${s[0][0]}|${s[0][1]}|${s[1][0]}|${s[1][1]}`;
		set.add(key);
	});

	segmentEach(segs2, (s) => {
		const key = `${s[0][0]}|${s[0][1]}|${s[1][0]}|${s[1][1]}`;
		set.delete(key);
	});

	return set.size ? false : true;
}
function touch(a, b, fast = false, skipBBOX = false){
	return getTouchOverlap(a, b, true, fast, skipBBOX);
}
function overlap(a, b, fast = false, skipBBOX = false){
	return getTouchOverlap(a, b, false, fast, skipBBOX);
}
function touchOverlap(a, b, fast, skipBBOX){
	return getTouchOverlap(a, b, true, fast, skipBBOX);
}
function getTouchOverlap(a, b, touch = false, fast = false, skipBBOX = false){
	if(!checkBBOX(a, b, false, false, skipBBOX)){ return false; }

	const pol = pointOnLine;
	const eq = equal;
	const seg1 = segmentAll(toSegments$2(a));
	const seg2 = segmentAll(toSegments$2(b));
	let bool = false;

	for(let s1 of seg1){
		const a1 = s1[0];
		const a2 = s1[1];
		
		for(let s2 of seg2){
			const b1 = s2[0];
			const b2 = s2[1];
			const x = lineLine(a1, a2, b1, b2, false, fast, skipBBOX);

			if(touch){
				bool = (x || pol(a1, s2) || pol(a2, s2) || pol(b1, s1) || pol(b2, s1)) ? true : false;
			} else if(x){
				bool = eq(x, a1) || eq(x, a2) || eq(x, b1) || eq(x, b2) ? false : true;
			}

			if(bool){ break; }
		}

		if(bool){ break; }
	}

	bool = bool || contains(a, b, true) || same(a, b);
	bool = bool || contains(b, a, true) || same(a, b);

	return bool;
}
function segmentOverlap(a, b, bbox1, bbox2){
	bbox1 = bbox1 || bbox(a);
	bbox2 = bbox2 || bbox(b);

	if(!bbox1.intersect(bbox2)){ return false; }
	if(bbox1.equal(bbox2)){ return true; }

	const pol = pointOnLine;
	const eq = equal;
	const a1 = a[0];
	const a2 = a[1];
	const b1 = b[0];
	const b2 = b[1];
	const ep = (eq(a1, b1, 0) || eq(a1, b2, 0) || eq(a2, b1, 0) || eq(a2, b2, 0)) ? 1 : 0;
	let cnt = 0;

	cnt += pol(a1, b);
	cnt += pol(a2, b);
	cnt += pol(b1, a);
	cnt += pol(b2, a);

	return cnt >= 2 + ep;
}
function between(point, seg1, seg2, tol = 0.00001){
	const ab = inverse(seg1, seg2);
	const ac = inverse(seg1, point);
	const bc = inverse(seg2, point);
	const sum = ac.distance + bc.distance;
	const diff = Math.abs(sum - ab.distance);

	return diff <= tol;
}
function crossesAntimeridian2(coords){
	const segs = segmentAll(toSegments$2(coords));
	
	for(let seg of segs){
		if(crossesAntimeridian(seg[0], seg[1])){ return true; }
	}

	return false;
}
function crossesAntimeridian(a, b){
	const x1 = ((a[0] + 180) % 360 + 360) % 360 - 180;
	const x2 = ((b[0] + 180) % 360 + 360) % 360 - 180;

	if(Math.abs(x1) === 180 || Math.abs(x2) === 180){ return false; }

	return Math.abs(x1 - x2) > 180;
}
function checkBBOX(a, b, contains = false, equal = false, skip = false){
	if(skip){ return true; }

	const bbox1 = bbox(a);
	const bbox2 = bbox(b);

	if(contains){
		return bbox1.contains(bbox2);
	} else if(equal){
		return bbox1.equal(bbox2);
	} else {
		return bbox1.intersect(bbox2);
	}
}

const {toRad} = utils$1;
const {sin, cos, atan2, sqrt, abs, tan, log, PI} = Math;
const earthRadius$1 = 6378137;

function along(coords, distance, units = 'm'){
	const segments = toSegments$2(coords);
	const len = segments.length;
	let sum = 0;

	for(let i = 0; i < len; i++){
		const seg = segments[i];
		const len = length(seg, units);
		sum += len;

		if(sum >= distance){
			return destination(seg[0], bearing(seg[0], seg[1]), sum - len, units);
		}
	}
}
function areaPerimeter(coords, units = 'm'){
	const type = getType(coords);
	const len = coords.length;
	let out = {area: 0, perimeter: 0};

	if(type !== 'Polygon' && type !== 'MultiPolygon'){ return {area: null, perimeter: null}; }

	if(type === 'MultiPolygon'){
		for(let i = 0; i < len; i++){
			const {area, perimeter} = areaPerimeter(coords[i], units);
			out.area += area;
			out.perimeter += perimeter;
		}

		return out;
	}

	for(let i = 0; i < len; i++){
		const cw = clockwise(coords[i]);
		const res = calcAreaPerimeter(coords[i], cw, units);
		out.area += i ? -res.area : res.area;
		out.perimeter += res.perimeter;
	}

	return out;
}
function area(coords, units){
	return areaPerimeter(coords, units).area;
}
function perimeter(coords, units){
	return areaPerimeter(coords, units).perimeter;
}
function bearing(a, b, final){
	const res = inverse(a, b);

	return final ? res.bearing2 : res.bearing1;
}
function centroid(coords){
	const points = uniqueCoords(coords);
	const len = points.length;
	const a = [];
	let x = 0, y = 0, b = 0, c = 0, d = 0, e = 0, i = null;

	for(let p of points){
		x += p[0];
		y += p[1];
	}

	x /= len;
	y /= len;

	for(let p of points){
		a.push(azimForward([x, y], p));
	}

	for(i = 0; i < a.length - 1; i++){
		b = a[i][0] * a[i + 1][1] - a[i + 1][0] * a[i][1];
		c += b;
		d += (a[i][0] + a[i + 1][0]) * b;
		e += (a[i][1] + a[i + 1][1]) * b;
	}

	b = a[i][0] * a[0][1] - a[0][0] * a[i][1];
	c += b;
	d = (d + (a[i][0] + a[0][0]) * b) / (3 * c);
	e = (e + (a[i][1] + a[0][1]) * b) / (3 * c);

	return azimReverse([x, y], [d, e]);
}
function centroidRadius(coords, units = 'm'){
	const point = centroid(coords);
	let max = 0;

	coordEach$1(coords, (coord) => {
		const dist = distance(point, coord);

		if(dist < max){ return; }

		max = dist;
	});

	return {centroid: point, radius: distance$1(max, 'm', units), units};
}
function destination(point, bearing, distance, units = 'm'){
	return direct(point, bearing, distance, units).point;
}
function distance(a, b, units = 'm'){
	return inverse(a, b, units).distance;
}
function rhumbBearing(a, b){
	const y1 = toRad(a[1]);
	const y2 = toRad(b[1]);
	let dx = toRad(b[0] - a[0]);

	if(dx > PI){ dx -= 2 * PI; }
	if(dx < -PI){ dx += 2 * PI; }

  const dy = log(tan(y2 / 2 + PI / 4) / tan(y1 / 2 + PI / 4));
  const rad = atan2(dx, dy);

  return (toDeg(rad) + 360) % 360;
}
function rhumbDestination(point, bearing, distance, units = 'm'){
	const delta = distance$1(distance, units, 'm') / earthRadius$1;
	const theta = toRad(bearing);
	const l1 = (point[0] * PI) / 180;
	const p1 = toRad(point[1]);
	const d1 = delta * cos(theta);
	let p2 = p1 + d1;

	if(abs(p2) > PI / 2){ p2 = p2 > 0 ? PI - p2 : -PI - p2; }

	const d2 = log(tan(p2 / 2 + PI / 4) / tan(p1 / 2 + PI / 4));
	const q = abs(d2) > 10e-12 ? d1 / d2 : cos(p1);
	const d3 = (delta * sin(theta)) / q;
	const l2 = l1 + d3;
	const x = (((l2 * 180) / PI + 540) % 360) - 180;
	const y = (p2 * 180) / PI;

	return [x, y];
}
function rhumbDistance(a, b, units){
	const y1 = (a[1] * PI) / 180;
	const y2 = (b[1] * PI) / 180;
	const dy = y2 - y1;
	let dx = (abs(b[0] - a[0]) * PI) / 180;

	if(dx > PI){ dx -= 2 * PI;}

	const dp = log(tan(y2 / 2 + PI / 4) / tan(y1 / 2 + PI / 4));
	const q = abs(dp) > 10e-12 ? dy / dp : cos(y1);
	const delta = sqrt(dy * dy + q * q * dx * dx);
	const dist = delta * earthRadius$1;

	return distance$1(dist, 'm', units);
}
function rhumbMidpoint(a, b){
	const x = ((b[0] - a[0]) / 2) + a[0];
	const y = ((b[1] - a[1]) / 2) + a[1];

	return [x, y];
}
function envelope(coords){
	return bbox(coords).polygon();
}
function kinks(coords, geodesic = true){
	const {segmentEach, toSegments, equal} = utils$1;
	const segments = new Set();
	const out = [];

	segmentEach(toSegments(coords), (seg) => { segments.add(seg); });

	for(let a of segments){
		segments.delete(a);

		for(let b of segments){
			if(equal(a[0], b[1]) || equal(a[1], b[0])){ continue; }

			const res = lineLine(a[0], a[1], b[0], b[1], false, geodesic ? false : true);

			if(res){ out.push({a, b, intersect: res}); }
		}
	}

	return out.length ? out : null;
}
function length(coords, units){
	const len = coords.length;
	let sum = 0;

	for(let i = 1; i < len; i++){
		const a = coords[i - 1];
		const b = coords[i];

		sum += distance(a, b, units);
	}

	return sum;
}
function midpoint(a, b, geodesic = true){
	return geodesic ? mid(a, b).point : rhumbMidpoint(a, b);
}
function calculateIntercept(coord1, speed1, heading1, coord2, speed2, units = 'nm'){
	const {x: x1, y: y1} = toCartesian(coord1, coord2);
	const {x: x2, y: y2} = toCartesian(coord2, coord2);
	const hr = toRad(heading1);
	const s1 = distance$1(speed1, units, 'm');
	const s2 = distance$1(speed2, units, 'm');
	const vx = s1 * sin(hr);
	const vy = s1 * cos(hr);
	const dx = x1 - x2;
	const dy = y1 - y2;
	const a = vx ** 2 + vy ** 2 - s2 ** 2;
	const b = 2 * (dx * vx + dy * vy);
	const c = dx ** 2 + dy ** 2;
	const discriminant = b ** 2 - 4 * a * c;

	if(discriminant < 0){ return null; }

	const t1 = (-b + sqrt(discriminant)) / (2 * a);
	const t2 = (-b - sqrt(discriminant)) / (2 * a);
	const time = Math.max(t1, t2);
	const dir = direct(coord1, heading1, speed1 * time, 'nm');
	inverse(coord2, dir.point, units);

	return {
		coord: dir.point,
		time,
		heading1: heading1,
		heading2: inv4.bearing1,
		distance1: dir.distance,
		distance2: inv4.distance
	};
}
function intersectGeodesic(a1, a2, b1, b2){
	const inv1 = inverse(a1, a2);
	const inv2 = inverse(b1, b2);
	const seg = line(a1, inv1.bearing1);
	const delta = 0.5;
	let step = 0;

	for(let i = 0; i < 20; i++){
		const {point} = seg.position(step);
		const inv3 = inverse(a1, point);
		const inv4 = inverse(b1, point);
		const diff = toRad$2(inv4.bearing1 - inv2.bearing1);
		const crossTrackError = Math.sin(diff) * inv4.distance;
		const ahead1 = seg.position(step + delta);
		const ahead2 = inverse(b1, ahead1.point);
		const aheadDiff = toRad$2(ahead2.bearing1 - inv2.bearing1);
		const aheadError = Math.sin(aheadDiff) * ahead2.distance;
		const derivativeError = (aheadError - crossTrackError) / delta;
		const deltaStep = -crossTrackError / derivativeError;
		const bool1 = Math.abs(deltaStep) < 1e-6;
		const bool2 = inv1.distance >= inv3.distance;
		const bool3 = inv2.distance >= inv4.distance;

		step += deltaStep;

		if(bool1 && bool2 && bool3){ return point; }
	}

	return null;
}
function intersectRhumb(a1, a2, b1, b2){
	let denom = (b2[1] - b1[1]) * (a2[0] - a1[0]) - (b2[0] - b1[0]) * (a2[1] - a1[1]);
	let ua = (b2[0] - b1[0]) * (a1[1] - b1[1]) - (b2[1] - b1[1]) * (a1[0] - b1[0]);
	let ub = (a2[0] - a1[0]) * (a1[1] - b1[1]) - (a2[1] - a1[1]) * (a1[0] - b1[0]);
	
	if(denom < 0){
		ua = -ua;
		ub = -ub;
		denom = -denom;
	}

	if(ua >= 0 && ua <= denom && ub >= 0 && ub <= denom && denom != 0){
		return [
			a1[0] + ua / denom * (a2[0] - a1[0]),
			a1[1] + ua / denom * (a2[1] - a1[1])
		];
	}

	return null;
}
function pointAtVelocity(coord, vx, vy, secs){
	const lon = coord[0];
	const lat = coord[1];
	const latRad = lat * Math.PI / 180;
	const dx = vx * secs;
	const dy = vy * secs;
	const dlat = dy / 111320; 
	const dlon = dx / (111320 * Math.cos(latRad));

	return [lon + dlon, lat + dlat];
}

const {lineEach, toSegments: toSegments$1, coordEach, roundCoord} = utils$1;
const earthRadius = 6378137;

function toMercator(coord){
	const a = coord[0] * 0.017453292519943295;
	const b = coord[1] * 0.017453292519943295;
	const x = earthRadius * a;
	const y = 3189068.5 * Math.log((1 + Math.sin(b)) / (1 - Math.sin(b)));

	return [x, y];
}
function geodesic(coords, tolerance = 25, units = 'km'){
	return lineEach(coords, (line) => {
		const segments = toSegments$1(line);
		let out = [line[0]];

		for(let seg of segments){
			const arr = geodesicLine(seg[0], seg[1], tolerance, units);
			arr.shift();
			out = out.concat(arr);
		}

		return antimeridianWrap(out);
	});
}
function geodesicLine(a, b, tolerance = 25, units = 'km'){
	if(a[0] === b[0]){ return [a, b]; }

	const {bearing1, distance} = inverse(a, b, units);
	const steps = Math.floor(distance / tolerance);
	const length = distance / steps;
	const out = [a];
	let x1 = a[0];

	for(let step = 1; step < steps; step++){
		const point = roundCoord(direct(a, bearing1, (length * step), units).point, 6);
		
		if(!point){ break; }
		
		const x2 = point[0];
		const dx = x1 - x2;

		if(dx < -180){
			point[0] += -360;
		} else if(dx > 180){
			point[0] += 360;
		}

		out.push(point);
		x1 = x2;
	}

	out.push(b);

	return out;
}
function move(coords, x = 0, y = 0){
	return coordEach(coords, (coord) => {
		return [coord[0] + x, coord[1] + y];
	});
}
function rotateCCW(coords){
	return rotate(coords, -90);
}
function rotateCW(coords){
	return rotate(coords, 90);
}
function rotate(coords, angle, center){
	center = center || centroid(coords);

	return coordEach(coords, (coord) => {
		const info = inverse(center, coord);
		const bearing = info.bearing1 + angle;

		return destination(center, bearing, info.dist);
	});
}
function flip(coords){
	return scaleGeom(coords, {factor: -1, x: true, y: true});
}
function flipX(coords){
	return scaleGeom(coords, {factor: -1, x: true, y: false});
}
function flipY(coords){
	return scaleGeom(coords, {factor: -1, x: false, y: true});
}
function scale(coords, factor, center){
	return scaleGeom(coords, {factor, center, x: true, y: true});
}
function scaleByDistance(coords, distance, units = 'm'){
	return scaleGeom(coords, {factor, distance, units, x: true, y: true});
}
function scaleGeom(coords, opts){
	const c = opts.center || centroid(coords);
	const f = opts.factor || null;
	const d = distance$1(opts.distance || 0, opts.units || 'm', 'm');

	return coordEach(coords, (coord) => {
		const info = inverse(c, coord);
		const dist = f ? info.distance * f : info.distance + d; 
		const dest = destination(c, info.bearing1, dist);

		return [
			opts.x ? dest[0] : coord[0],
			opts.y ? dest[1] : coord[1]
		];
	});
}
function fromGeodesic(coords, tol = 0.00001){
	return lineEach(coords, (line) => {
		const len = line.length;
		const out = [line[0]];
		let a = line[0];

		for(let i = 1; i < len - 1; i++){
			const b = line[i];
			const c = line[i + 1];

			if(between(b, a, c, tol)){
				continue;
			} else {
				a = b;
				out.push(b);
			}
		}

		out.push(line[len - 1]);

		return out;
	});
}
function clone(coords){
	return coordEach(coords, (coord) => {
		return [coord[0], coord[1]];
	});
}
function rewind(coords, clockwise$1 = false, close = true){
	const type = getType(coords);

	if(type === 'MultiPolygon'){
		const out = [];

		for(let i = 0, len = coords.length; i < len; i++){
			out[i] = rewind(coords[i], clockwise$1);
		}

		return out;
	}

	return lineEach(coords, (ring, idx) => {
		const cw = clockwise$1 ? idx === 0 : idx !== 0;

		if(close && !closed(ring)){ ring.push(ring[0]); }

		return clockwise(ring) === cw ? ring : ring.reverse();
	});
}
function unwrap(coords){
	return coordEach$1(coords, (coord) => {
		let x = coord[0];

		if(x < -180 || x > 180){
			x = ((x + 180) % 360 + 360) % 360 - 180;
		}

		return [x, coord[1]];
	});
}
function wrap(coords){
	return antimeridianWrap(coords);
}
function antimeridianWrap(coords){
	return lineEach(coords, (line) => {
		const out = [line[0]];
		let a = line[0][0];

		for(let i = 1, len = line.length; i < len; i++){
			const b = line[i][0];
			const y = line[i][1];
			const x = b + (b - a > 180 ? -360 : a - b > 180 ? 360 : 0);
			
			out[i] = [x, y];
			a = x;
		}

		return out;
	});
}
/*
export function antimeridianSplitPolygon(coords){
	const type = utils.getType(coords);

	if(type === 'MultiPolygon'){
		return coords.map(antimeridianSplitPolygon);
	} else if(type !== 'Polygon'){
		return null;
	}

	return coords.map((ring) => {
		const 
		for(let i = 1; i < ring.length; i++){
			const a = ring[i - 1];
			const b = ring[i];
			const cross = boolean.crossesAntimeridian(a, b);

			if(cross){
				console.log(a, b);
			}
		}
	});
}
*/
function antimeridianSplit(a, b, geodesic = true){
	const cross = crossesAntimeridian(a, b);

	if(!cross){ return [[a, b]]; }

	const method = geodesic ? intersectGeodesic : intersectRhumb;
	const bbox$1 = bbox(geodesic ? geodesicLine(a, b) : [a, b]);
	const x1 = ((a[0] + 180) % 360 + 360) % 360 - 180;
	const x2 = ((b[0] + 180) % 360 + 360) % 360 - 180;
	const y1 = a[1];
	const y2 = b[1];
	const e = x1 < 0 ? {x: x1, y: y1} : {x: x2, y: y2};
	const w = x1 < 0 ? {x: x2, y: y2} : {x: x1, y: y1};
	const a1 = [e.x + 360, e.y];
	const a2 = [w.x, w.y];
	const b1 = [180, Math.min(bbox$1.maxY + 5, 90)];
	const b2 = [180, Math.max(bbox$1.minY - 5, -90)];
	const x = method(a1, a2, b1, b2);

	if(x){
		return [
			[[w.x, w.y], [180, x[1]]],
			[[-180, x[1]], [e.x, e.y]],
		];
	} else {
		return [a, b];
	}

	
}
function smooth(coords, factor = 0.75, iterations = 1){
	return lineEach(coords, (line) => {
		let out = line.slice(0);

		for(let i = 0; i < iterations; i++){
			out = smoothIterate(out, factor);
		}

		return out;
	});
}
function smoothIterate(coords, factor){
	const out = [coords[0]];
	const len = coords.length;

	for(let i = 0; i < len; i++){
		const curr = coords[i];
		const next = coords[i + 1];

		if(!next){ break; }

		const a = curr.map((axis, idx) => factor * axis + (1 - factor) * next[idx]);
		const b = curr.map((axis, idx) => (1 - factor) * axis + factor * next[idx]);

		out.push(a, b);
	}

	out.push(coords[len - 1]);

	return out;
}
function dmsPrecision(coords, precision, unit){
	const calc = (val, lat) => {
		let {dir, deg, min, sec} = degToDms(val, lat);

		if(unit === 'deg'){
			deg = roundNearest(deg, precision);
			min = 0;
			sec = 0;
		} else if(unit === 'min'){
			min = roundNearest(min, precision);
			sec = 0;

			if(min >= 60){
				deg++;
				min = 0;
			}
		} else if(unit === 'sec'){
			sec = roundNearest(sec, precision);

			if(sec >= 60){
				min++;
				sec = 0;
			}
		}

		return dmsToDeg(deg, min, sec, dir);
	};
	return coordEach(coords, (coord) => {
		return [
			calc(coord[0], false),
			calc(coord[1], true)
		];
	});
}

const greatCircle = geodesic;

function checkPolygonSplit(polygon, line, geodesic = true){
	const ring = [polygon[0]];
	const a = line[0];
	const b = line[line.length - 1];

	return !kinks(line, geodesic) && !pointInPolygon(a, ring) && !pointInPolygon(b, ring);
}
function polygonSplit(polygon, line, geodesic = true){
	if(!checkPolygonSplit(polygon, line, geodesic)){ return polygon; }

	const segs1 = getSegments(rewind(polygon));
	const segs2 = getSegments(line);

	split(segs1, segs2, geodesic ? false : true);
	setLines(segs2, line, polygon, geodesic);

	const map1 = getMap(segs1);
	const map2 = getMap(segs2);

	return assemble$1(map1, map2, geodesic);
}
function assemble$1(map1, map2, geodesic$1){
	const rings = [];
	const polys = new Set();
	const interate = (seg, ring, origin, skip = false) => {
		const key = seg.key2;
		const hit1 = map1.get(key);
		const hit2 = skip ? null : map2.get(key);

		if(key === origin || (!hit1 && !hit2)){ return; }
		if(!hit2){ map1.delete(key); }

		const next = hit2 || hit1;

		ring.push(next);
		interate(next, ring, origin, hit2 ? true : false);
	};

	while(map1.size){
		for(let [key, seg] of map1){
			const ring = [seg];

			rings.push(ring);
			interate(seg, ring, key);
			map1.delete(key);
		}
	}

	for(let ring of rings){
		const arr = [ring[0].a];

		for(let {b, coords} of ring){
			arr.push(...coords, b);
		}

		if(arr.length < 4){ continue; }

		const a = arr[0];
		const b = arr.at(-1);

		if(a[0] !== b[0] || a[1] !== b[1]){
			arr.push(a);
		}
		
		polys.add({coords: [arr], test: geodesic$1 ? geodesic([arr]) : [arr]});
	}

	for(let a of polys){
		for(let b of polys){
			if(a === b){ continue; }

			const point = a.coords[0][0];

			if(pointInPolygon(point, b.test)){
				const hole = a.coords[0];

				b.coords.push(hole);
				b.test.push(geodesic$1 ? geodesic(hole) : hole);
				polys.delete(a);
				break;
			}
		}
	}

	return polys.size ? Array.from(polys).map(obj => rewind(obj.coords)) : [];
}
function setLines(segs, line, polygon, geodesic$1){
	const poly = geodesic$1 ? geodesic(polygon) : polygon;
	const map = new Map();
	const set = sort(segs, line);
	const iterate = (seg) => {
		const key = seg.key2;
		const hit = map.get(key);

		if(!hit){ return; }

		map.delete(key);
		set.delete(hit);
		seg.coords.push(hit.a);
		seg.key2 = hit.key2;
		seg.b = hit.b;

		iterate(seg);
	};

	for(let seg of set){
		if(pointInPolygon(midpoint(seg.a, seg.b, geodesic$1), poly, true)){
			map.set(seg.key1, seg);
		} else {
			set.delete(seg);
		}
	}

	for(let [key, seg] of map){
		iterate(seg);
		map.delete(key);
	}

	for(let {a, b, coords} of Array.from(set)){
		addSegment(set, [b, a]).coords = coords.slice().reverse();
	}
}
function sort(set, line){
	const map = getMap(set);
	let key = line[0].join(':');
	let curr = map.get(key);

	set.clear();

	map.delete(key);
	set.add(curr);

	while(map.size){
		key = curr.key2;

		curr = map.get(key);

		map.delete(key);
		set.add(curr);
	}

	return set;
}
function split(segs1, segs2, fast){
	for(let a of segs1){
		for(let b of segs2){
			if(!a.bbox.touch(b.bbox)){ continue; }

			const x = lineLine(a.a, a.b, b.a, b.b, false, fast, true);

			if(!x){ continue; }

			const bool1 = equal(a.a, x) || equal(a.b, x);
			const bool2 = equal(b.a, x) || equal(b.b, x);

			if(bool1 && bool2){ continue; }
			if(!bool1){ splitSegment(segs1, a, x); }
			if(!bool2){ splitSegment(segs2, b, x); }

			break;
		}
	}
}
function splitSegment(set, seg, x){
	set.delete(seg);

	addSegment(set, [seg.a, x]);
	addSegment(set, [x, seg.b]);
}
function getMap(set, key = 'key1'){
	const map = new Map();

	for(let obj of set){
		delete obj.bbox;
		delete obj.keys;
		map.set(obj[key], obj);
	}

	return map;
}
function getSegments(poly){
	const segs = segmentAll(toSegments$2(poly));
	const set = new Set();

	for(let seg of segs){
		addSegment(set, seg);
	}

	return set;
}
function addSegment(set, seg){
	const a = seg[0];
	const b = seg[1];
	const bbox$1 = bbox(seg);
	const key1 = a.join(':');
	const key2 = b.join(':');
	const keys = new Set([key1, key2]);
	const coords = [];
	const obj = {a, b, bbox: bbox$1, key1, key2, keys, coords};
	
	set.add(obj);

	return obj;
}

//import {default as clipper} from 'polygon-clipping';

function union(){
	const args = Array.from(arguments);

	return union$1(...args);
}
function difference(){
	const args = Array.from(arguments);

	return difference$1(...args);
}
function intersection(){
	const args = Array.from(arguments);
	
	return intersection2(...args);
}
function xor(){
	const args = Array.from(arguments);
	
	return xor$1(...args);
}
function unkink(poly){
	return union$1(poly, poly);
}

const {pow} = Math;

function arc(center, radius, units, ang1, ang2, clockwise = true, density = 4){
	const out = [];
	let a1 = clockwise ? ang1 : ang2;
	let a2 = clockwise ? ang2 : ang1;

	a2 += a2 <= a1 ? 360 : 0;

	const steps = Math.ceil(Math.abs(a2 - a1) / density);

	out.push(destination(center, a1, radius, units));

	for(let i = 1; i < steps; i++){
		out.push(destination(center, a1 + (i * density), radius, units));
	}

	out.push(destination(center, a2, radius, units));

	return clockwise ? out : out.reverse();
}
function sector(center, radius, units, bearing1, bearing2, clockwise = true, density = 4){
	const curve = arc(center, radius, units, bearing1, bearing2, clockwise, density);

	return [center, ...curve, center];
}
function regular(center, radius, sides, units = 'm'){
	const density = 360 / sides;
	const ang1 = 0 + sides % 2 === 0 ? (density / 2) : 0;
	const ang2 = ang1 + 360;

	return arc(center, radius, units, ang1, ang2, true, density);
}
function circle(center, radius, units = 'm', density = 4){
	const coords = arc(center, radius, units, 0, 360, true, density);
	const a = coords[0];
	const b = coords.at(-1);

	if(a[0] !== b[0] || a[1] !== b[1]){
		coords.push(a);
	}

	return coords;
}
function bezier(args){
	const arr = Array.from(arguments);
	const len = arr.length;
	const type = len === 4 || len == 5 ? 'cubic' : 'quadratic';
	const p1 = arr[0];
	const p2 = arr[1];
	const c1 = arr[2];
	const c2 = type === 'cubic' ? arr[3] : null;
	const density = (type === 'cubic' ? arr[4] : arr[3]) || 20;
	const method = type === 'cubic' ? calcCubic : calcQuadratic;
	const incr = 1 / density;
	const dims = p1.length;
	const x1 = p1[0];
	const y1 = p1[1];
	const z1 = dims === 3 ? p1[2] : 0;
	const x2 = p2[0];
	const y2 = p2[1];
	const z2 = dims === 3 ? p2[2] : 0;
	const cx1 = c1[0];
	const cy1 = c1[1];
	const cz1 = dims === 3 ? c1[2] : 0;
	const cx2 = c2 ? c2[0] : null;
	const cy2 = c2 ? c2[1] : null;
	const cz2 = c2 && dims === 3 ? c2[2] : 0;
	const out = [p1];

	for(let t = 0; t < 1; t += incr){
		const x = method(t, x1, x2, cx1, cx2);
		const y = method(t, y1, y2, cy1, cy2);

		if(dims === 3){
			const z = method(t, z1, z2, cz1, cz2);

			out.push([x, y, z]);
		} else {
			out.push([x, y]);
		}
	}

	out.push(p2);

	return out;
}
function calcCubic(t, a, b, c1, c2){
	return pow(1 - t, 3) * a + 3 * pow(1 - t, 2) * t * c1 + 3 * (1 - t) * pow(t, 2) * c2 + pow(t, 3) * b;
}
function calcQuadratic(t, a, b, c){
	return pow(1 - t, 2) * a + 2 * t * (1 - t) * c + pow(t, 2) * b;
}

function buffer(coords, radius, units = 'km', geodesic$1 = true, density = 4, mitre = false){
	const gtype = getType(coords);
	let out = null;

	if(gtype === 'point'){
		out = [circle(coords, radius, units, density)];
	} else if(gtype === 'LineString'){
		out = bufferLine(coords, radius, units, density, mitre);
	} else if(gtype === 'MultiLineString'){
		out = coords.map((line) => { return bufferLine(line, radius, units, density, mitre)});
	} else if(gtype === 'MultiPolygon'){
		return coords.map((poly) => { return buffer(poly, radius, units, density)});
	} else {
		const {norm, shift} = normalize(coords);

		out = norm.map((ring) => {
			const res = edge(unique(ring), radius, units, density, true);

			return shift ? move(res, shift, 0) : res;
		});
	}

	return geodesic$1 ? geodesic(out) : out;
}
function normalize(coords){
	const bbox$1 = bbox(coords);
	const out = {
		shift: 0,
		norm: rewind(coords, true)
	};

	if(bbox$1.maxX > 180){
		out.shift = (bbox$1.maxX - 170) * -1;
	} else if(bbox$1.minX < -180){
		out.shift = (bbox$1.minX + 170);
	}

	if(out.shift){
		out.norm = move(out.norm, out.shift, 0);
	}

	out.shift *= -1;

	return out;
}
function bufferLine(coords, radius, units, density, mitre){
	const a = coords.map((coord) => { return roundCoord$1(coord, 6); });
	const b = a.slice(0).reverse();
	const e1 = edge(a, radius, units, density, false, mitre);
	const e2 = edge(b, radius, units, density, false, mitre);
	const out = [...e1, ...e2];

	out.push(out[0]);

	return [out];
}
function pab(origin, bearing, radius, units){
	const {point} = direct(origin, bearing, radius, units);

	return point;
}
function edge(coords, radius, units, density, closed = false, mitre = false){
	const segments = toSegments$2(coords);
	const state = {index: new Set(), coords: [], prev: null};

	if(closed){ segments.push(segments[0]); }

	for(let i = 1; i < segments.length; i++){
		const a = segments[i - 1];
		const b = segments[i];
		const inv1 = inverse(a[0], a[1]);
		const inv2 = inverse(b[0], b[1]);
		const ang1a = inv1.bearing1 - 90;
		const ang1b = inv1.bearing2 - 90;
		const ang2a = inv2.bearing1 - 90;
		const ang2b = inv2.bearing2 - 90;
		const delta = Math.abs(ang2a - ang1b);
		const a1 = pab(a[0], ang1a, radius, units);
		const a2 = pab(a[1], ang1b, radius, units);
		const b1 = pab(b[0], ang2a, radius, units);
		const b2 = pab(b[1], ang2b, radius, units);
		const x = intersectRhumb(a1, a2, b1, b2);

		if(!closed && i === 1){ addPoint(state, a1); }

		if(x){
			addPoint(state, x);
		} else if(delta > 0.00001){
			const arc$1 = arc(a[1], radius, units, ang1b, ang2a, true, density);

			for(let point of arc$1){ addPoint(state, point); }
		} else {
			addPoint(state, a1);
			addPoint(state, a2);
		}
	}

	if(!closed){
		const seg = segments.pop();
		const ang = inverse(seg[1], seg[0]).bearing1;
		const ang1 = ang + 90;
		const ang2 = ang - 90;

		if(mitre){
			addPoint(state, direct(seg[1], ang1, radius, units).point);
			addPoint(state, direct(seg[1], ang2, radius, units).point);
		} else {
			const arc$1 = arc(seg[1], radius, units, ang1, ang2, true, density);
			
			for(let point of arc$1){ addPoint(state, point); }
		}
	}

	const out = state.coords;

	if(closed){
		out.push(out[0]);

		return unkink([out])[0][0];
	} else {
		return out;
	}
}
function addPoint(state, point){
	const coord = roundCoord$1(point, 6);
	const key = coord.join(':');
	const dist = state.prev ? inverse(state.prev, coord).dist : 1000;

	if(state.index.has(key) || dist < 100){ return; }

	state.index.add(key);
	state.prev = coord;
	state.coords.push(coord);
}
function unique(ring){
	const out = [];
	const set = new Set();

	for(let coord of ring){
		const key = coord.join('|');

		if(set.has(key)){ continue; }

		out.push(coord);
		set.add(key);
	}

	out.push(out[0]);

	return out;
}

function simplify(coords, tolerance, high){
	return lineEach$1(coords, (line) => {
		const tol = tolerance !== undefined ? tolerance * tolerance : 1;
		const arr = high ? line : simplifyLow(line, tol);

		return simplifyHigh(arr, tol);
	});
}
function simplifyLow(points, tol) {
	const len = points.length;
	const out = [points[0]];
	let a = points[0];
	let b = null;

	for(let i = 1; i < len; i++){
		b = points[i];

		const dx = b[0] - a[0];
		const dy = b[1] - a[1];
		const dist = dx * dx + dy * dy;

		if(dist > tol){
			out.push(b);
			a = b;
		}
	}

	if(a !== b){ out.push(b); }

	return out;
}
function simplifyHigh(points, tol){
	const last = points.length - 1;
	const out = [points[0]];

	step(points, 0, last, tol, out);
	out.push(points[last]);

	return out;
}
function step(points, first, last, tol, out){
	let max = tol;
	let index;

	for(let i = first + 1; i < last; i++){
		const dist = getDist(points[i], points[first], points[last]);

		if(dist > max){
			index = i;
			max = dist;
		}
	}

	if(max > tol){
		if(index - first > 1){
			step(points, first, index, tol, out);
		}

		out.push(points[index]);

		if(last - index > 1){
			step(points, index, last, tol, out);
		}
	}
}
function getDist(p, p1, p2){
	let x = p1[0];
	let y = p1[1];
	let dx = p2[0] - x;
	let dy = p2[1] - y;

	if(dx !== 0 || dy !== 0){
		const t = ((p[0] - x) * dx + (p[1] - y) * dy) / (dx * dx + dy * dy);

		if(t > 1){
			x = p2[0];
			y = p2[1];
		} else if(t > 0){
			x += dx * t;
			y += dy * t;
		}
	}

	dx = p[0] - x;
	dy = p[1] - y;

	return dx * dx + dy * dy;
}

function featureCollection(features = []){
	const arr = Array.isArray(features) ? features : [features];

	return {type: 'FeatureCollection', features: arr};
}
function addFeature(featureCollection, feature){
	featureCollection.features.push(feature);
}
function feature(geometry, properties = {}){
	return {type: 'Feature', properties, geometry};
}
function point$1(coords, props){
	const geom = {type: 'Point', coordinates: coords};
	return props ? feature(geom, props) : geom;
}
function lineString$1(coords, props, geodesic = false){
	const geom = setGeom('LineString', coords, geodesic);
	return props ? feature(geom, props) : geom;
}
function polygon$1(coords, props, geodesic = false){
	const geom = setGeom('Polygon', coords, geodesic);
	return props ? feature(geom, props) : geom;
}
function multiPoint(coords, props){
	const geom = setGeom('MultiPoint', coords);
	return props ? feature(geom, props) : geom;
}
function multiLineString(coords, props, geodesic = false){
	const geom = setGeom('MultiLineString', coords, geodesic);
	return props ? feature(geom, props) : geom;
}
function multiPolygon$1(coords, props, geodesic = false){
	const geom = setGeom('MultiPolygon', coords, geodesic);
	return props ? feature(geom, props) : geom;
}
function setGeom(type, coords, geodesic$1 = false){
	return {type, coordinates: geodesic$1 ? geodesic(coords) : coords};
}

class Cartesian{
	constructor(point){
		this.a = 6378137.0;
		this.f = 1 / 298.257223563;
		this.e2 = this.f * (2 - this.f);

		this.reset(point);
	}
	forward(point){
		const ecef = this.toECEF(point[0], point[1], point[2] || 0);
		const dx = ecef.x - this.x;
		const dy = ecef.y - this.y;
		const dz = ecef.z - this.z;
		const x = this.r11 * dx + this.r12 * dy + this.r13 * dz;
		const y = this.r21 * dx + this.r22 * dy + this.r23 * dz;
		const z = this.r31 * dx + this.r32 * dy + this.r33 * dz;

		return {x, y, z};
	}
	reverse(x, y, z) {
		const dx = this.r11 * x + this.r21 * y + this.r31 * z;
		const dy = this.r12 * x + this.r22 * y + this.r32 * z;
		const dz = this.r13 * x + this.r23 * y + this.r33 * z;

		return this.toGeodetic(dx + this.x, dy + this.y, dz + this.z);
	}
	reset(point){
		this.lon = point[0];
		this.lat = point[1];
		this.height = point[2] || 0;
		
		const {x, y, z} = this.toECEF(this.lon, this.lat, this.height);

		this.x = x;
		this.y = y;
		this.z = z;

		this.computeRotationMatrix(this.lon, this.lat);
	}
	toECEF(lon, lat, height){
		const {sinLat, cosLat, sinLon, cosLon} = this.getRadSinCos(lon, lat);
		const n = this.a / Math.sqrt(1 - this.e2 * sinLat * sinLat);
		const x = (n + height) * cosLat * cosLon;
		const y = (n + height) * cosLat * sinLon;
		const z = (n * (1 - this.e2) + height) * sinLat;

		return {x, y, z};
	}
	toGeodetic(x, y, z){
		const lon = Math.atan2(y, x);
		const p = Math.sqrt(x * x + y * y);
		let lat = Math.atan2(z, p * (1 - this.e2));

		for(let i = 0; i < 5; i++){
			const sinLat = Math.sin(lat);
			const n = this.a / Math.sqrt(1 - this.e2 * sinLat * sinLat);
			const h = p / Math.cos(lat) - n;

			lat = Math.atan2(z, p * (1 - this.e2 * n / (n + h)));
		}

		const sinLat = Math.sin(lat);
		const n = this.a / Math.sqrt(1 - this.e2 * sinLat * sinLat);
		const height = p / Math.cos(lat) - n;

		return [lon * 180 / Math.PI, lat * 180 / Math.PI, height];
	}
	computeRotationMatrix(lon, lat){
		const {sinLat, cosLat, sinLon, cosLon} = this.getRadSinCos(lon, lat);
		
		this.r11 = -sinLon;
		this.r12 = cosLon;
		this.r13 = 0;
		this.r21 = -sinLat * cosLon;
		this.r22 = -sinLat * sinLon;
		this.r23 = cosLat;
		this.r31 = cosLat * cosLon;
		this.r32 = cosLat * sinLon;
		this.r33 = sinLat;
	}
	getRadSinCos(lon, lat){
		const latRad = lat * Math.PI / 180;
		const lonRad = lon * Math.PI / 180;
		const sinLat = Math.sin(latRad);
		const cosLat = Math.cos(latRad);
		const sinLon = Math.sin(lonRad);
		const cosLon = Math.cos(lonRad);

		return {latRad, lonRad, sinLat, cosLat, sinLon, cosLon};
	}
}

function cartesian(point){
	return new Cartesian(point);
}

const polygons = new Set(['Polygon', 'MultiPolygon']);

function serialize(coords, geodesicTol = 0.00001){
	const type = getType(coords);

	if(type === 'Point'){
		return {type: 'Point', subtype: 'Point', geom: {type: 'Point', coord: coords}};
	}

	const geom = lineEach$1(rewind(coords), (line) => {
		return encodeLine(line.slice(), type, geodesicTol);
	});

	const subtype = getSubtype(geom, type);

	return {type, subtype, geom};
}
function deserialize(obj){
	let {type, geom} = obj;
	const poly = type === 'Polygon' || type === 'MultiPolygon';
	let coords = objectsEach(geom, (arr) => { return decodeLine(arr, poly); });

	if(poly){
		coords = unkink(coords);
		type = coords.length > 1 ? 'MultiPolygon' : 'Polygon';
		coords = coords.length > 1 ? coords : coords[0];
	}

	return {type: type, coordinates: coords};
}
function decodeLine(arr, poly){
	const len = arr.length;
	let out = [];

	for(let i = 0; i < len; i++){
		const obj = arr[i];
		const {type} = obj;

		if(type === 'line'){
			const {a, b} = obj;

			if(i === 0){ out.push(a); }

			out.push(b);
		} else if(type === 'circle'){
			const {center, radius, units} = obj;
			out.pop();
			out = [...out, ...circle(center, radius, units)];
		} else if(type === 'arc'){
			const {center, radius, units, ang1, ang2, clockwise} = obj;
			out.pop();
			out = [...out, ...arc(center, radius, units, ang1, ang2, clockwise)];
		}
	}

	return poly ? closePolygon(out) : out;
}
function encodeLine(line, gtype, tol){
	const coords = fromGeodesic(line, tol);
	const len = coords.length;
	const segs = [];
	const arcs = [];
	const type = 'line';
	const wrap = [...coords.slice(0), ...coords.slice(1)];
	let arc = null;

	for(let i = 0; i < len; i++){
		const a = coords[i];
		const b = wrap[i + 1];
		const c = wrap[i + 2];
		const circle = getCircle(a, b, c);

		segs.push({type, a, b, geodesic: isGeodesic(line, a, b)});

		if(arc){
			if(circle && centerRadiusEqual(arc, circle)){
				arc.b++;
				arc.cnt++;
			} else {
				if(arc.cnt > 4){ arcs.push(arc); }
				arc = null;
			}
		} else if(circle){
			circle.a = i;
			circle.b = i + 2;
			circle.cnt = 1;
			arc = circle;
		}
	}

	if(arc && arc.cnt > 4){ arcs.push(arc); }

	if(arcs.length === 1 && arc && arc.cnt === len){
		if(len >= 30){
			arc.type = 'circle';
			delete arc.a;
			delete arc.b;
			delete arc.cnt;

			return [arc];
		} else {
			arcs.length = 0;
		}
	}

	segs.pop();

	return assemble(gtype, arcs, segs, coords, len);
}
function assemble(gtype, arcs, segs, coords, len){
	const {map, set} = setArcs(arcs, segs, coords);
	const out = [];

	for(let i = 0; i < len; i++){
		if(!set.has(i) && segs[i]){
			const {a, b} = segs[i];

			if(a[0] !== b[0] || a[1] !== b[1]){ out.push(segs[i]); }
		}

		if(map.has(i)){
			const obj = map.get(i);
			delete obj.a;
			delete obj.b;
			delete obj.cnt;
			out.push(obj);
		}
	}

	const a = out[0];
	const b = out.at(-1);

	if(centerRadiusEqual(a, b)){
		out.pop();
		a.ang1 = b.ang1;
	} else if(!polygons.has(gtype)){
		out.pop();
	}

	return out;
}
function setArcs(arcs, segs, coords){
	const max = segs.length - 1;
	const set = new Set();
	const map = new Map();
	let prev = null;

	for(let arc of arcs){
		const {center, radius} = arc;
		const tol = arcTolerance(arc, segs);
		const seg1 = arcSegment(arc, segs, tol, 'a');
		const seg2 = arcSegment(arc, segs, tol, 'b');
		const intr1 = lineArc(seg1.a, seg1.b, center, radius);
		const intr2 = lineArc(seg2.b, seg2.a, center, radius);

		arc.ang1 = bearing(center, intr1);
		arc.ang2 = bearing(center, intr2);
		arc.clockwise = getClockwise(arc, coords);
		seg1.b = destination(center, arc.ang1, radius);
		seg2.a = destination(center, arc.ang2, radius);

		if(prev && Math.abs(prev.b - arc.a) === 1){ arcArc(arc, prev, intr1); }

		const a = arc.a < 0 ? -1 : arc.a;
		const b = arc.b > max ? max + 1 : arc.b;

		for(let i = a + 1; i < b; i++){ set.add(i); }

		map.set(a, arc);
		prev = arc;
	}

	return {set, map};
}
function arcArc(a, b, intr){
	const arr = circleCircle(a.center, a.radius, b.center, b.radius);

	if(!arr.length){ return; }

	let point = null;
	let min = Infinity;

	for(let pt of arr){
		const dist = distance(pt, intr);

		if(dist < min){
			min = dist;
			point = pt;
		}
	}

	a.ang1 = bearing(a.center, point);
	b.ang2 = bearing(b.center, point);
}
function arcTolerance(arc, segs){
	const {center, radius} = arc;
	const {a, b} = segs[arc.a];
	const mid = midpoint(a, b);

	return Math.ceil(radius - distance(center, mid)) + 10;
}
function arcSegment(arc, segs, tol, key){
	const {center, radius} = arc;
	const incr = key === 'a' ? -1 : 1;
	let offset = arc[key];
	let idx = null;

	while(idx === null){
		const {a, b} = getOffset(segs, offset);
		const d1 = Math.abs(radius - Math.round(distance(center, a)));
		const d2 = Math.abs(radius - Math.round(distance(center, b)));
		const delta = Math.max(d1, d2);

		if(delta >= tol){ idx = offset; }

		offset += incr;
	}

	arc[key] = idx;

	return getOffset(segs, idx);
}
function getClockwise(arc, coords){
	const orig = [arc.center];
	const max = Math.max(0, arc.a);
	const arr = [...orig, ...coords.slice(max + 1, arc.b - 1), ...orig];

	return clockwise(arr);
}
function lineArc(a, b, center, radius){
	if(radius === Math.round(distance(b, center))){ return b; }

	const intr = lineCircle(a, b, center, radius);

	if(intr.length){ return intr[0]; }

	return destination(center, bearing(center, b), radius);
}
function getCircle(a, b, c){
	const circle = circleFromThreePoints(a, b, c);
	const type = 'arc';

	if(!circle){ return null; }

	let {center, radius, uom} = circle;

	radius = Math.round(radius);
	center[0] = Number(center[0].toFixed(5));
	center[1] = Number(center[1].toFixed(5));

	return {type, center, radius, uom};
}
function centerRadiusEqual(a, b){
	if(!a.center || !b.center){ return false; }

	const dx = Math.abs(a.center[0] - b.center[0]);
	const dy = Math.abs(a.center[1] - b.center[1]);
	const dr = Math.abs(a.radius - b.radius);

	return (dx <= 0.0001 && dy <= 0.0001 && dr <= 5);
}
function isGeodesic(line, a, b, tol, units){
	const idx1 = line.indexOf(a);
	const idx2 = line.indexOf(b, idx1);
	const bool = idx2 - idx1 > 1;

	return bool;
}
function getOffset(arr, offset){
	const max = arr.length - 1;

	if(offset > max){
		return arr[(offset - max) - 1];
	} else if(offset < 0){
		return arr[max + (offset + 1)];
	} else {
		return arr[offset];
	}
}
function getSubtype(geom, type){
	const arr = (type === 'Polygon' && geom.length === 1) ? geom[0] : geom;

	if(arr.length === 1){
		return arr[0].type;
	} else {
		return type;
	}
}
function circleFromThreePoints(p1, p2, p3, uom = 'm'){
	const lc = cartesian(p1);
	const lc1 = lc.forward(p1);
	const lc2 = lc.forward(p2);
	const lc3 = lc.forward(p3);
	const x1 = lc1.x;
	const y1 = lc1.y;
	const x2 = lc2.x;
	const y2 = lc2.y;
	const x3 = lc3.x;
	const y3 = lc3.y;
	const mx12 = (x1 + x2) / 2;
	const my12 = (y1 + y2) / 2;
	const mx23 = (x2 + x3) / 2;
	const my23 = (y2 + y3) / 2;
	const dx12 = x2 - x1;
	const dy12 = y2 - y1;
	const dx23 = x3 - x2;
	const dy23 = y3 - y2;
	const det = dx12 * dy23 - dy12 * dx23;

	if(Math.abs(det) < 1e-10){ return null; }

	let cx = null;
	let cy = null;

	if(Math.abs(dx12) < 1e-10){
		cx = mx12;
		cy = my23 - (dx23 / dy23) * (cx - mx23);
	} else if(Math.abs(dx23) < 1e-10){
		cx = mx23;
		cy = my12 - (dx12 / dy12) * (cx - mx12);
	} else {
		const slope12 = -dx12 / dy12;
		const slope23 = -dx23 / dy23;

		cx = (my23 - my12 + slope12 * mx12 - slope23 * mx23) / (slope12 - slope23);
		cy = my12 + slope12 * (cx - mx12);
	}

	const radius = Math.sqrt((cx - x1) ** 2 + (cy - y1) ** 2);
	const center = lc.reverse(cx, cy, 0);

	return {center, radius, uom};
}

function tin(coords, polygon = false){
	const res = triangulate(coords.map((a) => { return {x: a[0], y: a[1]}; }));
	const out = res.map((obj) => {
		const {a, b, c} = obj;
		const arr = [[a.x, a.y],[b.x, b.y],[c.x, c.y]];

		if(polygon){ arr.push(arr[0]); }

		return arr;
	});

	return polygon ? [out] : out;
}
function triangulate(vertices){
	const len = vertices.length;

	if(len < 3){ return []; }

	vertices.sort((a, b) => { return b.x - a.x; });

	let i = len - 1;
	let xmin = vertices[i].x;
	let xmax = vertices[0].x;
	let ymin = vertices[i].y;
	let ymax = ymin;

	while(i--){
		if(vertices[i].y < ymin){ ymin = vertices[i].y; }
		if(vertices[i].y > ymax){ ymax = vertices[i].y; }
	}

	let dx = xmax - xmin;
	let dy = ymax - ymin;
	let dmax = Math.max(dx, dy);
	let xmid = (xmax + xmin) * 0.5;
	let ymid = (ymax + ymin) * 0.5;
	const closed = [];
	const edges = [];
	const open = [
		triangle(
			{x: xmid - 20 * dmax, y: ymid - dmax, sentinel: true},
			{x: xmid, y: ymid + 20 * dmax, sentinel: true},
			{x: xmid + 20 * dmax, y: ymid - dmax, sentinel: true}
		)
	];

	i = vertices.length;

	while(i--){
		edges.length = 0;
		let j = open.length;

		while(j--){
			dx = vertices[i].x - open[j].x;

			if(dx > 0 && dx * dx > open[j].r){
				closed.push(open[j]);
				open.splice(j, 1);
				continue;
			}

			dy = vertices[i].y - open[j].y;

			if(dx * dx + dy * dy > open[j].r){ continue; }

			edges.push(
				open[j].a, open[j].b,
				open[j].b, open[j].c,
				open[j].c, open[j].a
			);

			open.splice(j, 1);
		}

		dedup(edges);

		j = edges.length;

		while(j){
			let b = edges[--j];
			let a = edges[--j];
			open.push(triangle(a, b, vertices[i]));
		}
	}

	const arr = [...closed, ...open];

	i = arr.length;

	while(i--){
		if(arr[i].a.sentinel || arr[i].b.sentinel || arr[i].c.sentinel){ arr.splice(i, 1); }
	}

	return arr;
}
function triangle(a, b, c){
	const v1 = b.x - a.x;
	const v2 = b.y - a.y;
	const v3 = c.x - a.x;
	const v4 = c.y - a.y;
	const v5 = v1 * (a.x + b.x) + v2 * (a.y + b.y);
	const v6 = v3 * (a.x + c.x) + v4 * (a.y + c.y);
	const v7 = 2 * (v1 * (c.y - b.y) - v2 * (c.x - b.x));
	let mx = null;
	let my = null;
	let dx = null;
	let dy = null;

	if(Math.abs(v7) < 0.000001){
		mx = Math.min(a.x, b.x, c.x);
		my = Math.min(a.y, b.y, c.y);
		dx = (Math.max(a.x, b.x, c.x) - mx) * 0.5;
		dy = (Math.max(a.y, b.y, c.y) - my) * 0.5;

		return {a, b, c, x: mx + dx, y: my + dy, r: dx * dx + dy * dy};
	} else {
		const x = (v4 * v5 - v2 * v6) / v7;
		const y = (v1 * v6 - v3 * v5) / v7;
		dx = x - a.x;
		dy = y - a.y;

		return {a, b, c, x, y, r: dx * dx + dy * dy};
	}
}
function dedup(edges){
	let len = edges.length;

	while(len){
		const b = edges[--len];
		const a = edges[--len];
		let i = len;

		while(i){
			let n = edges[--i];
			let m = edges[--i];

			if((a === m && b === n) || (a === n && b === m)){
				edges.splice(len, 2);
				edges.splice(i, 2);
				len -= 2;
			}
		}
	}
}

const templates = new Map([
	[3, `a°b'c"d`],
	[4, `a b cd`],
	[5, `abcd`],
	[6, `a°b.r'd`],
	[7, `a b.rd`],
	[8, `ab.rd`]
]);
const regex$1 = {
	dmsArr: /(\d{2,3})(\d{2})?(\d{2}(?:\.\d+)?)?([NSEW])/g,
	dms: /^(\d{2,3})(\d{2})?(\d{2}(?:\.\d+)?)?([NSEW])$/,
	dec: /^([-]*)(\d{1,2}\.\d+)([NS]{0,1}) ([-]*)(\d{1,3}\.\d+)([EW]{0,1})$/,
	order: /^.*[NS].*[EW].*$/
};
const negDir = new Set(['S', 'W']);

function formatCoord(coord, format = 1){
	if(format <= 2){
		return {
			lon: formatDecimal(coord[0], format, false),
			lat: formatDecimal(coord[1], format, true)
		}
	} else {
		return {
			lon: formatDMS(coord[0], format, false),
			lat: formatDMS(coord[1], format, true)
		}
	}
}
function formatDMS(val, format, lat){
	if(!lat){ val = ((val + 180) % 360 + 360) % 360 - 180; }

	const {dir, deg, min, sec} = degToDms(val, lat);
	const str = templates.get(format);
	const a = deg.toString().padStart(lat ? 2 : 3, '0');
	const b = min.toString().padStart(2, '0');
	const c = Math.floor(sec).toString().padStart(2, '0');
	const r = round$2(sec / 60, 4).toString().substring(2).padStart(4, '0');
	const d = dir;

	return str.replace('a', a).replace('b', b).replace('c', c).replace('d', d).replace('r', r);
}
function formatDecimal(val, format, lat){
	const num = Math.round(val * 1000000) / 1000000;
	const neg = num < 0;
	const dir = getDir(format, neg, lat);
	const abs = Math.abs(num);
	const deg = Math.floor(abs);
	const rem = abs - deg;
	const a = deg.toString();
	const b = (rem || '0.0').toString().substring(2, 8);

	if(!dir){
		return neg ? `-${a}.${b}` : `${a}.${b}`;
	} else {
		return `${a}.${b}${dir}`;
	}
}
function parseCoord(coord){
	coord = coord.replace(/[,|/:]/g, ' ').toUpperCase();
	coord = coord.replace(/\s+/g, ' ').trim();

	if(regex$1.dec.test(coord)){
		return parseDecimal(coord);
	}

	coord = coord.replace(/[°'"]/g, '');
	coord = coord.replace(/(\d)\s+(\d)/g, '$1$2');

	const arr = coord.match(regex$1.dmsArr) || [];

	if(arr.length === 2){
		const a = parseDMS(arr[0]);
		const b = parseDMS(arr[1]);

		return regex$1.order.test(coord) ? [b, a] : [a, b];
	} else {
		return null;
	}
}
function parseDecimal(coord){
	const m = coord.match(regex$1.dec);
	const np1 = m[1] || negDir.has(m[3]) ? '-' : '';
	const np2 = m[4] || negDir.has(m[6]) ? '-' : '';
	
	return [
		Number(`${np1}${m[2]}`),
		Number(`${np2}${m[5]}`),
	];
}
function parseDMS(val){
	const m = val.toUpperCase().match(regex$1.dms);
	const deg = Number(m[1]);
	const min = Number(m[2] || 0);
	const sec = Number(m[3] || 0);
	
	return dmsToDeg(deg, min, sec, m[4]);
}
function getDir(format, neg, lat){
	if(format === 1){ return null; }

	if(lat){
		return neg ? 'S' : 'N';
	} else {
		return neg ? 'W' : 'E';
	}
}

const regex = /^\s*(geometrycollection|point|linestring|polygon|multipoint|multilinestring|multipolygon)\s*\((geometrycollection|point|linestring|polygon|multipoint|multilinestring|multipolygon|[\S\s\d\-,.()])+\)\s*$/m;

function wktToGeoJSON(wkt){
	if(!regex.test(wkt.toLowerCase())){ return null; }

	wkt = wkt.toLowerCase();
	wkt = wkt.replace(/(\d)\s+(\d)/g, '$1*$2');
	wkt = wkt.replace(/\s+/g, '');
	wkt = wkt.replace(/^geometrycollection\s*\((.+)\)$/, '$1');
	wkt = wkt.replace(/[,]*([a-z]+)/g, 'x$1');
	wkt = wkt.replace(/^x(.*)$/, '$1');

	const arr = wkt.split('x').map(str => parseGeom(str));

	return arr.length === 1 ? arr[0] : {type: 'GeometryCollection', geometries: arr};
}
function parseGeom(str){
	const m = str.match(/^([a-z]+)(.+)$/);
	const gtype = m[1];
	const coords = m[2];
	const out = {};
	
	switch(gtype){
		case 'point':
			out.type = 'Point';
			out.coordinates = point(coords);
		break;
		case 'linestring':
			out.type = 'LineString';
			out.coordinates = lineString(coords);
		break;
		case 'polygon':
			out.type = 'Polygon';
			out.coordinates = polygon(coords);
		break;
		case 'multipoint':
			out.type = 'MultiPoint';
			out.coordinates = lineSting(coords);
		break;
		case 'multilinestring':
			out.type = 'MultiLineString';
			out.coordinates = polygon(coords);
		break;
		case 'multipolygon':
			out.type = 'MultiPolygon';
			out.coordinates = multiPolygon(coords);
		break;
	}

	return out;
}
function point(coord){
	coord = coord.replace(/[()]/g, '');

	return coord.split('*').map((str) => Number(str));
}
function lineString(coords){
	coords = coords.replace(/[()]/g, '');

	return coords.split(',').map((coord) => point(coord));
}
function polygon(coords){
	const rings = coords.split('),(');

	return rings.map((ring) => {
		return lineString(ring);
	});
}
function multiPolygon(coords){
	const out = [];

	coords = coords.replace(/^\((.*)\)$/, '$1');
	coords = coords.replace(/[)]{2},/g, '))x');

	for(let poly of coords.split('x')){
		out.push(polygon(poly));
	}

	return out;
}

function topoSnap(coords1, coords2, tol = 100, units = 'm'){
	const arr = [coords1, coords2];
	const getRtree = (coords) => {
		const rtree$1 = rtree();
		const segs = utils.segmentAll(toSegments(coords));
		const set = new Set();

		for(let seg of segs){
			const a = seg[0];
			const b = seg[1];
			const bbox = BBOX().add(a).add(b).buffer(tol, units);
	
			set.add(a.join(':'));
			set.add(b.join(':'));
			rtree$1.insert({a, b, bbox});
		}

		return {rtree: rtree$1, set};
	};
	
	for(let [idx, coords] of arr.entries()){
		const {rtree, set} = getRtree(idx === 1 ? coords1 : coords2);

		utils.ringEach(coords, (ring) => {
			for(let [i, coord] of ring.entries()){
				if(set.has(coord.join(':'))){ continue; }

				const hits = rtree.search(BBOX().add(coord));
				const res = {distance: Infinity, point: null};

				if(!hits.length){ continue; }

				for(let hit of hits){
					const {distance, point} = pointLine(coord, hit.a, hit.b, true, units);

					if(distance < res.distance){
						res.distance = distance;
						res.point = point;
					}
				}

				if(res.distance <= tol){
					ring[i] = res.point;
				}
			}
		});
	}
}

const data = [
	{
		epoch: 2025,
		name: 'WMM-2025',
		start: 1731474000000,
		end: 1889240400000,
		max1: 12,
		max2: 12,
		g1: [0,-29351.8,-1410.8,-2556.6,2951.1,1649.3,1361,-2404.1,1243.8,453.6,895,799.5,55.7,-281.1,12.1,-233.2,368.9,187.2,-138.7,-142,20.9,64.4,63.8,76.9,-115.7,-40.9,14.9,-60.7,79.5,-77,-8.8,59.3,15.8,2.5,-11.1,14.2,23.2,10.8,-17.5,2,-21.7,16.9,15,-16.8,0.9,4.6,7.8,3,-0.2,-2.5,-13.1,2.4,8.6,-8.7,-12.9,-1.3,-6.4,0.2,2,-1,-0.6,-0.9,1.5,0.9,-2.7,-3.9,2.9,-1.5,-2.5,2.4,-0.6,-0.1,-0.6,-0.1,1.1,-1,-0.2,2.6,-2,-0.2,0.3,1.2,-1.3,0.6,0.6,0.5,-0.1,-0.4,-0.2,-1.3,-0.7],
		h1: [0,0,4545.4,0,-3133.6,-815.1,0,-56.6,237.5,-549.5,0,278.6,-133.9,212,-375.6,0,45.4,220.2,-122.9,43,106.1,0,-18.4,16.8,48.8,-59.8,10.9,72.7,0,-48.9,-14.4,-1,23.4,-7.4,-25.1,-2.3,0,7.1,-12.6,11.4,-9.7,12.7,0.7,-5.2,3.9,0,-24.8,12.2,8.3,-3.3,-5.2,7.2,-0.6,0.8,10,0,3.3,0,2.4,5.3,-9.1,0.4,-4.2,-3.8,0.9,-9.1,0,0,2.9,-0.6,0.2,0.5,-0.3,-1.2,-1.7,-2.9,-1.8,-2.3,0,-1.3,0.7,1,-1.4,0,0.6,-0.1,0.8,0.1,-1,0.1,0.2],
		g2: [0,12,9.7,-11.6,-5.2,-8,-1.3,-4.2,0.4,-15.6,-1.6,-2.4,-6,5.6,-7,0.6,1.4,0,0.6,2.2,0.9,-0.2,-0.4,0.9,1.2,-0.9,0.3,0.9,0,-0.1,-0.1,0.5,-0.1,-0.8,-0.8,0.8,-0.1,0.2,0,0.5,-0.1,0.3,0.2,0,0.2,0,-0.1,0.1,0.3,-0.3,0,0.3,-0.1,0.1,-0.1,0.1,0,0.1,0.1,0,-0.3,0,-0.1,-0.1,0,0,0,0,0,0,0,-0.1,0,0,-0.1,-0.1,-0.1,-0.1,0,0,0,0,0,0,0.1,0,0,0,-0.1,0,-0.1],
		h2: [0,0,-21.5,0,-27.7,-12.1,0,4,-0.3,-4.1,0,-1.1,4.1,1.6,-4.4,0,-0.5,2.2,0.4,1.7,1.9,0,0.3,-1.6,-0.4,0.9,0.7,0.9,0,0.6,0.5,-0.8,0,-1,0.6,-0.2,0,-0.2,0.5,-0.4,0.4,-0.5,-0.6,0.3,0.2,0,-0.3,0.3,-0.3,0.3,0.2,-0.1,-0.2,0.4,0.1,0,0,0,-0.2,0.1,-0.1,0.1,0,-0.1,0.2,0,0,0,0.1,0,0.1,0,0,0.1,0,0,0,0,0,0,0,-0.1,0.1,0,0,0,0,0,0,0,-0.1],
	},
	{
		epoch: 2020,
		name: 'WMM-2020',
		start: 1575954000000,
		end: 1733806800000,
		max1: 12,
		max2: 12,
		g1: [0,-29404.5,-1450.7,-2500,2982,1676.8,1363.9,-2381,1236.2,525.7,903.1,809.4,86.2,-309.4,47.9,-234.4,363.1,187.8,-140.7,-151.2,13.7,65.9,65.6,73,-121.5,-36.2,13.5,-64.7,80.6,-76.8,-8.3,56.5,15.8,6.4,-7.2,9.8,23.6,9.8,-17.5,-0.4,-21.1,15.3,13.7,-16.5,-0.3,5,8.2,2.9,-1.4,-1.1,-13.3,1.1,8.9,-9.3,-11.9,-1.9,-6.2,-0.1,1.7,-0.9,0.6,-0.9,1.9,1.4,-2.4,-3.9,3,-1.4,-2.5,2.4,-0.9,0.3,-0.7,-0.1,1.4,-0.6,0.2,3.1,-2,-0.1,0.5,1.3,-1.2,0.7,0.3,0.5,-0.2,-0.5,0.1,-1.1,-0.3],
		h1: [0,0,4652.9,0,-2991.6,-734.8,0,-82.2,241.8,-542.9,0,282,-158.4,199.8,-350.1,0,47.7,208.4,-121.3,32.2,99.1,0,-19.1,25,52.7,-64.4,9,68.1,0,-51.4,-16.8,2.3,23.5,-2.2,-27.2,-1.9,0,8.4,-15.3,12.8,-11.8,14.9,3.6,-6.9,2.8,0,-23.3,11.1,9.8,-5.1,-6.2,7.8,0.4,-1.5,9.7,0,3.4,-0.2,3.5,4.8,-8.6,-0.1,-4.2,-3.4,-0.1,-8.8,0,0,2.6,-0.5,-0.4,0.6,-0.2,-1.7,-1.6,-3,-2,-2.6,0,-1.2,0.5,1.3,-1.8,0.1,0.7,-0.1,0.6,0.2,-0.9,0,0.5],
		g2: [0,6.7,7.7,-11.5,-7.1,-2.2,2.8,-6.2,3.4,-12.2,-1.1,-1.6,-6,5.4,-5.5,-0.3,0.6,-0.7,0.1,1.2,1,-0.6,-0.4,0.5,1.4,-1.4,0,0.8,-0.1,-0.3,-0.1,0.7,0.2,-0.5,-0.8,1,-0.1,0.1,-0.1,0.5,-0.1,0.4,0.5,0,0.4,-0.1,-0.2,0,0.4,-0.3,0,0.3,0,0,-0.4,0,0,0,0.2,-0.1,-0.2,0,-0.1,-0.2,-0.1,0,0,-0.1,0,0,0,-0.1,0,0,-0.1,-0.1,-0.1,-0.1,0,0,0,0,0,0,0,0,0,0,0,0,-0.1],
		h2: [0,0,-25.1,0,-30.2,-23.9,0,5.7,-1,1.1,0,0.2,6.9,3.7,-5.6,0,0.1,2.5,-0.9,3,0.5,0,0.1,-1.8,-1.4,0.9,0.1,1,0,0.5,0.6,-0.7,-0.2,-1.2,0.2,0.3,0,-0.3,0.7,-0.2,0.5,-0.3,-0.5,0.4,0.1,0,-0.3,0.2,-0.4,0.4,0.1,0,-0.2,0.5,0.2,0,0,0.1,-0.3,0.1,-0.2,0.1,0,-0.1,0.2,0,0,0,0.1,0,0.2,0,0,0.1,0,-0.1,0,0,0,0,0,-0.1,0.1,0,0,0,0.1,0,0,0,-0.1],
	},
	{
		epoch: 2015,
		name: 'WMM-2015',
		start: 1418619600000,
		end: 1576386000000,
		max1: 12,
		max2: 12,
		g1: [0,-29438.5,-1501.1,-2445.3,3012.5,1676.6,1351.1,-2352.3,1225.6,581.9,907.2,813.7,120.3,-335,70.3,-232.6,360.1,192.4,-141,-157.4,4.3,69.5,67.4,72.8,-129.8,-29,13.2,-70.9,81.6,-76.1,-6.8,51.9,15,9.3,-2.8,6.7,24,8.6,-16.9,-3.2,-20.6,13.3,11.7,-16,-2,5.4,8.8,3.1,-3.1,0.6,-13.3,-0.1,8.7,-9.1,-10.5,-1.9,-6.5,0.2,0.6,-0.6,1.7,-0.7,2.1,2.3,-1.8,-3.6,3.1,-1.5,-2.3,2.1,-0.9,0.6,-0.7,0.2,1.7,-0.2,0.4,3.5,-2,-0.3,0.4,1.3,-0.9,0.9,0.1,0.5,-0.4,-0.4,0.2,-0.9,0],
		h1: [0,0,4796.2,0,-2845.6,-642,0,-115.3,245,-538.3,0,283.4,-188.6,180.9,-329.5,0,47.4,196.9,-119.4,16.1,100.1,0,-20.7,33.2,58.8,-66.5,7.3,62.5,0,-54.1,-19.4,5.6,24.4,3.3,-27.5,-2.3,0,10.2,-18.1,13.2,-14.6,16.2,5.7,-9.1,2.2,0,-21.6,10.8,11.7,-6.8,-6.9,7.8,1,-3.9,8.5,0,3.3,-0.3,4.6,4.4,-7.9,-0.6,-4.1,-2.8,-1.1,-8.7,0,-0.1,2.1,-0.7,-1.1,0.7,-0.2,-2.1,-1.5,-2.5,-2,-2.3,0,-1,0.5,1.8,-2.2,0.3,0.7,-0.1,0.3,0.2,-0.9,-0.2,0.7],
		g2: [0,10.7,17.9,-8.6,-3.3,2.4,3.1,-6.2,-0.4,-10.4,-0.4,0.8,-9.2,4,-4.2,-0.2,0.1,-1.4,0,1.3,3.8,-0.5,-0.2,-0.6,2.4,-1.1,0.3,1.5,0.2,-0.2,-0.4,1.3,0.2,-0.4,-0.9,0.3,0,0.1,-0.5,0.5,-0.2,0.4,0.2,-0.4,0.3,0,-0.1,-0.1,0.4,-0.5,-0.2,0.1,0,-0.2,-0.1,0,0,-0.1,0.3,-0.1,-0.1,-0.1,0,-0.2,-0.1,-0.2,0,0,-0.1,0.1,0,0,0,0,0,0,-0.1,-0.1,0.1,0,0,0.1,-0.1,0,0.1,0,0,0,0,0,0],
		h2: [0,0,-26.8,0,-27.1,-13.3,0,8.4,-0.4,2.3,0,-0.6,5.3,3,-5.3,0,0.4,1.6,-1.1,3.3,0.1,0,0,-2.2,-0.7,0.1,1,1.3,0,0.7,0.5,-0.2,-0.1,-0.7,0.1,0.1,0,-0.3,0.3,0.3,0.6,-0.1,-0.2,0.3,0,0,-0.2,-0.1,-0.2,0.1,0.1,0,-0.2,0.4,0.3,0,0.1,-0.1,0,0,-0.2,0.1,-0.1,-0.2,0.1,-0.1,0,0,0.1,0,0.1,0,0,0.1,0,-0.1,0,-0.1,0,0,0,-0.1,0,0,0,0,0,0,0,0,0],
	},
	{
		epoch: 2010,
		name: 'WMM-2010',
		start: 1258693200000,
		end: 1416459600000,
		max1: 12,
		max2: 12,
		g1: [0,-29496.6,-1586.3,-2396.6,3026.1,1668.6,1340.1,-2326.2,1231.9,634,912.6,808.9,166.7,-357.1,89.4,-230.9,357.2,200.3,-141.1,-163,-7.8,72.8,68.6,76,-141.4,-22.8,13.2,-77.9,80.5,-75.1,-4.7,45.3,13.9,10.4,1.7,4.9,24.4,8.1,-14.5,-5.6,-19.3,11.5,10.9,-14.1,-3.7,5.4,9.4,3.4,-5.2,3.1,-12.4,-0.7,8.4,-8.5,-10.1,-2,-6.3,0.9,-1.1,-0.2,2.5,-0.3,2.2,3.1,-1,-2.8,3,-1.5,-2.1,1.7,-0.5,0.5,-0.8,0.4,1.8,0.1,0.7,3.8,-2.2,-0.2,0.3,1,-0.6,0.9,-0.1,0.5,-0.4,-0.4,0.2,-0.8,0],
		h1: [0,0,4944.4,0,-2707.7,-576.1,0,-160.2,251.9,-536.6,0,286.4,-211.2,164.3,-309.1,0,44.6,188.9,-118.2,0,100.9,0,-20.8,44.1,61.5,-66.3,3.1,55,0,-57.9,-21.1,6.5,24.9,7,-27.7,-3.3,0,11,-20,11.9,-17.4,16.7,7,-10.8,1.7,0,-20.5,11.5,12.8,-7.2,-7.4,8,2.1,-6.1,7,0,2.8,-0.1,4.7,4.4,-7.2,-1,-3.9,-2,-2,-8.3,0,0.2,1.7,-0.6,-1.8,0.9,-0.4,-2.5,-1.3,-2.1,-1.9,-1.8,0,-0.9,0.3,2.1,-2.5,0.5,0.6,0,0.1,0.3,-0.9,-0.2,0.9],
		g2: [0,11.6,16.5,-12.1,-4.4,1.9,0.4,-4.1,-2.9,-7.7,-1.8,2.3,-8.7,4.6,-2.1,-1,0.6,-1.8,-1,0.9,1,-0.2,-0.2,-0.1,2,-1.7,-0.3,1.7,0.1,-0.1,-0.6,1.3,0.4,0.3,-0.7,0.6,-0.1,0.1,-0.6,0.2,-0.2,0.3,0.3,-0.6,0.2,0,-0.1,0,0.3,-0.4,-0.3,0.1,-0.1,-0.4,-0.2,0,0,-0.1,0.2,0,-0.1,-0.2,0,-0.1,-0.2,-0.2,0,0,0,0.1,0,0,0,0,0,0,-0.1,0,0,0,0.1,0.1,-0.1,0,0,0,0,0,0,-0.1,0.1],
		h2: [0,0,-25.9,0,-22.5,-11.8,0,7.3,-3.9,-2.6,0,1.1,2.7,3.9,-0.8,0,0.4,1.8,1.2,4,-0.6,0,-0.2,-2.1,-0.4,-0.6,0.5,0.9,0,0.7,0.3,-0.1,-0.1,-0.8,-0.3,0.3,0,-0.1,0.2,0.4,0.4,0.1,-0.1,0.4,0.3,0,0,-0.2,0,-0.1,0.1,0,-0.2,0.3,0.2,0,0.1,-0.1,0,-0.1,-0.1,0,-0.1,-0.2,0,-0.1,0,0,0.1,0,0.1,0,0.1,0,-0.1,-0.1,0,-0.1,0,0,0,0,0,0,0.1,0,0,0,0,0,0],
	}
];

const ellipsoid = getEllipsoid(6378.137, 6356.7523142, 6371.2);
const range = {min: Infinity, max: 0};

for(let {start, end} of data){
	range.min = Math.min(range.min, start);
	range.max = Math.max(range.max, end);
}

range.min = new Date(range.min).toISOString();
range.max = new Date(range.max).toISOString();

function geomag(coord, date = Date.now()){
	const model = getModel(new Date(date));
	
	if(!model){
		const {min, max} = range;

		return {error: `Geomagnetic model is only valid from ${min} and ${max}`}
	}

	const point = getPoint(coord);
	const legendre = getLegendre(point, model.max1);
	const harmonic = getHarmonic(point, model.max1);
	const vector = getVector(point, model, legendre, harmonic);
	
	return compute(vector);
}
function compute (vector){
	const {x, y, z} = vector;
	const h = Math.sqrt(x * x + y * y);
	const f = Math.sqrt(h * h + z * z);
	const d = 180 / Math.PI * Math.atan2(y, x);
	const i = 180 / Math.PI * Math.atan2(z, h);

	return {
		x: x,
		y: y,
		z: z,
		decl: d,
		incl: i,
		horizIntensity: h,
		totalIntensity: f,
	};
}
function getPoint(coord){
	const lon = coord[0];
	const lat = coord[1];
	const elev = coord[2] || 0;
	const cos = Math.cos(lat * Math.PI / 180);
	const sin = Math.sin(lat * Math.PI / 180);
	const rc = ellipsoid.a / Math.sqrt(1 - ellipsoid.epsq * sin * sin);
	const xp = (rc + elev) * cos;
	const zp = (rc * (1 - ellipsoid.epsq) + elev) * sin;
	const radius = Math.sqrt(xp * xp + zp * zp);
	const x = 180 / Math.PI * Math.asin(zp / radius);
	const y = lon;

	return {lon, lat, x, y, elev, radius};
}
function getVector(point, model, legendre, harmonic){
	const {data, cos, sin} = harmonic;
	const {g1, h1, max1} = model;
	const cosLon = Math.cos(Math.PI/180 * point.x);
	const psi = Math.PI / 180 * (point.x - point.lat);
	let norm1 = 1.0;
	let norm2 = null;
	let norm3 = null;
	let bx = 0;
	let by = 0;
	let bz = 0;

	for(let n = 1; n <= max1; n++){
		for(let m = 0; m <= n; m++){
			const i = n * (n + 1) / 2 + m;
			
			bz -= data[n] * (g1[i] * cos[m] + h1[i] * sin[m]) * (n + 1) * legendre.pcup[i];
			by += data[n] * (g1[i] * sin[m] - h1[i] * cos[m]) * (m) * legendre.pcup[i];
			bx -= data[n] * (g1[i] * cos[m] + h1[i] * sin[m]) * legendre.dcup[i];
		}
	}

	if(Math.abs(cosLon) > 1e-10){
		by = by / cosLon;
	} else {
		const pcup = [1];
		const sinLon = Math.sin(Math.PI/180 * point.x);

		by = 0;

		for(let n = 1; n <= this.n_max; n++){
			const i = n * (n + 1) / 2 + 1;

			norm2 = norm1 * (2 * n - 1) / n;
			norm3 = norm2 * Math.sqrt(2 * n / (n + 1));
			norm1 = norm2;

			if(n === 1){
				pcup[n] = pcup[n-1];
			} else {
				const k = ((n - 1) * (n - 1) - 1) / ((2 * n - 1) * (2 * n - 3));
				pcup[n] = sinLon * pcup[n - 1] - k * pcup[n - 2];
			}

			by += data[n] * (g[i] * sin[1] - h[i] * cos[1]) * pcup[n] * norm3;
		}
	}

	return {
		z: bx * Math.sin(psi) + bz * Math.cos(psi),
		x: bx * Math.cos(psi) - bz * Math.sin(psi),
		y: by
	};
}
function getHarmonic(point, max){
	const {lon, radius} = point;

	const cos = Math.cos(Math.PI/180 * lon);
	const sin = Math.sin(Math.PI/180 * lon);
	const cosLat = [1, cos];
	const sinLat = [0, sin];
	const data = [(ellipsoid.r / radius) * (ellipsoid.r / radius)];

	for(let n = 1; n <= max; n++){
		data[n] = data[n - 1] * (ellipsoid.r / radius);
	}
	for(let m = 2; m <= max; m++){
		cosLat[m] = cosLat[m - 1] * cos - sinLat[m - 1] * sin;
		sinLat[m] = cosLat[m - 1] * sin + sinLat[m - 1] * cos;
	}

	return {data, cos: cosLat, sin: sinLat};
}
function getLegendre(point, max){
	const sin = Math.sin(Math.PI / 180 * point.x);
	const bool = max <= 16 || (1 - Math.abs(sin)) < 1e-10;
	
	return bool ? getLow(sin, max) : getHigh(sin, max);
}
function getLow(x, max){
	const norm = [1];
	const pcup = [1];
	const dcup = [0];
	const z = Math.sqrt((1 - x) * ( 1 + x));
	let i, i1, i2, k;

	for(let n = 1; n <= max; n++){
		for(let m = 0; m <= n; m++){
			i = n * (n + 1) / 2 + m;
			
			if(n === m){
				i1 = (n - 1) * n / 2 + m - 1;
				pcup[i] = z * pcup[i1];
				dcup[i] = z * dcup[i1] + x * pcup[i1];
			} else if (n === 1 && m === 0){
				i1 = (n - 1) * n / 2 + m;
				pcup[i] = x * pcup[i1];
				dcup[i] = x * dcup[i1] - z * pcup[i1];
			} else if (n > 1 && n !== m) {
				i1 = (n - 2) * (n - 1) / 2 + m;
				i2 = (n - 1) * n / 2 + m;
				
				if(m > n - 2){
					pcup[i] = x * pcup[i2];
					dcup[i] = x * dcup[i2] - z * pcup[i2];
				} else {
					k = ((n - 1) * (n - 1) - m * m) / ((2 * n - 1) * (2 * n - 3));
					pcup[i] = x * pcup[i2] - k * pcup[i1];
					dcup[i] = x * dcup[i2] - z * pcup[i2] - k * dcup[i1];
				}
			}
		}
	}
	
	for(let n = 1; n <= max; n++) {
		i = n * (n + 1) / 2;
		i1 = (n - 1) * n / 2;
		norm[i] = norm[i1] * (2 * n - 1) / n;
		
		for(let m = 1; m <= n; m++){
			i = n * (n + 1) / 2 + m;
			i1 = n * (n + 1) / 2 + m - 1;
			norm[i] = norm[i1] * Math.sqrt(((n - m + 1) * (m === 1 ? 2 : 1)) / (n + m));
		}	
	}

	for(let n = 1; n <= max; n++) {
		for(let m = 0; m <= n; m++) {
			i = n * (n + 1) / 2 + m;

			pcup[i] *= norm[i];
			dcup[i] *= -norm[i];
		}
	}

	return {pcup, dcup};
}
function getHigh(x, max){
	const z = Math.sqrt((1 - x) * (1 + x));
	const f1 = [];
	const f2 = [];
	const pre = [];
	const pcup = [1, x];
	const dcup = [0, z];
	let pm1 = x;
	let pm2 = 1;
	let k = 2;

	for(let n = 0; n <= 2 * max + 1; ++n){
		pre[n] = Math.sqrt(n);
	}

	for(let n = 0; n <= max; n++){
		k++;
		f1[k] = (2 * n - 1) / n;
		f2[k] = (n - 1) / n;
		
		for(m = 1; m <= n - 2; m++){
			k++;
			f1[k] = (2 * n - 1) / pre[n + m] / pre[n - m];
			f2[k] = pre[n - m - 1] * pre[n + m - 1] / pre[n + m] / pre[n - m];
		}
		
		k += 2;
	}
	
	k = 1;

	for(n = 2; n <= max; n++){
		k = k + n;
		plm = f1[k] * x * pm1 - f2[k] * pm2;
		pcup[k] = plm;
		dcup[k] = n * (pm1 - x * plm) / z;
		pm2 = pm1;
		pm1 = plm;
	}

	let scale = 1 / 1.0e-280;
	let pmm = pre[2] * 1.0e-280;
	let kstart = 0;

	for(let m = 1; m <= max - 1; ++m){
		scale *= z;
		kstart = kstart + m + 1;
		pmm = pmm * pre[2 * m + 1] / pre[2 * m];
		pcup[kstart] = pmm * scale / pre[2 * m + 1];
		dcup[kstart] = -(m * x * pcup[kstart] / z);
		pm2 = pmm / pre[2 * m + 1];
		k = kstart + m + 1;
		pm1 = x * pre[2 * m + 1] * pm2;
		pcup[k] = pm1 * scale;
		dcup[k] = (pm2 * scale * pre[2 * m + 1] - x * (m + 1) * pcup[k]) / z;

		for(let n = m + 2; n <= max; ++n){
			k = k + n;
			plm = x * f1[k] * pm1 - f2[k] * pm2;
			pcup[k] = plm * scale;
			dcup[k] = (pre[n + m] * pre[n - m] * pm1 * scale - n * x * pcup[k]) / z;
			pm2 = pm1;
			pm1 = plm;
		}
	}

	scale = scale * z;
	kstart = kstart + m + 1;
	pmm = pmm / pre[2 * max];
	pcup[kstart] = pmm * scale;
	dcup[kstart] = -max * x * pcup[kstart] / z;

	return {pcup, dcup};
}
function getModel(date){
	const ts = date.valueOf();
	const year = date.getFullYear();
	const base = new Date(year, 0, 1);
	const frac = (ts - base.valueOf()) / (1000 * 3600 * 24 * 365);
	const curr = year + frac;

	for(let model of data){
		if(ts >= model.start && ts <= model.end){
			const delta = curr - model.epoch;

			return setModel(model, delta);
		}
	}

	return null;
}
function setModel(model, delta){
	const {max1, max2} = model;
	const maxIdx = max2 * (max2 + 1) / 2 + max2;
	const out = Object.assign({}, model, {g1: [0], h1: [0], g2: [0], h2: [0]});

	for(let a = 1; a <= max1; a++){
		for(let b = 0; b <= a; b++){
			const idx = a * (a + 1) / 2 + b;
			const g1 = model.g1[idx];
			const h1 = model.h1[idx];
			const g2 = model.g2[idx];
			const h2 = model.h2[idx];

			if(idx <= maxIdx){
				out.g1[idx] = g1 + delta * g2;
				out.h1[idx] = h1 + delta * h2;
				out.g2[idx] = g2;
				out.h2[idx] = h2;
			} else {
				out.g1[idx] = g1;
				out.h1[idx] = h1;
			}
		}
	}

	return out;
}
function getEllipsoid(a, b, r){
	const out = {a, b, r};

	out.flat = (a - b) / a;
	out.inverseFlat = 1 / out.flat;
	out.epsq = (a * a - b * b) / (a * a);
	out.ep = Math.sqrt(out.epsq);

	return out;
}

var geo = /*#__PURE__*/Object.freeze({
	__proto__: null,
	Vec3: Vec3,
	addFeature: addFeature,
	along: along,
	angleDiff: angleDiff$1,
	antimeridianSplit: antimeridianSplit,
	antimeridianWrap: antimeridianWrap,
	arc: arc,
	arcDirect: arcDirect,
	area: area,
	areaPerimeter: areaPerimeter,
	azimForward: azimForward,
	azimReverse: azimReverse,
	bbox: bbox,
	bearing: bearing,
	between: between,
	bezier: bezier,
	buffer: buffer,
	calcAreaPerimeter: calcAreaPerimeter,
	calculateIntercept: calculateIntercept,
	centroid: centroid,
	centroidRadius: centroidRadius,
	checkPolygonSplit: checkPolygonSplit,
	circle: circle,
	circleCircle: circleCircle,
	circleFromPoints: circleFromPoints,
	circleNSEW: circleNSEW,
	clockwise: clockwise,
	clone: clone,
	closePolygon: closePolygon,
	closed: closed,
	concave: concave,
	contains: contains,
	coordAll: coordAll,
	coordEach: coordEach$1,
	crossesAntimeridian: crossesAntimeridian,
	crossesAntimeridian2: crossesAntimeridian2,
	degToDms: degToDms,
	deltaAngle: deltaAngle,
	deserialize: deserialize,
	destination: destination,
	difference: difference,
	direct: direct,
	direct2: direct2,
	directLine: directLine,
	distance: distance,
	dmsPrecision: dmsPrecision,
	dmsToDeg: dmsToDeg,
	endpoints: endpoints,
	envelope: envelope,
	equal: equal,
	exteriorRings: exteriorRings,
	feature: feature,
	featureCollection: featureCollection,
	flip: flip,
	flipX: flipX,
	flipY: flipY,
	formatCoord: formatCoord,
	forward: forward,
	fromGeodesic: fromGeodesic,
	fromSegments: fromSegments,
	fromVec: fromVec,
	geodesic: geodesic,
	geodesicLine: geodesicLine,
	geomag: geomag,
	getType: getType,
	greatCircle: greatCircle,
	interiorRings: interiorRings,
	intersectGeodesic: intersectGeodesic,
	intersectRhumb: intersectRhumb,
	intersection: intersection,
	inverse: inverse,
	inverse2: inverse2,
	inverseLine: inverseLine,
	isClosed: isClosed,
	isCoord: isCoord,
	isLine: isLine,
	isObject: isObject,
	isObjects: isObjects,
	isRing: isRing,
	isSegment: isSegment,
	isSegments: isSegments,
	kinks: kinks,
	length: length,
	line: line,
	lineAll: lineAll,
	lineCircle: lineCircle,
	lineEach: lineEach$1,
	lineLine: lineLine,
	lineLineFast: lineLineFast,
	lineLineIntersect: lineLineIntersect,
	lineString: lineString$1,
	mid: mid,
	midpoint: midpoint,
	minMax: minMax,
	move: move,
	multiLineString: multiLineString,
	multiPoint: multiPoint,
	multiPolygon: multiPolygon$1,
	objectAll: objectAll,
	objectEach: objectEach,
	objectsEach: objectsEach,
	options: options,
	overlap: overlap,
	parseCoord: parseCoord,
	parseDMS: parseDMS,
	perimeter: perimeter,
	point: point$1,
	pointAtVelocity: pointAtVelocity,
	pointCount: pointCount,
	pointDelta: pointDelta,
	pointInPolygon: pointInPolygon,
	pointLine: pointLine,
	pointOnLine: pointOnLine,
	pointPolygon: pointPolygon,
	pointPolygonRelate: pointPolygonRelate,
	polygon: polygon$1,
	polygonSplit: polygonSplit,
	regular: regular,
	reverse: reverse,
	rewind: rewind,
	rhumbBearing: rhumbBearing,
	rhumbDestination: rhumbDestination,
	rhumbDistance: rhumbDistance,
	rhumbMidpoint: rhumbMidpoint,
	ringAll: ringAll,
	ringEach: ringEach,
	rotate: rotate,
	rotateCCW: rotateCCW,
	rotateCW: rotateCW,
	round: round$2,
	roundCoord: roundCoord$1,
	rtree: rtree,
	same: same,
	scale: scale,
	scaleByDistance: scaleByDistance,
	sector: sector,
	segmentAll: segmentAll,
	segmentEach: segmentEach,
	segmentOverlap: segmentOverlap,
	segmentsEach: segmentsEach,
	serialize: serialize,
	setPrecision: setPrecision,
	simplify: simplify,
	smooth: smooth,
	threeCircles: threeCircles,
	tin: tin,
	toDeg: toDeg,
	toMercator: toMercator,
	toRad: toRad$2,
	toSegments: toSegments$2,
	toVec: toVec,
	topoSnap: topoSnap,
	touch: touch,
	touchOverlap: touchOverlap,
	triangulate: triangulate$1,
	union: union,
	uniqueCoords: uniqueCoords,
	unkink: unkink,
	unwrap: unwrap,
	unwrapCoord: unwrapCoord,
	uuid: uuid,
	wktToGeoJSON: wktToGeoJSON,
	wrap: wrap,
	xor: xor
});

const offsets = new Map([
	[0, 180],
	[1, 90],
	[2, 45],
	[3, 20],
	[4, 10],
	[5, 5],
	[6, 2.5],
	[7, 1],
	[8, 0.5],
	[9, 0.25]
]);

class Graticule{
	constructor(caller, opts){
		this.caller = caller;
		this.visible = opts.showGraticule;
		this.addLayers(caller);
		this.render();

		caller.map.on('move', this.render.bind(this));
	}
	addLines(features, zoom, min, max, lat){
		const offset = offsets.get(zoom) || 0.25;
		const a = lat ? -90 : -360;
		const b = lat ? 90 : 360;

		for(let deg = a; deg <= b; deg += offset){
			if(deg < min || deg > max){
				 continue;
			} else if(lat){
				this.addLine(features, deg, -180, 180, deg, true);
			} else {
				this.addLine(features, deg, -90, 90, deg, false);
			}
		}
	}
	addLine(features, deg, a, b, c, lat){
		const label = this.toDMS(deg, lat);
		const properties = {label};
		const coordinates = lat ? [[a, c], [b, c]] : [[c, a], [c, b]];
		const geometry = {type: 'LineString', coordinates};
		
		features.push({type: 'Feature', properties, geometry});
	}
	render(){
		if(!this.visible){ return; }

		const {caller} = this;
		const bounds = caller.getBounds();
		const zoom = Math.round(caller.getZoom());
		const minX = bounds.getWest();
		const maxX = bounds.getEast();
		const minY = bounds.getSouth();
		const maxY = bounds.getNorth();
		const features = [];
		const fc = {type: 'FeatureCollection', features};

		this.addLines(features, zoom, Math.floor(minX), Math.ceil(maxX), false);
		this.addLines(features, zoom, Math.floor(minY), Math.ceil(maxY), true);

		caller.setSourceData('graticule', fc);
	}
	toDMS(val, lat){
		if(val < -180 || val > 180){
			val = ((val + 180) % 360 + 360) % 360 - 180;
		}

		const {deg, min, sec, dir} = degToDms(val, lat);
		const pad = lat ? 2 : 3;
		const arr = [];

		arr.push(`${deg.toString().padStart(pad, '0')}`);

		if(min || sec){ arr.push(`${min.toString().padStart(2, '0')}`); }
		if(sec){
			const split = sec.toString().split('.');
			const a = split[0].padStart(2, '0');
			const b = split[1] ? `.${split[1]}` : '';

			arr.push(`${a}${b}`);
		}
		arr.push(dir);

		return arr.join('  ');
	}
	addLayers(caller){
		const layer1 = {
			id: 'graticule-line',
			source: 'graticule',
			type: 'line',
			minzoom: 0,
			paint: {
				lineColor: '#778899',
				lineWidth: 1
			}
		};
		const layer2 =  {
			id: 'graticule-label',
			source: 'graticule',
			type: 'symbol',
			minzoom: 0,
			layout: {
				textField: '{label}',
				textFont: ['DIN Pro Medium', 'Arial Unicode MS Regular'],
				textSize: 16,
				symbolPlacement: 'line-center'
			},
			paint: {
				textHaloColor: '#ffffff',
				textHaloWidth: 1.25,
				textColor: '#000000'
			}
		};

		caller.addSource('graticule');
		caller.addLayer(layer1);
		caller.addLayer(layer2);
	}
	show(){
		this.visible = true;
		this.render();
	}
	hide(){
		this.visible = false;
		this.caller.setSourceData('graticule');
	}
	toggle(){
		if(this.visible){
			this.hide();
		} else {
			this.show();
		}
	}
}

const groups = {
	administration: ['Administrative boundaries, admin'],
	placeLabels: [
		'Place labels, place-labels', 'Point of interest labels, poi-labels', 'Buildings, building-labels',
		'Natural features, natural-labels'
	],
	terrain: ['Terrain, land'],
	transportation: [
		'Road network, bridges', 'Road network, surface', 'Road network, surface-icons', 'Road network, tunnels',
		'Road network, tunnels-case', 'Transit, bridges', 'Transit, built', 'Transit, elevated', 'Transit, ferries',
		'Transit, ferry-aerialway-labels', 'Transit, surface', 'Walking, cycling, etc., barriers-bridges',
		'Walking, cycling, etc., surface', 'Walking, cycling, etc., tunnels'
	],
	transportationLabels: [
		'Road network, road-labels', 'Transit, transit-labels', 'Walking, cycling, etc., walking-cycling-labels'
	]
};

class BaseLayers{
	constructor(caller, opts){
		this.caller = caller;
		this.setIndex(opts);
		this.render();
	}
	setIndex(opts){
		const set = new Set(opts.hideBaseGroups || []);
		
		this.index = new Map();

		for(let [key, arr] of Object.entries(groups)){
			for(let val of arr){
				this.index.set(val, set.has(key) ? false : true);
			}
		}
	}
	render(){
		const map = this.caller.map;
		const {layers} = map.getStyle();

		for(let obj of layers){
			if(!obj.metadata){ continue; }

			const key = obj.metadata['mapbox:group'];

			if(!key){ return; }

			const bool = this.index.has(key) ? this.index.get(key) : true;
			const visible = bool ? 'visible' : 'none';

			map.setLayoutProperty(obj.id, 'visibility', visible);
		}
	}
	show(group){
		this.updateKeys(group, true);
	}
	hide(group){
		this.updateKeys(group, false);
	}
	updateKeys(group, visible){
		clearTimeout(this.timer);

		for(let key of groups[group] || []){
			this.index.set(key, visible);
		}

		this.timer = setTimeout(this.render.bind(this), 0);
	}
}

const conic = new Set(['albers', 'lambertConformalConic']);
const overlays = new Set();
const events$1 = ['click','dblclick','mousedown','mouseup','mousemove','movestart','moveend','move','zoom','contextmenu'];

class MapAPI{
	constructor(view, container){
		const {multiMap, navControl, scaleControl, fullscreenControl, coordFormat, id} = view.opts;
		const el = dom({tag: 'div', id: id, style: `map-container ${view.opts.theme}`}, container);
		const opts = Object.assign({container: el[0]}, view.opts);
		const map = new mapboxgl.Map(opts);
		const loadThreebox = globalThis.Threebox ? true : false;

		this.opts = opts;
		this.container = el;
		this.canvasContainer = $(map.getCanvasContainer());
		this.overlay = dom({tag: 'div', style: 'map-overlay'}, el);
		this.map = map;
		this.view = view;
		this.emit = view.emit.bind(view);
		this.layers = new Map();
		this.images = new Map();
		this.filters = new Map();
		this.sources = new Set();
		this.selected = false;
		this.coordFormat = coordFormat;

		if(multiMap){ el.addClass('k-widget map-border'); }
		if(navControl){ map.addControl(new mapboxgl.NavigationControl(navControl)); }
		if(scaleControl){ map.addControl(new mapboxgl.ScaleControl(scaleControl)); }
		if(fullscreenControl){ map.addControl(new mapboxgl.FullscreenControl()); }
		if(loadThreebox){
			this.threebox = new Threebox(map, map.getCanvas().getContext('webgl'), {defaultLights: true});
			this.threebox.defaultCursor = '';
		}

		map.setRenderWorldCopies(true);
		map.on('move', this.updateOverlays.bind(this));
		map.once('load', () => {
			for(let evt of events$1){ map.on(evt, this.eventHandle.bind(this)); }

			if(loadThreebox){
				map.addLayer({
					id: 'threebox',
					type: 'custom',
					render: () => { this.threebox.update(); }
				});
			}

			this.setMousePosition(opts);
			this.emit('load');
		});
		map.on('style.load', () => {
			if(this.baseLayers){
				this.baseLayers.render();
			} else {
				this.baseLayers = new BaseLayers(this, view.opts);
				this.graticule = new Graticule(this, view.opts);
			}
			
			this.setDEM();
			map.setFog({});
		});
	}
	clear3dLines(){
		if(!this.threebox){ return; }

		this.threebox.clear();
	}
	add3dLine(a, b, opts){
		if(!this.threebox){ return; }

		const obj1 = Object.assign({geometry: [a, b]}, opts);
		const obj2 = Object.assign({}, opts, {geometry: [[a[0], a[1], 0], a], opacity: 0.25, width: 1});
		const obj3 = Object.assign({}, opts, {geometry: [[a[0], a[1], 0], [b[0], b[1], 0]], opacity: 0.25, width: 1});

		this.threebox.add(this.threebox.line(obj1));

		if(opts.vertical){ this.threebox.add(this.threebox.line(obj2)); }
		if(opts.base){ this.threebox.add(this.threebox.line(obj3)); }
		this.map.triggerRepaint();
	}
	setDEM(){
		if(!this.opts.elevation){ return; }

		this.addSource('mapbox-dem', {
			type: 'raster-dem',
			url: 'mapbox://mapbox.mapbox-terrain-dem-v1',
			tileSize: 512,
			maxzoom: 20
		});
	
		this.map.setTerrain({source: 'mapbox-dem', exaggeration: 1});
	}
	setCursor(cursor){
		this.canvasContainer.css('cursor', cursor);

		if(this.threebox){ this.threebox.defaultCursor = cursor; }
	}
	setMousePosition(opts){
		const {elevation, elevationUnit, showPosition} = this.opts;
		const {lon, lat} = formatCoord(opts.center, this.coordFormat);
		const text = `${lat} ${lon}`;

		if(!showPosition){ return; }
		
		this.mapPosDiv = dom({tag: 'span', text: text, style: 'map-position'}, this.container);
		this.lastPos = opts.center;

		this.map.on('mousemove', (evt) => {
			const {lng, lat} = evt.lngLat;
			const pos = formatCoord([lng, lat], this.coordFormat);
			const elev = elevation ? this.getElevation([lng, lat], elevationUnit) : '';

			this.mapPosDiv.text(`${pos.lat} ${pos.lon}${elev}`);
			this.lastPos = [lng, lat];
		});
	}
	getElevation(coord, unit){
		const elev = this.map.queryTerrainElevation(coord) || 0;
		const val = Math.round(distance$1(elev, 'm', unit));

		return ` Elevation: ${val}${unit}`;
	}
	eventHandle(evt){
		const {type, lngLat, point} = evt;
		const {view, map} = this;

		if(!view.eventMap.has(type)){ return; }

		evt.coord = lngLat ? [lngLat.lng, lngLat.lat] : null;
		evt.mapInstance = this;
		evt.map = map;
		evt.x = point.x;
		evt.y = point.y;

		if(type === 'contextmenu'){ evt.originalEvent.preventDefault(); }
		if(type === 'movestart'){ this.moving = true; }
		if(type === 'moveend'){ this.moving = false; }

		this.emit(type, evt);
	}
	resize(){
		this.map.resize();
	}
	setStyle(style){
		const {sources, layers, images, filters, map} = this;
		const srcMap = new Map();

		this.opts.styleName = style.key;
		this.opts.style = style.uri;

		for(let key of sources){
			srcMap.set(key, map.getSource(key).serialize());
		}

		map.once('data', () => {
			for(let [key, obj] of images){ 
				map.addImage(key, obj.image, obj.opts);
			}
			for(let [id, obj] of srcMap){ map.addSource(id, obj); }
			for(let obj of layers.values()){ map.addLayer(obj); }
			for(let [layer, filter] of filters){ map.setFilter(layer, filter);}
		});

		map.setStyle(style.uri);
	}
	addLayer(opts){
		const {map, layers} = this;
	
		if(map.getLayer(opts.id)){
			console.error(`Map Layer: ${opts.id} already exists!`);
			return;
		}

		opts = this.fromCamelCase(opts);

		if(!map.getSource(opts.source)){
			this.addSource(opts.source);
		}

		map.addLayer(opts);
		layers.set(opts.id, opts);
	}
	setCoordFormat(val){
		const pos = formatCoord(this.lastPos, val);

		this.mapPosDiv.text(`${pos.lat} ${pos.lon}`);
		this.coordFormat = val;
	}
	setProjection(name){
		const obj = {name};

		this.opts.projection = name;

		if(conic.has(name)){
			obj.parallels = [90, 90];
		}

		this.map.setProjection(obj);
	}
	project(point){
		return this.map.project(point);
	}
	removeLayer(id){
		this.map.removeLayer(id);
		this.layers.delete(id);
	}
	addSource(id, opts = {}){
		const {map, sources} =  this;

		if(map.getSource(id)){
			console.error(`Map Source: ${id} already exists!`);
			return;
		}

		opts.type = opts.type || 'geojson';

		if(opts.type === 'geojson'){
			opts.data = opts.data || {type: 'FeatureCollection', features: []};
		}

		map.addSource(id, opts);
		sources.add(id);
	}
	removeSource(id){
		this.map.removeSource(id);
		sources.delete(id);
	}
	getSource(id){
		return this.map.getSource(id);
	}
	addImage(name, path, opts){
		return new Promise((resolve) => {
			this.map.loadImage(path, (err, image) => {
				this.images.set(name, {image, opts});
				this.map.addImage(name, image, opts);
				resolve();
			});
		});
	}
	setSourceData(id, data){
		this.map.getSource(id).setData(data || {type: 'FeatureCollection', features: []});
	}
	updateSourceData(id, data){
		this.map.getSource(id).updateData(data || {type: 'FeatureCollection', features: []});
	}
	getStyle(style){
		return styleMap.get(style);
	}
	getBounds(){
		return this.map.getBounds();
	}
	getCenter(){
		return this.map.getCenter();
	}
	getSize(){
		return {height: this.map._containerHeight, width: this.map._containerWidth};
	}
	getZoom(){
		return this.map.getZoom();
	}
	setBounds(bounds){
		this.map.fitBounds(bounds);
	}
	setCenter(center){
		this.map.setCenter(center);
	}
	setZoom(zoom){
		this.map.setZoom(zoom);
	}
	query(bbox, layers, rendered = true){
		return this.map.queryRenderedFeatures(bbox, {layers});
	}
	showBaseLayer(group){
		this.baseLayers.show(group);
	}
	hideBaseLayer(group){
		this.baseLayers.hide(group);
	}
	showGraticule(){
		this.graticule.show();
	}
	hideGraticule(){
		this.graticule.hide();
	}
	addMarker(coord, properties){
		const marker = new mapboxgl.Marker(properties);

		marker.setLngLat(coord);
		marker.addTo(this.map);

		return marker;
	}
	removeMarker(marker){
		for(let item of Array.isArray(marker) ? marker : [marker]){
			if(!item){ continue; }
			item.remove();
		}
	}
	fromCamelCase(obj){
		const out = {};

		for(let [key, val] of Object.entries(obj)){
			if(val === null){ continue; }

			if(val instanceof Object){
				val = Array.isArray(val) ? val : this.fromCamelCase(val);
			}
			
			out[fromCamelCase(key, '-')] = val;
		}

		return out;
	}
	setPaintProperty(layer, property, value){
		this.map.setPaintProperty(layer, property, value);
	}
	setLayoutProperty(layer, property, value){
		this.map.setLayoutProperty(layer, property, value);
	}
	setFilter(layer, filter){
		this.filters.set(layer, filter);
		this.map.setFilter(layer, filter);
	}
	clearCache(id){
		const ts = Date.now();
		const src = this.map.getSource(id);

		if(!src.origTiles){ src.origTiles = src.tiles.slice(); }

		src.setTiles(src.origTiles.map((a) => { return `${a}&ts=${ts}`; }));
	}
	addOverlay(point, text){
		const overlay = new Overlay(this, point, text);

		overlays.add(overlay);

		return overlay;
	}
	removeOverlay(overlay){
		overlay.destroy();
		overlays.delete(overlay);
	}
	updateOverlays(){
		for(let item of overlays){ item.setPosition(); }
	}
	screenshot(format){
		const map = this.map;
		const canvas = map.getCanvas();
		
		return new Promise((resolve) => {
			map.once('render', () => { canvas.toBlob(resolve, format, 1); });
			map.triggerRepaint();
		});
	}
}

class Overlay{
	constructor(map, point, text){
		this.map = map;
		this.el = dom({tag: 'div', class: 'overlay'},map.overlay);
		this.x = 0;
		this.y = 0;
		this.update(point, text);
	}
	update(point, text){
		this.el.text(text);
		this.point = point;
		this.setPosition();
	}
	setPosition(){
		const {x, y} = this.map.project(this.point);
		const dx = Math.abs(this.x - x);
		const dy = Math.abs(this.y - y);
		const delta = Math.max(dx, dy);

		if(delta <= 0.5){ return; }

		this.x = x;
		this.y = y;
		this.el.css({top: `${this.y - 10}px`, left: `${this.x + 20}px`});
	}
	destroy(){
		this.el.remove();
	}
}

function mapAPI(view, container){
	return new MapAPI(view, container);
}

const layers = [
	{id: 'fe-fill', type: 'fill', select: true},
	{id: 'fe-line', type: 'line', select: true},
	{id: 'fe-point', type: 'circle'}
];

class Layers{
	constructor(caller){
		this.caller = caller;
		this.map = caller.api.active;
		this.layers = new Map([[1, []], [2, []]]);
		this.markers = [];

		this.addLayers();
	}
	addLayers(){
		for(let obj of layers){
			const {id, type, select} = obj;
			const layer = {type, filter: this.getFilters(obj)};

			switch(type){
				case 'fill':
					layer.paint = {
						fillColor: {type: 'identity', property: 'fillColor'},
						fillOpacity: {type: 'identity', property: 'fillOpacity'}
					};
					layer.filter = ['all', ['==', '$type', 'Polygon']];
				break;
				case 'line':
					layer.layout = {lineJoin: 'round', lineCap: 'round'};
					layer.paint = {
						lineColor: {type: 'identity', property: 'lineColor'},
						lineOpacity: {type: 'identity', property: 'lineOpacity'},
						lineWidth: 3,
						lineBlur: 1
					};
				break;
				case 'circle':
					layer.paint = {
						circleStrokeColor: {type: 'identity', property: 'lineColor'},
						circleStrokeOpacity: {type: 'identity', property: 'lineOpacity'},
						circleColor: {type: 'identity', property: 'fillColor'},
						circleOpacity: {type: 'identity', property: 'fillOpacity'},
						circleStrokeWidth: {type: 'identity', property: 'circleStrokeWidth'},
						circleRadius: {type: 'identity', property: 'circleRadius'}
					};
					layer.filter = ['all', ['==', '$type', 'Point']];
				break;
			}

			for(let [key, list] of this.layers){
				layer.source = `drawingTool${key}`;
				layer.id = `${id}${key}`;
	
				if(select){ list.push(layer.id); }
				this.map.addLayer(layer);
			}
		}
	}
	getFilters(def){
		const out = ['all'];

		if(def.label){
			out.push(['has', 'label']);
		}

		if(def.type === 'circle'){
			out.push(['==', '$type', 'Point']);
		}

		return out;
	}
	getFeatures(idx, evt, first = false){
		const {coord, x, y} = evt;
		const bbox = [[x - 5, y - 5], [x + 5, y + 5]];
		const hits = this.map.query(bbox, this.layers.get(idx));
		const set = new Set();
		const out = [];

		if(!hits.length){
			return out;
		} else if(idx === 2){
			return hits;
		}

		for(let hit of hits){
			const {id} = hit.properties;

			if(id){ set.add(id); }
		}

		for(let id of Array.from(set).sort()){
			const obj = this.caller.features.get(id);
			const {geomClass, renderCoords} = obj;

			if(geomClass === 'polygon'){
				if (pointInPolygon(coord, renderCoords)){
					out.push(obj);
				}
			} else {
				out.push(obj);
			}
		}

		return first ? out.shift() : out;
	}
	getStyle(lineColor, fillColor, lineOpacity = 1, fillOpacity = 0.2, circleRadius = 5, circleStrokeWidth = 2){
		return {
			lineColor: lineColor,
			lineOpacity: lineOpacity,
			fillColor: fillColor || lineColor,
			fillOpacity: fillOpacity,
			circleRadius: circleRadius,
			circleStrokeWidth: circleStrokeWidth
		};
	}
	addMarker(coord, draggable, color){
		const marker = this.map.addMarker(coord, {draggable, color, scale: 0.7});

		this.markers.push(marker);

		return marker;
	}
	clearMarkers(){
		this.map.removeMarker(this.markers);
		this.markers = [];
	}
	removeMarker(marker){
		this.map.removeMarker(marker);
	}
	setData(key, featureCollection$1 = featureCollection()){
		for(let feature of featureCollection$1.features){
			const {geometry} = feature;

			if(geometry.type === 'Point'){ continue; }

			geometry.coordinates = antimeridianWrap(geometry.coordinates);
		}

		this.map.setSourceData(`drawingTool${key}`, featureCollection$1);
	}
	destroy(){
		for(let key of this.layers.keys()){
			for(let obj of layers){
				this.map.removeLayer(`${obj.id}${key}`);
			}

			this.map.removeSource(`drawingTool${key}`);
		}
	}
}

function layers$1(api){
	return new Layers(api);
}

const points2 = new Set(['circle','rectangle','regular']);
const points3 = new Set(['sector']);

class Composer extends EventEmitter{
	constructor(caller){
		super();

		const {getStyle} = caller.layers;
		
		this.caller = caller;
		this.style1 = getStyle('#ff9900');
		this.style2 = getStyle('#ff0000');
		this.style3 = getStyle('#1174ac');
	}
	activate(){
		const {caller} = this;

		this.out = null;
		this.active = true;
		this.origin = null;
		this.points = [];
		this.gtype = caller.get('gtype');
		this.units = caller.get('units');
		this.prev = null;
		
		caller.set('regular', this.gtype === 'regular');
		caller.set('mode', 'draw');
		caller.dragPan(false);
		caller.layers.setData(2);
	}
	mousedown(evt){
		const close = this.checkSnapClose(evt);

		this.addPoint(evt);
		this.render();

		if(close){ this.complete(); }
	}
	mousemove(evt){
		if(this.points.length === 0){ return; }

		this.checkSnapClose(evt);
		this.render(evt.coord);
	}
	dblclick(){
		this.render();
		this.complete();
	}
	addPoint(evt){
		const {x, y, coord} = evt;
		const {prev, origin} = this;

		this.origin = origin || evt;

		if(prev){
			const dx = Math.abs(prev.x - x);
			const dy = Math.abs(prev.y - y);
			const delta = Math.max(dx, dy);

			if(delta <= 1){ return; }
		}

		this.points.push(coord);
		this.prev = {x, y};
	}
	render(point){
		const {caller, gtype, points} = this;
		const arr = points.slice(0);
		const len = arr.length + (point ? 1 : 0);
		const out = {type: this.gtype, coords: arr, valid: true};

		if(point){ arr.push(point); }

		if(len === 1){
			if(gtype !== 'point'){ return; }

			out.type = 'point';
			out.coords = arr[0];
		} else if(len === 2){
			switch(gtype){
				case 'circle':
					this.setCircle(arr, out);
				break;
				case 'rectangle':
					out.type = 'polygon';
					out.coords = bbox(arr).polygon()[0];
				break;
				case 'regular':
					this.setRegular(arr, out);
				break;
				default:
					out.type = 'lineString';
				break;
			}
		}

		if(out.type === 'polygon'){ this.closePolygon(out); }

		const coords = this.geodesic(gtype, len, out.coords);

		out.feature = geo[out.type](coords, out.valid ? this.style1 : this.style2);
		caller.layers.setData(2, featureCollection(out.feature));
		
		this.out = out;
	}
	checkSnapClose(evt){
		const {gtype, origin, points} = this;
		const len = points.length + 1;

		if(gtype === 'point'){ return true; }
		if(gtype === 'polygon' && len <= 2){ return false;}
		if(len === 2 && points2.has(gtype)){ return true; }
		if(len === 3 && points3.has(gtype)){ return true; }
		if(origin === null){ return false; }

		const delta = Math.max(
			Math.abs(evt.x - origin.x),
			Math.abs(evt.y - origin.y)
		);

		if(delta > 10){ return false; }

		evt.point = origin.point;
		evt.coord = origin.coord;

		return true;
	}
	setCircle(points, out){
		const {units} = this;
		out.units = units;
		out.center = this.origin.coord;
		out.radius = distance(points[0], points[1], units);
		out.coords = circle(points[0], out.radius, units, 1);
		out.type = 'polygon';
	}
	setRegular(points, out){
		const {units} = this;
		const sides = this.caller.get('sides');
		const radius = distance(points[0], points[1], units);

		out.coords = regular(points[0], radius, sides, units);
		out.type = 'polygon';
	}
	closePolygon(out){
		const {endpoints, equal, kinks} = geo;
		const ep = endpoints(out.coords);

		if(!equal(ep.a, ep.b, 0)){ out.coords.push(out.coords[0]); }

		if(this.gtype === 'polygon'){
			out.valid = kinks(out.coords) ? false : true;

			if(!out.valid){
				out.type = 'lineString';
				return;
			}
		}

		out.coords = [out.coords];
	}
	geodesic(gtype, len, coords){
		if(!this.caller.get('geodesic') || (len === 1 || gtype === 'circle')){
			return coords;
		} else {
			return geodesic(coords);
		}
	}
	complete(){
		const {out, gtype} = this;

		if(out){
			const obj = {
				type: out.feature.geometry.type,
				coordinates: out.coords,
				geodesic: gtype === 'point' ? false : this.caller.get('geodesic')
			};

			if(out.center){
				obj.center = out.center;
				obj.radius = out.radius;
				obj.units = out.units;
				obj.geodesic = false;
			}

			this.emit('feature', obj);
		}

		this.activate();
	}
	eventHandle(evt){
		const {type} = evt;

		if(!this.active || type === 'mouseup'){ return; }

		this[type](evt);
	}
}

function composer(caller){
	return new Composer(caller);
}

let Editor$1 = class Editor{
	constructor(caller){
		const {layers} = caller;

		this.caller = caller;
		this.layers = layers;
		this.style1 = layers.getStyle('#ffffff', '#ff9900', 1, 1, 4, 2);
		this.style2 = layers.getStyle('#ffffff', '#ff9900', 1, 1, 3, 2);
	}
	activate(feature){
		this.feature = feature;
		this.feature.edit = true;
		this.mode = feature.radius ? 'circle' : feature.geomClass;
		this.node = null;
		this.render();
	}
	deactivate(){
		if(!this.feature){ return; }

		this.feature.edit = false;
		this.layers.setData(2);
		this.caller.render();

		delete this.feature;
	}
	render(){
		this.arr = [];
		this.fc = featureCollection();

		if(this.mode === 'circle'){
			this.setCircleControls();
		} else {
			this.setSegmentControls();
		}

		this.layers.setData(2, this.fc);
		this.caller.render();
	}
	setSegmentControls(){
		const {fc, mode, feature} = this;
		const {geodesic, coordinates} = feature;
		
		this.lineRings = this.mode === 'line' ? lineAll([coordinates]) : ringAll(coordinates);

		for(let idx1 = 0; idx1 < this.lineRings.length; idx1++){
			const lineRing = this.lineRings[idx1];
			const offset = mode === 'line' ? 0 : 1;

			for(let idx2 = 0; idx2 < lineRing.length - offset; idx2++){
				const a = lineRing[idx2];
				const b = lineRing[idx2 + 1];
				const prop1 = Object.assign({action: 1, idx1, idx2}, this.style1);

				addFeature(fc, point$1(a, prop1));

				if(b){
					const mid = geodesic ? midpoint(a, b) : rhumbMidpoint(a, b);
					const prop2 = Object.assign({action: 2, idx1, idx2: idx2 + 1, mid}, this.style2);

					addFeature(fc, point$1(mid, prop2));
				}
			}
		}
	}
	setCircleControls(){
		const {feature, fc, style1} = this;
		const {center, radius, units} = feature;
		const p1 = center;
		const p2 = destination(center, 90, radius, units);
		const prop1 = Object.assign({action: 1}, style1);
		const prop2 = Object.assign({action: 2}, style1);

		addFeature(fc, point$1(p1, prop1));
		addFeature(fc, point$1(p2, prop2));
	}
	setNode(evt){
		const hit = this.layers.getFeatures(2, evt)[0];

		if(!hit){ return; }

		const {action, idx1, idx2} = hit.properties;

		if(this.mode !== 'circle' && action === 2){
			const arr = this.lineRings[idx1];

			arr.splice(idx2, 0, evt.coord);

			this.render();
		}

		this.node = {action, idx1, idx2};
	}
	mousemove(evt){
		const {feature} = this;
		const {coord} = evt;
		const {action, idx1, idx2} = this.node;

		if(this.mode === 'circle'){
			if(action === 1){
				feature.center = coord;
			} else {
				feature.radius = distance(feature.center, coord, feature.units);
			}

			feature.coordinates = [circle(feature.center, feature.radius, feature.units)];
		} else {
			this.lineRings[idx1].splice(idx2, 1, coord);
		}

		this.render();
	}
	eventHandle(evt){
		const {type} = evt;

		if(type === 'mousedown'){
			this.setNode(evt);
		} else if(type === 'mouseup'){
			this.node = null;
		} else if(this.node && type === 'mousemove'){
			this.mousemove(evt);
		}
	}
};

function editor(caller){
	return new Editor$1(caller);
}

class Selector{
	constructor(caller){
		this.caller = caller;
		this.layers = caller.layers;
		this.selected = new Set();
	}
	getFirst(){
		const [out] = this.selected;

		return out;
	}
	copy(){
		const {caller} = this;
		const obj = JSON.parse(JSON.stringify(this.getFirst()));
		const id = caller.seq++;

		obj.id = id;
		obj.selected = false;
		caller.features.set(id, obj);
		caller.render();
	}
	delete(){
		const {features} = this.caller;

		for(let [key, obj] of features){
			if(obj.selected){ features.delete(key); }
		}

		this.selected.clear();
	}
	deselect(){
		const {caller} = this;

		for(let obj of caller.features.values()){
			obj.selected = false;
		}

		this.selected.clear();

		caller.render();
	}
	select(hits){
		const {caller} = this;
		const groups = {a: [], b: []};

		if(!hits.length){ return; }

		for(let obj of hits){
			const ab = obj.selected ? 'b' : 'a';

			groups[ab].push(obj);
		}

		groups.b.reverse();

		if(groups.a.length){
			groups.a[0].selected = true;
		} else {
			groups.b[0].selected = false;
		}

		for(let obj of hits){
			if(obj.selected){
				this.selected.add(obj);
			} else {
				this.selected.delete(obj);
			}
		}

		caller.setState(true);
	}
	polygonize(){
		const obj = this.getFirst();

		delete obj.center;
		delete obj.radius;
		delete obj.units;
	}
	setGeodesic(checked){
		this.getFirst().geodesic = checked;
	}
	setBuffer(checked){
		const buffer = this.caller.get('buffer').toJSON();

		this.getFirst().buffer = checked ? buffer : false;
	}
	setPrecision(checked){
		const precision = this.caller.get('precision').toJSON();

		this.getFirst().precision = checked ? precision : false;
	}
	rotate(arg){
		const feature = this.getFirst();

		feature.coordinates = geo[arg](feature.coordinates);
	}
	flip(arg){
		const feature = this.getFirst();

		feature.coordinates = geo[arg](feature.coordinates);
	}
	operation(arg){
		const arr = Array.from(this.selected);
		const a = arr[0];
		const b = arr[1];
		const coords1 = a.geodesic ? geodesic(a.coordinates) : a.coordinates;
		const coords2 = b.geodesic ? geodesic(b.coordinates) : b.coordinates;
		const multi = geo[arg](coords1, coords2);

		this.addMultiPolygon(multi, a.geodesic);
	}
	split(){
		const {line, polygon, geodesic} = this.getLinePoly();
		const multi = polygonSplit(polygon, line, geodesic);

		this.addMultiPolygon(multi, geodesic);
	}
	addMultiPolygon(multi, geodesic){
		const type = 'Polygon';
		this.delete();

		for(let coords of multi){
			this.caller.addFeature({type, geodesic, coordinates: fromGeodesic(coords, 0.2)});
		}
	}
	checkSplit(){
		const {line, polygon} = this.getLinePoly();

		return line ? checkPolygonSplit(polygon, line) : false;
	}
	getLinePoly(){
		if(this.selected.size !== 2){ return {}; }

		const out = {geodesic: false};

		for(let {geomClass, coordinates, geodesic} of this.selected){
			out[geomClass] = coordinates;
			out.geodesic = geodesic || out.geodesic; 
		}

		return out.line && out.polygon ? out : {};
	}
	eventHandle(evt){
		const hits = this.layers.getFeatures(1, evt, false) || [];

		switch(evt.type){
			case 'mousemove':
				this.caller.setCursor(hits.length ? 'pointer' : '');
			break;
			case 'mousedown':
				this.select(hits);
			break;
		}
	}
}

function selector(caller){
	return new Selector(caller);
}

const angles =[0, 90, 180, 270];

class Editor{
	constructor(caller){
		const {layers} = caller;
		
		this.caller = caller;
		this.layers = layers;
		this.style = caller.layers.getStyle('#ff8c00');
	}
	activate(feature){
		this.feature = feature;
		this.feature.edit = true;
		this.base = clone(feature.coordinates);
		this.markers = new Map();
		this.angle1 = 45;
		this.angle2 = 45;

		this.setOrigin();
	}
	deactivate(){
		if(!this.feature){ return; }

		this.feature.edit = false;
		this.layers.setData(2);
		this.layers.clearMarkers();
		this.caller.render();

		delete this.feature;
		delete this.base;
	}
	scale(marker){
		const pos = marker.getLngLat().toArray();
		const dist = distance(this.centroid, pos);

		this.transform({mode: 'scale', factor: dist / this.radius});
	}
	rotate(marker){
		const {centroid, radius, angle1} = this;
		const pos = marker.getLngLat().toArray();
		const angle = bearing(centroid, pos) - angle1;
		const pab = destination(centroid, angle + angle1, radius);

		marker.setLngLat(pab);

		this.angle2 = angle + angle1;
		this.transform({mode: 'rotate', angle: angle});
	}
	move(marker){
		const pos = marker.getLngLat().toArray();

		this.transform({mode: 'move', p1: this.centroid, p2: pos});
	}
	transform(opts){
		const {centroid, base} = this;
		const {mode, angle, factor, p1, p2} = opts;
		const dx = p1 ? p2[0] - p1[0] : null;
		const dy = p1 ? p2[1] - p1[1] : null;
		let coords = null;

		if(mode === 'move'){
			coords = move(base, dx, dy);
		} else if(mode === 'scale'){
			coords = scale(base, factor, centroid);
		} else if(mode === 'rotate'){
			coords = rotate(base, angle, centroid);
		}

		this.feature.coordinates = coords;

		if(mode !== 'rotate'){ this.render(); }

		this.caller.render();
	}
	setOrigin(){
		const {centroid, radius, units} = centroidRadius(this.feature.coordinates, 'm');

		this.centroid = centroid;
		this.radius = radius;
		this.units = units;

		this.setMarkers();
		this.render();
	}
	render(){
		const {centroid, radius, units} = centroidRadius(this.feature.coordinates, 'm');
		const circle$1 = circle(centroid, radius, units);
		const poly = lineString$1(circle$1, this.style);

		console.log({centroid, radius, units, circle: circle$1, poly});

		this.layers.setData(2, featureCollection(poly));

		if(!this.markers.size){ return; }

		for(let a of this.markers.values()){
			const {prefix, idx} = a;
			let pos = null;

			if(prefix === 'a'){
				continue;
			} else if(prefix === 'b'){
				pos = destination(centroid, angles[idx], radius, units);
			} else if(prefix === 'c'){
				pos = destination(centroid, this.angle1, radius, units);
			}

			a.setLngLat(pos);
		}
	}
	setMarkers(){
		const {centroid, radius, units, angle1} = this;
		const pos = destination(centroid, angle1, radius, units);

		this.setMarker('a', centroid, 'move', '#4cbb17');

		for(let i = 0; i < 4; i++){
			const pos = destination(centroid, angles[i], radius, units);
			const marker = this.setMarker(`b${i}`, pos, 'scale', '#1e90ff');
			marker.idx = i;
		}

		this.setMarker('c', pos, 'rotate', this.style.fillColor);
	}
	setMarker(key, pos, mode, color){
		const marker = this.layers.addMarker(pos, true, color);

		marker.on('drag', this[mode].bind(this, marker));
		marker.on('dragend', this.dragend.bind(this));
		marker.prefix = key.substring(0, 1);

		this.markers.set(key, marker);

		return marker;
	}
	dragend(){
		this.layers.clearMarkers();
		this.base = clone(this.feature.coordinates);
		this.angle1 = this.angle2 || 45;
		this.markers.clear();
		this.setOrigin();
	}
}

function transformer(caller){
	return new Editor(caller);
}

function view$1(caller){
	return [
		{el: 'div', flex: 'col', height: '100%', items: [
			{
				el: 'div',
				flex: 'row',
				alignItems: 'center',
				justifyContent: 'space-between',
				style: 'k-picker-solid',
				borderStyle: 'solid',
				borderWidth: '0 0 1px 0',
				padding: '5px 10px',
				items: [
					{el: 'div', text: 'Coordinates', fontSize: '1.1em'},
					{el: 'button', options: {icon: 'x', fillMode: 'flat'}, bind: {click: 'deactivate'}}
				]
			},
			{
				el: 'div',
				id: caller.id,
				flex: 'col',
				stretch: true,
				padding: 10,
				gap: 10,
				items: getEditor(caller)
			}
		]}
		
	];
}
function getEditor(caller){
	switch(caller.mode){
		case 'circle':
		case 'point':
			return pointCircle(caller);
		case 'polygon':
		case 'line':
			return polyLine(caller);
		
	}
}
function pointCircle(caller){
	const point = caller.mode === 'point';
	const label = caller.iso === 'ca' ? 'Centre' : 'Center';
	const a = {
		el: 'textBox',
		name: 'lat',
		width: 200,
		uppercase: true,
		bind: {value: 'data.lat'},
		options: {
			label: point ? 'Latitude' : `${label} Latitude`
		}
	};
	const b = {
		el: 'textBox',
		name: 'lon',
		width: 200,
		uppercase: true,
		bind: {value: 'data.lon'},
		options: {
			label: point ? 'Longitude' : `${label} Longitude`
		}
	};
	const c = {
		el: 'numericTextBox',
		width: 200,
		bind: {value: 'data.radius'},
		options: {
			label: 'Radius',
			format: 'n2',
			min: 0
		}
	};
	const d = {
		el: 'dropDownList',
		width: 200,
		bind: {value: 'data.units'},
		options: {
			autoWidth: true,
			valuePrimitive: true,
			dataTextField: 'val',
			dataValueField: 'val',
			label: 'Units',
			template: ({text, val}) => `<span>${text} (${val})</span>`,
			valueTemplate: ({text, val}) => `<span>${text} (${val})</span>`,
			dataSource: [
				{val: 'm', text: 'Meter'},
				{val: 'km', text: 'Kilometer'},
				{val: 'ft', text: 'Feet'},
				{val: 'mi', text: 'Mile'},
				{val: 'NM', text: 'Nautical Mile'}
			]
		}
	};
	const e = {
		el: 'button',
		text: 'Apply',
		bind: {click: 'updatePointCircle'},
		options: {
			themeColor: 'primary'
		}
	};

	return point ? [a, b, e] : [a, b, c, d, e];
}
function polyLine(caller){
	const validation = {coord: caller.validate.bind(caller)};
	const dataSource = {
		sort: {field: 'sort', dir: 'asc'},
		schema: {
			model: {
				id: 'id',
				fields: {
					id: {type: 'string'},
					lon: {type: 'string', name: 'lon', validation},
					lat: {type: 'string', name: 'lat', validation},
					sort: {type: 'number'}
				}
			}
		}
	};

	if(caller.mode === 'polygon'){
		dataSource.group = {field: 'ring'};
	}

	return {
		el: 'grid',
		id: `grid-${caller.id}`,
		options: {
			height: '100%',
			width: 285,
			scrollable: true,
			navigatable: true,
			dataSource: dataSource,
			editable: 'incell',
			edit: caller.onEdit.bind(caller),
			cellClose: caller.updateCoord.bind(caller),
			columns: [
				{title: 'Latitude', field: 'lat', width: 125},
				{title: 'Longitude', field: 'lon', width: 125}
			]
		}
	};
}

const latLon = {
	lat: {
		min: -90,
		max: 90,
		regex: /^(\d{2})(\d{2})(\d{2})[NS]{1}$/
	},
	lon: {
		min: -180,
		max: 180,
		regex: /^(\d{3})(\d{2})(\d{2})[EW]{1}$/
	}
};

class CoordEditor extends Model{
	constructor(caller){
		super();

		this.caller = caller;
		this.style = caller.layers.getStyle('#ffffff', '#ff9900', 1, 1, 4, 2);
		this.container = caller.api.elements.get('right');
		this.active = false;
	}
	setPointCircle(){
		const {center, radius, units} = this.feature;
		const dms = formatCoord(center, 5);
		const lon = this.dms ? dms.lon : center[0].toFixed(6);
		const lat = this.dms ? dms.lat : center[1].toFixed(6);

		this.set('data', {lon, lat, radius, units});
		this.setValidator();
	}
	setPolyLine(){
		const line = this.mode === 'line';
		const grid = viewManager.get(`grid-${this.id}`);
		const data = [];
		let sort = 0;

		for(let a = 0; a < this.coords.length; a++){
			const ring = this.coords[a];
			const group = a === 0 ? 'Exterior' : `Hole ${a}`;

			for(let b = 0; b < ring.length - (line ? 0 : 1); b++){
				const coord = ring[b];
				const dms = formatCoord(coord, 5);
				const obj = {
					id: `${a}:${b}`,
					a: a,
					b: b,
					ring: group,
					sort: sort++,
					lon: this.dms ? dms.lon : coord[0].toFixed(6),
					lat: this.dms ? dms.lat : coord[1].toFixed(6)
				};

				data.push(obj);
			}
		}

		grid.dataSource.data(data);
	}
	updatePointCircle(){
		if(!this.validator.validate()){ return null; }

		const {mode, dms, feature} = this;
		const {lon, lat, radius, units} = this.get('data');
		const coord = [
			Number(dms ? parseDMS(lon) : lon),
			Number(dms ? parseDMS(lat) : lat)
		];

		if(mode === 'point'){
			feature.coordinates = coord;
		} else {
			feature.center = coord;
			feature.radius = radius;
			feature.units = units;
			feature.coordinates = [circle(coord, radius, units)];
		}

		this.caller.render();
	}
	updateCoord(evt){
		const {model} = evt;
		const {dms} = this;
		const {a, b, lon, lat} = model;
		const ring = this.coords[a];
		const last = ring.length - 1;
		const coord = [
			Number(dms ? parseDMS(lon) : lon),
			Number(dms ? parseDMS(lat) : lat)
		];

		ring[b] = coord;

		if(b === 0 && this.mode === 'polygon'){ ring[last] = coord; }
		
		if(dms){
			model.set('lon', lon.toUpperCase());
			model.set('lat', lat.toUpperCase());
		}

		model.set('dirty', false);

		this.clear();
		this.caller.render();
	}
	editor(container, options){
		const {field, model} = options;
		const type = this.dms ? 'textBox' : 'numericTextBox';
		const opts = {
			value: model[field],
			format: 'n6',
			decimals: 6,
			min: field === 'lat' ? -90 : -180,
			max: field === 'lat' ? 90 : 180
		};

		viewManager.load(this, [{el: type, uppercase: true, options: opts}], container);
	}
	setValidator(){
		this.validator = viewManager.validator(this.id, {
			validateOnBlur: true,
			rules:{
				coord: this.validate.bind(this)
			}
		});
	}
	validate(el){
		const {dms} = this;
		const key = el.attr('name');

		if(key !== 'lat' && key !== 'lon'){ return true; }

		const val = el.val().toUpperCase();
		const {regex, min, max} = latLon[key];
		const m = dms ? val.match(regex) : val.match(/^[-]*\d+[.]*\d*$/);

		el.attr('data-coord-msg', `Invalid ${key === 'lat' ? 'latitude' : 'longitude'}`);

		if(!m){
			return false;
		} else if(dms){
			const a = Number(m[1]);
			const b = Number(m[2]);
			const c = Number(m[3]);
			
			if(a > max || b > 59 || c > 59){
				return false; 
			} else if(a === max && (b || c)){
				return false;
			} else {
				return true;
			}
		} else {
			const num = Number(val);

			return num >= min && num <= max;
		}
	}
	onEdit(evt){
		const el = evt.container.find('input');
		const {a, b} = evt.model;
		const coord = this.coords[a][b];
		const point = point$1(coord, this.style);

		el.css('text-transform', 'uppercase');

		this.caller.layers.setData(2, featureCollection([point]));
	}
	clear(){
		this.caller.layers.setData(2);
	}
	toggle(feature, bool){
		if(bool){
			this.activate(feature);
		} else {
			this.deactivate();
		}
	}
	activate(feature){
		const {center, geomClass} = feature;

		if(this.active){ return; }

		this.mode = center ? 'circle' : geomClass;
		this.feature = feature;
		this.active = true;
		this.coords = this.mode === 'polygon' ? feature.coordinates : [feature.coordinates];
		this.dms = this.caller.get('format') === 'dms';
		this.iso = this.caller.get('iso');
		this.id = uuid();

		viewManager.load(this, view$1(this), this.container);

		switch(this.mode){
			case 'point':
			case 'circle':
				this.setPointCircle();
			break;
			case 'polygon':
			case 'line':
				this.setPolyLine();
			break;
		}
	}
	deactivate(){
		if(!this.active){ return; }

		this.caller.toggleButton('coords', false);
		this.validator = null;
		this.active = false;
		this.clear();
		viewManager.empty(this.container);
	}
}

function coordEditor(caller){
	return new CoordEditor(caller);
}

function toolbarView(caller, bgItems){
	return {el: 'div', flex: 'col', width: '100%', items: [
		{el: 'div', flex: 'row', gap: 5, padding: '5px 10px', alignItems: 'center', items: group1(caller, bgItems)},
		{el: 'div', flex: 'row', gap: 5, padding: '5px 10px', alignItems: 'center', items: group2(caller)},
		{el: 'div', flex: 'row', gap: 5, padding: '5px 10px', alignItems: 'center', items: group3()}
	]}
}
function group1(caller, bgItems){
	return [
		button(caller, 'Close', 'close', 'icon-cancel2'),
		button(caller, 'Import', 'import', 'gis-layer-upload', false, null, 'showImport'),
		button(caller, 'Export', 'export', 'gis-layer-download', false, 'enableAny', 'showExport'),
		{el: 'buttonGroup', bind: {select: 'toolbarEvent', enabled: 'enabled.geometry'}, options: {items: bgItems}},
		button(caller, 'Polygonize', 'polygonize', 'icon-circle', false, null, 'showPolygonize')
	];
}
function group2(caller){
	return [
		{el: 'dropDownButton', text: 'Boolean Operation', bind: {click: 'toolbarEvent', enabled: 'enableOps'}, options: {
			spriteCssClass: 'gis-union',
			showArrowButton: true,
			items: [
				{text: 'Union', id: 'ops1', key: 'union', group: 'ops', spriteCssClass: 'gis-union'},
				{text: 'Intersect', id: 'ops2', key: 'intersection', group: 'ops', spriteCssClass: 'gis-intersection'},
				{text: 'Difference', id: 'ops3', key: 'difference', group: 'ops', spriteCssClass: 'gis-difference'},
				{text: 'Symmetrical Difference', id: 'ops4', key: 'xor', group: 'ops', spriteCssClass: 'gis-sym-difference'}
			]
		}},
		{el: 'dropDownButton', text: 'Rotate', bind: {click: 'toolbarEvent', enabled: 'enableOnePolyLine'}, options: {
			spriteCssClass: 'icon-rotate',
			showArrowButton: true,
			items: [
				{text: 'Rotate CW', id: 'rotate1', key: 'rotateCW', group: 'transform', spriteCssClass: 'icon-rotate'},
				{text: 'Rotate CCW', id: 'rotate2', key: 'rotateCCW', group: 'transform', spriteCssClass: 'icon-rotate-1'}
			]
		}},
		/*
		{el: 'dropDownButton', text: 'Flip', bind: {click: 'toolbarEvent', enabled: 'enableOnePolyLine'}, options: {
			spriteCssClass: 'icon-rotate',
			showArrowButton: true,
			items: [
				{text: 'Flip X', id: 'flip1', key: 'flipX', group: 'transform', spriteCssClass: 'gis-flip-h'},
				{text: 'Flip Y', id: 'flip2', key: 'flipY', group: 'transform', spriteCssClass: 'gis-flip-v'}
			]
		}},*/
		button(caller, 'Copy', 'copy', 'gis-copy-poly', false, 'enableOne'),
		button(caller, 'Delete', 'delete', 'icon-trashcan', false, 'enableAny'),
		button(caller, 'Coordinates', 'coords', 'gis-coord-system', true, 'enableOne'),
		//button(caller, 'Rotate CW', 'rotateCW', 'icon-rotate', false, 'enableOnePolyLine'),
		//button(caller, 'Rotate CCW', 'rotateCCW', 'icon-rotate-1', false, 'enableOnePolyLine'),
		//button(caller, 'Flip X', 'flipX', 'gis-flip-h', false, 'enableOnePolyLine'),
		//button(caller, 'Flip Y', 'flipY', 'gis-flip-v', false, 'enableOnePolyLine'),
		button(caller, 'Split', 'split', 'gis-split-polygon', false, 'enableSplit'),
		button(caller, 'Geodesic', 'geodesic', 'gis-globe-o', true, 'enableOnePolyLine'),
		button(caller, 'Buffer', 'buffer', 'gis-buffer', true, 'enableOne'),
		button(caller, 'Precision', 'precision', 'gis-grid', true, 'enableOnePolyLine')
	];
}
function group3(){
	return [
		{el: 'label', text: 'Regular Sides', bind: {visible: 'showSides'}},
		{el: 'numericTextBox', width: 70, bind: {value: 'sides', visible: 'showSides'}, options: {
			min: 3,
			max: 20,
			decimals: 0,
			format: '#'
		}},
		{el: 'numericTextBox', width: 100, bind: {value: 'buffer.size', change: 'changeBuffer', enabled: 'enableOne'}, options: {
			label: 'Buffer Size',
			min: 0
		}},
		{el: 'dropDownList', width: 70, bind: {value: 'buffer.units', change: 'changeBuffer', enabled: 'enableOnePolyLine'}, options: {
			autoWidth: true,
			valuePrimitive: true,
			dataTextField: 'val',
			dataValueField: 'val',
			template: ({text, val}) => `<span>${text} (${val})</span>`,
			dataSource: [
				{val: 'm', text: 'Meter'},
				{val: 'km', text: 'Kilometer'},
				{val: 'ft', text: 'Feet'},
				{val: 'mi', text: 'Mile'},
				{val: 'NM', text: 'Nautical Mile'}
			]
		}},
		{el: 'numericTextBox', width: 70, bind: {value: 'precision.size', change: 'changePrecision', enabled: 'enableOne'}, options: {
			label: 'Precision',
			min: 1,
			max: 60,
			decimals: 0,
			format: '#'
		}},
		{el: 'dropDownList', width: 95, bind: {value: 'precision.units', change: 'changePrecision', enabled: 'enableOne'}, options: {
			autoWidth: true,
			valuePrimitive: true,
			dataTextField: 'text',
			dataValueField: 'val',
			dataSource: [
				{val: 'deg', text: 'Degree'},
				{val: 'min', text: 'Minute'},
				{val: 'sec', text: 'Second'}
			]
		}}
	];
}
function button(caller, text, key, spriteCssClass, toggle, enabled, visible){
	const bind = toggle ? {toggle: 'toolbarEvent'} : {click: 'toolbarEvent'};
	const el = toggle ? 'toggleButton' : 'button';
	const id = `${key}-${caller.id}`;

	if(enabled){ bind.enabled = enabled; }
	if(visible){ bind.visible = visible; }

	return {el, id, text, bind, options: {key, spriteCssClass}};
}

const events = ['mousedown','mousemove','mouseup','dblclick'];
const geomClass = new Map([
	['Point', 'point'],
	['MultiPoint', 'point'],
	['LineString', 'line'],
	['MultiLineString', 'line'],
	['Polygon', 'polygon'],
	['MultiPolygon', 'polygon']
]);
const geomMenu = [
	{text: 'Select', key: 'select', mode: 'select', spriteCssClass: 'icon-pointer-7'},
	{text: 'Modify', key: 'edit', mode: 'edit', spriteCssClass: 'gis-modify-poly-o'},
	{text: 'Transform', key: 'transform', mode: 'transform', spriteCssClass: 'gis-translate'},
	{text: 'Polygon', key: 'polygon', mode: 'draw', spriteCssClass: 'gis-polygon-o'},
	{text: 'Line', key: 'lineString', mode: 'draw', spriteCssClass: 'gis-polyline'},
	{text: 'Circle', key: 'circle', mode: 'draw', spriteCssClass: 'gis-circle-o'},
	{text: 'Rectangle', key: 'rectangle', mode: 'draw', spriteCssClass: 'gis-square-o'},
	{text: 'Regular', key: 'regular', mode: 'draw', spriteCssClass: 'gis-regular-shape-o'},
	{text: 'Point', key: 'point', mode: 'draw', spriteCssClass: 'gis-poi'}
];

class DrawTool extends Model{
	constructor(api){
		super({sides: 4});

		this.id = uuid();
		this.seq = 1;
		this.api = api;
		this.layers = layers$1(this);
		this.composer = composer(this);
		this.editor = editor(this);
		this.selector = selector(this);
		this.transformer = transformer(this);
		this.coordEditor = coordEditor(this);
		this.editStyle = this.layers.getStyle('#ff9900');
		this.selectStyle = this.layers.getStyle('#800080');
	}
	addFeature(obj, addOnly = false){
		obj.id = obj.id || uuid();
		obj.properties = this.layers.getStyle('#4169e1');
		obj.geomClass = geomClass.get(obj.type);
		obj.geodesic = obj.geodesic || false;
		obj.buffer = obj.buffer || false;
		obj.precision = false;
		obj.selected = false;

		this.features.set(obj.id, obj);

		if(addOnly){
			return;
		} else if(this.get('singleFeature')){
			this.deactivate(true);
		} else {
			this.setState();
			this.render();
		}
	}
	activate(opts = {}){
		const {promise, api} = this;
		const topDiv = api.elements.get('top');
		const buttons = new Map();

		if(promise){ return promise; }

		this.set(Object.assign({
			mode: 'none',
			gtype: 'polygon',
			units: 'km',
			format: 'dms',
			iso: 'us',
			toolbar: true,
			geodesic: true,
			fullScreen: false,
			singleFeature: false,
			preset: api.opts.preset,
			disable: []
		}, opts));

		api.setLayout(1);

		if(this.get('fullScreen')){
			api.fullViewport(this.get('fullScreen'));
		}

		if(this.get('toolbar')){
			this.createToolbar(topDiv, buttons);
		} else {
			viewManager.empty(topDiv);
		}

		this.promise = new Promise((resolve) => { this.resolve = resolve; });
		this.cursor = null;
		this.buttons = buttons;
		this.features = new Map();
		this.mapInstance = api.active;
		this.container = this.mapInstance.canvasContainer;
		this.map = api.active.map;
		this.map.doubleClickZoom.disable();
		this.listener = this.eventHandle.bind(this);
		this.featureListener = this.addFeature.bind(this);
		this.composer.on('feature', this.featureListener);
		this.defaultBuffer = {size: 1, units: this.get('units')};
		this.defaultPrecision = {size: 1, units: 'sec'};
		this.set('buffer', this.defaultBuffer);
		this.set('precision', this.defaultPrecision);
		this.setState();

		for(let evt of events){ api.on(evt, this.listener); }

		if(opts.features){ this.loadFeatures(opts.features); }
		if(opts.singleFeature){
			this.setCursor('crosshair');
			this.composer.activate();
		}

		return this.promise;
	}
	deactivate(single = false){
		const {api, map} = this;

		viewManager.empty(api.elements.get('top'));

		for(let event of events){ api.off(event, this.listener); }

		this.setCursor();
		this.resolve(this.getOutput(single));
		this.features = new Map();
		this.promise = null;
		this.layers.setData(1);
		this.layers.setData(2);
		this.layers.clearMarkers();
		this.coordEditor.deactivate();
		this.composer.off('feature', this.featureListener);

		api.fullViewport(false);
		api.setLayout(this.get('preset'));

		setTimeout(() => {
			map.doubleClickZoom.enable();
			map.dragPan.enable();
		}, 0);
	}
	setState(render){
		if(!this.get('toolbar')){ return; }

		const {features} = this;
		const mode = this.get('mode');
		const cnts = {sel: 0, point: 0, line: 0, polygon: 0, circle: 0};
		const obj = this.selector.getFirst() || {geodesic: false, buffer: false, precision: false};
	
		for(let {selected, geomClass, center} of features.values()){
			if(!selected){ continue; }
			if(center){ cnts.circle++; }

			cnts.sel++;
			cnts[geomClass]++;
		}

		const {sel, line, polygon, circle} = cnts;
		const bool1 = mode === 'edit' || sel === 1;
		const bool2 = mode === 'transform' || (sel === 1 && polygon === 1 && !circle);
		const bool3 = obj.buffer ? true : false;
		const bool4 = obj.precision ? true : false;
		const bool5 = (sel === 1 && this.coordEditor.active);

		this.toggleEnabled('edit', bool1);
		this.toggleEnabled('transform', bool2);
		this.toggleButton('geodesic', sel === 1 && obj.geodesic);
		this.toggleButton('buffer', sel === 1 && bool3);
		this.toggleButton('precision', sel === 1 && bool4);
		this.toggleButton('coords', bool5);
		this.set('enableAny', sel > 0);
		this.set('enableOne', sel === 1);
		this.set('enableOps', sel === 2 && polygon === 2);
		this.set('enableOnePolyLine', sel === 1 && (polygon || line) && !circle);
		this.set('enableSplit', this.selector.checkSplit());
		this.set('precision', sel === 1 && obj.precision ? obj.precision : this.defaultPrecision);
		this.set('buffer', sel === 1 && obj.buffer ? obj.buffer : this.defaultBuffer);
		this.set('showPolygonize', sel === 1 && circle);
		this.dragPan(mode !== 'draw' && mode !== 'edit');

		if(!bool5){ this.coordEditor.deactivate(); }
		if(render){ this.render(); }
	}
	toolbarEvent(evt){
		const {options} = evt.sender;
		const selected = this.selector.getFirst();
		const currMode = this.get('mode');
		const idx = this.getEventIdx(evt);
		const {checked} = evt;
		const {key, mode, group} = idx === null ? options : options.items[idx];

		if(mode !== 'draw' && mode === currMode){ console.log('abort'); return; }

		this.layers.setData(2);

		if(mode){
			this.set('mode', mode);
			this.setCursor(mode === 'draw' ? 'crosshair' : '');
			this.coordEditor.deactivate();
			this.transformer.deactivate();
			this.editor.deactivate();

			switch(mode){
				case 'draw':
					this.set('gtype', key);
					this.composer.activate();
				break;
				case 'edit':
					this.editor.activate(selected);
				break;
				case 'transform':
					this.transformer.activate(selected);
				break;
			}

			this.selector.deselect();
		}

		if(key === 'delete'){
			this.selector.delete();
		} else if(key === 'copy'){
			this.selector.copy();
		} else if(group === 'ops'){
			this.selector.operation(key);
		}  else if(key === 'flipX' || key === 'flipY'){
			this.selector.flip(key);
		} else if(key === 'rotateCW' || key === 'rotateCCW'){
			this.selector.rotate(key);
		} else if(key === 'geodesic'){
			this.selector.setGeodesic(checked);
		} else if(key === 'buffer'){
			this.selector.setBuffer(checked);
		} else if(key === 'precision'){
			this.selector.setPrecision(checked);
		} else if(key === 'polygonize'){
			this.selector.polygonize();
		} else if(key === 'split'){
			this.selector.split();
		} else if(key === 'close'){
			this.deactivate();
		} else if(key === 'coords'){
			this.coordEditor.toggle(selected, checked);
		}

		this.setState(true);
	}
	getEventIdx(evt){
		if(evt.indices){
			return evt.indices[0];
		} else if(evt.id && evt.id.match(/^[a-z]+\d+$/)){
			return Number(evt.id.match(/^[a-z]+(\d+)$/)[1]) - 1;
		} else {
			return null;
		}
	}
	changeBuffer(){
		const obj = this.selector.getFirst();

		if(obj.buffer){
			obj.buffer = this.get('buffer').toJSON();

			this.render();
		}
	}
	changePrecision(){
		const obj = this.selector.getFirst();

		if(obj.precision){
			obj.precision = this.get('precision').toJSON();

			this.render();
		}
	}
	toggleEnabled(keys, bool){
		const arr = Array.isArray(keys) ? keys : [keys];
		const method = bool ? 'removeClass' : 'addClass';

		for(let key of arr){
			$(`#${key}-${this.id}`)[method]('k-disabled');
		}
	}
	toggleButton(key, bool){
		this.buttons.get(key).toggle(bool);
	}
	render(){
		const features = [];

		for(let feature of this.features.values()){
			const {id, type, properties, edit, selected, buffer} = feature;
			let style = properties;

			feature.renderCoords = this.getCoords(feature);

			if(edit){
				style = this.editStyle;
			} else if(selected){
				style = this.selectStyle;
			}

			const props = Object.assign({id}, style);

			features.push({
				properties: props,
				geometry: {
					type: buffer ? 'Polygon' : type,
					coordinates: feature.renderCoords
				}
			});

			if(buffer){
				features.push({
					properties: props,
					geometry: {
						type: 'MultiLineString',
						coordinates: this.getBufferCoords(feature)
					}
				});
			}
		}

		this.layers.setData(1, featureCollection(features));
	}
	getBufferCoords(feature){
		const {type, coordinates, geodesic, precision, center, radius, units} = feature;

		if(center){
			return [circle(center, radius, units)];
		} else {
			return this.getCoords({geodesic, precision, coordinates: type === 'Polygon' ? coordinates : [coordinates]})
		}
	}
	getCoords(feature){
		const {geodesic: geodesic$1, buffer: buffer$1, precision, coordinates, center, radius, units} = feature;
		let out = clone(coordinates);

		if(precision){ out = dmsPrecision(out, precision.size, precision.units); }
		if(buffer$1){
			if(center){
				const dist = distance$1(buffer$1.size, buffer$1.units, units);

				out = [circle(center, radius + dist, units)];
			} else {
				out = buffer(out, buffer$1.size, buffer$1.units, geodesic$1);
			}
		}
		if(geodesic$1){ out = geodesic(out); }

		return out;
	}
	getOutput(single){
		const features = [];

		for(let feature of this.features.values()){
			const {id, type, coordinates, properties, geodesic: geodesic$1, center, radius, buffer, units} = feature;
			const out = {
				id,
				geodesic: geodesic$1,
				type: 'Feature',
				properties: Object.assign({}, properties),
				geometry: {
					type: type,
					coordinates: geodesic$1 ? geodesic(coordinates) : coordinates
				}
			};

			if(center){
				out.center = center;
				out.radius = radius;
				out.units = units;
			}

			if(buffer){ out.buffer = buffer; }

			features.push(out);
		}

		return single ? features.shift() : features;
	}
	loadFeatures(features){
		for(let {geometry, geodesic, buffer, center, radius, units} of features){
			const obj = {geodesic, center, radius, units, buffer};
			const {type, coordinates} = geometry;

			obj.type = type;
			obj.coordinates = geodesic ? fromGeodesic(coordinates, 0.2) : coordinates;

			this.addFeature(obj, true);
		}

		this.setState();
		this.render();
	}
	createToolbar(container, buttons){
		const set = new Set(this.get('disable'));
		const menuButtons = [];

		for(let item of geomMenu){
			const {key} = item;

			if(set.has(key)){ continue; }
			
			//item.selected = key === gtype;
			item.attributes = {id: `${key}-${this.id}`};
			menuButtons.push(item);
		}

		this.set('showSides', set.has('regular') ? false : true);
		this.set('showImport', set.has('import') ? false : true);
		this.set('showExport', set.has('export') ? false : true);

		viewManager.load(this, toolbarView(this, menuButtons), container);

		for(let key of ['geodesic', 'buffer', 'precision', 'coords']){
			buttons.set(key, viewManager.get(`${key}-${this.id}`));
		}
	}
	eventHandle(evt){
		switch(this.get('mode')){
			case 'draw':
				this.composer.eventHandle(evt);
			break;
			case 'select':
				this.selector.eventHandle(evt);
			break;
			case 'edit':
				this.editor.eventHandle(evt);
			break;
		}
	}
	dragPan(bool){
		if(bool){
			this.map.dragPan.enable();
		} else {
			this.map.dragPan.disable();
		}
	}
	setCursor(cursor = ''){
		if(cursor === this.cursor){ return; }

		this.cursor = cursor;
		this.mapInstance.setCursor(cursor);
	}
}

function drawTool(api){
	return new DrawTool(api);
}

const layouts = new Map([
	[1, [[2,2,1], [0,0,0], [0,0,0], [0,0,0]]],
	[2, [[1,1,1], [1,1,1], [1,1,1], [1,1,1]]],
	[3, [[1,2,1], [0,0,0], [1,2,1], [0,0,0]]],
	[4, [[2,1,1], [0,0,0], [2,1,1], [0,0,0]]],
	[5, [[1,2,1], [1,1,1], [0,0,0], [1,1,1]]],
	[6, [[1,1,1], [1,2,1], [1,2,1], [0,0,0]]],
	[7, [[2,1,1], [0,0,0], [1,1,1], [1,1,1]]],
	[8, [[1,1,1], [1,1,1], [2,1,1], [0,0,0]]]
]);
const uri = 'mapbox://styles/mapbox';
const styleMap$1 = new Map([
	['streets', {uri: `${uri}/streets-v12`, theme: 'mid'}],
	['satellite', {uri: `${uri}/satellite-v9`, theme: 'dark'}],
	['satelliteStreets', {uri: `${uri}/satellite-streets-v12`, theme: 'dark'}],
	['light', {uri: `${uri}/light-v11`, theme: 'light'}],
	['dark', {uri: `${uri}/dark-v11`, theme: 'dark'}],
	['outdoors', {uri: `${uri}/outdoors-v12`, theme: 'mid'}]
]);

class MapWidget extends Model{
	constructor(opts, container){
		super();

		this.container = container;
		this.elements = this.getElements();
		this.opts = this.getOptions(opts);
		this.maps = new Map();
		this.state = 0;
		
		this.on('load', this.onload.bind(this));
		this.setLayout(this.opts.preset);

		for(let id = 1; id <= (this.opts.multiMap ? 4 : 1); id++){
			const el = this.elements.get(`map${id}`);

			this.maps.set(id, {container: el, map: mapAPI(this, el)});
		}
	}
	fitBounds(bounds, opts = {}){
		const map = this.active.map;

		if(bounds.minX){
			const {minX, minY, maxX, maxY} = bounds;
			bounds = [[minX, minY],[maxX, maxY]];
		}

		return new Promise((resolve) => {
			map.once('idle', resolve);
			map.resize().fitBounds(bounds, opts);
		});
	}
	easeTo(opts){
		this.active.map.easeTo(opts);
	}
	flyTo(opts){
		this.active.map.flyTo(opts);
	}
	jumpTo(opts){
		this.active.map.jumpTo(opts);
	}
	dragPan(bool){
		const onOff = bool ? 'enable' : 'disable';

		this.active.map.dragPan[onOff]();
	}
	async addImage(name, path, opts = {}){
		for(let obj of this.maps.values()){
			await obj.map.addImage(name, path, opts);
		}
	}
	clear3dLines(){
		for(let obj of this.maps.values()){
			obj.map.clear3dLines();
		}
	}
	add3dLine(coord1, coord2, opts){
		coord1[2] = coord1[2] || 0;
		coord2[2] = coord2[2] || 0;
		opts = Object.assign({color: '#000000', width: 1, opacity: 1, vertical: false}, opts);
	
		for(let obj of this.maps.values()){
			obj.map.add3dLine(coord1, coord2, opts);
		}
	}
	setLayout(idx){
		const preset = Number(idx || this.opts.preset);
		const arr = layouts.get(preset);

		for(let i = 0; i < 4; i++){
			const el = this.elements.get(`map${i + 1}`);
			const vals = arr[i];
			el.css('grid-column-end', `span ${vals[0]}`);
			el.css('grid-row-end', `span ${vals[1]}`);
			
			if(vals[2]){
				el.show();
			} else {
				el.hide();
			}
		}

		this.opts.preset = preset;
		this.applyAll('resize');
	}
	setCursor(cursor){
		this.active.setCursor(cursor);
	}
	setStyle(key){
		const style = styleMap$1.get(key || this.get('style'));

		style.key = key;

		this.active.setStyle(style);

		if(key){ this.set('style', key); }
	}
	setActive(evt){
		const map = evt.mapInstance;

		if(map.selected){
			this.focus(map);
			return;
		}

		if(this.active){
			this.active.selected = false;
			this.active.container.removeClass('map-focus');
		}

		map.selected = true;
		this.active = map;
		this.focus(map);
		this.emit('mapActivation', map);
	}
	getBounds(){
		return this.active.getBounds();
	}
	getCenter(){
		return this.active.getCenter().toArray();
	}
	getCenterZoom(){
		return {
			center: this.active.getCenter().toArray(),
			zoom: this.active.getZoom()
		};
	}
	setCoordFormat(val){
		this.active.setCoordFormat(val);
	}
	setProjection(val){
		this.active.setProjection(val);
	}
	setCenterZoom(center, zoom){
		this.active.setCenter(center);
		this.active.setZoom(zoom);
	}
	apply(){
		const args = Array.from(arguments);
		const method = args.shift();

		return this.active.map[method](...args);
	}
	applyAll(){
		const args = Array.from(arguments);
		const method = args.shift();

		for(let obj of this.maps.values()){
			obj.map[method](...args);
		}
	}
	query(bbox, layers){
		return this.active.query(bbox, layers);
	}
	focus(map){
		const {multiMap, preset} = this.opts;

		if(multiMap && preset !== 1){ map.container.addClass('map-focus'); }
		if(preset === 1){ map.container.removeClass('map-focus'); }
	}
	async screenshot(){
		const map = this.active;
		const data = [
			{ext: 'png', blob: await map.screenshot('image/png')},
			{ext: 'jpg', blob: await map.screenshot('image/jpeg')}
		];

		fileSave('Map Screenshot', data);
	}
	async screenshotRaw(){
		const blob = await this.active.screenshot('image/png');

		return await blob.arrayBuffer();
	}
	addOverlay(point, text){
		return this.active.addOverlay(point, text);
	}
	removeOverlay(overlay){
		this.active.removeOverlay(overlay);
	}
	updateOverlays(){
		this.active.updateOverlays();
	}
	activateEditor(opts = {}){
		return this.drawTool.activate(opts);
	}
	editorLoadFeatures(features){
		this.drawTool.loadFeatures(features);
	}
	fullViewport(on = true){
		const div = this.elements.get('wrapper');
		const parent = on ? 'body' : this.container;
		const method = on ? 'addClass' : 'removeClass';
		
		div[method]('full-viewport');
		div.appendTo(parent);

		this.applyAll('resize');
	}
	onload(){
		this.state++;

		if(this.state < this.maps.size){ return; }

		this.setActive({mapInstance: this.maps.get(1).map});
		this.drawTool = drawTool(this);
		this.on('mousedown', this.setActive.bind(this));
		this.set('active', true);
		this.emit('ready');

		//this.drawTool.activate();
	}
	getOptions(opts){
		const out = Object.assign({
			multiMap: false,
			preset: 1,
			center: [-98.5795, 39.8283],
			zoom: 4,
			pitch: 0,
			bearing: 0,
			style: 'streets',
			projection: 'globe',
			coordFormat: 1,
			elevation: false,
			elevationUnit: 'm',
			attributionControl: false,
			fullscreenControl: true,
			showPosition: true,
			navControl: {showCompass: true, showZoom: true, visualizePitch: true},
			scaleControl: {maxWidth: 100, unit: 'imperial'},
			menu: false,
			drawTool: {},
			contextMenu: [],
			showLayers: [],
			hideLayers: [],
			hideBaseGroups: []
		}, opts || {});
		
		out.styleName = out.style;

		const {uri, theme} = styleMap$1.get(out.style);
		
		this.set('style', out.style);

		out.style = uri;
		out.theme = theme;

		if(out.preset > 1){ out.multiMap = true; }
		if(out.bounds){
			out.fitBoundsOptions = {padding: 10};
			delete out.zoom;
		}
	
		return out;
	}
	getElements(){
		const id = uuid();
		const {load, get} = viewManager;
		const view = [
			{el: 'div', id: `wrapper-${id}`, class: 'k-body', height: '100%', width: '100%', items: [
				{el: 'div', flex: 'col', height: '100%', width: '100%', items: [
					{el: 'div', id: `top-${id}`},
					{el: 'div', flex: 'row', stretch: true, items: [
						{el: 'div', id: `left-${id}`},
						{el: 'div', flex: 'col', stretch: true, items: [
							{el: 'div', id: `grid-${id}`, grid: {rows: '1fr 1fr', cols: '1fr 1fr'}, height: '100%', width: '100%', items: [
								{el: 'div', id: `map1-${id}`},
								{el: 'div', id: `map2-${id}`},
								{el: 'div', id: `map3-${id}`},
								{el: 'div', id: `map4-${id}`}
							]}
						]},
						{el: 'div', id: `right-${id}`}
					]},
					{el: 'div', id: `bottom-${id}`}
				]}
			]}
		];
	
		load(this, view, this.container);
	
		return new Map([
			['wrapper', get(`wrapper-${id}`)],
			['grid', get(`grid-${id}`)],
			['top', get(`top-${id}`)],
			['bottom', get(`bottom-${id}`)],
			['left', get(`left-${id}`)],
			['right', get(`right-${id}`)],
			['map1', get(`map1-${id}`)],
			['map2', get(`map2-${id}`)],
			['map3', get(`map3-${id}`)],
			['map4', get(`map4-${id}`)],
		]);
	}
}

const kendoInternal = new Set(['Label']);
const types = new Map([
	['password', {kendo: 'kendoTextBox', tag: 'input', type: 'password'}]
]);
const typeMap = new Map([
	['AutoComplete', {tag: 'input'}],
	['Button', {tag: 'button'}],
	['Captcha', {tag: 'input'}],
	['CheckBox', {tag: 'input', type: 'checkbox'}],
	['CheckBoxGroup', {tag: 'ul'}],
	['ColorPicker', {tag: 'input'}],
	['ComboBox', {tag: 'input'}],
	['DateInput', {tag: 'input'}],
	['DatePicker', {tag: 'input'}],
	['DateTimePicker', {tag: 'input'}],
	['DropDownList', {tag: 'input'}],
	['DropDownTree', {tag: 'input'}],
	['Editor', {tag: 'textarea'}],
	['FloatingActionButton', {tag: 'button'}],
	['Form', {tag: 'form'}],
	['ListBox', {tag: 'select'}],
	['MaskedTextBox', {tag: 'input'}],
	['Menu', {tag: 'ul'}],
	['MultiColumnComboBox', {tag: 'input'}],
	['MultiSelect', {tag: 'select'}],
	['NumericTextBox', {tag: 'input'}],
	['PanelBar', {tag: 'ul'}],
	['RadioButton', {tag: 'input', 'type': 'radio'}],
	['RadioGroup', {tag: 'ul'}],
	['Rating', {tag: 'input'}],
	['Slider', {tag: 'input'}],
	['SplitButton', {tag: 'button'}],
	['Switch', {tag: 'input'}],
	['TextArea', {tag: 'textarea'}],
	['TextBox', {tag: 'input'}],
	['TimePicker', {tag: 'input'}],
	['TimeDurationPicker', {tag: 'input'}],
	['Upload', {tag: 'input', type: 'file'}],
	['Validator', {tag: 'form'}],
	['Wizard', {tag: 'form'}]
]);

function initialize(){
	const regex = /^[A-Z].+$/;
	const arr1 = Array.from(Object.keys(kendo.ui));
	const arr2 = Array.from(Object.keys(kendo.dataviz));

	for(let key of [...arr1, ...arr2]){
		const obj = typeMap.get(key) || {};

		if(!regex.test(key) || kendoInternal.has(key)){ continue; }

		obj.kendo = `kendo${key}`;
		obj.tag = obj.tag || 'div';
		types.set(key.toLowerCase(), obj);
	}

	typeMap.clear();
}

if(typeof kendo !== 'undefined'){ initialize(); }

function elements$1(opts, container, caller){
	opts.el = opts.el.toLowerCase();
	opts = Object.assign(opts, types.get(opts.el) || {});

	if(opts.el === 'panel'){
		opts = setPanel(opts, container);
	} else if(opts.el === 'gridlayout'){
		const grid = gridLayout(opts, container, caller);
		return {el: grid, primitive: grid};
	} else if(opts.el === 'map'){
		const map = new MapWidget(opts, container);
		return {el: map, primitive: map};
	} else if(opts.el === 'window'){
		container = $('body');
	}

	preprocess(opts);

	opts.tag = opts.tag || opts.el;

	const {kendo, options} = opts;
	const primitive = dom(opts, container);

	if(opts.el === 'tabstrip'){
		const items = opts.items || [];

		delete opts.items;

		for(let item of items){
			viewManager.add(item, primitive, caller);
		}
	}

	const el = kendo ? primitive[kendo](options || {}).data(kendo) : primitive;

	if(opts.el === 'window'){
		setWindowEvents(el);
	}

	return {el, primitive};
}
function setWindowEvents(el){
	for(let evt of ['open', 'refresh', 'dragstart', 'maximize']){
		el.bind(evt, resetScroll);
	}
}
function resetScroll(){
	const win = $(window);
	const top = win.scrollTop();
	const left = win.scrollLeft();

	setTimeout(() => {
		win.scrollTop(top).scrollLeft(left);
	}, 0);
}
function preprocess(opts){
	opts.style = styleArray(opts.style);

	if(opts.el === 'panel'){
		return;
	} else if(opts.grid){
		opts.style.push('grid', 'k-body');
		opts.gridTemplateRows = opts.grid.rows || null;
		opts.gridTemplateColumns = opts.grid.cols || null;
		delete opts.grid;
	} else if(opts.flex){
		opts.style.push('flex', opts.flex);
		delete opts.flex;
	}

	if(opts.colSpan){
		opts.gridColumnEnd = `span ${opts.colSpan}`;
		delete opts.colSpan;
	}

	if(opts.rowSpan){
		opts.gridRowEnd = `span ${opts.rowSpan}`;
		delete opts.rowSpan;
	}
}
function setPanel(opts, container){
	opts = Object.assign({
		direction: opts.direction || 'auto',
		stretch: false,
		border: false,
		style: []
	}, opts);

	opts.tag = 'panel';
	opts.style = styleArray(opts.style);

	if(opts.direction === 'auto'){
		opts.direction = container.css('flexDirection') === 'row' ? 'col' : 'row';
	}

	opts.style.push(opts.direction, 'k-body');

	if(opts.stretch){
		opts.flex = 'auto';
		opts.overflow = opts.overflow || 'auto';
	}

	if(opts.border){ opts.style.push('border'); }

	delete opts.stretch;

	return opts;
}
function gridLayout(opts, container, caller){
	const cols = opts.cols || 1;
	const items = opts.items || [];
	
	opts.tag = 'div';
	opts.display = 'grid';
	opts.gridTemplateColumns = `repeat(${cols}, 1fr)`;
	opts.gap = opts.gutter;
	opts.style = styleArray(opts.style);

	delete opts.cols;
	delete opts.gutter;
	delete opts.items;

	const el = dom(opts, container);

	for(let item of items){
		const span1 = item.colSpan || 1;
		const span2 = item.rowSpan || 1;
		const opts2 = {el: 'div'};

		opts2.gridColumnEnd = span1 === 1 ? null : `span ${span1}`;
		opts2.gridRowEnd = span2 === 1 ? null :`span ${span2}`; 

		delete item.colSpan;
		delete item.rowSpan;

		const wrapper = dom(opts2, el);

		viewManager.add(item, wrapper, caller);
	}

	return el;
}
function styleArray(style = []){
	return Array.isArray(style)? style : style.split(' ');
}

const ruleMap = {
	length: {label: 'Length (%)', regex: /(.{1})/g},
	numeric: {label: 'Numbers (%)', regex: /([0-9]{1})/g},
	uppercase: {label: 'Uppercase (%)', regex: /([A-Z]{1})/g},
	lowercase: {label: 'Lowercase (%)', regex: /([a-z]{1})/g},
	symbol: {label: 'Characters (%)', regex: /([^A-Za-z0-9 ]{1})/g},
	space: {label: 'Spaces (%)', regex: /([ ]{1})/g}
};

class PasswordChecker extends Model{
	constructor(rules, input, container){
		super({valid: false, rules: {}});
		const list = [];
		const view = [{el: 'gridLayout', width: 420, cols: 3, gutter: '5px', items: list}];

		for(let [key, rule] of Object.entries(ruleMap)){
			const cnt = rules[key] || 0;

			if(!cnt){ continue; }

			list.push({el: 'div', text: rule.label.replace('%', cnt), bind: {style: {color: `rules.${key}.color`}}});
			this.set(`rules.${key}`, {regex: rule.regex, cnt: cnt, color: '#e40609'});
		}

		this.el = input.element;

		viewManager.load(this, view, container);
		this.el.on('keyup', this.check.bind(this));
	}
	check(){
		const pw = this.el.val();
		const rules = this.get('rules').toJSON();
		let out = true;

		for(let [key, obj] of Object.entries(rules)){
			const match = pw.match(obj.regex) || [];
			const pass = match.length >= obj.cnt;
			const path = `rules.${key}.color`;

			this.set(path, pass ? '#278200' : '#d51a22');
			out = pass ? out : false;
		}

		return out;
	}

}

function passwordChecker(rules, input, container){
	return new PasswordChecker(rules, input, container);
}

const elements = new Map();

const body = globalThis.$ ? $('body') : null;

function load(caller, view, container = body, emptyContainer = true){
	container = typeof container === 'string' ? elements.get(container) : container;
	
	if(emptyContainer){ empty(container); }
	
	iterate(view, container, caller);
}
function get(key){
	return elements.get(key);
}
function unset(key){
	const arr = Array.isArray(key) ? key : [key];

	for(let id of arr){ elements.delete(id); }
}
function show(container){
	showHideToggle(container, 'show');
}
function hide(container){
	showHideToggle(container, 'hide');
}
function toggle(container){
	showHideToggle(container, 'toggle');
}
function empty(container){
	if(!container || container === body){ return; }

	const obj = getContainer(container);
	const el = obj.element || obj;

	if(!el){ return; }

	try {
		kendo.destroy(el);
	} catch {}

	try {
		kendo.unbind(el);
	} catch {}

	if(el.find){
		for(let item of el.find('[id]')){
			unset($(item).attr('id'));
		}
	}
	
	if(el.empty){ 
		el.empty();
	}
}
function destroy(container){
	const el = getContainer(container);

	unset(container);

	if(!el){ return; }

	empty(el);

	const actions = ['destroy', 'empty', 'remove'];

	for(let action of actions){
		if(!el[action]){ continue; }

		try {
			el[action]();
		} catch {}
	}
}
function add(opts, container, caller){
	const {el, primitive} = elements$1(opts, container, caller);

	register(opts, el);

	if(opts.bind){ kendo.bind(primitive, caller.model); }
	if(opts.items){ iterate(opts.items, primitive, caller); }
}
function focus(id){
	const el = get(id);
	
	if(el.focus){
		el.focus();
	} else if(el.element && el.element.focus){
		el.element.focus();
	}
}
function validator(id, opts){
	return get(id).kendoValidator(opts).data('kendoValidator');
}
function toggleToolbar(toolbar, enabled = false){

	for(let {id} of toolbar.options.items){
		if(!id){ continue; }

		toolbar.enable(`#${id}`, enabled);
	}
}
function showHideToggle(container, action){
	const el = getContainer(container);

	if(el && el[action]){
		el[action]();
	} else {
		console.error('Cannot', action, container);
	}
}
function getContainer(container){
	return typeof container === 'string' ? get(container) : container;
}
function iterate(view, container, caller){
	const arr = Array.isArray(view) ? view : [view];

	for(let opts of arr){ add(opts, container, caller); }
}
function register(opts, el){
	if(!opts.id){ return; }

	if(elements.has(opts.id)){
		console.error(`id: ${opts.id} is already registered`);
		return;
	}

	elements.set(opts.id, el);
}

var viewManager$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	add: add,
	destroy: destroy,
	elements: elements,
	empty: empty,
	focus: focus,
	get: get,
	hide: hide,
	load: load,
	show: show,
	toggle: toggle,
	toggleToolbar: toggleToolbar,
	unset: unset,
	validator: validator
});

const pw = 'Your password has expired and must be reset.';
const step1 = 'Download authenticator app on your mobile device.';
const step2 = 'Scan QR Code below in your authenticator app or copy the code for manual entry.';
const step3 = 'Enter the 6 digit verification code.';
const view = [
	{el: 'panel', direction: 'col', alignItems: 'center', stretch: true, items: [
		{el: 'panel', gap: 40, alignItems: 'center', width: 450, paddingTop: 80, items: [
			{el: 'img', src: 'images/nav-canada.svg', height: 80},
			{el: 'div', text: 'NAVenGIS', fontWeight: 800, color: '#006eb0', fontSize: '2em'}
		]},
		{el: 'panel', marginTop: 20, items: [
			{el: 'div', style: 'k-items border5', width: 450, padding: 10, items: [
				{el: 'div', fontSize: '1.8em', bind: {text: 'label'}},
				{el: 'div', border: '1px solid #c40000', borderRadius: 4, padding: 20, margin: '10px 0',
					bind: {visible: 'error'},
					items: [
						{el: 'div', text: 'A problem has occurred', fontSize: '1.3em', color: '#c40000', marginBottom: 15},
						{el: 'div', fontSize: '0.9em', bind: {text: 'error'}}
					]
				},
				{el: 'panel', gap: 20, marginTop: 20, items: [
					{el: 'panel', direction: 'col', gap: 5, bind: {visible: 'show.a'}, items: [
						{el: 'label', for: 'a', text: 'Username', marginLeft: 5},
						{el: 'textBox', id: 'a', fontSize: '1.1em', width: '100%', bind: {value: 'username'}}
					]},
					{el: 'panel', direction: 'col', gap: 5, bind: {visible: 'show.b'}, items: [
						{el: 'label', for: 'b', text: 'Password',  marginLeft: 5},
						{el: 'password', id: 'b', fontSize: '1.1em', width: '100%', bind: {value: 'password'}}
					]},
					{el: 'panel', direction: 'col', gap: 10, bind: {visible: 'show.c'}, items: [
						{el: 'div', items: [
							{el: 'span', text: 'Step 1:', marginRight: 10, fontWeight: 800},
							{el: 'span', text: step1}
						]},
						{el: 'div', items: [
							{el: 'span', text: 'Step 2:', marginRight: 10, fontWeight: 800},
							{el: 'span', text: step2}
						]},
						{el: 'panel', border: '1px solid red', direction: 'col', gap: 10, alignItems: 'center', items: [
							{el: 'qrcode', id: 'qrcode', margin: '10px 0', bind: {value: 'qrcode'}, options: {
								errorCorrection: 'M',
								size: 300
							}},
							{el: 'button', width: 300, text: 'Copy text code to clipboard', bind: {click: 'clipboard'}, options: {
								fillMode: 'solid',
								themeColor: 'secondary'
							}}
						]},
						{el: 'div', marginBottom: 10, items: [
							{el: 'span', text: 'Step 3:', marginRight: 10, fontWeight: 800},
							{el: 'span', text: step3}
						]},
						{el: 'div', items: [
							{el: 'maskedTextBox', id: 'c', fontSize: '1.1em', textAlign: 'center',
								bind: {value: 'token'},
								options: {mask: '000 000'}
							}
						]}
					]},
					{el: 'panel', direction: 'col', gap: 10, bind: {visible: 'show.d'}, items: [
						{el: 'div', marginBottom: 10, items: [
							{el: 'span', text: step3}
						]},
						{el: 'div', items: [
							{el: 'maskedTextBox', id: 'd', fontSize: '1.1em', textAlign: 'center',
								bind: {value: 'token'},
								options: {mask: '000 000'}
							}
						]}
					]},
					{el: 'panel', direction: 'col', gap: 5, bind: {visible: 'show.e'}, items: [
						{el: 'div', text: pw, marginBottom: 10},
						{el: 'label', for: 'e', text: 'New Password',  marginLeft: 5},
						{el: 'password', id: 'e', fontSize: '1.1em', width: '100%', bind: {value: 'pw1'}},
						{el: 'label', for: 'f', text: 'Confirm Password',  margin: '10px 0 0 5px'},
						{el: 'password', id: 'f', fontSize: '1.1em', width: '100%', bind: {value: 'pw2'}},
						{el: 'div', id: 'pwPolicy', marginTop: 10}
					]},
					{el: 'button', id: 'authButton', fontSize: '1.2em', text: 'Continue',
						bind: {click: 'authenticate'},
						options: {themeColor: 'primary'}
					}
				]}
			]}
		]}
	]}
];

const steps = new Map([
	[1, {step: 1, show: {a: 1, b: 0, c: 0, d: 0, e: 0}, label: 'Sign In', buttonText: 'Continue'}],
	[2, {step: 2, show: {a: 0, b: 1, c: 0, d: 0, e: 0}, label: 'Sign In', buttonText: 'Sign In'}],
	[3, {step: 3, show: {a: 0, b: 0, c: 1, d: 0, e: 0}, label: 'Two-Factor Authentication', buttonText: 'Verify'}],
	[4, {step: 4, show: {a: 0, b: 0, c: 0, d: 1, e: 0}, label: 'Two-Factor Authentication', buttonText: 'Verify'}],
	[5, {step: 5, show: {a: 0, b: 0, c: 0, d: 0, e: 1}, label: 'Reset Password', buttonText: 'Reset'}]
]);

class Main extends Model{
	constructor(){
		super({
			label: 'Sign In',
			error: null,
			step: 1,
			show: {a: true, b: false, c: false},
			username: null,
			password: 'null',
			pw1: null,
			pw2: null,
			phone: null,
			token: null
		});

		load(this, view);
		get('a').focus();

		$('body').on('keyup', (evt) => {
			if(evt.originalEvent.key === 'Enter'){ this.authenticate(); }
		});
	}
	async authenticate(){
		const data = this.validate();

		if(!data){ return; }

		const res = await this.fetch('/authenticate', {data});
		const step = data.step;
		const button = get('authButton');
		let opts = null;

		if(res.error){
			this.set('error', res.error);
			return;
		} else if(res.authenticated){
			window.location.reload();
			return;
		}

		const {passwordReset, tfEnabled, tfSet, tfUri, tfKey} = res;

		if(step === 1){
			opts = {step: 2, focus: 'b'};
		} else if(step === 2 && tfEnabled && !tfSet){
			this.set('qrcode', tfUri);
			this.set('twoFactorCode', tfKey);
			opts = {step: 3, focus: 'c'};
		} else if(step === 2 && tfEnabled){
			opts = {step: 4, focus: 'd'};
		} else if(passwordReset){
			opts = {step: 5, focus: 'e'};
		}

		if(!this.pwCheck && res.pwPolicy){
			this.pwCheck = passwordChecker(res.pwPolicy, get('e'), get('pwPolicy'));
		}

		const next = steps.get(opts.step);
		this.set(next);
		button.element.text(next.buttonText);
		focus(opts.focus);
	}
	clipboard(){
		navigator.clipboard.writeText(this.get('twoFactorCode').toUpperCase());
	}
	validate(){
		if(this.get('password') === 'null'){ this.set('password', null); }

		const {username, password, pw1, pw2, token, step} = this.model.toJSON();
		let err = null;

		if(!username){
			err = 'Username is required.';
		} else if(step === 2 && !password){
			err = 'Password is required.';
		} else if(step === 3 && !token){
			err = 'Two-factor verification code required.';
		} else if(step === 3 && token.toString().length !== 7){
			err = 'Two-factor verification code is invalid.';
		} else if(step === 4 && token.toString().length !== 7){
			err = 'Two-factor verification code is invalid.';
		} else if(step === 5 && (!pw1 || !pw2)){
			err = 'New and confirm passwords required.';
		} else if(step === 5 && pw1 !== pw2){
			err = 'Passwords do not match.';
		} else if(step === 5 && !this.pwCheck.check()){
			err = 'Password does not comply with policy.';
		}

		this.set('error', err);

		return err ? null : {username, password, pw1, pw2, token, step};
	}
}

window.viewManager = viewManager$1;
window.main = new Main();
